export const seeds = {
  "seed_1":{
		"map_id":"seed_1",
		"data":{
			"_width": 20,
			"_height": 20,
			"data": [
				{"q": 0,"r": 0,"height": 0,"terrain": "text1","treeIndex": 1},
				{"q": 0,"r": 1,"height": -0.5785973045679013,"terrain": "text4"},
				{"q": 0,"r": 2,"height": -0.7676161928530334,"terrain": "text4"},
				{"q": 0,"r": 3,"height": -0.5257206709645419,"terrain": "text3"},
				{"q": 0,"r": 4,"height": -0.10364573031400083,"terrain": "text5"},
				{"q": 0,"r": 5,"height": 0.14244744538082044,"terrain": "text1"},
				{"q": 0,"r": 6,"height": 0.09534623975794534,"terrain": "text2","treeIndex": 1},
				{"q": 0,"r": 7,"height": -0.1448567302763185,"terrain": "text2"},
				{"q": 0,"r": 8,"height": -0.3586028279833107,"terrain": "text6"},
				{"q": 0,"r": 9,"height": -0.4662661919169754,"terrain": "text2"},
				{"q": 0,"r": -10,"height": -0.36402047214209676,"terrain": "text2"},
				{"q": 0,"r": -9,"height": -0.3464677012952272,"terrain": "text5"},
				{"q": 0,"r": -8,"height": -0.26589781577047833,"terrain": "text4"},
				{"q": 0,"r": -7,"height": -0.1517448016573133,"terrain": "text6"},
				{"q": 0,"r": -6,"height": 0.05838340542582823,"terrain": "text6","treeIndex": 1},
				{"q": 0,"r": -5,"height": 0.4343556494360168,"terrain": "text1"},
				{"q": 0,"r": -4,"height": 0.8669115348585789,"terrain": "mountain"},
				{"q": 0,"r": -3,"height": 1.207689267545065,"terrain": "mountain"},
				{"q": 0,"r": -2,"height": 1.1630274305072663,"terrain": "mountain"},
				{"q": 0,"r": -1,"height": 0.6719500288477358,"terrain": "text6"},
				{"q": 1,"r": 0,"height": 0.5785973045679013,"terrain": "text4","treeIndex": 1},
				{"q": 1,"r": 1,"height": 0.010924787213063052,"terrain": "text4"},
				{"q": 1,"r": 2,"height": -0.2770014747345587,"terrain": "text6"},
				{"q": 1,"r": 3,"height": -0.2221063261831396,"terrain": "text4"},
				{"q": 1,"r": 4,"height": 0.026981589853775773,"terrain": "text7","treeIndex": 0},
				{"q": 1,"r": 5,"height": 0.20589455074357493,"terrain": "text2","treeIndex": 1},
				{"q": 1,"r": 6,"height": 0.20113936076470554,"terrain": "text3","treeIndex": 1},
				{"q": 1,"r": 7,"height": 0.07964361704412702,"terrain": "text2"},
				{"q": 1,"r": 8,"height": -0.020073143016024197,"terrain": "text4"},
				{"q": 1,"r": 9,"height": -0.029978619490461017,"terrain": "text2"},
				{"q": 1,"r": -10,"height": -0.4664270070713121,"terrain": "text2"},
				{"q": 1,"r": -9,"height": -0.3086199552390142,"terrain": "text6"},
				{"q": 1,"r": -8,"height": -0.049313670979208135,"terrain": "text2"},
				{"q": 1,"r": -7,"height": 0.2377315791066727,"terrain": "text2"},
				{"q": 1,"r": -6,"height": 0.5350020413972234,"terrain": "text1"},
				{"q": 1,"r": -5,"height": 0.8825919586521781,"terrain": "mountain"},
				{"q": 1,"r": -4,"height": 1.2595474897048073,"terrain": "mountain"},
				{"q": 1,"r": -3,"height": 1.5729088963226339,"terrain": "mountain"},
				{"q": 1,"r": -2,"height": 1.5649134991435087,"terrain": "mountain"},
				{"q": 1,"r": -1,"height": 1.1674877599506002,"terrain": "mountain"},
				{"q": 2,"r": 0,"height": 0.7696892835543169,"terrain": "mountain"},
				{"q": 2,"r": 1,"height": 0.35296101382588296,"terrain": "text1"},
				{"q": 2,"r": 2,"height": 0.0868465661991851,"terrain": "text2","treeIndex": 0},
				{"q": 2,"r": 3,"height": 0.0735779388380479,"terrain": "text3"},
				{"q": 2,"r": 4,"height": 0.2588149604629375,"terrain": "text5"},
				{"q": 2,"r": 5,"height": 0.47777900141963203,"terrain": "text3","treeIndex": 0},
				{"q": 2,"r": 6,"height": 0.6130726712931548,"terrain": "text5","treeIndex": 1},
				{"q": 2,"r": 7,"height": 0.6398179661683483,"terrain": "text4","treeIndex": 0},
				{"q": 2,"r": 8,"height": 0.5662474423906172,"terrain": "text1","treeIndex": 1},
				{"q": 2,"r": 9,"height": 0.4896532265760787,"terrain": "text4","treeIndex": 1},
				{"q": 2,"r": -10,"height": -0.3855944549875463,"terrain": "text4"},
				{"q": 2,"r": -9,"height": -0.1976989338891303,"terrain": "text2"},
				{"q": 2,"r": -8,"height": 0.15358118313817357,"terrain": "text5"},
				{"q": 2,"r": -7,"height": 0.5823528541779482,"terrain": "text6","treeIndex": 1},
				{"q": 2,"r": -6,"height": 0.9549617949287241,"terrain": "mountain"},
				{"q": 2,"r": -5,"height": 1.2048336652852716,"terrain": "mountain"},
				{"q": 2,"r": -4,"height": 1.398780889560201,"terrain": "mountain"},
				{"q": 2,"r": -3,"height": 1.515330710024362,"terrain": "mountain"},
				{"q": 2,"r": -2,"height": 1.4370740404673592,"terrain": "mountain"},
				{"q": 2,"r": -1,"height": 1.1541175695984747,"terrain": "mountain"},
				{"q": 3,"r": 0,"height": 0.5582435098668794,"terrain": "text2","treeIndex": 1},
				{"q": 3,"r": 1,"height": 0.3779335259496043,"terrain": "text5"},
				{"q": 3,"r": 2,"height": 0.17613597369448744,"terrain": "text6","treeIndex": 1},
				{"q": 3,"r": 3,"height": 0.13085178047999996,"terrain": "text3"},
				{"q": 3,"r": 4,"height": 0.3171235873048298,"terrain": "text3","treeIndex": 0},
				{"q": 3,"r": 5,"height": 0.6588219941063719,"terrain": "text4","treeIndex": 1},
				{"q": 3,"r": 6,"height": 1.0074389504736179,"terrain": "mountain"},
				{"q": 3,"r": 7,"height": 1.2106496020978916,"terrain": "mountain"},
				{"q": 3,"r": 8,"height": 1.1274620414058267,"terrain": "mountain"},
				{"q": 3,"r": 9,"height": 0.8945131962995964,"terrain": "mountain"},
				{"q": 3,"r": -10,"height": -0.10405739937869984,"terrain": "text3"},
				{"q": 3,"r": -9,"height": 0.008358730767917155,"terrain": "text4"},
				{"q": 3,"r": -8,"height": 0.3131491874978683,"terrain": "text2","treeIndex": 1},
				{"q": 3,"r": -7,"height": 0.7515953514824694,"terrain": "mountain"},
				{"q": 3,"r": -6,"height": 1.1164616918133334,"terrain": "mountain"},
				{"q": 3,"r": -5,"height": 1.1897324182716051,"terrain": "mountain"},
				{"q": 3,"r": -4,"height": 1.1036818972987654,"terrain": "mountain"},
				{"q": 3,"r": -3,"height": 0.9443355667200002,"terrain": "mountain"},
				{"q": 3,"r": -2,"height": 0.7762356108612346,"terrain": "mountain"},
				{"q": 3,"r": -1,"height": 0.6509144910261724,"terrain": "text2"},
				{"q": 4,"r": 0,"height": 0.2304415176461766,"terrain": "text7"},
				{"q": 4,"r": 1,"height": 0.24178814474679672,"terrain": "text6"},
				{"q": 4,"r": 2,"height": 0.04478531970396907,"terrain": "text5","treeIndex": 0},
				{"q": 4,"r": 3,"height": -0.10094358335910235,"terrain": "text5"},
				{"q": 4,"r": 4,"height": 0.046165092933946966,"terrain": "text1"},
				{"q": 4,"r": 5,"height": 0.4930199984038541,"terrain": "text6"},
				{"q": 4,"r": 6,"height": 1.0349704076414707,"terrain": "mountain"},
				{"q": 4,"r": 7,"height": 1.418755652708905,"terrain": "mountain"},
				{"q": 4,"r": 8,"height": 1.3828359645422192,"terrain": "mountain"},
				{"q": 4,"r": 9,"height": 1.0610528650835487,"terrain": "mountain"},
				{"q": 4,"r": -10,"height": 0.303953951087645,"terrain": "text2"},
				{"q": 4,"r": -9,"height": 0.3128198978256882,"terrain": "text1","treeIndex": 0},
				{"q": 4,"r": -8,"height": 0.4631291027610661,"terrain": "text7","treeIndex": 0},
				{"q": 4,"r": -7,"height": 0.751851981993692,"terrain": "mountain"},
				{"q": 4,"r": -6,"height": 0.9555953781781064,"terrain": "mountain"},
				{"q": 4,"r": -5,"height": 0.8179901112162776,"terrain": "mountain"},
				{"q": 4,"r": -4,"height": 0.4984937862095981,"terrain": "text5"},
				{"q": 4,"r": -3,"height": 0.17049940743670733,"terrain": "text6","treeIndex": 1},
				{"q": 4,"r": -2,"height": 0.007100429662307145,"terrain": "text5"},
				{"q": 4,"r": -1,"height": 0.0611181864896104,"terrain": "text5"},
				{"q": 5,"r": 0,"height": 0.14086127592779785,"terrain": "text3"},
				{"q": 5,"r": 1,"height": 0.2115424024641615,"terrain": "text5","treeIndex": 0},
				{"q": 5,"r": 2,"height": -0.09396282227012995,"terrain": "text6"},
				{"q": 5,"r": 3,"height": -0.4426892839160657,"terrain": "text6"},
				{"q": 5,"r": 4,"height": -0.43880786581318876,"terrain": "text5"},
				{"q": 5,"r": 5,"height": 0.005705669232332469,"terrain": "text5","treeIndex": 1},
				{"q": 5,"r": 6,"height": 0.6432494067200882,"terrain": "text2","treeIndex": 1},
				{"q": 5,"r": 7,"height": 1.1865945231485064,"terrain": "mountain"},
				{"q": 5,"r": 8,"height": 1.2942098181189665,"terrain": "mountain"},
				{"q": 5,"r": -10,"height": 0.6526162575551582,"terrain": "text7"},
				{"q": 5,"r": -9,"height": 0.6035627585970584,"terrain": "text3","treeIndex": 1},
				{"q": 5,"r": -8,"height": 0.588396405667835,"terrain": "text2","treeIndex": 1},
				{"q": 5,"r": -7,"height": 0.6317489882152112,"terrain": "text4"},
				{"q": 5,"r": -6,"height": 0.5900086272427989,"terrain": "text5","treeIndex": 1},
				{"q": 5,"r": -5,"height": 0.31114056228725295,"terrain": "text4","treeIndex": 1},
				{"q": 5,"r": -4,"height": -0.05256433153939977,"terrain": "text3"},
				{"q": 5,"r": -3,"height": -0.332781464526749,"terrain": "text5"},
				{"q": 5,"r": -2,"height": -0.3747115245272571,"terrain": "text4"},
				{"q": 5,"r": -1,"height": -0.17193124818299016,"terrain": "text5"},
				{"q": 6,"r": 0,"height": 0.3638354245845643,"terrain": "text3","treeIndex": 1},
				{"q": 6,"r": 1,"height": 0.38113829895397666,"terrain": "text4"},
				{"q": 6,"r": 2,"height": -0.10339987659661358,"terrain": "text6"},
				{"q": 6,"r": 3,"height": -0.6966761541225036,"terrain": "text1"},
				{"q": 6,"r": 4,"height": -0.8899250060062867,"terrain": "text3"},
				{"q": 6,"r": 5,"height": -0.5345791021933394,"terrain": "text4"},
				{"q": 6,"r": 6,"height": 0.09553371135999997,"terrain": "text2"},
				{"q": 6,"r": -10,"height": 0.8792594563899281,"terrain": "mountain"},
				{"q": 6,"r": -9,"height": 0.8151527104967481,"terrain": "mountain"},
				{"q": 6,"r": -8,"height": 0.6469090810416461,"terrain": "text4","treeIndex": 1},
				{"q": 6,"r": -7,"height": 0.418633595628313,"terrain": "text2","treeIndex": 0},
				{"q": 6,"r": -6,"height": 0.13587240447999993,"terrain": "text3"},
				{"q": 6,"r": -5,"height": -0.1972679379835386,"terrain": "text4"},
				{"q": 6,"r": -4,"height": -0.43060555841316794,"terrain": "text1"},
				{"q": 6,"r": -3,"height": -0.479143813573333,"terrain": "text6"},
				{"q": 6,"r": -2,"height": -0.3157817071776128,"terrain": "text5"},
				{"q": 6,"r": -1,"height": 0.011620818259609783,"terrain": "text4","treeIndex": 1},
				{"q": 7,"r": 0,"height": 0.7379696986801939,"terrain": "text5"},
				{"q": 7,"r": 1,"height": 0.6056560872275885,"terrain": "text4","treeIndex": 1},
				{"q": 7,"r": 2,"height": -0.012944075501554117,"terrain": "text5"},
				{"q": 7,"r": 3,"height": -0.7081746813772244,"terrain": "text7"},
				{"q": 7,"r": 4,"height": -1.003543909525888,"terrain": "text3"},
				{"q": 7,"r": -10,"height": 1.0269677868484313,"terrain": "mountain"},
				{"q": 7,"r": -9,"height": 1.0249292894182718,"terrain": "mountain"},
				{"q": 7,"r": -8,"height": 0.7734704700414204,"terrain": "mountain"},
				{"q": 7,"r": -7,"height": 0.31596938014369336,"terrain": "text2"},
				{"q": 7,"r": -6,"height": -0.1802656371285598,"terrain": "text4"},
				{"q": 7,"r": -5,"height": -0.5393874546441093,"terrain": "text5"},
				{"q": 7,"r": -4,"height": -0.6134101467233084,"terrain": "text3"},
				{"q": 7,"r": -3,"height": -0.372472322106996,"terrain": "text2"},
				{"q": 7,"r": -2,"height": 0.04316505682849603,"terrain": "text3"},
				{"q": 7,"r": -1,"height": 0.4674845908410761,"terrain": "text6","treeIndex": 1},
				{"q": 8,"r": 0,"height": 0.9941450271823749,"terrain": "mountain"},
				{"q": 8,"r": 1,"height": 0.7013038825197555,"terrain": "text2"},
				{"q": 8,"r": 2,"height": 0.08914162597878467,"terrain": "text7","treeIndex": 0},
				{"q": 8,"r": -10,"height": 0.9698565866540951,"terrain": "mountain"},
				{"q": 8,"r": -9,"height": 1.109973757097284,"terrain": "mountain"},
				{"q": 8,"r": -8,"height": 0.9403500453624183,"terrain": "mountain"},
				{"q": 8,"r": -7,"height": 0.453499458987142,"terrain": "text4"},
				{"q": 8,"r": -6,"height": -0.11977143818534985,"terrain": "text5"},
				{"q": 8,"r": -5,"height": -0.4888012666001116,"terrain": "text1"},
				{"q": 8,"r": -4,"height": -0.4799833539533117,"terrain": "text6"},
				{"q": 8,"r": -3,"height": -0.05872293595153116,"terrain": "text3"},
				{"q": 8,"r": -2,"height": 0.5001871554327836,"terrain": "text6"},
				{"q": 8,"r": -1,"height": 0.9023186185910473,"terrain": "mountain"},
				{"q": 9,"r": 0,"height": 1.0677489840134493,"terrain": "mountain"},
				{"q": 9,"r": -10,"height": 0.713020625514403,"terrain": "text3"},
				{"q": 9,"r": -9,"height": 1.0071120059199998,"terrain": "mountain"},
				{"q": 9,"r": -8,"height": 1.032445708406255,"terrain": "mountain"},
				{"q": 9,"r": -7,"height": 0.7123566159855141,"terrain": "text7"},
				{"q": 9,"r": -6,"height": 0.22234743632954024,"terrain": "text1","treeIndex": 0},
				{"q": 9,"r": -5,"height": -0.1250279592476038,"terrain": "text3"},
				{"q": 9,"r": -4,"height": -0.09307984409839604,"terrain": "text1"},
				{"q": 9,"r": -3,"height": 0.3667064021202449,"terrain": "text2","treeIndex": 1},
				{"q": 9,"r": -2,"height": 0.8935957576771139,"terrain": "mountain"},
				{"q": 9,"r": -1,"height": 1.1572046689387208,"terrain": "mountain"},
				{"q": 10,"r": -10,"height": 0.44556216023980066,"terrain": "text2"},
				{"q": 10,"r": -9,"height": 0.8096527119753085,"terrain": "mountain"},
				{"q": 10,"r": -8,"height": 0.9889053914520063,"terrain": "mountain"},
				{"q": 10,"r": -7,"height": 0.8777136829449474,"terrain": "mountain"},
				{"q": 10,"r": -6,"height": 0.5591374584811204,"terrain": "text2"},
				{"q": 10,"r": -5,"height": 0.28790653534730143,"terrain": "text3","treeIndex": 0},
				{"q": 10,"r": -4,"height": 0.3291560071998991,"terrain": "text6","treeIndex": 0},
				{"q": 10,"r": -3,"height": 0.720047029889932,"terrain": "text3","treeIndex": 0},
				{"q": 10,"r": -2,"height": 1.1043507248273128,"terrain": "mountain"},
				{"q": 11,"r": -10,"height": 0.2632550391708582,"terrain": "text2","treeIndex": 0},
				{"q": 11,"r": -9,"height": 0.6310166279816587,"terrain": "text3","treeIndex": 0},
				{"q": 11,"r": -8,"height": 0.9120418273048965,"terrain": "mountain"},
				{"q": 11,"r": -7,"height": 0.9862594778623788,"terrain": "mountain"},
				{"q": 11,"r": -6,"height": 0.8292388293851691,"terrain": "mountain"},
				{"q": 11,"r": -5,"height": 0.6117881794633185,"terrain": "text2","treeIndex": 0},
				{"q": 11,"r": -4,"height": 0.5983969477308071,"terrain": "text3"},
				{"q": 12,"r": -10,"height": 0.2702940580254289,"terrain": "text2"},
				{"q": 12,"r": -9,"height": 0.6391276206210712,"terrain": "text7","treeIndex": 1},
				{"q": 12,"r": -8,"height": 1.0108518416348138,"terrain": "mountain"},
				{"q": 12,"r": -7,"height": 1.194340480837285,"terrain": "mountain"},
				{"q": 12,"r": -6,"height": 1.084039030521116,"terrain": "mountain"},
				{"q": 13,"r": -10,"height": 0.3165934088674928,"terrain": "text5"},
				{"q": 13,"r": -9,"height": 0.7355064025447222,"terrain": "text1","treeIndex": 0},
				{"q": 13,"r": -8,"height": 1.1738018996078634,"terrain": "mountain"},
				{"q": 14,"r": -10,"height": 0.173097881660633,"terrain": "text4","treeIndex": 0},
				{"q": -5,"r": 0,"height": -0.13725178371141677,"terrain": "text7"},
				{"q": -5,"r": 1,"height": 0.2653488979853632,"terrain": "text2","treeIndex": 1},
				{"q": -5,"r": 2,"height": 0.7635440469901071,"terrain": "mountain"},
				{"q": -5,"r": 3,"height": 0.9843057373213288,"terrain": "mountain"},
				{"q": -5,"r": 4,"height": 0.8371284644920263,"terrain": "mountain"},
				{"q": -5,"r": 5,"height": 0.5021385011620847,"terrain": "text4","treeIndex": 1},
				{"q": -5,"r": 6,"height": 0.07558635161949662,"terrain": "text3","treeIndex": 1},
				{"q": -5,"r": 7,"height": -0.2827191722066905,"terrain": "text1"},
				{"q": -5,"r": 8,"height": -0.4289776509477073,"terrain": "text3"},
				{"q": -5,"r": 9,"height": -0.4601549023108028,"terrain": "text2"},
				{"q": -5,"r": -10,"height": 0.33037575200352914,"terrain": "text4"},
				{"q": -5,"r": -9,"height": -0.007986111389688355,"terrain": "text2"},
				{"q": -5,"r": -8,"height": -0.326355725962503,"terrain": "text1"},
				{"q": -5,"r": -7,"height": -0.4036059276101369,"terrain": "text1"},
				{"q": -5,"r": -6,"height": -0.1476315807000064,"terrain": "text1"},
				{"q": -5,"r": -5,"height": 0.35385171062462534,"terrain": "text4"},
				{"q": -5,"r": -4,"height": 0.7162953224574472,"terrain": "text3"},
				{"q": -5,"r": -3,"height": 0.6202957454292686,"terrain": "text1"},
				{"q": -5,"r": -2,"height": 0.18119722351869083,"terrain": "text4","treeIndex": 0},
				{"q": -5,"r": -1,"height": -0.18376202685233442,"terrain": "text3"},
				{"q": -6,"r": 0,"height": -0.4113797967028339,"terrain": "text7"},
				{"q": -6,"r": 1,"height": 0.04923266965251946,"terrain": "text4"},
				{"q": -6,"r": 2,"height": 0.6544022444283606,"terrain": "text2","treeIndex": 0},
				{"q": -6,"r": 3,"height": 0.9845647450359494,"terrain": "mountain"},
				{"q": -6,"r": 4,"height": 0.8957606644061573,"terrain": "mountain"},
				{"q": -6,"r": 5,"height": 0.5578707325069493,"terrain": "text5","treeIndex": 1},
				{"q": -6,"r": 6,"height": 0.1310979392029586,"terrain": "text1","treeIndex": 0},
				{"q": -6,"r": 7,"height": -0.17016456571957417,"terrain": "text3"},
				{"q": -6,"r": 8,"height": -0.21750619376098645,"terrain": "text1"},
				{"q": -6,"r": 9,"height": -0.16172194386652664,"terrain": "text5"},
				{"q": -6,"r": -9,"height": -0.19184874218165338,"terrain": "text5"},
				{"q": -6,"r": -8,"height": -0.4091625425174573,"terrain": "text2"},
				{"q": -6,"r": -7,"height": -0.4091110347997811,"terrain": "text6"},
				{"q": -6,"r": -6,"height": -0.11208882877666156,"terrain": "text3"},
				{"q": -6,"r": -5,"height": 0.3954798177896297,"terrain": "text6","treeIndex": 0},
				{"q": -6,"r": -4,"height": 0.7333301955061804,"terrain": "text1"},
				{"q": -6,"r": -3,"height": 0.541487627925068,"terrain": "text6"},
				{"q": -6,"r": -2,"height": -0.022736046529762535,"terrain": "text3"},
				{"q": -6,"r": -1,"height": -0.46288504759503146,"terrain": "text4"},
				{"q": -7,"r": 0,"height": -0.932971370860181,"terrain": "text7"},
				{"q": -7,"r": 1,"height": -0.4890300014786224,"terrain": "text5"},
				{"q": -7,"r": 2,"height": 0.14481621494869262,"terrain": "text3","treeIndex": 1},
				{"q": -7,"r": 3,"height": 0.6062298125795469,"terrain": "text2"},
				{"q": -7,"r": 4,"height": 0.7007265893014378,"terrain": "text3","treeIndex": 1},
				{"q": -7,"r": 5,"height": 0.536199799954745,"terrain": "text3","treeIndex": 1},
				{"q": -7,"r": 6,"height": 0.26951551921614314,"terrain": "text6","treeIndex": 0},
				{"q": -7,"r": 7,"height": 0.03474370911458968,"terrain": "text6"},
				{"q": -7,"r": 8,"height": -0.05277541234691202,"terrain": "text5"},
				{"q": -7,"r": 9,"height": -0.0656787873285069,"terrain": "text6"},
				{"q": -7,"r": -7,"height": -0.23031131469822547,"terrain": "text5"},
				{"q": -7,"r": -6,"height": 0.09552016878964537,"terrain": "text5","treeIndex": 1},
				{"q": -7,"r": -5,"height": 0.48904003616985264,"terrain": "text2"},
				{"q": -7,"r": -4,"height": 0.6702785465536837,"terrain": "text5"},
				{"q": -7,"r": -3,"height": 0.289256550217903,"terrain": "text7","treeIndex": 0},
				{"q": -7,"r": -2,"height": -0.4306111989869931,"terrain": "text7"},
				{"q": -7,"r": -1,"height": -0.9501075905594196,"terrain": "text6"},
				{"q": -8,"r": 0,"height": -1.2698662696778604,"terrain": "text6"},
				{"q": -8,"r": 1,"height": -0.9195782944799997,"terrain": "text1"},
				{"q": -8,"r": 2,"height": -0.4039631301389488,"terrain": "text3"},
				{"q": -8,"r": 3,"height": 0.05009984849144844,"terrain": "text4","treeIndex": 1},
				{"q": -8,"r": 4,"height": 0.3074370064680485,"terrain": "text4"},
				{"q": -8,"r": 5,"height": 0.42135601736424244,"terrain": "text3","treeIndex": 1},
				{"q": -8,"r": 6,"height": 0.4201567487518708,"terrain": "text6"},
				{"q": -8,"r": 7,"height": 0.26815039372711175,"terrain": "text5"},
				{"q": -8,"r": 8,"height": 0.0694999137737432,"terrain": "text6"},
				{"q": -8,"r": 9,"height": -0.10239491170869738,"terrain": "text4"},
				{"q": -8,"r": -5,"height": 0.5209385962547176,"terrain": "text7","treeIndex": 1},
				{"q": -8,"r": -4,"height": 0.4983735746749835,"terrain": "text4","treeIndex": 1},
				{"q": -8,"r": -3,"height": -0.021161129641434087,"terrain": "text2"},
				{"q": -8,"r": -2,"height": -0.7655109049246129,"terrain": "text7"},
				{"q": -8,"r": -1,"height": -1.2559425719396395,"terrain": "text1"},
				{"q": -9,"r": 0,"height": -1.2370628192508482,"terrain": "text5"},
				{"q": -9,"r": 1,"height": -1.0275246888487026,"terrain": "text4"},
				{"q": -9,"r": 2,"height": -0.719295786637772,"terrain": "text5"},
				{"q": -9,"r": 3,"height": -0.4043141089991903,"terrain": "text2"},
				{"q": -9,"r": 4,"height": -0.10172387715209469,"terrain": "text5"},
				{"q": -9,"r": 5,"height": 0.23686693270414202,"terrain": "text2","treeIndex": 0},
				{"q": -9,"r": 6,"height": 0.4861878948323606,"terrain": "text7"},
				{"q": -9,"r": 7,"height": 0.45353250807498957,"terrain": "text6","treeIndex": 0},
				{"q": -9,"r": 8,"height": 0.21287667688649542,"terrain": "text4","treeIndex": 1},
				{"q": -9,"r": 9,"height": -0.06841522115071166,"terrain": "text2"},
				{"q": -9,"r": -3,"height": -0.18584637180959668,"terrain": "text4"},
				{"q": -9,"r": -2,"height": -0.8096328059298739,"terrain": "text5"},
				{"q": -9,"r": -1,"height": -1.1881011885298305,"terrain": "text4"},
				{"q": -10,"r": 0,"height": -0.9650613672130851,"terrain": "text5"},
				{"q": -10,"r": 1,"height": -0.8741748147269405,"terrain": "text5"},
				{"q": -10,"r": 2,"height": -0.7564767207089611,"terrain": "text3"},
				{"q": -10,"r": 3,"height": -0.6249151369822776,"terrain": "text6"},
				{"q": -10,"r": 4,"height": -0.38748083415236767,"terrain": "text2"},
				{"q": -10,"r": 5,"height": 0.034312879474421104,"terrain": "text2","treeIndex": 1},
				{"q": -10,"r": 6,"height": 0.43400779155449903,"terrain": "text4","treeIndex": 1},
				{"q": -10,"r": 7,"height": 0.5473806946295734,"terrain": "text5"},
				{"q": -10,"r": 8,"height": 0.39306436411747675,"terrain": "text5"},
				{"q": -10,"r": 9,"height": 0.12660253913580216,"terrain": "text6","treeIndex": 0},
				{"q": -10,"r": -1,"height": -0.886600468610418,"terrain": "text4"},
				{"q": -11,"r": 1,"height": -0.612398852621118,"terrain": "text3"},
				{"q": -11,"r": 2,"height": -0.6668082950761528,"terrain": "text6"},
				{"q": -11,"r": 3,"height": -0.7243213151126815,"terrain": "text5"},
				{"q": -11,"r": 4,"height": -0.5985431650339541,"terrain": "text4"},
				{"q": -11,"r": 5,"height": -0.1893604596380477,"terrain": "text6"},
				{"q": -11,"r": 6,"height": 0.277477341910883,"terrain": "text3","treeIndex": 0},
				{"q": -11,"r": 7,"height": 0.5280434046423123,"terrain": "text3"},
				{"q": -11,"r": 8,"height": 0.5133665172210056,"terrain": "text6","treeIndex": 0},
				{"q": -11,"r": 9,"height": 0.3299798584730863,"terrain": "text2"},
				{"q": -12,"r": 3,"height": -0.7815101412352483,"terrain": "text1"},
				{"q": -12,"r": 4,"height": -0.7139179098128359,"terrain": "text2"},
				{"q": -12,"r": 5,"height": -0.3939007290680815,"terrain": "text3"},
				{"q": -12,"r": 6,"height": 0.0341757516467556,"terrain": "text6"},
				{"q": -12,"r": 7,"height": 0.3806092921448029,"terrain": "text3"},
				{"q": -12,"r": 8,"height": 0.5232206543855142,"terrain": "text7"},
				{"q": -12,"r": 9,"height": 0.44752582084070247,"terrain": "text5"},
				{"q": -13,"r": 5,"height": -0.4747896721747571,"terrain": "text6"},
				{"q": -13,"r": 6,"height": -0.15040612099981743,"terrain": "text7"},
				{"q": -13,"r": 7,"height": 0.2124308534732469,"terrain": "text2","treeIndex": 1},
				{"q": -13,"r": 8,"height": 0.4455021919767562,"terrain": "text4","treeIndex": 0},
				{"q": -13,"r": 9,"height": 0.4195097398345949,"terrain": "text4"},
				{"q": -14,"r": 7,"height": 0.1997641313647895,"terrain": "text2"},
				{"q": -14,"r": 8,"height": 0.3811285096434154,"terrain": "text3","treeIndex": 0},
				{"q": -14,"r": 9,"height": 0.2934706262802977,"terrain": "text3","treeIndex": 1},
				{"q": -15,"r": 9,"height": 0.1921823836823106,"terrain": "text3"},
				{"q": -4,"r": 0,"height": -0.226291874638878,"terrain": "text3"},
				{"q": -4,"r": 1,"height": 0.03496447518696852,"terrain": "text2"},
				{"q": -4,"r": 2,"height": 0.41233191993234986,"terrain": "text5"},
				{"q": -4,"r": 3,"height": 0.6351247126027312,"terrain": "text1"},
				{"q": -4,"r": 4,"height": 0.6096086366051681,"terrain": "text7","treeIndex": 1},
				{"q": -4,"r": 5,"height": 0.4228578590567646,"terrain": "text3"},
				{"q": -4,"r": 6,"height": 0.08556703636204296,"terrain": "text5","treeIndex": 0},
				{"q": -4,"r": 7,"height": -0.31136377059075704,"terrain": "text2"},
				{"q": -4,"r": 8,"height": -0.6221371613500913,"terrain": "text3"},
				{"q": -4,"r": 9,"height": -0.8135598778189553,"terrain": "text4"},
				{"q": -4,"r": -10,"height": 0.5181132872659251,"terrain": "text5","treeIndex": 1},
				{"q": -4,"r": -9,"height": 0.17653135203901807,"terrain": "text3"},
				{"q": -4,"r": -8,"height": -0.18485823376489224,"terrain": "text3"},
				{"q": -4,"r": -7,"height": -0.32826451501199405,"terrain": "text6"},
				{"q": -4,"r": -6,"height": -0.15138416561811469,"terrain": "text6"},
				{"q": -4,"r": -5,"height": 0.2713719511143176,"terrain": "text4","treeIndex": 1},
				{"q": -4,"r": -4,"height": 0.5931220029675275,"terrain": "text6"},
				{"q": -4,"r": -3,"height": 0.5356993166521155,"terrain": "text1"},
				{"q": -4,"r": -2,"height": 0.16745270468067483,"terrain": "text4"},
				{"q": -4,"r": -1,"height": -0.1859041682657548,"terrain": "text3"},
				{"q": -3,"r": 0,"height": -0.556984182781706,"terrain": "text1"},
				{"q": -3,"r": 1,"height": -0.5464847341558313,"terrain": "text6"},
				{"q": -3,"r": 2,"height": -0.28976311041044656,"terrain": "text4"},
				{"q": -3,"r": 3,"height": 0.05532343597073247,"terrain": "text6"},
				{"q": -3,"r": 4,"height": 0.3081359256480779,"terrain": "text3"},
				{"q": -3,"r": 5,"height": 0.3655142690580324,"terrain": "text1","treeIndex": 1},
				{"q": -3,"r": 6,"height": 0.1421297125610919,"terrain": "text5"},
				{"q": -3,"r": 7,"height": -0.30520833538160497,"terrain": "text3"},
				{"q": -3,"r": 8,"height": -0.7743615793725742,"terrain": "text6"},
				{"q": -3,"r": 9,"height": -1.1049118583119044,"terrain": "text6"},
				{"q": -3,"r": -10,"height": 0.5669750861064478,"terrain": "text2","treeIndex": 1},
				{"q": -3,"r": -9,"height": 0.24760832155527981,"terrain": "text2","treeIndex": 0},
				{"q": -3,"r": -8,"height": -0.13490537004044467,"terrain": "text5"},
				{"q": -3,"r": -7,"height": -0.35015709623524566,"terrain": "text4"},
				{"q": -3,"r": -6,"height": -0.2706074396351936,"terrain": "text2"},
				{"q": -3,"r": -5,"height": 0.06939731786295064,"terrain": "text2","treeIndex": 1},
				{"q": -3,"r": -4,"height": 0.3693018399273056,"terrain": "text2"},
				{"q": -3,"r": -3,"height": 0.3920731757263885,"terrain": "text4","treeIndex": 0},
				{"q": -3,"r": -2,"height": 0.09620103637025992,"terrain": "text6"},
				{"q": -3,"r": -1,"height": -0.3148965159736801,"terrain": "text3"},
				{"q": -2,"r": 0,"height": -0.7696801135806249,"terrain": "text4"},
				{"q": -2,"r": 1,"height": -1.0448868263941493,"terrain": "text5"},
				{"q": -2,"r": 2,"height": -0.9191886856892167,"terrain": "text3"},
				{"q": -2,"r": 3,"height": -0.45282454775302006,"terrain": "text5"},
				{"q": -2,"r": 4,"height": 0.06356048038191939,"terrain": "text5"},
				{"q": -2,"r": 5,"height": 0.3224697531331805,"terrain": "text2"},
				{"q": -2,"r": 6,"height": 0.1914130633086851,"terrain": "text3"},
				{"q": -2,"r": 7,"height": -0.2603262930170941,"terrain": "text3"},
				{"q": -2,"r": 8,"height": -0.7560059575301032,"terrain": "text6"},
				{"q": -2,"r": 9,"height": -1.1121722725876306,"terrain": "text6"},
				{"q": -2,"r": -10,"height": 0.3510077669317056,"terrain": "text3"},
				{"q": -2,"r": -9,"height": 0.09486874786560104,"terrain": "text4","treeIndex": 1},
				{"q": -2,"r": -8,"height": -0.21903573656344594,"terrain": "text3"},
				{"q": -2,"r": -7,"height": -0.41855220275469507,"terrain": "text2"},
				{"q": -2,"r": -6,"height": -0.37103988659736786,"terrain": "text4"},
				{"q": -2,"r": -5,"height": -0.05622880408253894,"terrain": "text1"},
				{"q": -2,"r": -4,"height": 0.2782537328285425,"terrain": "text5","treeIndex": 1},
				{"q": -2,"r": -3,"height": 0.42438876260216873,"terrain": "text5"},
				{"q": -2,"r": -2,"height": 0.20842564070124908,"terrain": "text4","treeIndex": 0},
				{"q": -2,"r": -1,"height": -0.2863474326302257,"terrain": "text3"},
				{"q": -1,"r": 0,"height": -0.5785973045679017,"terrain": "text1"},
				{"q": -1,"r": 1,"height": -1.0632074475718716,"terrain": "text2"},
				{"q": -1,"r": 2,"height": -1.0895412677550695,"terrain": "text4"},
				{"q": -1,"r": 3,"height": -0.650259969523036,"terrain": "text4"},
				{"q": -1,"r": 4,"height": -0.07322831230427763,"terrain": "text1"},
				{"q": -1,"r": 5,"height": 0.2376178161189448,"terrain": "text2","treeIndex": 0},
				{"q": -1,"r": 6,"height": 0.1624221957924003,"terrain": "text4"},
				{"q": -1,"r": 7,"height": -0.19529438431988289,"terrain": "text1"},
				{"q": -1,"r": 8,"height": -0.5690577940047024,"terrain": "text5"},
				{"q": -1,"r": 9,"height": -0.8286475104077501,"terrain": "text1"},
				{"q": -1,"r": -10,"height": -0.04125997178314689,"terrain": "text3"},
				{"q": -1,"r": -9,"height": -0.1781167195289265,"terrain": "text1"},
				{"q": -1,"r": -8,"height": -0.31500623321158217,"terrain": "text2"},
				{"q": -1,"r": -7,"height": -0.38247952143168584,"terrain": "text2"},
				{"q": -1,"r": -6,"height": -0.2731628497930526,"terrain": "text6"},
				{"q": -1,"r": -5,"height": 0.07230224688811183,"terrain": "text4","treeIndex": 1},
				{"q": -1,"r": -4,"height": 0.47053874403470336,"terrain": "text7","treeIndex": 1},
				{"q": -1,"r": -3,"height": 0.7371468615571124,"terrain": "text2"},
				{"q": -1,"r": -2,"height": 0.6057546751402361,"terrain": "text2"},
				{"q": -1,"r": -1,"height": 0.06894763212958602,"terrain": "text3","treeIndex": 1}
			],
			"halfWidth": 10,
			"halfHeight": 10
		}
	},
  "seed_2":{
	"map_id":"seed_2",
	"data": {
		"_width": 20,
		"_height": 20,
		"data": [
			{
				"q": 0,
				"r": 0,
				"height": 0,
				"terrain": "text4"
			},
			{
				"q": 0,
				"r": 1,
				"height": -0.6719500288477367,
				"terrain": "text2"
			},
			{
				"q": 0,
				"r": 2,
				"height": -1.1650773210692211,
				"terrain": "text1"
			},
			{
				"q": 0,
				"r": 3,
				"height": -1.236331282603828,
				"terrain": "text6"
			},
			{
				"q": 0,
				"r": 4,
				"height": -0.9760488329987178,
				"terrain": "text7"
			},
			{
				"q": 0,
				"r": 5,
				"height": -0.6871132618461382,
				"terrain": "text2"
			},
			{
				"q": 0,
				"r": 6,
				"height": -0.4416355761335402,
				"terrain": "text2"
			},
			{
				"q": 0,
				"r": 7,
				"height": -0.23408161059746974,
				"terrain": "text3"
			},
			{
				"q": 0,
				"r": 8,
				"height": -0.09137624330424907,
				"terrain": "text7"
			},
			{
				"q": 0,
				"r": 9,
				"height": -0.014853171273058852,
				"terrain": "text3"
			},
			{
				"q": 0,
				"r": -10,
				"height": 0.6841767741415219,
				"terrain": "text5"
			},
			{
				"q": 0,
				"r": -9,
				"height": 0.8174443495500268,
				"terrain": "mountain"
			},
			{
				"q": 0,
				"r": -8,
				"height": 0.8722358780175616,
				"terrain": "mountain"
			},
			{
				"q": 0,
				"r": -7,
				"height": 0.8107488754398294,
				"terrain": "mountain"
			},
			{
				"q": 0,
				"r": -6,
				"height": 0.6649407564607793,
				"terrain": "text5"
			},
			{
				"q": 0,
				"r": -5,
				"height": 0.5771690078988216,
				"terrain": "text2"
			},
			{
				"q": 0,
				"r": -4,
				"height": 0.6739274506623258,
				"terrain": "text7"
			},
			{
				"q": 0,
				"r": -3,
				"height": 0.9142813218171644,
				"terrain": "mountain"
			},
			{
				"q": 0,
				"r": -2,
				"height": 0.9684201228675089,
				"terrain": "mountain"
			},
			{
				"q": 0,
				"r": -1,
				"height": 0.6252736667078188,
				"terrain": "text3"
			},
			{
				"q": 1,
				"r": 0,
				"height": 0.6719500288477367,
				"terrain": "text4"
			},
			{
				"q": 1,
				"r": 1,
				"height": -0.008112503015006555,
				"terrain": "text3"
			},
			{
				"q": 1,
				"r": 2,
				"height": -0.5909224014273156,
				"terrain": "text5"
			},
			{
				"q": 1,
				"r": 3,
				"height": -0.749780976982521,
				"terrain": "text5"
			},
			{
				"q": 1,
				"r": 4,
				"height": -0.5276358970776888,
				"terrain": "text6"
			},
			{
				"q": 1,
				"r": 5,
				"height": -0.24793703943527864,
				"terrain": "text1"
			},
			{
				"q": 1,
				"r": 6,
				"height": -0.03988967747325639,
				"terrain": "text3"
			},
			{
				"q": 1,
				"r": 7,
				"height": 0.09072795356574037,
				"terrain": "text3"
			},
			{
				"q": 1,
				"r": 8,
				"height": 0.11886213821238778,
				"terrain": "text2"
			},
			{
				"q": 1,
				"r": 9,
				"height": 0.09062952011824504,
				"terrain": "text3"
			},
			{
				"q": 1,
				"r": -10,
				"height": 0.7281135908742691,
				"terrain": "text7"
			},
			{
				"q": 1,
				"r": -9,
				"height": 0.799698249549619,
				"terrain": "mountain"
			},
			{
				"q": 1,
				"r": -8,
				"height": 0.7269577087407371,
				"terrain": "text6"
			},
			{
				"q": 1,
				"r": -7,
				"height": 0.5338237663927715,
				"terrain": "text2"
			},
			{
				"q": 1,
				"r": -6,
				"height": 0.3363332785701695,
				"terrain": "text1"
			},
			{
				"q": 1,
				"r": -5,
				"height": 0.30477643379989355,
				"terrain": "text6"
			},
			{
				"q": 1,
				"r": -4,
				"height": 0.52786891647465,
				"terrain": "text2"
			},
			{
				"q": 1,
				"r": -3,
				"height": 0.9994645772279726,
				"terrain": "mountain"
			},
			{
				"q": 1,
				"r": -2,
				"height": 1.333977162383714,
				"terrain": "mountain"
			},
			{
				"q": 1,
				"r": -1,
				"height": 1.2087978437557985,
				"terrain": "mountain"
			},
			{
				"q": 2,
				"r": 0,
				"height": 1.163027430507266,
				"terrain": "mountain"
			},
			{
				"q": 2,
				"r": 1,
				"height": 0.5576585317339346,
				"terrain": "text6"
			},
			{
				"q": 2,
				"r": 2,
				"height": 0.030286817323251884,
				"terrain": "text6"
			},
			{
				"q": 2,
				"r": 3,
				"height": -0.10779139643711755,
				"terrain": "text2"
			},
			{
				"q": 2,
				"r": 4,
				"height": 0.10876829286227899,
				"terrain": "text5"
			},
			{
				"q": 2,
				"r": 5,
				"height": 0.35398939882349345,
				"terrain": "text5"
			},
			{
				"q": 2,
				"r": 6,
				"height": 0.48442923336078253,
				"terrain": "text5"
			},
			{
				"q": 2,
				"r": 7,
				"height": 0.4830961472518989,
				"terrain": "text5"
			},
			{
				"q": 2,
				"r": 8,
				"height": 0.3333262201440448,
				"terrain": "text4"
			},
			{
				"q": 2,
				"r": 9,
				"height": 0.15181154524215923,
				"terrain": "text1"
			},
			{
				"q": 2,
				"r": -10,
				"height": 0.4175078295534049,
				"terrain": "text6"
			},
			{
				"q": 2,
				"r": -9,
				"height": 0.438667181745286,
				"terrain": "text7"
			},
			{
				"q": 2,
				"r": -8,
				"height": 0.2714529520496867,
				"terrain": "text4"
			},
			{
				"q": 2,
				"r": -7,
				"height": 0.000390406599903359,
				"terrain": "text7"
			},
			{
				"q": 2,
				"r": -6,
				"height": -0.18499730010895865,
				"terrain": "text3"
			},
			{
				"q": 2,
				"r": -5,
				"height": -0.11792476026800633,
				"terrain": "text3"
			},
			{
				"q": 2,
				"r": -4,
				"height": 0.25593359551018224,
				"terrain": "text6"
			},
			{
				"q": 2,
				"r": -3,
				"height": 0.955818811845282,
				"terrain": "mountain"
			},
			{
				"q": 2,
				"r": -2,
				"height": 1.5318774001195579,
				"terrain": "mountain"
			},
			{
				"q": 2,
				"r": -1,
				"height": 1.5895454530427526,
				"terrain": "mountain"
			},
			{
				"q": 3,
				"r": 0,
				"height": 1.2076892675450652,
				"terrain": "mountain"
			},
			{
				"q": 3,
				"r": 1,
				"height": 0.7181207479571129,
				"terrain": "text4"
			},
			{
				"q": 3,
				"r": 2,
				"height": 0.3592432470821685,
				"terrain": "text4"
			},
			{
				"q": 3,
				"r": 3,
				"height": 0.33431137156638824,
				"terrain": "text3"
			},
			{
				"q": 3,
				"r": 4,
				"height": 0.5633024404596954,
				"terrain": "text7"
			},
			{
				"q": 3,
				"r": 5,
				"height": 0.7529463202349398,
				"terrain": "mountain"
			},
			{
				"q": 3,
				"r": 6,
				"height": 0.807087238449469,
				"terrain": "mountain"
			},
			{
				"q": 3,
				"r": 7,
				"height": 0.716942634761409,
				"terrain": "text6"
			},
			{
				"q": 3,
				"r": 8,
				"height": 0.46254404124812565,
				"terrain": "text6"
			},
			{
				"q": 3,
				"r": 9,
				"height": 0.19748750424916794,
				"terrain": "text2"
			},
			{
				"q": 3,
				"r": -10,
				"height": -0.009407000818470235,
				"terrain": "text6"
			},
			{
				"q": 3,
				"r": -9,
				"height": -0.012400991201921174,
				"terrain": "text6"
			},
			{
				"q": 3,
				"r": -8,
				"height": -0.195130382601801,
				"terrain": "text6"
			},
			{
				"q": 3,
				"r": -7,
				"height": -0.43831804516451334,
				"terrain": "text2"
			},
			{
				"q": 3,
				"r": -6,
				"height": -0.5153474016930666,
				"terrain": "text2"
			},
			{
				"q": 3,
				"r": -5,
				"height": -0.28542629411094544,
				"terrain": "text4"
			},
			{
				"q": 3,
				"r": -4,
				"height": 0.22902393436260912,
				"terrain": "text2"
			},
			{
				"q": 3,
				"r": -3,
				"height": 0.9931135722615198,
				"terrain": "mountain"
			},
			{
				"q": 3,
				"r": -2,
				"height": 1.5534304974044817,
				"terrain": "mountain"
			},
			{
				"q": 3,
				"r": -1,
				"height": 1.58795764175995,
				"terrain": "mountain"
			},
			{
				"q": 4,
				"r": 0,
				"height": 0.8669115348585785,
				"terrain": "mountain"
			},
			{
				"q": 4,
				"r": 1,
				"height": 0.46723336368551277,
				"terrain": "text4"
			},
			{
				"q": 4,
				"r": 2,
				"height": 0.2663524480917683,
				"terrain": "text1"
			},
			{
				"q": 4,
				"r": 3,
				"height": 0.35530931870919835,
				"terrain": "text2"
			},
			{
				"q": 4,
				"r": 4,
				"height": 0.5847936237601624,
				"terrain": "text6"
			},
			{
				"q": 4,
				"r": 5,
				"height": 0.7092613442899718,
				"terrain": "text3"
			},
			{
				"q": 4,
				"r": 6,
				"height": 0.7246505005501409,
				"terrain": "text3"
			},
			{
				"q": 4,
				"r": 7,
				"height": 0.6608754360736458,
				"terrain": "text3"
			},
			{
				"q": 4,
				"r": 8,
				"height": 0.4660845334958591,
				"terrain": "text3"
			},
			{
				"q": 4,
				"r": 9,
				"height": 0.2609207685689946,
				"terrain": "text4"
			},
			{
				"q": 4,
				"r": -10,
				"height": -0.21778384174455157,
				"terrain": "text4"
			},
			{
				"q": 4,
				"r": -9,
				"height": -0.22230108443221858,
				"terrain": "text2"
			},
			{
				"q": 4,
				"r": -8,
				"height": -0.3627741156207879,
				"terrain": "text3"
			},
			{
				"q": 4,
				"r": -7,
				"height": -0.5117292093771351,
				"terrain": "text6"
			},
			{
				"q": 4,
				"r": -6,
				"height": -0.406704478499895,
				"terrain": "text7"
			},
			{
				"q": 4,
				"r": -5,
				"height": 0.025106958137005586,
				"terrain": "text4"
			},
			{
				"q": 4,
				"r": -4,
				"height": 0.610164964086217,
				"terrain": "text5"
			},
			{
				"q": 4,
				"r": -3,
				"height": 1.2155200280517477,
				"terrain": "mountain"
			},
			{
				"q": 4,
				"r": -2,
				"height": 1.4799827295264072,
				"terrain": "mountain"
			},
			{
				"q": 4,
				"r": -1,
				"height": 1.2843860149134925,
				"terrain": "mountain"
			},
			{
				"q": 5,
				"r": 0,
				"height": 0.43435564943601673,
				"terrain": "text3"
			},
			{
				"q": 5,
				"r": 1,
				"height": 0.07170228435699386,
				"terrain": "text3"
			},
			{
				"q": 5,
				"r": 2,
				"height": -0.0606141874082516,
				"terrain": "text5"
			},
			{
				"q": 5,
				"r": 3,
				"height": 0.055912235558423715,
				"terrain": "text3"
			},
			{
				"q": 5,
				"r": 4,
				"height": 0.2423357269614952,
				"terrain": "text4"
			},
			{
				"q": 5,
				"r": 5,
				"height": 0.3025006875336329,
				"terrain": "text2"
			},
			{
				"q": 5,
				"r": 6,
				"height": 0.31540780132872437,
				"terrain": "text4"
			},
			{
				"q": 5,
				"r": 7,
				"height": 0.3747241290418743,
				"terrain": "text5"
			},
			{
				"q": 5,
				"r": 8,
				"height": 0.36813262155573895,
				"terrain": "text6"
			},
			{
				"q": 5,
				"r": -10,
				"height": -0.1413375267376214,
				"terrain": "text3"
			},
			{
				"q": 5,
				"r": -9,
				"height": -0.10719908195366629,
				"terrain": "text7"
			},
			{
				"q": 5,
				"r": -8,
				"height": -0.1838300409728842,
				"terrain": "text3"
			},
			{
				"q": 5,
				"r": -7,
				"height": -0.22887443864041473,
				"terrain": "text2"
			},
			{
				"q": 5,
				"r": -6,
				"height": 0.02564151062810177,
				"terrain": "text3"
			},
			{
				"q": 5,
				"r": -5,
				"height": 0.5880914038488932,
				"terrain": "text5"
			},
			{
				"q": 5,
				"r": -4,
				"height": 1.1573128870686855,
				"terrain": "mountain"
			},
			{
				"q": 5,
				"r": -3,
				"height": 1.5041884982675773,
				"terrain": "mountain"
			},
			{
				"q": 5,
				"r": -2,
				"height": 1.398632368092807,
				"terrain": "mountain"
			},
			{
				"q": 5,
				"r": -1,
				"height": 0.9292474919042227,
				"terrain": "mountain"
			},
			{
				"q": 6,
				"r": 0,
				"height": -0.034288594574171355,
				"terrain": "text5"
			},
			{
				"q": 6,
				"r": 1,
				"height": -0.37463907908161165,
				"terrain": "text7"
			},
			{
				"q": 6,
				"r": 2,
				"height": -0.4653387400913592,
				"terrain": "text6"
			},
			{
				"q": 6,
				"r": 3,
				"height": -0.3397731919551933,
				"terrain": "text2"
			},
			{
				"q": 6,
				"r": 4,
				"height": -0.1981062259229705,
				"terrain": "text4"
			},
			{
				"q": 6,
				"r": 5,
				"height": -0.19667401691399755,
				"terrain": "text2"
			},
			{
				"q": 6,
				"r": 6,
				"height": -0.17488337597666073,
				"terrain": "text4"
			},
			{
				"q": 6,
				"r": -10,
				"height": -0.053458472390149614,
				"terrain": "text4"
			},
			{
				"q": 6,
				"r": -9,
				"height": 0.0828492273924103,
				"terrain": "text4"
			},
			{
				"q": 6,
				"r": -8,
				"height": 0.11530035283140722,
				"terrain": "text6"
			},
			{
				"q": 6,
				"r": -7,
				"height": 0.19155407726590393,
				"terrain": "text2"
			},
			{
				"q": 6,
				"r": -6,
				"height": 0.5315067384372002,
				"terrain": "text5"
			},
			{
				"q": 6,
				"r": -5,
				"height": 1.0923078692521804,
				"terrain": "mountain"
			},
			{
				"q": 6,
				"r": -4,
				"height": 1.5529073336877584,
				"terrain": "mountain"
			},
			{
				"q": 6,
				"r": -3,
				"height": 1.640252427635125,
				"terrain": "mountain"
			},
			{
				"q": 6,
				"r": -2,
				"height": 1.2198551019384534,
				"terrain": "mountain"
			},
			{
				"q": 6,
				"r": -1,
				"height": 0.5270805002403511,
				"terrain": "text5"
			},
			{
				"q": 7,
				"r": 0,
				"height": -0.532672801657313,
				"terrain": "text7"
			},
			{
				"q": 7,
				"r": 1,
				"height": -0.8164105042798121,
				"terrain": "text7"
			},
			{
				"q": 7,
				"r": 2,
				"height": -0.8296857062149923,
				"terrain": "text4"
			},
			{
				"q": 7,
				"r": 3,
				"height": -0.6304900768807906,
				"terrain": "text3"
			},
			{
				"q": 7,
				"r": 4,
				"height": -0.4511493678525401,
				"terrain": "text7"
			},
			{
				"q": 7,
				"r": -10,
				"height": -0.1470597757033631,
				"terrain": "text6"
			},
			{
				"q": 7,
				"r": -9,
				"height": 0.07962313851846814,
				"terrain": "text6"
			},
			{
				"q": 7,
				"r": -8,
				"height": 0.23681515517877974,
				"terrain": "text3"
			},
			{
				"q": 7,
				"r": -7,
				"height": 0.44126969646161124,
				"terrain": "text4"
			},
			{
				"q": 7,
				"r": -6,
				"height": 0.8014134937410453,
				"terrain": "mountain"
			},
			{
				"q": 7,
				"r": -5,
				"height": 1.21829113144207,
				"terrain": "mountain"
			},
			{
				"q": 7,
				"r": -4,
				"height": 1.4654348978592215,
				"terrain": "mountain"
			},
			{
				"q": 7,
				"r": -3,
				"height": 1.3434433031548285,
				"terrain": "mountain"
			},
			{
				"q": 7,
				"r": -2,
				"height": 0.7749574622740635,
				"terrain": "mountain"
			},
			{
				"q": 7,
				"r": -1,
				"height": 0.016934345266140294,
				"terrain": "text2"
			},
			{
				"q": 8,
				"r": 0,
				"height": -0.8120569931419054,
				"terrain": "text7"
			},
			{
				"q": 8,
				"r": 1,
				"height": -0.9927885390052644,
				"terrain": "text5"
			},
			{
				"q": 8,
				"r": 2,
				"height": -0.9180743675123435,
				"terrain": "text1"
			},
			{
				"q": 8,
				"r": -10,
				"height": -0.24701115875443375,
				"terrain": "text4"
			},
			{
				"q": 8,
				"r": -9,
				"height": 0.013595663522406765,
				"terrain": "text3"
			},
			{
				"q": 8,
				"r": -8,
				"height": 0.246594439386499,
				"terrain": "text2"
			},
			{
				"q": 8,
				"r": -7,
				"height": 0.5177458950843656,
				"terrain": "text3"
			},
			{
				"q": 8,
				"r": -6,
				"height": 0.8172715429320836,
				"terrain": "mountain"
			},
			{
				"q": 8,
				"r": -5,
				"height": 1.0066608161502224,
				"terrain": "mountain"
			},
			{
				"q": 8,
				"r": -4,
				"height": 1.0250288038648172,
				"terrain": "mountain"
			},
			{
				"q": 8,
				"r": -3,
				"height": 0.8090190137207491,
				"terrain": "mountain"
			},
			{
				"q": 8,
				"r": -2,
				"height": 0.2806299153209347,
				"terrain": "text6"
			},
			{
				"q": 8,
				"r": -1,
				"height": -0.36645256833025414,
				"terrain": "text2"
			},
			{
				"q": 9,
				"r": 0,
				"height": -0.7358760552745309,
				"terrain": "text5"
			},
			{
				"q": 9,
				"r": -10,
				"height": -0.047499065884773484,
				"terrain": "text2"
			},
			{
				"q": 9,
				"r": -9,
				"height": 0.20444657339091493,
				"terrain": "text2"
			},
			{
				"q": 9,
				"r": -8,
				"height": 0.43070155596978077,
				"terrain": "text6"
			},
			{
				"q": 9,
				"r": -7,
				"height": 0.6591451896250099,
				"terrain": "text7"
			},
			{
				"q": 9,
				"r": -6,
				"height": 0.8230153653123605,
				"terrain": "mountain"
			},
			{
				"q": 9,
				"r": -5,
				"height": 0.7872447587946765,
				"terrain": "mountain"
			},
			{
				"q": 9,
				"r": -4,
				"height": 0.6303658907962174,
				"terrain": "text7"
			},
			{
				"q": 9,
				"r": -3,
				"height": 0.4101489703608092,
				"terrain": "text5"
			},
			{
				"q": 9,
				"r": -2,
				"height": 0.024068493218688536,
				"terrain": "text2"
			},
			{
				"q": 9,
				"r": -1,
				"height": -0.43476498285298304,
				"terrain": "text5"
			},
			{
				"q": 10,
				"r": -10,
				"height": 0.5267489711934156,
				"terrain": "text5"
			},
			{
				"q": 10,
				"r": -9,
				"height": 0.7619091399588475,
				"terrain": "mountain"
			},
			{
				"q": 10,
				"r": -8,
				"height": 0.9154367146737947,
				"terrain": "mountain"
			},
			{
				"q": 10,
				"r": -7,
				"height": 1.0046618619313061,
				"terrain": "mountain"
			},
			{
				"q": 10,
				"r": -6,
				"height": 0.9796054211841287,
				"terrain": "mountain"
			},
			{
				"q": 10,
				"r": -5,
				"height": 0.7587070267080742,
				"terrain": "mountain"
			},
			{
				"q": 10,
				"r": -4,
				"height": 0.5033050013401892,
				"terrain": "text7"
			},
			{
				"q": 10,
				"r": -3,
				"height": 0.3174815708366524,
				"terrain": "text2"
			},
			{
				"q": 10,
				"r": -2,
				"height": 0.0613444650858872,
				"terrain": "text2"
			},
			{
				"q": 11,
				"r": -10,
				"height": 1.1451639600574106,
				"terrain": "mountain"
			},
			{
				"q": 11,
				"r": -9,
				"height": 1.320882685567737,
				"terrain": "mountain"
			},
			{
				"q": 11,
				"r": -8,
				"height": 1.3770475651077754,
				"terrain": "mountain"
			},
			{
				"q": 11,
				"r": -7,
				"height": 1.3263085102817702,
				"terrain": "mountain"
			},
			{
				"q": 11,
				"r": -6,
				"height": 1.138581000604217,
				"terrain": "mountain"
			},
			{
				"q": 11,
				"r": -5,
				"height": 0.7909566508410459,
				"terrain": "mountain"
			},
			{
				"q": 11,
				"r": -4,
				"height": 0.494729791075066,
				"terrain": "text3"
			},
			{
				"q": 12,
				"r": -10,
				"height": 1.4708252548007077,
				"terrain": "mountain"
			},
			{
				"q": 12,
				"r": -9,
				"height": 1.5579638328029675,
				"terrain": "mountain"
			},
			{
				"q": 12,
				"r": -8,
				"height": 1.5447925479558848,
				"terrain": "mountain"
			},
			{
				"q": 12,
				"r": -7,
				"height": 1.4427606410099882,
				"terrain": "mountain"
			},
			{
				"q": 12,
				"r": -6,
				"height": 1.1991653017267558,
				"terrain": "mountain"
			},
			{
				"q": 13,
				"r": -10,
				"height": 1.3066454919448964,
				"terrain": "mountain"
			},
			{
				"q": 13,
				"r": -9,
				"height": 1.3499566213701142,
				"terrain": "mountain"
			},
			{
				"q": 13,
				"r": -8,
				"height": 1.3345507448612155,
				"terrain": "mountain"
			},
			{
				"q": 14,
				"r": -10,
				"height": 0.8089898746153321,
				"terrain": "mountain"
			},
			{
				"q": -5,
				"r": 0,
				"height": 0.37548242554158784,
				"terrain": "text1"
			},
			{
				"q": -5,
				"r": 1,
				"height": 0.2553254801637125,
				"terrain": "text6"
			},
			{
				"q": -5,
				"r": 2,
				"height": 0.06322295241494696,
				"terrain": "text6"
			},
			{
				"q": -5,
				"r": 3,
				"height": -0.10676168356791008,
				"terrain": "text3"
			},
			{
				"q": -5,
				"r": 4,
				"height": -0.3131690444838279,
				"terrain": "text2"
			},
			{
				"q": -5,
				"r": 5,
				"height": -0.5642188837808141,
				"terrain": "text3"
			},
			{
				"q": -5,
				"r": 6,
				"height": -0.7123422250081386,
				"terrain": "text5"
			},
			{
				"q": -5,
				"r": 7,
				"height": -0.749359156306822,
				"terrain": "text6"
			},
			{
				"q": -5,
				"r": 8,
				"height": -0.6135480552911954,
				"terrain": "text4"
			},
			{
				"q": -5,
				"r": 9,
				"height": -0.33028343319497455,
				"terrain": "text3"
			},
			{
				"q": -5,
				"r": -10,
				"height": -0.032320314443135656,
				"terrain": "text4"
			},
			{
				"q": -5,
				"r": -9,
				"height": 0.336697359047583,
				"terrain": "text1"
			},
			{
				"q": -5,
				"r": -8,
				"height": 0.6274875314166478,
				"terrain": "text7"
			},
			{
				"q": -5,
				"r": -7,
				"height": 0.6391879975430808,
				"terrain": "text3"
			},
			{
				"q": -5,
				"r": -6,
				"height": 0.30862911156420403,
				"terrain": "text2"
			},
			{
				"q": -5,
				"r": -5,
				"height": -0.2682666721396379,
				"terrain": "text4"
			},
			{
				"q": -5,
				"r": -4,
				"height": -0.7060589471471544,
				"terrain": "text5"
			},
			{
				"q": -5,
				"r": -3,
				"height": -0.676609163295662,
				"terrain": "text6"
			},
			{
				"q": -5,
				"r": -2,
				"height": -0.24226282489982037,
				"terrain": "text2"
			},
			{
				"q": -5,
				"r": -1,
				"height": 0.22274002808070287,
				"terrain": "text6"
			},
			{
				"q": -6,
				"r": 0,
				"height": 0.5380518004760494,
				"terrain": "text3"
			},
			{
				"q": -6,
				"r": 1,
				"height": 0.3672446671494276,
				"terrain": "text6"
			},
			{
				"q": -6,
				"r": 2,
				"height": 0.031480410285738336,
				"terrain": "text6"
			},
			{
				"q": -6,
				"r": 3,
				"height": -0.2855266071954158,
				"terrain": "text3"
			},
			{
				"q": -6,
				"r": 4,
				"height": -0.545092075613685,
				"terrain": "text4"
			},
			{
				"q": -6,
				"r": 5,
				"height": -0.7587514121972474,
				"terrain": "text7"
			},
			{
				"q": -6,
				"r": 6,
				"height": -0.8145606684085582,
				"terrain": "text4"
			},
			{
				"q": -6,
				"r": 7,
				"height": -0.6798241627038497,
				"terrain": "text2"
			},
			{
				"q": -6,
				"r": 8,
				"height": -0.3721701942843111,
				"terrain": "text3"
			},
			{
				"q": -6,
				"r": 9,
				"height": -0.007899465912266534,
				"terrain": "text6"
			},
			{
				"q": -6,
				"r": -9,
				"height": 0.31818694377231305,
				"terrain": "text5"
			},
			{
				"q": -6,
				"r": -8,
				"height": 0.5745134040272686,
				"terrain": "text5"
			},
			{
				"q": -6,
				"r": -7,
				"height": 0.585558440753593,
				"terrain": "text6"
			},
			{
				"q": -6,
				"r": -6,
				"height": 0.2539585401366612,
				"terrain": "text4"
			},
			{
				"q": -6,
				"r": -5,
				"height": -0.33880821285135815,
				"terrain": "text3"
			},
			{
				"q": -6,
				"r": -4,
				"height": -0.7944964919895248,
				"terrain": "text6"
			},
			{
				"q": -6,
				"r": -3,
				"height": -0.7468858835383547,
				"terrain": "text1"
			},
			{
				"q": -6,
				"r": -2,
				"height": -0.23309861426917972,
				"terrain": "text7"
			},
			{
				"q": -6,
				"r": -1,
				"height": 0.3323429953707038,
				"terrain": "text7"
			},
			{
				"q": -7,
				"r": 0,
				"height": 0.5914621092894108,
				"terrain": "text6"
			},
			{
				"q": -7,
				"r": 1,
				"height": 0.35391396089391064,
				"terrain": "text5"
			},
			{
				"q": -7,
				"r": 2,
				"height": -0.07352974028262227,
				"terrain": "text7"
			},
			{
				"q": -7,
				"r": 3,
				"height": -0.5068712235367214,
				"terrain": "text2"
			},
			{
				"q": -7,
				"r": 4,
				"height": -0.8302682556565696,
				"terrain": "text3"
			},
			{
				"q": -7,
				"r": 5,
				"height": -0.9973028769490324,
				"terrain": "text6"
			},
			{
				"q": -7,
				"r": 6,
				"height": -0.923156854592154,
				"terrain": "text4"
			},
			{
				"q": -7,
				"r": 7,
				"height": -0.5785376159970645,
				"terrain": "text6"
			},
			{
				"q": -7,
				"r": 8,
				"height": -0.07202648716652693,
				"terrain": "text1"
			},
			{
				"q": -7,
				"r": 9,
				"height": 0.3777832384981967,
				"terrain": "text4"
			},
			{
				"q": -7,
				"r": -7,
				"height": 0.49914673937343945,
				"terrain": "text3"
			},
			{
				"q": -7,
				"r": -6,
				"height": 0.11852149618964412,
				"terrain": "text3"
			},
			{
				"q": -7,
				"r": -5,
				"height": -0.45117712223296574,
				"terrain": "text5"
			},
			{
				"q": -7,
				"r": -4,
				"height": -0.8672649715699483,
				"terrain": "text3"
			},
			{
				"q": -7,
				"r": -3,
				"height": -0.7638857149344515,
				"terrain": "text6"
			},
			{
				"q": -7,
				"r": -2,
				"height": -0.1833759390845964,
				"terrain": "text4"
			},
			{
				"q": -7,
				"r": -1,
				"height": 0.41738772015830644,
				"terrain": "text6"
			},
			{
				"q": -8,
				"r": 0,
				"height": 0.5310395118468122,
				"terrain": "text4"
			},
			{
				"q": -8,
				"r": 1,
				"height": 0.25552050255816794,
				"terrain": "text6"
			},
			{
				"q": -8,
				"r": 2,
				"height": -0.1736265040734359,
				"terrain": "text4"
			},
			{
				"q": -8,
				"r": 3,
				"height": -0.6367966588316595,
				"terrain": "text6"
			},
			{
				"q": -8,
				"r": 4,
				"height": -0.9955119730235839,
				"terrain": "text2"
			},
			{
				"q": -8,
				"r": 5,
				"height": -1.1191146826047327,
				"terrain": "text1"
			},
			{
				"q": -8,
				"r": 6,
				"height": -0.9598483263272459,
				"terrain": "text1"
			},
			{
				"q": -8,
				"r": 7,
				"height": -0.5286565606054741,
				"terrain": "text1"
			},
			{
				"q": -8,
				"r": 8,
				"height": 0.02317733493596802,
				"terrain": "text5"
			},
			{
				"q": -8,
				"r": 9,
				"height": 0.4533959644301514,
				"terrain": "text4"
			},
			{
				"q": -8,
				"r": -5,
				"height": -0.4791489378443061,
				"terrain": "text5"
			},
			{
				"q": -8,
				"r": -4,
				"height": -0.8445899777884914,
				"terrain": "text3"
			},
			{
				"q": -8,
				"r": -3,
				"height": -0.722546590983199,
				"terrain": "text2"
			},
			{
				"q": -8,
				"r": -2,
				"height": -0.14209794014332883,
				"terrain": "text5"
			},
			{
				"q": -8,
				"r": -1,
				"height": 0.42751884932711337,
				"terrain": "text3"
			},
			{
				"q": -9,
				"r": 0,
				"height": 0.24542269984323306,
				"terrain": "text5"
			},
			{
				"q": -9,
				"r": 1,
				"height": -0.007743176281434783,
				"terrain": "text5"
			},
			{
				"q": -9,
				"r": 2,
				"height": -0.3542317962672,
				"terrain": "text4"
			},
			{
				"q": -9,
				"r": 3,
				"height": -0.7222776244954023,
				"terrain": "text6"
			},
			{
				"q": -9,
				"r": 4,
				"height": -1.0118873279132137,
				"terrain": "text7"
			},
			{
				"q": -9,
				"r": 5,
				"height": -1.0844791563716072,
				"terrain": "text6"
			},
			{
				"q": -9,
				"r": 6,
				"height": -0.9257593508172242,
				"terrain": "text5"
			},
			{
				"q": -9,
				"r": 7,
				"height": -0.5909829359862017,
				"terrain": "text5"
			},
			{
				"q": -9,
				"r": 8,
				"height": -0.19736929381106355,
				"terrain": "text6"
			},
			{
				"q": -9,
				"r": 9,
				"height": 0.09290374041254179,
				"terrain": "text2"
			},
			{
				"q": -9,
				"r": -3,
				"height": -0.7328683597434871,
				"terrain": "text7"
			},
			{
				"q": -9,
				"r": -2,
				"height": -0.2883177291903827,
				"terrain": "text4"
			},
			{
				"q": -9,
				"r": -1,
				"height": 0.17990733882153342,
				"terrain": "text5"
			},
			{
				"q": -10,
				"r": 0,
				"height": -0.2720406378786022,
				"terrain": "text2"
			},
			{
				"q": -10,
				"r": 1,
				"height": -0.408058544480136,
				"terrain": "text5"
			},
			{
				"q": -10,
				"r": 2,
				"height": -0.5945928384795361,
				"terrain": "text4"
			},
			{
				"q": -10,
				"r": 3,
				"height": -0.7740413976433203,
				"terrain": "text7"
			},
			{
				"q": -10,
				"r": 4,
				"height": -0.9122560602819736,
				"terrain": "text5"
			},
			{
				"q": -10,
				"r": 5,
				"height": -0.9416040866831819,
				"terrain": "text3"
			},
			{
				"q": -10,
				"r": 6,
				"height": -0.868138918931717,
				"terrain": "text2"
			},
			{
				"q": -10,
				"r": 7,
				"height": -0.744379985133153,
				"terrain": "text2"
			},
			{
				"q": -10,
				"r": 8,
				"height": -0.5944396075882152,
				"terrain": "text2"
			},
			{
				"q": -10,
				"r": 9,
				"height": -0.4681150123456789,
				"terrain": "text5"
			},
			{
				"q": -10,
				"r": -1,
				"height": -0.3596758524579545,
				"terrain": "text3"
			},
			{
				"q": -11,
				"r": 1,
				"height": -0.7109475439266826,
				"terrain": "text1"
			},
			{
				"q": -11,
				"r": 2,
				"height": -0.6285074397958799,
				"terrain": "text1"
			},
			{
				"q": -11,
				"r": 3,
				"height": -0.5667927471237075,
				"terrain": "text4"
			},
			{
				"q": -11,
				"r": 4,
				"height": -0.5456244560237749,
				"terrain": "text4"
			},
			{
				"q": -11,
				"r": 5,
				"height": -0.5725915646757334,
				"terrain": "text4"
			},
			{
				"q": -11,
				"r": 6,
				"height": -0.6634033707694403,
				"terrain": "text3"
			},
			{
				"q": -11,
				"r": 7,
				"height": -0.8421833683225627,
				"terrain": "text1"
			},
			{
				"q": -11,
				"r": 8,
				"height": -0.9948971899074692,
				"terrain": "text7"
			},
			{
				"q": -11,
				"r": 9,
				"height": -1.0407805254129097,
				"terrain": "text3"
			},
			{
				"q": -12,
				"r": 3,
				"height": -0.18860951287468908,
				"terrain": "text1"
			},
			{
				"q": -12,
				"r": 4,
				"height": -0.05368812055880376,
				"terrain": "text4"
			},
			{
				"q": -12,
				"r": 5,
				"height": -0.061047085228208536,
				"terrain": "text3"
			},
			{
				"q": -12,
				"r": 6,
				"height": -0.2700863216165601,
				"terrain": "text6"
			},
			{
				"q": -12,
				"r": 7,
				"height": -0.7275870519401879,
				"terrain": "text6"
			},
			{
				"q": -12,
				"r": 8,
				"height": -1.1959968641455976,
				"terrain": "text7"
			},
			{
				"q": -12,
				"r": 9,
				"height": -1.4467812492337695,
				"terrain": "text6"
			},
			{
				"q": -13,
				"r": 5,
				"height": 0.31484483017571124,
				"terrain": "text1"
			},
			{
				"q": -13,
				"r": 6,
				"height": 0.1227538261640091,
				"terrain": "text4"
			},
			{
				"q": -13,
				"r": 7,
				"height": -0.4068876207344111,
				"terrain": "text4"
			},
			{
				"q": -13,
				"r": 8,
				"height": -1.018004233363394,
				"terrain": "text6"
			},
			{
				"q": -13,
				"r": 9,
				"height": -1.3769166774029606,
				"terrain": "text7"
			},
			{
				"q": -14,
				"r": 7,
				"height": -0.08452795157450149,
				"terrain": "text5"
			},
			{
				"q": -14,
				"r": 8,
				"height": -0.5867315316333244,
				"terrain": "text5"
			},
			{
				"q": -14,
				"r": 9,
				"height": -0.8616461525447843,
				"terrain": "text2"
			},
			{
				"q": -15,
				"r": 9,
				"height": -0.2706339593885343,
				"terrain": "text2"
			},
			{
				"q": -4,
				"r": 0,
				"height": 0.0002820076559974932,
				"terrain": "text1"
			},
			{
				"q": -4,
				"r": 1,
				"height": -0.16017674681571326,
				"terrain": "text2"
			},
			{
				"q": -4,
				"r": 2,
				"height": -0.2436651505156165,
				"terrain": "text3"
			},
			{
				"q": -4,
				"r": 3,
				"height": -0.2481060327130668,
				"terrain": "text7"
			},
			{
				"q": -4,
				"r": 4,
				"height": -0.31631609685555456,
				"terrain": "text4"
			},
			{
				"q": -4,
				"r": 5,
				"height": -0.5062278751708789,
				"terrain": "text7"
			},
			{
				"q": -4,
				"r": 6,
				"height": -0.655762684248417,
				"terrain": "text3"
			},
			{
				"q": -4,
				"r": 7,
				"height": -0.7610408447483046,
				"terrain": "text6"
			},
			{
				"q": -4,
				"r": 8,
				"height": -0.7255702241040917,
				"terrain": "text7"
			},
			{
				"q": -4,
				"r": 9,
				"height": -0.5035967333794593,
				"terrain": "text4"
			},
			{
				"q": -4,
				"r": -10,
				"height": 0.05468110886215416,
				"terrain": "text2"
			},
			{
				"q": -4,
				"r": -9,
				"height": 0.3627193615024611,
				"terrain": "text2"
			},
			{
				"q": -4,
				"r": -8,
				"height": 0.6305750906716879,
				"terrain": "text6"
			},
			{
				"q": -4,
				"r": -7,
				"height": 0.6445578844303075,
				"terrain": "text1"
			},
			{
				"q": -4,
				"r": -6,
				"height": 0.3522981228855787,
				"terrain": "text7"
			},
			{
				"q": -4,
				"r": -5,
				"height": -0.146184824058165,
				"terrain": "text4"
			},
			{
				"q": -4,
				"r": -4,
				"height": -0.511381794755559,
				"terrain": "text6"
			},
			{
				"q": -4,
				"r": -3,
				"height": -0.48336728907363813,
				"terrain": "text6"
			},
			{
				"q": -4,
				"r": -2,
				"height": -0.19559526848224973,
				"terrain": "text6"
			},
			{
				"q": -4,
				"r": -1,
				"height": 0.03704048785403173,
				"terrain": "text6"
			},
			{
				"q": -3,
				"r": 0,
				"height": -0.4971814984938345,
				"terrain": "text3"
			},
			{
				"q": -3,
				"r": 1,
				"height": -0.7904583988298683,
				"terrain": "text1"
			},
			{
				"q": -3,
				"r": 2,
				"height": -0.8624899533801405,
				"terrain": "text1"
			},
			{
				"q": -3,
				"r": 3,
				"height": -0.7279113122476919,
				"terrain": "text6"
			},
			{
				"q": -3,
				"r": 4,
				"height": -0.5861542853180791,
				"terrain": "text2"
			},
			{
				"q": -3,
				"r": 5,
				"height": -0.592033927008474,
				"terrain": "text6"
			},
			{
				"q": -3,
				"r": 6,
				"height": -0.6346172282775072,
				"terrain": "text7"
			},
			{
				"q": -3,
				"r": 7,
				"height": -0.7073667490096427,
				"terrain": "text2"
			},
			{
				"q": -3,
				"r": 8,
				"height": -0.7112613284766436,
				"terrain": "text3"
			},
			{
				"q": -3,
				"r": 9,
				"height": -0.5614603977475723,
				"terrain": "text6"
			},
			{
				"q": -3,
				"r": -10,
				"height": 0.0902168954585052,
				"terrain": "text3"
			},
			{
				"q": -3,
				"r": -9,
				"height": 0.34065202058534116,
				"terrain": "text1"
			},
			{
				"q": -3,
				"r": -8,
				"height": 0.6116044428659344,
				"terrain": "text3"
			},
			{
				"q": -3,
				"r": -7,
				"height": 0.689215467528885,
				"terrain": "text2"
			},
			{
				"q": -3,
				"r": -6,
				"height": 0.5002136394285503,
				"terrain": "text3"
			},
			{
				"q": -3,
				"r": -5,
				"height": 0.13236692653718607,
				"terrain": "text4"
			},
			{
				"q": -3,
				"r": -4,
				"height": -0.11777976547140018,
				"terrain": "text4"
			},
			{
				"q": -3,
				"r": -3,
				"height": -0.10915279876638789,
				"terrain": "text2"
			},
			{
				"q": -3,
				"r": -2,
				"height": -0.05525546335034681,
				"terrain": "text1"
			},
			{
				"q": -3,
				"r": -1,
				"height": -0.17860061365101437,
				"terrain": "text7"
			},
			{
				"q": -2,
				"r": 0,
				"height": -0.7655619925093308,
				"terrain": "text2"
			},
			{
				"q": -2,
				"r": 1,
				"height": -1.2261661958074344,
				"terrain": "text3"
			},
			{
				"q": -2,
				"r": 2,
				"height": -1.4025472644257393,
				"terrain": "text5"
			},
			{
				"q": -2,
				"r": 3,
				"height": -1.2424061377856719,
				"terrain": "text2"
			},
			{
				"q": -2,
				"r": 4,
				"height": -0.9479062207959181,
				"terrain": "text4"
			},
			{
				"q": -2,
				"r": 5,
				"height": -0.764519835022047,
				"terrain": "text3"
			},
			{
				"q": -2,
				"r": 6,
				"height": -0.6475178379707074,
				"terrain": "text6"
			},
			{
				"q": -2,
				"r": 7,
				"height": -0.5926056810820084,
				"terrain": "text3"
			},
			{
				"q": -2,
				"r": 8,
				"height": -0.5423073394201585,
				"terrain": "text6"
			},
			{
				"q": -2,
				"r": 9,
				"height": -0.43181036386471516,
				"terrain": "text6"
			},
			{
				"q": -2,
				"r": -10,
				"height": 0.18352060765798067,
				"terrain": "text5"
			},
			{
				"q": -2,
				"r": -9,
				"height": 0.40110617879535204,
				"terrain": "text1"
			},
			{
				"q": -2,
				"r": -8,
				"height": 0.6595967601583088,
				"terrain": "text2"
			},
			{
				"q": -2,
				"r": -7,
				"height": 0.7780016309017932,
				"terrain": "mountain"
			},
			{
				"q": -2,
				"r": -6,
				"height": 0.6766578880062917,
				"terrain": "text4"
			},
			{
				"q": -2,
				"r": -5,
				"height": 0.44040848621928697,
				"terrain": "text4"
			},
			{
				"q": -2,
				"r": -4,
				"height": 0.31116779605614775,
				"terrain": "text6"
			},
			{
				"q": -2,
				"r": -3,
				"height": 0.3129434556677881,
				"terrain": "text5"
			},
			{
				"q": -2,
				"r": -2,
				"height": 0.18905244366452434,
				"terrain": "text1"
			},
			{
				"q": -2,
				"r": -1,
				"height": -0.2147513696430145,
				"terrain": "text2"
			},
			{
				"q": -1,
				"r": 0,
				"height": -0.5785973045679017,
				"terrain": "text5"
			},
			{
				"q": -1,
				"r": 1,
				"height": -1.173044498952401,
				"terrain": "text4"
			},
			{
				"q": -1,
				"r": 2,
				"height": -1.5140305703209131,
				"terrain": "text1"
			},
			{
				"q": -1,
				"r": 3,
				"height": -1.4485683510578076,
				"terrain": "text4"
			},
			{
				"q": -1,
				"r": 4,
				"height": -1.1322462634527857,
				"terrain": "text5"
			},
			{
				"q": -1,
				"r": 5,
				"height": -0.8548237442767335,
				"terrain": "text3"
			},
			{
				"q": -1,
				"r": 6,
				"height": -0.6260913452409564,
				"terrain": "text7"
			},
			{
				"q": -1,
				"r": 7,
				"height": -0.43514914719942055,
				"terrain": "text3"
			},
			{
				"q": -1,
				"r": 8,
				"height": -0.28956577079633944,
				"terrain": "text7"
			},
			{
				"q": -1,
				"r": 9,
				"height": -0.18105505641713027,
				"terrain": "text4"
			},
			{
				"q": -1,
				"r": -10,
				"height": 0.41088836997138933,
				"terrain": "text4"
			},
			{
				"q": -1,
				"r": -9,
				"height": 0.5951060018473793,
				"terrain": "text6"
			},
			{
				"q": -1,
				"r": -8,
				"height": 0.777107783785094,
				"terrain": "mountain"
			},
			{
				"q": -1,
				"r": -7,
				"height": 0.8433032820048219,
				"terrain": "mountain"
			},
			{
				"q": -1,
				"r": -6,
				"height": 0.7527992473855794,
				"terrain": "mountain"
			},
			{
				"q": -1,
				"r": -5,
				"height": 0.6120376443662178,
				"terrain": "text1"
			},
			{
				"q": -1,
				"r": -4,
				"height": 0.5990352020195651,
				"terrain": "text5"
			},
			{
				"q": -1,
				"r": -3,
				"height": 0.6709569296305397,
				"terrain": "text4"
			},
			{
				"q": -1,
				"r": -2,
				"height": 0.5382901040750773,
				"terrain": "text5"
			},
			{
				"q": -1,
				"r": -1,
				"height": 0.0630297514068973,
				"terrain": "text7"
			}
		],
		"halfWidth": 10,
		"halfHeight": 10
	}
	},
  "seed_3":{
	"map_id": "seed_3",
	"data": {
		"_width": 20,
		"_height": 20,
		"data": [
			{
				"q": 0,
				"r": 0,
				"height": 0,
				"terrain": "text7"
			},
			{
				"q": 0,
				"r": 1,
				"height": 0.04667636213991771,
				"terrain": "text7"
			},
			{
				"q": 0,
				"r": 2,
				"height": 0.19665719820171218,
				"terrain": "text1"
			},
			{
				"q": 0,
				"r": 3,
				"height": 0.32204996078666337,
				"terrain": "text6"
			},
			{
				"q": 0,
				"r": 4,
				"height": 0.3021213823363921,
				"terrain": "text1"
			},
			{
				"q": 0,
				"r": 5,
				"height": 0.10994425394731644,
				"terrain": "text3"
			},
			{
				"q": 0,
				"r": 6,
				"height": -0.26964118032723916,
				"terrain": "text5"
			},
			{
				"q": 0,
				"r": 7,
				"height": -0.7671312648423596,
				"terrain": "text6"
			},
			{
				"q": 0,
				"r": 8,
				"height": -1.0537117088964072,
				"terrain": "text3"
			},
			{
				"q": 0,
				"r": 9,
				"height": -0.9749949004931214,
				"terrain": "text3"
			},
			{
				"q": 0,
				"r": -10,
				"height": -0.6273949577388045,
				"terrain": "text1"
			},
			{
				"q": 0,
				"r": -9,
				"height": -0.5962324284457563,
				"terrain": "text5"
			},
			{
				"q": 0,
				"r": -8,
				"height": -0.4866088134086464,
				"terrain": "text4"
			},
			{
				"q": 0,
				"r": -7,
				"height": -0.3344074638242271,
				"terrain": "text7"
			},
			{
				"q": 0,
				"r": -6,
				"height": -0.11294870458456448,
				"terrain": "text6"
			},
			{
				"q": 0,
				"r": -5,
				"height": 0.1566085028787866,
				"terrain": "text5"
			},
			{
				"q": 0,
				"r": -4,
				"height": 0.3208397886912719,
				"terrain": "text2"
			},
			{
				"q": 0,
				"r": -3,
				"height": 0.32477430013312086,
				"terrain": "text5"
			},
			{
				"q": 0,
				"r": -2,
				"height": 0.19666691858560048,
				"terrain": "text4"
			},
			{
				"q": 0,
				"r": -1,
				"height": 0.04667636213991703,
				"terrain": "text4"
			},
			{
				"q": 1,
				"r": 0,
				"height": 0.625273666707819,
				"terrain": "text1"
			},
			{
				"q": 1,
				"r": 1,
				"height": 0.6263943906735845,
				"terrain": "text4"
			},
			{
				"q": 1,
				"r": 2,
				"height": 0.5812838126538361,
				"terrain": "text1"
			},
			{
				"q": 1,
				"r": 3,
				"height": 0.39203046655198076,
				"terrain": "text6"
			},
			{
				"q": 1,
				"r": 4,
				"height": 0.06397454662953389,
				"terrain": "text2"
			},
			{
				"q": 1,
				"r": 5,
				"height": -0.3080242362086921,
				"terrain": "text4"
			},
			{
				"q": 1,
				"r": 6,
				"height": -0.7197794900752865,
				"terrain": "text2"
			},
			{
				"q": 1,
				"r": 7,
				"height": -1.0713033489762342,
				"terrain": "text2"
			},
			{
				"q": 1,
				"r": 8,
				"height": -1.1018645264895273,
				"terrain": "text1"
			},
			{
				"q": 1,
				"r": 9,
				"height": -0.7578218053125654,
				"terrain": "text4"
			},
			{
				"q": 1,
				"r": -10,
				"height": -0.4486756983705037,
				"terrain": "text3"
			},
			{
				"q": 1,
				"r": -9,
				"height": -0.2673063290161334,
				"terrain": "text4"
			},
			{
				"q": 1,
				"r": -8,
				"height": -0.033863587613477256,
				"terrain": "text3"
			},
			{
				"q": 1,
				"r": -7,
				"height": 0.18378861001222413,
				"terrain": "text3"
			},
			{
				"q": 1,
				"r": -6,
				"height": 0.4113328434674678,
				"terrain": "text1"
			},
			{
				"q": 1,
				"r": -5,
				"height": 0.6524981310727932,
				"terrain": "text1"
			},
			{
				"q": 1,
				"r": -4,
				"height": 0.7888698561071069,
				"terrain": "mountain"
			},
			{
				"q": 1,
				"r": -3,
				"height": 0.7876324877688388,
				"terrain": "mountain"
			},
			{
				"q": 1,
				"r": -2,
				"height": 0.7028151052643125,
				"terrain": "text4"
			},
			{
				"q": 1,
				"r": -1,
				"height": 0.6290798152221311,
				"terrain": "text3"
			},
			{
				"q": 2,
				"r": 0,
				"height": 0.9684341530331453,
				"terrain": "mountain"
			},
			{
				"q": 2,
				"r": 1,
				"height": 0.9796758653780611,
				"terrain": "mountain"
			},
			{
				"q": 2,
				"r": 2,
				"height": 0.8207959307293236,
				"terrain": "mountain"
			},
			{
				"q": 2,
				"r": 3,
				"height": 0.3964160756493297,
				"terrain": "text7"
			},
			{
				"q": 2,
				"r": 4,
				"height": -0.18349320646637776,
				"terrain": "text2"
			},
			{
				"q": 2,
				"r": 5,
				"height": -0.6977968469276558,
				"terrain": "text6"
			},
			{
				"q": 2,
				"r": 6,
				"height": -1.1087606744969507,
				"terrain": "text4"
			},
			{
				"q": 2,
				"r": 7,
				"height": -1.2647559870280491,
				"terrain": "text3"
			},
			{
				"q": 2,
				"r": 8,
				"height": -1.0080354016552577,
				"terrain": "text4"
			},
			{
				"q": 2,
				"r": 9,
				"height": -0.4227293261004085,
				"terrain": "text5"
			},
			{
				"q": 2,
				"r": -10,
				"height": 0.0048795996004161735,
				"terrain": "text3"
			},
			{
				"q": 2,
				"r": -9,
				"height": 0.31552475628239246,
				"terrain": "text1"
			},
			{
				"q": 2,
				"r": -8,
				"height": 0.6629170950817431,
				"terrain": "text6"
			},
			{
				"q": 2,
				"r": -7,
				"height": 0.9173276430454986,
				"terrain": "mountain"
			},
			{
				"q": 2,
				"r": -6,
				"height": 1.0717598619424042,
				"terrain": "mountain"
			},
			{
				"q": 2,
				"r": -5,
				"height": 1.1703220377036387,
				"terrain": "mountain"
			},
			{
				"q": 2,
				"r": -4,
				"height": 1.1509894760326755,
				"terrain": "mountain"
			},
			{
				"q": 2,
				"r": -3,
				"height": 1.0176640903555922,
				"terrain": "mountain"
			},
			{
				"q": 2,
				"r": -2,
				"height": 0.9040417327647199,
				"terrain": "mountain"
			},
			{
				"q": 2,
				"r": -1,
				"height": 0.8998055217505206,
				"terrain": "mountain"
			},
			{
				"q": 3,
				"r": 0,
				"height": 0.9169028185755661,
				"terrain": "mountain"
			},
			{
				"q": 3,
				"r": 1,
				"height": 1.0010269761556725,
				"terrain": "mountain"
			},
			{
				"q": 3,
				"r": 2,
				"height": 0.9004361055806267,
				"terrain": "mountain"
			},
			{
				"q": 3,
				"r": 3,
				"height": 0.4732639718400002,
				"terrain": "text6"
			},
			{
				"q": 3,
				"r": 4,
				"height": -0.1757353566952909,
				"terrain": "text6"
			},
			{
				"q": 3,
				"r": 5,
				"height": -0.7596885468544301,
				"terrain": "text6"
			},
			{
				"q": 3,
				"r": 6,
				"height": -1.1807214384380185,
				"terrain": "text3"
			},
			{
				"q": 3,
				"r": 7,
				"height": -1.229831957156967,
				"terrain": "text7"
			},
			{
				"q": 3,
				"r": 8,
				"height": -0.834487055701622,
				"terrain": "text1"
			},
			{
				"q": 3,
				"r": 9,
				"height": -0.17518555491065588,
				"terrain": "text4"
			},
			{
				"q": 3,
				"r": -10,
				"height": 0.3733037229680624,
				"terrain": "text5"
			},
			{
				"q": 3,
				"r": -9,
				"height": 0.7646590741576558,
				"terrain": "mountain"
			},
			{
				"q": 3,
				"r": -8,
				"height": 1.1800202964493085,
				"terrain": "mountain"
			},
			{
				"q": 3,
				"r": -7,
				"height": 1.4139802924947462,
				"terrain": "mountain"
			},
			{
				"q": 3,
				"r": -6,
				"height": 1.4334637298751254,
				"terrain": "mountain"
			},
			{
				"q": 3,
				"r": -5,
				"height": 1.322129087567989,
				"terrain": "mountain"
			},
			{
				"q": 3,
				"r": -4,
				"height": 1.090532084164999,
				"terrain": "mountain"
			},
			{
				"q": 3,
				"r": -3,
				"height": 0.8005776004215199,
				"terrain": "mountain"
			},
			{
				"q": 3,
				"r": -2,
				"height": 0.670872787379768,
				"terrain": "text3"
			},
			{
				"q": 3,
				"r": -1,
				"height": 0.7590474520078898,
				"terrain": "mountain"
			},
			{
				"q": 4,
				"r": 0,
				"height": 0.6874362968470641,
				"terrain": "text2"
			},
			{
				"q": 4,
				"r": 1,
				"height": 0.8759729762889409,
				"terrain": "mountain"
			},
			{
				"q": 4,
				"r": 2,
				"height": 0.9538590497870374,
				"terrain": "mountain"
			},
			{
				"q": 4,
				"r": 3,
				"height": 0.7210575752134178,
				"terrain": "text2"
			},
			{
				"q": 4,
				"r": 4,
				"height": 0.18758214947415733,
				"terrain": "text3"
			},
			{
				"q": 4,
				"r": 5,
				"height": -0.3998956410142074,
				"terrain": "text3"
			},
			{
				"q": 4,
				"r": 6,
				"height": -0.8777844372668303,
				"terrain": "text4"
			},
			{
				"q": 4,
				"r": 7,
				"height": -0.9826541413276746,
				"terrain": "text7"
			},
			{
				"q": 4,
				"r": 8,
				"height": -0.6664914353532048,
				"terrain": "text7"
			},
			{
				"q": 4,
				"r": 9,
				"height": -0.10957813380565273,
				"terrain": "text7"
			},
			{
				"q": 4,
				"r": -10,
				"height": 0.49769983013840424,
				"terrain": "text6"
			},
			{
				"q": 4,
				"r": -9,
				"height": 0.8992499010843196,
				"terrain": "mountain"
			},
			{
				"q": 4,
				"r": -8,
				"height": 1.2936983973073126,
				"terrain": "mountain"
			},
			{
				"q": 4,
				"r": -7,
				"height": 1.4413691995284015,
				"terrain": "mountain"
			},
			{
				"q": 4,
				"r": -6,
				"height": 1.2950843911889927,
				"terrain": "mountain"
			},
			{
				"q": 4,
				"r": -5,
				"height": 0.9979228369213499,
				"terrain": "mountain"
			},
			{
				"q": 4,
				"r": -4,
				"height": 0.627652510085311,
				"terrain": "text3"
			},
			{
				"q": 4,
				"r": -3,
				"height": 0.2960806294648314,
				"terrain": "text6"
			},
			{
				"q": 4,
				"r": -2,
				"height": 0.2409896033475569,
				"terrain": "text4"
			},
			{
				"q": 4,
				"r": -1,
				"height": 0.44491928281566473,
				"terrain": "text2"
			},
			{
				"q": 5,
				"r": 0,
				"height": 0.6041106245809376,
				"terrain": "text2"
			},
			{
				"q": 5,
				"r": 1,
				"height": 0.8813094346509517,
				"terrain": "mountain"
			},
			{
				"q": 5,
				"r": 2,
				"height": 1.1252467554836485,
				"terrain": "mountain"
			},
			{
				"q": 5,
				"r": 3,
				"height": 1.099872315699011,
				"terrain": "mountain"
			},
			{
				"q": 5,
				"r": 4,
				"height": 0.7329619622922767,
				"terrain": "text6"
			},
			{
				"q": 5,
				"r": 5,
				"height": 0.18357370573591422,
				"terrain": "text6"
			},
			{
				"q": 5,
				"r": 6,
				"height": -0.3638429375842859,
				"terrain": "text3"
			},
			{
				"q": 5,
				"r": 7,
				"height": -0.6149462874567533,
				"terrain": "text6"
			},
			{
				"q": 5,
				"r": 8,
				"height": -0.4941119540657091,
				"terrain": "text5"
			},
			{
				"q": 5,
				"r": -10,
				"height": 0.5635301574456741,
				"terrain": "text6"
			},
			{
				"q": 5,
				"r": -9,
				"height": 0.9029983679960378,
				"terrain": "mountain"
			},
			{
				"q": 5,
				"r": -8,
				"height": 1.1667874206932292,
				"terrain": "mountain"
			},
			{
				"q": 5,
				"r": -7,
				"height": 1.13678352754429,
				"terrain": "mountain"
			},
			{
				"q": 5,
				"r": -6,
				"height": 0.8183171961657614,
				"terrain": "mountain"
			},
			{
				"q": 5,
				"r": -5,
				"height": 0.4340958874133908,
				"terrain": "text1"
			},
			{
				"q": 5,
				"r": -4,
				"height": 0.08614732649345519,
				"terrain": "text4"
			},
			{
				"q": 5,
				"r": -3,
				"height": -0.12151640966650096,
				"terrain": "text2"
			},
			{
				"q": 5,
				"r": -2,
				"height": -0.01872793403318415,
				"terrain": "text6"
			},
			{
				"q": 5,
				"r": -1,
				"height": 0.2958342127012392,
				"terrain": "text6"
			},
			{
				"q": 6,
				"r": 0,
				"height": 0.649406622213847,
				"terrain": "text5"
			},
			{
				"q": 6,
				"r": 1,
				"height": 0.9761952167835346,
				"terrain": "mountain"
			},
			{
				"q": 6,
				"r": 2,
				"height": 1.3256047957860395,
				"terrain": "mountain"
			},
			{
				"q": 6,
				"r": 3,
				"height": 1.4635076587913753,
				"terrain": "mountain"
			},
			{
				"q": 6,
				"r": 4,
				"height": 1.2642632636648292,
				"terrain": "mountain"
			},
			{
				"q": 6,
				"r": 5,
				"height": 0.8159040404649442,
				"terrain": "mountain"
			},
			{
				"q": 6,
				"r": 6,
				"height": 0.27035287552000004,
				"terrain": "text1"
			},
			{
				"q": 6,
				"r": -10,
				"height": 0.6708633110844692,
				"terrain": "text3"
			},
			{
				"q": 6,
				"r": -9,
				"height": 0.9110388576661443,
				"terrain": "mountain"
			},
			{
				"q": 6,
				"r": -8,
				"height": 0.9760577179523307,
				"terrain": "mountain"
			},
			{
				"q": 6,
				"r": -7,
				"height": 0.70079745052228,
				"terrain": "text4"
			},
			{
				"q": 6,
				"r": -6,
				"height": 0.19748692403719997,
				"terrain": "text2"
			},
			{
				"q": 6,
				"r": -5,
				"height": -0.2144612998657246,
				"terrain": "text1"
			},
			{
				"q": 6,
				"r": -4,
				"height": -0.4331928533660674,
				"terrain": "text6"
			},
			{
				"q": 6,
				"r": -3,
				"height": -0.4244047905730661,
				"terrain": "text6"
			},
			{
				"q": 6,
				"r": -2,
				"height": -0.13528452265908178,
				"terrain": "text4"
			},
			{
				"q": 6,
				"r": -1,
				"height": 0.28949517063915853,
				"terrain": "text7"
			},
			{
				"q": 7,
				"r": 0,
				"height": 0.6416451037689089,
				"terrain": "text3"
			},
			{
				"q": 7,
				"r": 1,
				"height": 0.9132166750371042,
				"terrain": "mountain"
			},
			{
				"q": 7,
				"r": 2,
				"height": 1.2277792320708047,
				"terrain": "mountain"
			},
			{
				"q": 7,
				"r": 3,
				"height": 1.4582365548093856,
				"terrain": "mountain"
			},
			{
				"q": 7,
				"r": 4,
				"height": 1.4749294794558951,
				"terrain": "mountain"
			},
			{
				"q": 7,
				"r": -10,
				"height": 0.8894094610468491,
				"terrain": "mountain"
			},
			{
				"q": 7,
				"r": -9,
				"height": 1.0290304021168613,
				"terrain": "mountain"
			},
			{
				"q": 7,
				"r": -8,
				"height": 0.8823317970703395,
				"terrain": "mountain"
			},
			{
				"q": 7,
				"r": -7,
				"height": 0.35477055342203345,
				"terrain": "text2"
			},
			{
				"q": 7,
				"r": -6,
				"height": -0.3154871524387873,
				"terrain": "text3"
			},
			{
				"q": 7,
				"r": -5,
				"height": -0.7311097657348614,
				"terrain": "text5"
			},
			{
				"q": 7,
				"r": -4,
				"height": -0.8256418890357153,
				"terrain": "text3"
			},
			{
				"q": 7,
				"r": -3,
				"height": -0.6360997644889577,
				"terrain": "text3"
			},
			{
				"q": 7,
				"r": -2,
				"height": -0.20724496700355116,
				"terrain": "text3"
			},
			{
				"q": 7,
				"r": -1,
				"height": 0.2884732018801677,
				"terrain": "text6"
			},
			{
				"q": 8,
				"r": 0,
				"height": 0.6067589800776241,
				"terrain": "text1"
			},
			{
				"q": 8,
				"r": 1,
				"height": 0.7272305333866101,
				"terrain": "text4"
			},
			{
				"q": 8,
				"r": 2,
				"height": 0.8507251673143259,
				"terrain": "mountain"
			},
			{
				"q": 8,
				"r": -10,
				"height": 1.056822959834616,
				"terrain": "mountain"
			},
			{
				"q": 8,
				"r": -9,
				"height": 1.145037108375707,
				"terrain": "mountain"
			},
			{
				"q": 8,
				"r": -8,
				"height": 0.9124466771118867,
				"terrain": "mountain"
			},
			{
				"q": 8,
				"r": -7,
				"height": 0.299434061577564,
				"terrain": "text1"
			},
			{
				"q": 8,
				"r": -6,
				"height": -0.40727621428760524,
				"terrain": "text6"
			},
			{
				"q": 8,
				"r": -5,
				"height": -0.7993655564405464,
				"terrain": "text3"
			},
			{
				"q": 8,
				"r": -4,
				"height": -0.8448244170238504,
				"terrain": "text2"
			},
			{
				"q": 8,
				"r": -3,
				"height": -0.5976113312240232,
				"terrain": "text1"
			},
			{
				"q": 8,
				"r": -2,
				"height": -0.14221234746161565,
				"terrain": "text2"
			},
			{
				"q": 8,
				"r": -1,
				"height": 0.32663167420392025,
				"terrain": "text6"
			},
			{
				"q": 9,
				"r": 0,
				"height": 0.6205071185731599,
				"terrain": "text3"
			},
			{
				"q": 9,
				"r": -10,
				"height": 0.8947995432510287,
				"terrain": "mountain"
			},
			{
				"q": 9,
				"r": -9,
				"height": 1.004545290190915,
				"terrain": "mountain"
			},
			{
				"q": 9,
				"r": -8,
				"height": 0.8678232921913784,
				"terrain": "mountain"
			},
			{
				"q": 9,
				"r": -7,
				"height": 0.40532649631138945,
				"terrain": "text3"
			},
			{
				"q": 9,
				"r": -6,
				"height": -0.16683363791387829,
				"terrain": "text1"
			},
			{
				"q": 9,
				"r": -5,
				"height": -0.4977028510150544,
				"terrain": "text1"
			},
			{
				"q": 9,
				"r": -4,
				"height": -0.5383153491524314,
				"terrain": "text2"
			},
			{
				"q": 9,
				"r": -3,
				"height": -0.31756793657008264,
				"terrain": "text3"
			},
			{
				"q": 9,
				"r": -2,
				"height": 0.0684556073742571,
				"terrain": "text4"
			},
			{
				"q": 9,
				"r": -1,
				"height": 0.44076462675013584,
				"terrain": "text5"
			},
			{
				"q": 10,
				"r": -10,
				"height": 0.34801605446324235,
				"terrain": "text1"
			},
			{
				"q": 10,
				"r": -9,
				"height": 0.512110633744856,
				"terrain": "text5"
			},
			{
				"q": 10,
				"r": -8,
				"height": 0.5691283028305681,
				"terrain": "text4"
			},
			{
				"q": 10,
				"r": -7,
				"height": 0.3959540312628975,
				"terrain": "text5"
			},
			{
				"q": 10,
				"r": -6,
				"height": 0.06816605668941844,
				"terrain": "text6"
			},
			{
				"q": 10,
				"r": -5,
				"height": -0.15597527607456746,
				"terrain": "text5"
			},
			{
				"q": 10,
				"r": -4,
				"height": -0.18899280874418178,
				"terrain": "text3"
			},
			{
				"q": 10,
				"r": -3,
				"height": -0.020388178078673797,
				"terrain": "text3"
			},
			{
				"q": 10,
				"r": -2,
				"height": 0.27803743366055184,
				"terrain": "text6"
			},
			{
				"q": 11,
				"r": -10,
				"height": -0.2520159675765894,
				"terrain": "text6"
			},
			{
				"q": 11,
				"r": -9,
				"height": -0.028146140836309175,
				"terrain": "text3"
			},
			{
				"q": 11,
				"r": -8,
				"height": 0.22870797160627615,
				"terrain": "text2"
			},
			{
				"q": 11,
				"r": -7,
				"height": 0.3325265494802406,
				"terrain": "text5"
			},
			{
				"q": 11,
				"r": -6,
				"height": 0.22788009318077634,
				"terrain": "text5"
			},
			{
				"q": 11,
				"r": -5,
				"height": 0.08905994549848195,
				"terrain": "text6"
			},
			{
				"q": 11,
				"r": -4,
				"height": 0.05112244602770388,
				"terrain": "text3"
			},
			{
				"q": 12,
				"r": -10,
				"height": -0.5807573442538172,
				"terrain": "text5"
			},
			{
				"q": 12,
				"r": -9,
				"height": -0.3069321501639656,
				"terrain": "text1"
			},
			{
				"q": 12,
				"r": -8,
				"height": 0.08485780817983568,
				"terrain": "text4"
			},
			{
				"q": 12,
				"r": -7,
				"height": 0.3453168890260936,
				"terrain": "text6"
			},
			{
				"q": 12,
				"r": -6,
				"height": 0.34214537253426475,
				"terrain": "text3"
			},
			{
				"q": 13,
				"r": -10,
				"height": -0.5572824619826358,
				"terrain": "text7"
			},
			{
				"q": 13,
				"r": -9,
				"height": -0.24160817535353585,
				"terrain": "text3"
			},
			{
				"q": 13,
				"r": -8,
				"height": 0.1673863802707769,
				"terrain": "text4"
			},
			{
				"q": 14,
				"r": -10,
				"height": -0.3830580284855267,
				"terrain": "text7"
			},
			{
				"q": -5,
				"r": 0,
				"height": -0.037493181963701036,
				"terrain": "text5"
			},
			{
				"q": -5,
				"r": 1,
				"height": -0.25792700158673265,
				"terrain": "text2"
			},
			{
				"q": -5,
				"r": 2,
				"height": -0.4755068125628798,
				"terrain": "text4"
			},
			{
				"q": -5,
				"r": 3,
				"height": -0.4861416096665009,
				"terrain": "text1"
			},
			{
				"q": -5,
				"r": 4,
				"height": -0.23376951108719835,
				"terrain": "text2"
			},
			{
				"q": -5,
				"r": 5,
				"height": 0.12400516826488694,
				"terrain": "text1"
			},
			{
				"q": -5,
				"r": 6,
				"height": 0.5154365377295476,
				"terrain": "text3"
			},
			{
				"q": -5,
				"r": 7,
				"height": 0.8431633984989211,
				"terrain": "mountain"
			},
			{
				"q": -5,
				"r": 8,
				"height": 0.8844663822336449,
				"terrain": "mountain"
			},
			{
				"q": -5,
				"r": 9,
				"height": 0.6337727329347917,
				"terrain": "text6"
			},
			{
				"q": -5,
				"r": -10,
				"height": 0.7069410456697298,
				"terrain": "text4"
			},
			{
				"q": -5,
				"r": -9,
				"height": 1.0015446121614922,
				"terrain": "mountain"
			},
			{
				"q": -5,
				"r": -8,
				"height": 1.2441286363885393,
				"terrain": "mountain"
			},
			{
				"q": -5,
				"r": -7,
				"height": 1.11158057202317,
				"terrain": "mountain"
			},
			{
				"q": -5,
				"r": -6,
				"height": 0.5406514643332574,
				"terrain": "text5"
			},
			{
				"q": -5,
				"r": -5,
				"height": -0.1265170134125893,
				"terrain": "text7"
			},
			{
				"q": -5,
				"r": -4,
				"height": -0.6047683530068966,
				"terrain": "text2"
			},
			{
				"q": -5,
				"r": -3,
				"height": -0.6582498994336244,
				"terrain": "text3"
			},
			{
				"q": -5,
				"r": -2,
				"height": -0.3545188324841413,
				"terrain": "text3"
			},
			{
				"q": -5,
				"r": -1,
				"height": -0.04600536642071458,
				"terrain": "text4"
			},
			{
				"q": -6,
				"r": 0,
				"height": 0.268956706471172,
				"terrain": "text2"
			},
			{
				"q": -6,
				"r": 1,
				"height": -0.01593015081694721,
				"terrain": "text6"
			},
			{
				"q": -6,
				"r": 2,
				"height": -0.451472584367724,
				"terrain": "text2"
			},
			{
				"q": -6,
				"r": 3,
				"height": -0.7739001841730662,
				"terrain": "text3"
			},
			{
				"q": -6,
				"r": 4,
				"height": -0.8056454354500182,
				"terrain": "text3"
			},
			{
				"q": -6,
				"r": 5,
				"height": -0.5779180899891814,
				"terrain": "text3"
			},
			{
				"q": -6,
				"r": 6,
				"height": -0.13837663820279972,
				"terrain": "text3"
			},
			{
				"q": -6,
				"r": 7,
				"height": 0.42123846052129255,
				"terrain": "text4"
			},
			{
				"q": -6,
				"r": 8,
				"height": 0.7689730718051704,
				"terrain": "mountain"
			},
			{
				"q": -6,
				"r": 9,
				"height": 0.7649333253429639,
				"terrain": "mountain"
			},
			{
				"q": -6,
				"r": -9,
				"height": 0.6897651379240504,
				"terrain": "text4"
			},
			{
				"q": -6,
				"r": -8,
				"height": 0.8228311662730506,
				"terrain": "mountain"
			},
			{
				"q": -6,
				"r": -7,
				"height": 0.5339756633161048,
				"terrain": "text2"
			},
			{
				"q": -6,
				"r": -6,
				"height": -0.13653450752000007,
				"terrain": "text6"
			},
			{
				"q": -6,
				"r": -5,
				"height": -0.8012638100122695,
				"terrain": "text6"
			},
			{
				"q": -6,
				"r": -4,
				"height": -1.1891344223236786,
				"terrain": "text3"
			},
			{
				"q": -6,
				"r": -3,
				"height": -1.0188985870491467,
				"terrain": "text2"
			},
			{
				"q": -6,
				"r": -2,
				"height": -0.4039612964960021,
				"terrain": "text2"
			},
			{
				"q": -6,
				"r": -1,
				"height": 0.16172029377942593,
				"terrain": "text1"
			},
			{
				"q": -7,
				"r": 0,
				"height": 0.5445808330388419,
				"terrain": "text5"
			},
			{
				"q": -7,
				"r": 1,
				"height": 0.2663418985366248,
				"terrain": "text4"
			},
			{
				"q": -7,
				"r": 2,
				"height": -0.34608650585905126,
				"terrain": "text5"
			},
			{
				"q": -7,
				"r": 3,
				"height": -0.9639330828889577,
				"terrain": "text1"
			},
			{
				"q": -7,
				"r": 4,
				"height": -1.266686215844109,
				"terrain": "text2"
			},
			{
				"q": -7,
				"r": 5,
				"height": -1.1421779463983783,
				"terrain": "text3"
			},
			{
				"q": -7,
				"r": 6,
				"height": -0.6560819741066061,
				"terrain": "text7"
			},
			{
				"q": -7,
				"r": 7,
				"height": 0.07841300527318623,
				"terrain": "text6"
			},
			{
				"q": -7,
				"r": 8,
				"height": 0.6682235879456002,
				"terrain": "text4"
			},
			{
				"q": -7,
				"r": 9,
				"height": 0.8844474475871495,
				"terrain": "mountain"
			},
			{
				"q": -7,
				"r": -7,
				"height": -0.19613722384111976,
				"terrain": "text6"
			},
			{
				"q": -7,
				"r": -6,
				"height": -0.827592266401537,
				"terrain": "text3"
			},
			{
				"q": -7,
				"r": -5,
				"height": -1.3727832392994996,
				"terrain": "text4"
			},
			{
				"q": -7,
				"r": -4,
				"height": -1.6042987247077396,
				"terrain": "text7"
			},
			{
				"q": -7,
				"r": -3,
				"height": -1.2454015913780048,
				"terrain": "text4"
			},
			{
				"q": -7,
				"r": -2,
				"height": -0.42135520408020577,
				"terrain": "text4"
			},
			{
				"q": -7,
				"r": -1,
				"height": 0.3280262475958131,
				"terrain": "text6"
			},
			{
				"q": -8,
				"r": 0,
				"height": 0.6633546118645495,
				"terrain": "text3"
			},
			{
				"q": -8,
				"r": 1,
				"height": 0.4698588753465105,
				"terrain": "text3"
			},
			{
				"q": -8,
				"r": 2,
				"height": -0.18023379689172264,
				"terrain": "text2"
			},
			{
				"q": -8,
				"r": 3,
				"height": -0.9449537696240233,
				"terrain": "text2"
			},
			{
				"q": -8,
				"r": 4,
				"height": -1.3695126999608829,
				"terrain": "text2"
			},
			{
				"q": -8,
				"r": 5,
				"height": -1.2510792179758816,
				"terrain": "text2"
			},
			{
				"q": -8,
				"r": 6,
				"height": -0.7404770758171522,
				"terrain": "text5"
			},
			{
				"q": -8,
				"r": 7,
				"height": -0.011473605993566227,
				"terrain": "text2"
			},
			{
				"q": -8,
				"r": 8,
				"height": 0.5748364676471995,
				"terrain": "text5"
			},
			{
				"q": -8,
				"r": 9,
				"height": 0.8355309374114269,
				"terrain": "mountain"
			},
			{
				"q": -8,
				"r": -5,
				"height": -1.4989742087098317,
				"terrain": "text7"
			},
			{
				"q": -8,
				"r": -4,
				"height": -1.5936204841931503,
				"terrain": "text6"
			},
			{
				"q": -8,
				"r": -3,
				"height": -1.2042805425198404,
				"terrain": "text6"
			},
			{
				"q": -8,
				"r": -2,
				"height": -0.3998731003277416,
				"terrain": "text3"
			},
			{
				"q": -8,
				"r": -1,
				"height": 0.36577836472438074,
				"terrain": "text2"
			},
			{
				"q": -9,
				"r": 0,
				"height": 0.48982072272125216,
				"terrain": "text7"
			},
			{
				"q": -9,
				"r": 1,
				"height": 0.4276460508093952,
				"terrain": "text5"
			},
			{
				"q": -9,
				"r": 2,
				"height": -0.09736477828500212,
				"terrain": "text4"
			},
			{
				"q": -9,
				"r": 3,
				"height": -0.7735377389834981,
				"terrain": "text6"
			},
			{
				"q": -9,
				"r": 4,
				"height": -1.14258726803895,
				"terrain": "text2"
			},
			{
				"q": -9,
				"r": 5,
				"height": -0.9818774217151256,
				"terrain": "text3"
			},
			{
				"q": -9,
				"r": 6,
				"height": -0.5033655199906978,
				"terrain": "text1"
			},
			{
				"q": -9,
				"r": 7,
				"height": 0.039210126201759954,
				"terrain": "text4"
			},
			{
				"q": -9,
				"r": 8,
				"height": 0.3807168498565636,
				"terrain": "text6"
			},
			{
				"q": -9,
				"r": 9,
				"height": 0.4940857308309149,
				"terrain": "text7"
			},
			{
				"q": -9,
				"r": -3,
				"height": -1.0506663276147132,
				"terrain": "text5"
			},
			{
				"q": -9,
				"r": -2,
				"height": -0.4814510900588167,
				"terrain": "text4"
			},
			{
				"q": -9,
				"r": -1,
				"height": 0.14636316239244168,
				"terrain": "text4"
			},
			{
				"q": -10,
				"r": 0,
				"height": 0.0831358790705336,
				"terrain": "text2"
			},
			{
				"q": -10,
				"r": 1,
				"height": 0.15990026761016812,
				"terrain": "text2"
			},
			{
				"q": -10,
				"r": 2,
				"height": -0.15241681798286943,
				"terrain": "text6"
			},
			{
				"q": -10,
				"r": 3,
				"height": -0.5870053936005019,
				"terrain": "text1"
			},
			{
				"q": -10,
				"r": 4,
				"height": -0.7873045163684588,
				"terrain": "text4"
			},
			{
				"q": -10,
				"r": 5,
				"height": -0.6065351847468633,
				"terrain": "text7"
			},
			{
				"q": -10,
				"r": 6,
				"height": -0.25482627871569963,
				"terrain": "text4"
			},
			{
				"q": -10,
				"r": 7,
				"height": 0.003949132436941588,
				"terrain": "text3"
			},
			{
				"q": -10,
				"r": 8,
				"height": 0.024050743723350226,
				"terrain": "text3"
			},
			{
				"q": -10,
				"r": 9,
				"height": -0.07081611522633748,
				"terrain": "text4"
			},
			{
				"q": -10,
				"r": -1,
				"height": -0.28443776173833923,
				"terrain": "text1"
			},
			{
				"q": -11,
				"r": 1,
				"height": -0.1700861117734429,
				"terrain": "text2"
			},
			{
				"q": -11,
				"r": 2,
				"height": -0.22552612544215614,
				"terrain": "text3"
			},
			{
				"q": -11,
				"r": 3,
				"height": -0.33210397975807093,
				"terrain": "text5"
			},
			{
				"q": -11,
				"r": 4,
				"height": -0.2858636155176005,
				"terrain": "text4"
			},
			{
				"q": -11,
				"r": 5,
				"height": -0.07069700840100496,
				"terrain": "text2"
			},
			{
				"q": -11,
				"r": 6,
				"height": 0.11215190494059091,
				"terrain": "text2"
			},
			{
				"q": -11,
				"r": 7,
				"height": 0.015277300996533322,
				"terrain": "text2"
			},
			{
				"q": -11,
				"r": 8,
				"height": -0.34559198873590646,
				"terrain": "text5"
			},
			{
				"q": -11,
				"r": 9,
				"height": -0.6693641978230207,
				"terrain": "text7"
			},
			{
				"q": -12,
				"r": 3,
				"height": -0.08872968427328293,
				"terrain": "text2"
			},
			{
				"q": -12,
				"r": 4,
				"height": 0.2623301530064232,
				"terrain": "text4"
			},
			{
				"q": -12,
				"r": 5,
				"height": 0.5693000999557102,
				"terrain": "text3"
			},
			{
				"q": -12,
				"r": 6,
				"height": 0.6372514232411226,
				"terrain": "text3"
			},
			{
				"q": -12,
				"r": 7,
				"height": 0.23045643476310312,
				"terrain": "text7"
			},
			{
				"q": -12,
				"r": 8,
				"height": -0.4976706187972034,
				"terrain": "text7"
			},
			{
				"q": -12,
				"r": 9,
				"height": -1.0759363605089516,
				"terrain": "text3"
			},
			{
				"q": -13,
				"r": 5,
				"height": 0.9039200746069546,
				"terrain": "mountain"
			},
			{
				"q": -13,
				"r": 6,
				"height": 0.9946935404786339,
				"terrain": "mountain"
			},
			{
				"q": -13,
				"r": 7,
				"height": 0.5359384391986852,
				"terrain": "text5"
			},
			{
				"q": -13,
				"r": 8,
				"height": -0.3031743667059932,
				"terrain": "text1"
			},
			{
				"q": -13,
				"r": 9,
				"height": -1.0357433895766823,
				"terrain": "text4"
			},
			{
				"q": -14,
				"r": 7,
				"height": 0.7418211103955207,
				"terrain": "text7"
			},
			{
				"q": -14,
				"r": 8,
				"height": 0.03664124055694867,
				"terrain": "text5"
			},
			{
				"q": -14,
				"r": 9,
				"height": -0.7215796940681436,
				"terrain": "text5"
			},
			{
				"q": -15,
				"r": 9,
				"height": -0.5100834469636171,
				"terrain": "text6"
			},
			{
				"q": -4,
				"r": 0,
				"height": -0.43384472218271225,
				"terrain": "text5"
			},
			{
				"q": -4,
				"r": 1,
				"height": -0.5679519097395274,
				"terrain": "text5"
			},
			{
				"q": -4,
				"r": 2,
				"height": -0.5367075365986054,
				"terrain": "text4"
			},
			{
				"q": -4,
				"r": 3,
				"height": -0.2113908194951684,
				"terrain": "text2"
			},
			{
				"q": -4,
				"r": 4,
				"height": 0.3069816832783079,
				"terrain": "text4"
			},
			{
				"q": -4,
				"r": 5,
				"height": 0.7419893668568271,
				"terrain": "text2"
			},
			{
				"q": -4,
				"r": 6,
				"height": 1.029726079293026,
				"terrain": "mountain"
			},
			{
				"q": -4,
				"r": 7,
				"height": 1.1059257169636056,
				"terrain": "mountain"
			},
			{
				"q": -4,
				"r": 8,
				"height": 0.872170342878797,
				"terrain": "mountain"
			},
			{
				"q": -4,
				"r": 9,
				"height": 0.43712307355964375,
				"terrain": "text3"
			},
			{
				"q": -4,
				"r": -10,
				"height": 0.7142559334984996,
				"terrain": "text4"
			},
			{
				"q": -4,
				"r": -9,
				"height": 0.9947512687372831,
				"terrain": "mountain"
			},
			{
				"q": -4,
				"r": -8,
				"height": 1.3085351277227546,
				"terrain": "mountain"
			},
			{
				"q": -4,
				"r": -7,
				"height": 1.334338369872978,
				"terrain": "mountain"
			},
			{
				"q": -4,
				"r": -6,
				"height": 0.9322568622617597,
				"terrain": "mountain"
			},
			{
				"q": -4,
				"r": -5,
				"height": 0.3619843666397905,
				"terrain": "text2"
			},
			{
				"q": -4,
				"r": -4,
				"height": -0.13308867733284516,
				"terrain": "text5"
			},
			{
				"q": -4,
				"r": -3,
				"height": -0.37294455167620105,
				"terrain": "text2"
			},
			{
				"q": -4,
				"r": -2,
				"height": -0.37993317380955205,
				"terrain": "text3"
			},
			{
				"q": -4,
				"r": -1,
				"height": -0.3433176032606481,
				"terrain": "text3"
			},
			{
				"q": -3,
				"r": 0,
				"height": -0.851857140770891,
				"terrain": "text5"
			},
			{
				"q": -3,
				"r": 1,
				"height": -0.8732353812721095,
				"terrain": "text7"
			},
			{
				"q": -3,
				"r": 2,
				"height": -0.5740387135802321,
				"terrain": "text4"
			},
			{
				"q": -3,
				"r": 3,
				"height": 0.04266324138152003,
				"terrain": "text2"
			},
			{
				"q": -3,
				"r": 4,
				"height": 0.7099284974449991,
				"terrain": "text4"
			},
			{
				"q": -3,
				"r": 5,
				"height": 1.1033539675679889,
				"terrain": "mountain"
			},
			{
				"q": -3,
				"r": 6,
				"height": 1.1901350461951257,
				"terrain": "mountain"
			},
			{
				"q": -3,
				"r": 7,
				"height": 0.9648371961747464,
				"terrain": "mountain"
			},
			{
				"q": -3,
				"r": 8,
				"height": 0.5162015393293089,
				"terrain": "text4"
			},
			{
				"q": -3,
				"r": 9,
				"height": 0.042403204891070814,
				"terrain": "text7"
			},
			{
				"q": -3,
				"r": -10,
				"height": 0.39361662060978553,
				"terrain": "text6"
			},
			{
				"q": -3,
				"r": -9,
				"height": 0.5640536816367528,
				"terrain": "text5"
			},
			{
				"q": -3,
				"r": -8,
				"height": 0.8307345417008712,
				"terrain": "mountain"
			},
			{
				"q": -3,
				"r": -7,
				"height": 0.9474463766545764,
				"terrain": "mountain"
			},
			{
				"q": -3,
				"r": -6,
				"height": 0.7614465298025034,
				"terrain": "mountain"
			},
			{
				"q": -3,
				"r": -5,
				"height": 0.4150333482782057,
				"terrain": "text5"
			},
			{
				"q": -3,
				"r": -4,
				"height": 0.030191734514328994,
				"terrain": "text1"
			},
			{
				"q": -3,
				"r": -3,
				"height": -0.28465038719999963,
				"terrain": "text2"
			},
			{
				"q": -3,
				"r": -2,
				"height": -0.518040943555556,
				"terrain": "text2"
			},
			{
				"q": -3,
				"r": -1,
				"height": -0.7035462131027435,
				"terrain": "text5"
			},
			{
				"q": -2,
				"r": 0,
				"height": -0.9642879716305783,
				"terrain": "text3"
			},
			{
				"q": -2,
				"r": 1,
				"height": -0.8957202814288638,
				"terrain": "text4"
			},
			{
				"q": -2,
				"r": 2,
				"height": -0.4725647391167452,
				"terrain": "text3"
			},
			{
				"q": -2,
				"r": 3,
				"height": 0.18772308971559248,
				"terrain": "text4"
			},
			{
				"q": -2,
				"r": 4,
				"height": 0.7621409060595941,
				"terrain": "mountain"
			},
			{
				"q": -2,
				"r": 5,
				"height": 0.9876104862917603,
				"terrain": "mountain"
			},
			{
				"q": -2,
				"r": 6,
				"height": 0.8535857242528571,
				"terrain": "mountain"
			},
			{
				"q": -2,
				"r": 7,
				"height": 0.3887473392353561,
				"terrain": "text1"
			},
			{
				"q": -2,
				"r": 8,
				"height": -0.14292282855578334,
				"terrain": "text4"
			},
			{
				"q": -2,
				"r": 9,
				"height": -0.4896193487618877,
				"terrain": "text4"
			},
			{
				"q": -2,
				"r": -10,
				"height": -0.09766119377839806,
				"terrain": "text4"
			},
			{
				"q": -2,
				"r": -9,
				"height": -0.07760603884212901,
				"terrain": "text4"
			},
			{
				"q": -2,
				"r": -8,
				"height": 0.05978635212946961,
				"terrain": "text4"
			},
			{
				"q": -2,
				"r": -7,
				"height": 0.18452911275347963,
				"terrain": "text3"
			},
			{
				"q": -2,
				"r": -6,
				"height": 0.19971064366690133,
				"terrain": "text6"
			},
			{
				"q": -2,
				"r": -5,
				"height": 0.14247831109856057,
				"terrain": "text6"
			},
			{
				"q": -2,
				"r": -4,
				"height": -0.01624669278903121,
				"terrain": "text6"
			},
			{
				"q": -2,
				"r": -3,
				"height": -0.2599593768144873,
				"terrain": "text3"
			},
			{
				"q": -2,
				"r": -2,
				"height": -0.5558105411521416,
				"terrain": "text2"
			},
			{
				"q": -2,
				"r": -1,
				"height": -0.8271715254397868,
				"terrain": "text1"
			},
			{
				"q": -1,
				"r": 0,
				"height": -0.6252736667078188,
				"terrain": "text4"
			},
			{
				"q": -1,
				"r": 1,
				"height": -0.5357240437673798,
				"terrain": "text6"
			},
			{
				"q": -1,
				"r": 2,
				"height": -0.19494779632537992,
				"terrain": "text5"
			},
			{
				"q": -1,
				"r": 3,
				"height": 0.24353821000883868,
				"terrain": "text2"
			},
			{
				"q": -1,
				"r": 4,
				"height": 0.5356515847970651,
				"terrain": "text6"
			},
			{
				"q": -1,
				"r": 5,
				"height": 0.5416425624932999,
				"terrain": "text2"
			},
			{
				"q": -1,
				"r": 6,
				"height": 0.24338133531638245,
				"terrain": "text6"
			},
			{
				"q": -1,
				"r": 7,
				"height": -0.3105117494860267,
				"terrain": "text3"
			},
			{
				"q": -1,
				"r": 8,
				"height": -0.7670382905106538,
				"terrain": "text6"
			},
			{
				"q": -1,
				"r": 9,
				"height": -0.8992424051695497,
				"terrain": "text4"
			},
			{
				"q": -1,
				"r": -10,
				"height": -0.485991066698769,
				"terrain": "text6"
			},
			{
				"q": -1,
				"r": -9,
				"height": -0.536037611344734,
				"terrain": "text2"
			},
			{
				"q": -1,
				"r": -8,
				"height": -0.4826083341851441,
				"terrain": "text6"
			},
			{
				"q": -1,
				"r": -7,
				"height": -0.3712370053820002,
				"terrain": "text7"
			},
			{
				"q": -1,
				"r": -6,
				"height": -0.21999411856220755,
				"terrain": "text6"
			},
			{
				"q": -1,
				"r": -5,
				"height": -0.04506790369974567,
				"terrain": "text1"
			},
			{
				"q": -1,
				"r": -4,
				"height": 0.017176924103870343,
				"terrain": "text5"
			},
			{
				"q": -1,
				"r": -3,
				"height": -0.07977345522960397,
				"terrain": "text5"
			},
			{
				"q": -1,
				"r": -2,
				"height": -0.3051575012973946,
				"terrain": "text2"
			},
			{
				"q": -1,
				"r": -1,
				"height": -0.5384094683159281,
				"terrain": "text5"
			}
		],
		"halfWidth": 10,
		"halfHeight": 10
	}
	},
  "seed_4":{
	"map_id":"seed_4",
	"data": {
		"_width": 20,
		"_height": 20,
		"data": [
			{
				"q": 0,
				"r": 0,
				"height": 0,
				"terrain": "text3"
			},
			{
				"q": 0,
				"r": 1,
				"height": -0.5785973045679013,
				"terrain": "text4"
			},
			{
				"q": 0,
				"r": 2,
				"height": -0.7676070228793411,
				"terrain": "text5"
			},
			{
				"q": 0,
				"r": 3,
				"height": -0.5244613438793689,
				"terrain": "text5"
			},
			{
				"q": 0,
				"r": 4,
				"height": -0.09949608730670247,
				"terrain": "text2"
			},
			{
				"q": 0,
				"r": 5,
				"height": 0.14605693759720134,
				"terrain": "text6"
			},
			{
				"q": 0,
				"r": 6,
				"height": 0.0941378676396756,
				"terrain": "text7"
			},
			{
				"q": 0,
				"r": 7,
				"height": -0.14939440245630548,
				"terrain": "text2"
			},
			{
				"q": 0,
				"r": 8,
				"height": -0.36181584792951255,
				"terrain": "text6"
			},
			{
				"q": 0,
				"r": 9,
				"height": -0.49520086050591383,
				"terrain": "text5"
			},
			{
				"q": 0,
				"r": -10,
				"height": 0.8907694433355123,
				"terrain": "mountain"
			},
			{
				"q": 0,
				"r": -9,
				"height": 1.0407447874718754,
				"terrain": "mountain"
			},
			{
				"q": 0,
				"r": -8,
				"height": 1.011986902723934,
				"terrain": "mountain"
			},
			{
				"q": 0,
				"r": -7,
				"height": 0.78522782751834,
				"terrain": "mountain"
			},
			{
				"q": 0,
				"r": -6,
				"height": 0.4266475282089695,
				"terrain": "text2"
			},
			{
				"q": 0,
				"r": -5,
				"height": 0.19113501707564864,
				"terrain": "text6"
			},
			{
				"q": 0,
				"r": -4,
				"height": 0.2533095670083544,
				"terrain": "text7"
			},
			{
				"q": 0,
				"r": -3,
				"height": 0.5622271762985095,
				"terrain": "text3"
			},
			{
				"q": 0,
				"r": -2,
				"height": 0.7697081739118977,
				"terrain": "mountain"
			},
			{
				"q": 0,
				"r": -1,
				"height": 0.5785973045679017,
				"terrain": "text3"
			},
			{
				"q": 1,
				"r": 0,
				"height": 0.625273666707819,
				"terrain": "text7"
			},
			{
				"q": 1,
				"r": 1,
				"height": 0.03587995816382188,
				"terrain": "text6"
			},
			{
				"q": 1,
				"r": 2,
				"height": -0.2581914060673892,
				"terrain": "text7"
			},
			{
				"q": 1,
				"r": 3,
				"height": -0.1851822480472152,
				"terrain": "text3"
			},
			{
				"q": 1,
				"r": 4,
				"height": 0.07711813789920154,
				"terrain": "text1"
			},
			{
				"q": 1,
				"r": 5,
				"height": 0.23329004473166615,
				"terrain": "text5"
			},
			{
				"q": 1,
				"r": 6,
				"height": 0.15460649823789002,
				"terrain": "text4"
			},
			{
				"q": 1,
				"r": 7,
				"height": -0.11885646185108698,
				"terrain": "text4"
			},
			{
				"q": 1,
				"r": 8,
				"height": -0.3820073877708523,
				"terrain": "text5"
			},
			{
				"q": 1,
				"r": 9,
				"height": -0.5637006575610445,
				"terrain": "text1"
			},
			{
				"q": 1,
				"r": -10,
				"height": 0.7619399439411654,
				"terrain": "mountain"
			},
			{
				"q": 1,
				"r": -9,
				"height": 0.767963521655475,
				"terrain": "mountain"
			},
			{
				"q": 1,
				"r": -8,
				"height": 0.6289957359229016,
				"terrain": "text7"
			},
			{
				"q": 1,
				"r": -7,
				"height": 0.34392335625768067,
				"terrain": "text5"
			},
			{
				"q": 1,
				"r": -6,
				"height": -0.010261808135775652,
				"terrain": "text2"
			},
			{
				"q": 1,
				"r": -5,
				"height": -0.17212204713181498,
				"terrain": "text4"
			},
			{
				"q": 1,
				"r": -4,
				"height": 0.058101326345729176,
				"terrain": "text4"
			},
			{
				"q": 1,
				"r": -3,
				"height": 0.6358632339509965,
				"terrain": "text2"
			},
			{
				"q": 1,
				"r": -2,
				"height": 1.1221303182383815,
				"terrain": "mountain"
			},
			{
				"q": 1,
				"r": -1,
				"height": 1.123493775184315,
				"terrain": "mountain"
			},
			{
				"q": 2,
				"r": 0,
				"height": 0.964292281412326,
				"terrain": "mountain"
			},
			{
				"q": 2,
				"r": 1,
				"height": 0.4392428620213667,
				"terrain": "text4"
			},
			{
				"q": 2,
				"r": 2,
				"height": 0.16277951211184308,
				"terrain": "text5"
			},
			{
				"q": 2,
				"r": 3,
				"height": 0.22225310186279537,
				"terrain": "text3"
			},
			{
				"q": 2,
				"r": 4,
				"height": 0.44251435793264376,
				"terrain": "text6"
			},
			{
				"q": 2,
				"r": 5,
				"height": 0.562175801692732,
				"terrain": "text3"
			},
			{
				"q": 2,
				"r": 6,
				"height": 0.4715815376212646,
				"terrain": "text2"
			},
			{
				"q": 2,
				"r": 7,
				"height": 0.1419365652788664,
				"terrain": "text2"
			},
			{
				"q": 2,
				"r": 8,
				"height": -0.2501257140553581,
				"terrain": "text6"
			},
			{
				"q": 2,
				"r": 9,
				"height": -0.55876870788416,
				"terrain": "text2"
			},
			{
				"q": 2,
				"r": -10,
				"height": 0.37144309890821137,
				"terrain": "text4"
			},
			{
				"q": 2,
				"r": -9,
				"height": 0.25746413501373916,
				"terrain": "text6"
			},
			{
				"q": 2,
				"r": -8,
				"height": 0.08195021612575956,
				"terrain": "text4"
			},
			{
				"q": 2,
				"r": -7,
				"height": -0.13245219784437282,
				"terrain": "text3"
			},
			{
				"q": 2,
				"r": -6,
				"height": -0.3460832635292356,
				"terrain": "text6"
			},
			{
				"q": 2,
				"r": -5,
				"height": -0.3781158431453907,
				"terrain": "text4"
			},
			{
				"q": 2,
				"r": -4,
				"height": -0.014331750438683122,
				"terrain": "text5"
			},
			{
				"q": 2,
				"r": -3,
				"height": 0.6947816124733784,
				"terrain": "text7"
			},
			{
				"q": 2,
				"r": -2,
				"height": 1.2818031122292664,
				"terrain": "mountain"
			},
			{
				"q": 2,
				"r": -1,
				"height": 1.366666839846215,
				"terrain": "mountain"
			},
			{
				"q": 3,
				"r": 0,
				"height": 0.8517542981828358,
				"terrain": "mountain"
			},
			{
				"q": 3,
				"r": 1,
				"height": 0.45839090620945994,
				"terrain": "text1"
			},
			{
				"q": 3,
				"r": 2,
				"height": 0.288624679212212,
				"terrain": "text3"
			},
			{
				"q": 3,
				"r": 3,
				"height": 0.42861816388638824,
				"terrain": "text3"
			},
			{
				"q": 3,
				"r": 4,
				"height": 0.6957633072026163,
				"terrain": "text4"
			},
			{
				"q": 3,
				"r": 5,
				"height": 0.8276218712574346,
				"terrain": "mountain"
			},
			{
				"q": 3,
				"r": 6,
				"height": 0.7632073983561822,
				"terrain": "mountain"
			},
			{
				"q": 3,
				"r": 7,
				"height": 0.45229639995274795,
				"terrain": "text4"
			},
			{
				"q": 3,
				"r": 8,
				"height": 0.02320461927544558,
				"terrain": "text7"
			},
			{
				"q": 3,
				"r": 9,
				"height": -0.3363990353906059,
				"terrain": "text6"
			},
			{
				"q": 3,
				"r": -10,
				"height": 0.0690832631387947,
				"terrain": "text2"
			},
			{
				"q": 3,
				"r": -9,
				"height": -0.12720307089923288,
				"terrain": "text1"
			},
			{
				"q": 3,
				"r": -8,
				"height": -0.3254942756137532,
				"terrain": "text5"
			},
			{
				"q": 3,
				"r": -7,
				"height": -0.45710421754363484,
				"terrain": "text5"
			},
			{
				"q": 3,
				"r": -6,
				"height": -0.49768308059512534,
				"terrain": "text6"
			},
			{
				"q": 3,
				"r": -5,
				"height": -0.3744464786791,
				"terrain": "text4"
			},
			{
				"q": 3,
				"r": -4,
				"height": 0.058524203959445326,
				"terrain": "text5"
			},
			{
				"q": 3,
				"r": -3,
				"height": 0.7091363534984803,
				"terrain": "text1"
			},
			{
				"q": 3,
				"r": -2,
				"height": 1.162387900762455,
				"terrain": "mountain"
			},
			{
				"q": 3,
				"r": -1,
				"height": 1.1769150454498882,
				"terrain": "mountain"
			},
			{
				"q": 4,
				"r": 0,
				"height": 0.4286351620125708,
				"terrain": "text2"
			},
			{
				"q": 4,
				"r": 1,
				"height": 0.16938275058947128,
				"terrain": "text1"
			},
			{
				"q": 4,
				"r": 2,
				"height": 0.11969937138244173,
				"terrain": "text4"
			},
			{
				"q": 4,
				"r": 3,
				"height": 0.3241331526444045,
				"terrain": "text4"
			},
			{
				"q": 4,
				"r": 4,
				"height": 0.6120403598308183,
				"terrain": "text4"
			},
			{
				"q": 4,
				"r": 5,
				"height": 0.7513559029473147,
				"terrain": "mountain"
			},
			{
				"q": 4,
				"r": 6,
				"height": 0.7307930435518994,
				"terrain": "text2"
			},
			{
				"q": 4,
				"r": 7,
				"height": 0.5376168837257683,
				"terrain": "text4"
			},
			{
				"q": 4,
				"r": 8,
				"height": 0.24364788444987712,
				"terrain": "text6"
			},
			{
				"q": 4,
				"r": 9,
				"height": -0.007216047583015875,
				"terrain": "text5"
			},
			{
				"q": 4,
				"r": -10,
				"height": 0.03732627600078334,
				"terrain": "text3"
			},
			{
				"q": 4,
				"r": -9,
				"height": -0.19431340569648292,
				"terrain": "text6"
			},
			{
				"q": 4,
				"r": -8,
				"height": -0.42925646242789,
				"terrain": "text2"
			},
			{
				"q": 4,
				"r": -7,
				"height": -0.5424178424717738,
				"terrain": "text2"
			},
			{
				"q": 4,
				"r": -6,
				"height": -0.460623987367429,
				"terrain": "text3"
			},
			{
				"q": 4,
				"r": -5,
				"height": -0.20401674128907854,
				"terrain": "text5"
			},
			{
				"q": 4,
				"r": -4,
				"height": 0.20899964893038356,
				"terrain": "text3"
			},
			{
				"q": 4,
				"r": -3,
				"height": 0.6591881740416703,
				"terrain": "text6"
			},
			{
				"q": 4,
				"r": -2,
				"height": 0.8508424545438457,
				"terrain": "mountain"
			},
			{
				"q": 4,
				"r": -1,
				"height": 0.716398363320186,
				"terrain": "text6"
			},
			{
				"q": 5,
				"r": 0,
				"height": 0.017770549714346967,
				"terrain": "text2"
			},
			{
				"q": 5,
				"r": 1,
				"height": -0.16841883564905152,
				"terrain": "text7"
			},
			{
				"q": 5,
				"r": 2,
				"height": -0.16109589669228394,
				"terrain": "text6"
			},
			{
				"q": 5,
				"r": 3,
				"height": 0.029720293380509688,
				"terrain": "text4"
			},
			{
				"q": 5,
				"r": 4,
				"height": 0.24538233575963364,
				"terrain": "text6"
			},
			{
				"q": 5,
				"r": 5,
				"height": 0.33102903369529524,
				"terrain": "text2"
			},
			{
				"q": 5,
				"r": 6,
				"height": 0.33058949680197547,
				"terrain": "text3"
			},
			{
				"q": 5,
				"r": 7,
				"height": 0.2854019322446183,
				"terrain": "text1"
			},
			{
				"q": 5,
				"r": 8,
				"height": 0.2144664930651566,
				"terrain": "text3"
			},
			{
				"q": 5,
				"r": -10,
				"height": 0.2573171297389058,
				"terrain": "text3"
			},
			{
				"q": 5,
				"r": -9,
				"height": 0.038616811995588946,
				"terrain": "text6"
			},
			{
				"q": 5,
				"r": -8,
				"height": -0.2422395439417177,
				"terrain": "text2"
			},
			{
				"q": 5,
				"r": -7,
				"height": -0.3961598333106874,
				"terrain": "text6"
			},
			{
				"q": 5,
				"r": -6,
				"height": -0.2793531052192594,
				"terrain": "text5"
			},
			{
				"q": 5,
				"r": -5,
				"height": 0.03313987758686307,
				"terrain": "text3"
			},
			{
				"q": 5,
				"r": -4,
				"height": 0.36287298340544205,
				"terrain": "text5"
			},
			{
				"q": 5,
				"r": -3,
				"height": 0.5960355482673237,
				"terrain": "text5"
			},
			{
				"q": 5,
				"r": -2,
				"height": 0.567020806020178,
				"terrain": "text6"
			},
			{
				"q": 5,
				"r": -1,
				"height": 0.3132547828957325,
				"terrain": "text3"
			},
			{
				"q": 6,
				"r": 0,
				"height": -0.20950331646077924,
				"terrain": "text4"
			},
			{
				"q": 6,
				"r": 1,
				"height": -0.3691630302300244,
				"terrain": "text5"
			},
			{
				"q": 6,
				"r": 2,
				"height": -0.3616107222818472,
				"terrain": "text3"
			},
			{
				"q": 6,
				"r": 3,
				"height": -0.2506835707885499,
				"terrain": "text3"
			},
			{
				"q": 6,
				"r": 4,
				"height": -0.16959248391668938,
				"terrain": "text7"
			},
			{
				"q": 6,
				"r": 5,
				"height": -0.18563533378642555,
				"terrain": "text5"
			},
			{
				"q": 6,
				"r": 6,
				"height": -0.19402570429666072,
				"terrain": "text2"
			},
			{
				"q": 6,
				"r": -10,
				"height": 0.7489790119726968,
				"terrain": "text1"
			},
			{
				"q": 6,
				"r": -9,
				"height": 0.5766803043907471,
				"terrain": "text3"
			},
			{
				"q": 6,
				"r": -8,
				"height": 0.2680377444687394,
				"terrain": "text5"
			},
			{
				"q": 6,
				"r": -7,
				"height": 0.04938109498422172,
				"terrain": "text4"
			},
			{
				"q": 6,
				"r": -6,
				"height": 0.10678676044279989,
				"terrain": "text4"
			},
			{
				"q": 6,
				"r": -5,
				"height": 0.35948986315790565,
				"terrain": "text6"
			},
			{
				"q": 6,
				"r": -4,
				"height": 0.5591587214444212,
				"terrain": "text2"
			},
			{
				"q": 6,
				"r": -3,
				"height": 0.6088065356130662,
				"terrain": "text2"
			},
			{
				"q": 6,
				"r": -2,
				"height": 0.43732709860904073,
				"terrain": "text6"
			},
			{
				"q": 6,
				"r": -1,
				"height": 0.1093258454825057,
				"terrain": "text1"
			},
			{
				"q": 7,
				"r": 0,
				"height": -0.19408840572789524,
				"terrain": "text4"
			},
			{
				"q": 7,
				"r": 1,
				"height": -0.2685746421656435,
				"terrain": "text2"
			},
			{
				"q": 7,
				"r": 2,
				"height": -0.2183200030369268,
				"terrain": "text4"
			},
			{
				"q": 7,
				"r": 3,
				"height": -0.19799779927878236,
				"terrain": "text6"
			},
			{
				"q": 7,
				"r": 4,
				"height": -0.300289969529173,
				"terrain": "text6"
			},
			{
				"q": 7,
				"r": -10,
				"height": 1.2861490142442962,
				"terrain": "mountain"
			},
			{
				"q": 7,
				"r": -9,
				"height": 1.1842111186232205,
				"terrain": "mountain"
			},
			{
				"q": 7,
				"r": -8,
				"height": 0.9292911272822736,
				"terrain": "mountain"
			},
			{
				"q": 7,
				"r": -7,
				"height": 0.7063588331109295,
				"terrain": "text1"
			},
			{
				"q": 7,
				"r": -6,
				"height": 0.6746269563373878,
				"terrain": "text3"
			},
			{
				"q": 7,
				"r": -5,
				"height": 0.7751849837890197,
				"terrain": "mountain"
			},
			{
				"q": 7,
				"r": -4,
				"height": 0.7769550991132603,
				"terrain": "mountain"
			},
			{
				"q": 7,
				"r": -3,
				"height": 0.630490988608793,
				"terrain": "text7"
			},
			{
				"q": 7,
				"r": -2,
				"height": 0.3729113440824924,
				"terrain": "text6"
			},
			{
				"q": 7,
				"r": -1,
				"height": 0.061926271085320644,
				"terrain": "text1"
			},
			{
				"q": 8,
				"r": 0,
				"height": -0.13065279899487178,
				"terrain": "text4"
			},
			{
				"q": 8,
				"r": 1,
				"height": -0.0410850404801506,
				"terrain": "text1"
			},
			{
				"q": 8,
				"r": 2,
				"height": 0.15451209223261142,
				"terrain": "text2"
			},
			{
				"q": 8,
				"r": -10,
				"height": 1.381761451545266,
				"terrain": "mountain"
			},
			{
				"q": 8,
				"r": -9,
				"height": 1.3571256512582028,
				"terrain": "mountain"
			},
			{
				"q": 8,
				"r": -8,
				"height": 1.2523186781606066,
				"terrain": "mountain"
			},
			{
				"q": 8,
				"r": -7,
				"height": 1.1458311641790135,
				"terrain": "mountain"
			},
			{
				"q": 8,
				"r": -6,
				"height": 1.0987972082207738,
				"terrain": "mountain"
			},
			{
				"q": 8,
				"r": -5,
				"height": 1.0721106078270224,
				"terrain": "mountain"
			},
			{
				"q": 8,
				"r": -4,
				"height": 0.9061336600371634,
				"terrain": "mountain"
			},
			{
				"q": 8,
				"r": -3,
				"height": 0.5741659837211425,
				"terrain": "text6"
			},
			{
				"q": 8,
				"r": -2,
				"height": 0.23087988958221106,
				"terrain": "text4"
			},
			{
				"q": 8,
				"r": -1,
				"height": -0.01143185224695814,
				"terrain": "text2"
			},
			{
				"q": 9,
				"r": 0,
				"height": -0.10172364159141961,
				"terrain": "text4"
			},
			{
				"q": 9,
				"r": -10,
				"height": 0.954207378641975,
				"terrain": "mountain"
			},
			{
				"q": 9,
				"r": -9,
				"height": 0.9879641957290846,
				"terrain": "mountain"
			},
			{
				"q": 9,
				"r": -8,
				"height": 1.0512728598922432,
				"terrain": "mountain"
			},
			{
				"q": 9,
				"r": -7,
				"height": 1.1138645813564292,
				"terrain": "mountain"
			},
			{
				"q": 9,
				"r": -6,
				"height": 1.1352033889044817,
				"terrain": "mountain"
			},
			{
				"q": 9,
				"r": -5,
				"height": 1.0784392871304784,
				"terrain": "mountain"
			},
			{
				"q": 9,
				"r": -4,
				"height": 0.8401936301193142,
				"terrain": "mountain"
			},
			{
				"q": 9,
				"r": -3,
				"height": 0.400458504220344,
				"terrain": "text3"
			},
			{
				"q": 9,
				"r": -2,
				"height": 0.02254885427380876,
				"terrain": "text5"
			},
			{
				"q": 9,
				"r": -1,
				"height": -0.13673864281880094,
				"terrain": "text1"
			},
			{
				"q": 10,
				"r": -10,
				"height": 0.3350099070263679,
				"terrain": "text2"
			},
			{
				"q": 10,
				"r": -9,
				"height": 0.40750470781892983,
				"terrain": "text4"
			},
			{
				"q": 10,
				"r": -8,
				"height": 0.5760303914440756,
				"terrain": "text3"
			},
			{
				"q": 10,
				"r": -7,
				"height": 0.7399838185050513,
				"terrain": "text2"
			},
			{
				"q": 10,
				"r": -6,
				"height": 0.8237559381633652,
				"terrain": "mountain"
			},
			{
				"q": 10,
				"r": -5,
				"height": 0.7973640056739666,
				"terrain": "mountain"
			},
			{
				"q": 10,
				"r": -4,
				"height": 0.5807789228733238,
				"terrain": "text1"
			},
			{
				"q": 10,
				"r": -3,
				"height": 0.1644092412051626,
				"terrain": "text2"
			},
			{
				"q": 10,
				"r": -2,
				"height": -0.15986174094364192,
				"terrain": "text5"
			},
			{
				"q": 11,
				"r": -10,
				"height": -0.2863566067068033,
				"terrain": "text6"
			},
			{
				"q": 11,
				"r": -9,
				"height": -0.17284979814452728,
				"terrain": "text7"
			},
			{
				"q": 11,
				"r": -8,
				"height": 0.08001062209503795,
				"terrain": "text4"
			},
			{
				"q": 11,
				"r": -7,
				"height": 0.31750347058483264,
				"terrain": "text7"
			},
			{
				"q": 11,
				"r": -6,
				"height": 0.45671981545949,
				"terrain": "text3"
			},
			{
				"q": 11,
				"r": -5,
				"height": 0.4900556855898885,
				"terrain": "text7"
			},
			{
				"q": 11,
				"r": -4,
				"height": 0.3499134615851574,
				"terrain": "text6"
			},
			{
				"q": 12,
				"r": -10,
				"height": -0.7203673825390284,
				"terrain": "text6"
			},
			{
				"q": 12,
				"r": -9,
				"height": -0.5450208390310942,
				"terrain": "text5"
			},
			{
				"q": 12,
				"r": -8,
				"height": -0.21913549601711918,
				"terrain": "text4"
			},
			{
				"q": 12,
				"r": -7,
				"height": 0.06341527930323321,
				"terrain": "text2"
			},
			{
				"q": 12,
				"r": -6,
				"height": 0.22227557869721482,
				"terrain": "text1"
			},
			{
				"q": 13,
				"r": -10,
				"height": -0.6378900366847584,
				"terrain": "text2"
			},
			{
				"q": 13,
				"r": -9,
				"height": -0.4406821128850562,
				"terrain": "text2"
			},
			{
				"q": 13,
				"r": -8,
				"height": -0.11452146961457893,
				"terrain": "text5"
			},
			{
				"q": 14,
				"r": -10,
				"height": -0.1259211039024945,
				"terrain": "text4"
			},
			{
				"q": -5,
				"r": 0,
				"height": -0.7104453863118732,
				"terrain": "text3"
			},
			{
				"q": -5,
				"r": 1,
				"height": -0.8548213081701983,
				"terrain": "text6"
			},
			{
				"q": -5,
				"r": 2,
				"height": -0.7635220448013067,
				"terrain": "text4"
			},
			{
				"q": -5,
				"r": 3,
				"height": -0.5701813821070743,
				"terrain": "text2"
			},
			{
				"q": -5,
				"r": 4,
				"height": -0.4020143998520423,
				"terrain": "text6"
			},
			{
				"q": -5,
				"r": 5,
				"height": -0.30799103287100543,
				"terrain": "text2"
			},
			{
				"q": -5,
				"r": 6,
				"height": -0.3193238867310746,
				"terrain": "text2"
			},
			{
				"q": -5,
				"r": 7,
				"height": -0.3934873052326138,
				"terrain": "text2"
			},
			{
				"q": -5,
				"r": 8,
				"height": -0.4195373904254491,
				"terrain": "text6"
			},
			{
				"q": -5,
				"r": 9,
				"height": -0.3976138451589345,
				"terrain": "text4"
			},
			{
				"q": -5,
				"r": -10,
				"height": 0.19958295453352276,
				"terrain": "text4"
			},
			{
				"q": -5,
				"r": -9,
				"height": 0.1751192685681049,
				"terrain": "text6"
			},
			{
				"q": -5,
				"r": -8,
				"height": 0.21339113727589681,
				"terrain": "text6"
			},
			{
				"q": -5,
				"r": -7,
				"height": 0.26908467938682223,
				"terrain": "text2"
			},
			{
				"q": -5,
				"r": -6,
				"height": 0.28991619639045274,
				"terrain": "text3"
			},
			{
				"q": -5,
				"r": -5,
				"height": 0.25685533367497293,
				"terrain": "text4"
			},
			{
				"q": -5,
				"r": -4,
				"height": 0.1744073412941466,
				"terrain": "text2"
			},
			{
				"q": -5,
				"r": -3,
				"height": 0.04408875917067931,
				"terrain": "text5"
			},
			{
				"q": -5,
				"r": -2,
				"height": -0.16145939967952994,
				"terrain": "text3"
			},
			{
				"q": -5,
				"r": -1,
				"height": -0.43532177369564523,
				"terrain": "text2"
			},
			{
				"q": -6,
				"r": 0,
				"height": -0.4736458140048774,
				"terrain": "text4"
			},
			{
				"q": -6,
				"r": 1,
				"height": -0.6343722004006134,
				"terrain": "text5"
			},
			{
				"q": -6,
				"r": 2,
				"height": -0.6919918521142332,
				"terrain": "text4"
			},
			{
				"q": -6,
				"r": 3,
				"height": -0.7255838510184746,
				"terrain": "text7"
			},
			{
				"q": -6,
				"r": 4,
				"height": -0.7434015451443616,
				"terrain": "text2"
			},
			{
				"q": -6,
				"r": 5,
				"height": -0.7088630804294189,
				"terrain": "text2"
			},
			{
				"q": -6,
				"r": 6,
				"height": -0.65122522112,
				"terrain": "text4"
			},
			{
				"q": -6,
				"r": 7,
				"height": -0.5590017997597503,
				"terrain": "text3"
			},
			{
				"q": -6,
				"r": 8,
				"height": -0.41007143838380394,
				"terrain": "text5"
			},
			{
				"q": -6,
				"r": 9,
				"height": -0.2801276826477337,
				"terrain": "text7"
			},
			{
				"q": -6,
				"r": -9,
				"height": 0.07345834275306334,
				"terrain": "text3"
			},
			{
				"q": -6,
				"r": -8,
				"height": -0.07831924302445174,
				"terrain": "text5"
			},
			{
				"q": -6,
				"r": -7,
				"height": -0.22196284921959886,
				"terrain": "text5"
			},
			{
				"q": -6,
				"r": -6,
				"height": -0.3112075948566611,
				"terrain": "text6"
			},
			{
				"q": -6,
				"r": -5,
				"height": -0.3306345601238747,
				"terrain": "text5"
			},
			{
				"q": -6,
				"r": -4,
				"height": -0.30453620370896917,
				"terrain": "text5"
			},
			{
				"q": -6,
				"r": -3,
				"height": -0.22799929935079238,
				"terrain": "text4"
			},
			{
				"q": -6,
				"r": -2,
				"height": -0.1917556038742299,
				"terrain": "text4"
			},
			{
				"q": -6,
				"r": -1,
				"height": -0.2801186039438697,
				"terrain": "text6"
			},
			{
				"q": -7,
				"r": 0,
				"height": -0.25997951110653605,
				"terrain": "text6"
			},
			{
				"q": -7,
				"r": 1,
				"height": -0.439858781464999,
				"terrain": "text3"
			},
			{
				"q": -7,
				"r": 2,
				"height": -0.6180657554546061,
				"terrain": "text6"
			},
			{
				"q": -7,
				"r": 3,
				"height": -0.7613170438215637,
				"terrain": "text3"
			},
			{
				"q": -7,
				"r": 4,
				"height": -0.8282835651213657,
				"terrain": "text2"
			},
			{
				"q": -7,
				"r": 5,
				"height": -0.7739985567518398,
				"terrain": "text3"
			},
			{
				"q": -7,
				"r": 6,
				"height": -0.6112211928071636,
				"terrain": "text5"
			},
			{
				"q": -7,
				"r": 7,
				"height": -0.430932253439155,
				"terrain": "text1"
			},
			{
				"q": -7,
				"r": 8,
				"height": -0.27165425009770294,
				"terrain": "text3"
			},
			{
				"q": -7,
				"r": 9,
				"height": -0.18054167053567755,
				"terrain": "text6"
			},
			{
				"q": -7,
				"r": -7,
				"height": -0.6966724270056477,
				"terrain": "text2"
			},
			{
				"q": -7,
				"r": -6,
				"height": -0.7378235995271214,
				"terrain": "text5"
			},
			{
				"q": -7,
				"r": -5,
				"height": -0.6742892021876851,
				"terrain": "text6"
			},
			{
				"q": -7,
				"r": -4,
				"height": -0.5160257676175051,
				"terrain": "text6"
			},
			{
				"q": -7,
				"r": -3,
				"height": -0.2690301236960716,
				"terrain": "text3"
			},
			{
				"q": -7,
				"r": -2,
				"height": -0.09808168210768645,
				"terrain": "text6"
			},
			{
				"q": -7,
				"r": -1,
				"height": -0.11126392342706459,
				"terrain": "text6"
			},
			{
				"q": -8,
				"r": 0,
				"height": -0.10168133630527487,
				"terrain": "text2"
			},
			{
				"q": -8,
				"r": 1,
				"height": -0.2846699780196441,
				"terrain": "text4"
			},
			{
				"q": -8,
				"r": 2,
				"height": -0.5152341667994318,
				"terrain": "text4"
			},
			{
				"q": -8,
				"r": 3,
				"height": -0.6521396836081663,
				"terrain": "text3"
			},
			{
				"q": -8,
				"r": 4,
				"height": -0.6401750422098913,
				"terrain": "text2"
			},
			{
				"q": -8,
				"r": 5,
				"height": -0.4912804314238622,
				"terrain": "text2"
			},
			{
				"q": -8,
				"r": 6,
				"height": -0.23336824885372656,
				"terrain": "text7"
			},
			{
				"q": -8,
				"r": 7,
				"height": -0.05338998273277984,
				"terrain": "text2"
			},
			{
				"q": -8,
				"r": 8,
				"height": -0.011835707589225142,
				"terrain": "text6"
			},
			{
				"q": -8,
				"r": 9,
				"height": -0.06383917758811436,
				"terrain": "text3"
			},
			{
				"q": -8,
				"r": -5,
				"height": -0.6902844629053504,
				"terrain": "text4"
			},
			{
				"q": -8,
				"r": -4,
				"height": -0.404125944669994,
				"terrain": "text5"
			},
			{
				"q": -8,
				"r": -3,
				"height": -0.06355152805325731,
				"terrain": "text5"
			},
			{
				"q": -8,
				"r": -2,
				"height": 0.10350606534802398,
				"terrain": "text2"
			},
			{
				"q": -8,
				"r": -1,
				"height": 0.040930008074947066,
				"terrain": "text4"
			},
			{
				"q": -9,
				"r": 0,
				"height": 0.009334300661865469,
				"terrain": "text6"
			},
			{
				"q": -9,
				"r": 1,
				"height": -0.17148594839972842,
				"terrain": "text5"
			},
			{
				"q": -9,
				"r": 2,
				"height": -0.3857316508810119,
				"terrain": "text5"
			},
			{
				"q": -9,
				"r": 3,
				"height": -0.46135588702757296,
				"terrain": "text3"
			},
			{
				"q": -9,
				"r": 4,
				"height": -0.3607285110120526,
				"terrain": "text6"
			},
			{
				"q": -9,
				"r": 5,
				"height": -0.15201563171349347,
				"terrain": "text2"
			},
			{
				"q": -9,
				"r": 6,
				"height": 0.13190247544773348,
				"terrain": "text3"
			},
			{
				"q": -9,
				"r": 7,
				"height": 0.2669652085452247,
				"terrain": "text1"
			},
			{
				"q": -9,
				"r": 8,
				"height": 0.18704649205790858,
				"terrain": "text5"
			},
			{
				"q": -9,
				"r": 9,
				"height": -0.00022314368000020401,
				"terrain": "text7"
			},
			{
				"q": -9,
				"r": -3,
				"height": 0.27638812877262553,
				"terrain": "text2"
			},
			{
				"q": -9,
				"r": -2,
				"height": 0.37830847036842186,
				"terrain": "text3"
			},
			{
				"q": -9,
				"r": -1,
				"height": 0.20281567390100486,
				"terrain": "text3"
			},
			{
				"q": -10,
				"r": 0,
				"height": 0.1660939552300008,
				"terrain": "text6"
			},
			{
				"q": -10,
				"r": 1,
				"height": -0.06544782546196865,
				"terrain": "text2"
			},
			{
				"q": -10,
				"r": 2,
				"height": -0.27695371301488747,
				"terrain": "text5"
			},
			{
				"q": -10,
				"r": 3,
				"height": -0.3351111739428866,
				"terrain": "text2"
			},
			{
				"q": -10,
				"r": 4,
				"height": -0.23775292885141885,
				"terrain": "text6"
			},
			{
				"q": -10,
				"r": 5,
				"height": -0.06502857377063903,
				"terrain": "text2"
			},
			{
				"q": -10,
				"r": 6,
				"height": 0.1645348580697334,
				"terrain": "text3"
			},
			{
				"q": -10,
				"r": 7,
				"height": 0.24916528259550114,
				"terrain": "text1"
			},
			{
				"q": -10,
				"r": 8,
				"height": 0.11360425130321461,
				"terrain": "text6"
			},
			{
				"q": -10,
				"r": 9,
				"height": -0.13747448144032948,
				"terrain": "text6"
			},
			{
				"q": -10,
				"r": -1,
				"height": 0.43590188612614383,
				"terrain": "text4"
			},
			{
				"q": -11,
				"r": 1,
				"height": -0.0004307395281341053,
				"terrain": "text3"
			},
			{
				"q": -11,
				"r": 2,
				"height": -0.26438207038734285,
				"terrain": "text7"
			},
			{
				"q": -11,
				"r": 3,
				"height": -0.3701307920727636,
				"terrain": "text5"
			},
			{
				"q": -11,
				"r": 4,
				"height": -0.3481665940775788,
				"terrain": "text3"
			},
			{
				"q": -11,
				"r": 5,
				"height": -0.2570029706823006,
				"terrain": "text5"
			},
			{
				"q": -11,
				"r": 6,
				"height": -0.1006348210864732,
				"terrain": "text3"
			},
			{
				"q": -11,
				"r": 7,
				"height": -0.037744209990826394,
				"terrain": "text6"
			},
			{
				"q": -11,
				"r": 8,
				"height": -0.162315753451844,
				"terrain": "text5"
			},
			{
				"q": -11,
				"r": 9,
				"height": -0.4122859237854447,
				"terrain": "text6"
			},
			{
				"q": -12,
				"r": 3,
				"height": -0.41183026514440035,
				"terrain": "text6"
			},
			{
				"q": -12,
				"r": 4,
				"height": -0.5901813385049841,
				"terrain": "text5"
			},
			{
				"q": -12,
				"r": 5,
				"height": -0.644811359535933,
				"terrain": "text6"
			},
			{
				"q": -12,
				"r": 6,
				"height": -0.5825805267593579,
				"terrain": "text4"
			},
			{
				"q": -12,
				"r": 7,
				"height": -0.5204288713959154,
				"terrain": "text5"
			},
			{
				"q": -12,
				"r": 8,
				"height": -0.5713820847531679,
				"terrain": "text4"
			},
			{
				"q": -12,
				"r": 9,
				"height": -0.7410264713550594,
				"terrain": "text6"
			},
			{
				"q": -13,
				"r": 5,
				"height": -0.936393203219457,
				"terrain": "text2"
			},
			{
				"q": -13,
				"r": 6,
				"height": -0.9937798390529643,
				"terrain": "text5"
			},
			{
				"q": -13,
				"r": 7,
				"height": -0.954575856345302,
				"terrain": "text4"
			},
			{
				"q": -13,
				"r": 8,
				"height": -0.9216769146155881,
				"terrain": "text2"
			},
			{
				"q": -13,
				"r": 9,
				"height": -0.9737713814027077,
				"terrain": "text5"
			},
			{
				"q": -14,
				"r": 7,
				"height": -1.1409746178118694,
				"terrain": "text3"
			},
			{
				"q": -14,
				"r": 8,
				"height": -1.0532039581068218,
				"terrain": "text4"
			},
			{
				"q": -14,
				"r": 9,
				"height": -1.0060058563277865,
				"terrain": "text7"
			},
			{
				"q": -15,
				"r": 9,
				"height": -0.8774246262684693,
				"terrain": "text3"
			},
			{
				"q": -4,
				"r": 0,
				"height": -0.985408036176158,
				"terrain": "text6"
			},
			{
				"q": -4,
				"r": 1,
				"height": -1.1185978349273173,
				"terrain": "text6"
			},
			{
				"q": -4,
				"r": 2,
				"height": -0.8704435005717225,
				"terrain": "text5"
			},
			{
				"q": -4,
				"r": 3,
				"height": -0.39044976856435964,
				"terrain": "text2"
			},
			{
				"q": -4,
				"r": 4,
				"height": 0.03497509199818727,
				"terrain": "text7"
			},
			{
				"q": -4,
				"r": 5,
				"height": 0.2053150362702706,
				"terrain": "text4"
			},
			{
				"q": -4,
				"r": 6,
				"height": 0.13112669153448525,
				"terrain": "text6"
			},
			{
				"q": -4,
				"r": 7,
				"height": -0.07956184109743453,
				"terrain": "text3"
			},
			{
				"q": -4,
				"r": 8,
				"height": -0.26938017339124243,
				"terrain": "text6"
			},
			{
				"q": -4,
				"r": 9,
				"height": -0.37833392555025225,
				"terrain": "text3"
			},
			{
				"q": -4,
				"r": -10,
				"height": 0.02587048482802888,
				"terrain": "text6"
			},
			{
				"q": -4,
				"r": -9,
				"height": 0.15986195064517822,
				"terrain": "text7"
			},
			{
				"q": -4,
				"r": -8,
				"height": 0.4150895231086148,
				"terrain": "text2"
			},
			{
				"q": -4,
				"r": -7,
				"height": 0.6852128647716647,
				"terrain": "text7"
			},
			{
				"q": -4,
				"r": -6,
				"height": 0.8305579755904279,
				"terrain": "mountain"
			},
			{
				"q": -4,
				"r": -5,
				"height": 0.7953316602276876,
				"terrain": "mountain"
			},
			{
				"q": -4,
				"r": -4,
				"height": 0.6226303374867441,
				"terrain": "text6"
			},
			{
				"q": -4,
				"r": -3,
				"height": 0.2887910821342268,
				"terrain": "text5"
			},
			{
				"q": -4,
				"r": -2,
				"height": -0.1661218773353419,
				"terrain": "text6"
			},
			{
				"q": -4,
				"r": -1,
				"height": -0.6314214608642251,
				"terrain": "text4"
			},
			{
				"q": -3,
				"r": 0,
				"height": -1.2376934522770564,
				"terrain": "text2"
			},
			{
				"q": -3,
				"r": 1,
				"height": -1.4216848730087641,
				"terrain": "text2"
			},
			{
				"q": -3,
				"r": 2,
				"height": -1.0922012423884557,
				"terrain": "text2"
			},
			{
				"q": -3,
				"r": 3,
				"height": -0.38507194367999975,
				"terrain": "text3"
			},
			{
				"q": -3,
				"r": 4,
				"height": 0.2745872709953059,
				"terrain": "text5"
			},
			{
				"q": -3,
				"r": 5,
				"height": 0.533882329596786,
				"terrain": "text7"
			},
			{
				"q": -3,
				"r": 6,
				"height": 0.42328302749847513,
				"terrain": "text3"
			},
			{
				"q": -3,
				"r": 7,
				"height": 0.1601526296125103,
				"terrain": "text4"
			},
			{
				"q": -3,
				"r": 8,
				"height": -0.06957195537915872,
				"terrain": "text6"
			},
			{
				"q": -3,
				"r": 9,
				"height": -0.2296088976124273,
				"terrain": "text4"
			},
			{
				"q": -3,
				"r": -10,
				"height": 0.039572783480606284,
				"terrain": "text6"
			},
			{
				"q": -3,
				"r": -9,
				"height": 0.314728030428159,
				"terrain": "text3"
			},
			{
				"q": -3,
				"r": -8,
				"height": 0.7056852600027008,
				"terrain": "text5"
			},
			{
				"q": -3,
				"r": -7,
				"height": 1.0557654053877763,
				"terrain": "mountain"
			},
			{
				"q": -3,
				"r": -6,
				"height": 1.1955188247205832,
				"terrain": "mountain"
			},
			{
				"q": -3,
				"r": -5,
				"height": 1.1000679993141345,
				"terrain": "mountain"
			},
			{
				"q": -3,
				"r": -4,
				"height": 0.8596112835698668,
				"terrain": "mountain"
			},
			{
				"q": -3,
				"r": -3,
				"height": 0.40740134788638777,
				"terrain": "text7"
			},
			{
				"q": -3,
				"r": -2,
				"height": -0.19899362652520936,
				"terrain": "text2"
			},
			{
				"q": -3,
				"r": -1,
				"height": -0.7938856852117282,
				"terrain": "text3"
			},
			{
				"q": -2,
				"r": 0,
				"height": -1.1650821812611651,
				"terrain": "text4"
			},
			{
				"q": -2,
				"r": 1,
				"height": -1.4871613963488317,
				"terrain": "text4"
			},
			{
				"q": -2,
				"r": 2,
				"height": -1.2556713347096766,
				"terrain": "text5"
			},
			{
				"q": -2,
				"r": 3,
				"height": -0.5492236206403508,
				"terrain": "text4"
			},
			{
				"q": -2,
				"r": 4,
				"height": 0.1825690092590081,
				"terrain": "text3"
			},
			{
				"q": -2,
				"r": 5,
				"height": 0.5052950364926138,
				"terrain": "text4"
			},
			{
				"q": -2,
				"r": 6,
				"height": 0.41947312734188824,
				"terrain": "text7"
			},
			{
				"q": -2,
				"r": 7,
				"height": 0.1590230625905672,
				"terrain": "text6"
			},
			{
				"q": -2,
				"r": 8,
				"height": -0.06753450406155448,
				"terrain": "text1"
			},
			{
				"q": -2,
				"r": 9,
				"height": -0.23229782229363866,
				"terrain": "text4"
			},
			{
				"q": -2,
				"r": -10,
				"height": 0.3324870909086664,
				"terrain": "text4"
			},
			{
				"q": -2,
				"r": -9,
				"height": 0.662170845689849,
				"terrain": "text5"
			},
			{
				"q": -2,
				"r": -8,
				"height": 1.0111034960437195,
				"terrain": "mountain"
			},
			{
				"q": -2,
				"r": -7,
				"height": 1.2275421140384637,
				"terrain": "mountain"
			},
			{
				"q": -2,
				"r": -6,
				"height": 1.201421393756748,
				"terrain": "mountain"
			},
			{
				"q": -2,
				"r": -5,
				"height": 1.0070575822233636,
				"terrain": "mountain"
			},
			{
				"q": -2,
				"r": -4,
				"height": 0.7742572019011256,
				"terrain": "mountain"
			},
			{
				"q": -2,
				"r": -3,
				"height": 0.43102144137541765,
				"terrain": "text6"
			},
			{
				"q": -2,
				"r": -2,
				"height": -0.061005439855560256,
				"terrain": "text2"
			},
			{
				"q": -2,
				"r": -1,
				"height": -0.6288423781026231,
				"terrain": "text3"
			},
			{
				"q": -1,
				"r": 0,
				"height": -0.6719500288477358,
				"terrain": "text4"
			},
			{
				"q": -1,
				"r": 1,
				"height": -1.1594360570673325,
				"terrain": "text1"
			},
			{
				"q": -1,
				"r": 2,
				"height": -1.154642580474432,
				"terrain": "text5"
			},
			{
				"q": -1,
				"r": 3,
				"height": -0.6597996854136227,
				"terrain": "text3"
			},
			{
				"q": -1,
				"r": 4,
				"height": -0.038334472567117014,
				"terrain": "text2"
			},
			{
				"q": -1,
				"r": 5,
				"height": 0.28326105914897765,
				"terrain": "text4"
			},
			{
				"q": -1,
				"r": 6,
				"height": 0.23257581886831688,
				"terrain": "text2"
			},
			{
				"q": -1,
				"r": 7,
				"height": -0.015299154414616323,
				"terrain": "text7"
			},
			{
				"q": -1,
				"r": 8,
				"height": -0.23452298018043483,
				"terrain": "text5"
			},
			{
				"q": -1,
				"r": 9,
				"height": -0.3854672467049866,
				"terrain": "text5"
			},
			{
				"q": -1,
				"r": -10,
				"height": 0.7107654139218023,
				"terrain": "text5"
			},
			{
				"q": -1,
				"r": -9,
				"height": 0.983530824941846,
				"terrain": "mountain"
			},
			{
				"q": -1,
				"r": -8,
				"height": 1.145020785744475,
				"terrain": "mountain"
			},
			{
				"q": -1,
				"r": -7,
				"height": 1.1074927384217415,
				"terrain": "mountain"
			},
			{
				"q": -1,
				"r": -6,
				"height": 0.8676041404208994,
				"terrain": "mountain"
			},
			{
				"q": -1,
				"r": -5,
				"height": 0.6117489967110346,
				"terrain": "text3"
			},
			{
				"q": -1,
				"r": -4,
				"height": 0.4947515529114971,
				"terrain": "text7"
			},
			{
				"q": -1,
				"r": -3,
				"height": 0.4641420813439441,
				"terrain": "text3"
			},
			{
				"q": -1,
				"r": -2,
				"height": 0.318866935297175,
				"terrain": "text5"
			},
			{
				"q": -1,
				"r": -1,
				"height": -0.07424785094653608,
				"terrain": "text7"
			}
		],
		"halfWidth": 10,
		"halfHeight": 10
	}
	},
  "seed_5":{
	"map_id":"seed_5",
	"data": {
		"_width": 20,
		"_height": 20,
		"data": [
			{
				"q": 0,
				"r": 0,
				"height": 0,
				"terrain": "text6"
			},
			{
				"q": 0,
				"r": 1,
				"height": -0.5785973045679013,
				"terrain": "text6"
			},
			{
				"q": 0,
				"r": 2,
				"height": -0.7697033137199534,
				"terrain": "text5"
			},
			{
				"q": 0,
				"r": 3,
				"height": -0.560865006625281,
				"terrain": "text4"
			},
			{
				"q": 0,
				"r": 4,
				"height": -0.24395036383091478,
				"terrain": "text7"
			},
			{
				"q": 0,
				"r": 5,
				"height": -0.1678028926099138,
				"terrain": "text3"
			},
			{
				"q": 0,
				"r": 6,
				"height": -0.440973290337632,
				"terrain": "text2"
			},
			{
				"q": 0,
				"r": 7,
				"height": -0.9497939270092733,
				"terrain": "text2"
			},
			{
				"q": 0,
				"r": 8,
				"height": -1.274705809722908,
				"terrain": "text5"
			},
			{
				"q": 0,
				"r": 9,
				"height": -1.2533482594068004,
				"terrain": "text3"
			},
			{
				"q": 0,
				"r": -10,
				"height": -0.289728548264524,
				"terrain": "text4"
			},
			{
				"q": 0,
				"r": -9,
				"height": -0.7107233473159235,
				"terrain": "text6"
			},
			{
				"q": 0,
				"r": -8,
				"height": -0.8118346383990509,
				"terrain": "text4"
			},
			{
				"q": 0,
				"r": -7,
				"height": -0.532672801657313,
				"terrain": "text5"
			},
			{
				"q": 0,
				"r": -6,
				"height": -0.03428859457417155,
				"terrain": "text3"
			},
			{
				"q": 0,
				"r": -5,
				"height": 0.4343556494360168,
				"terrain": "text2"
			},
			{
				"q": 0,
				"r": -4,
				"height": 0.8669115348585789,
				"terrain": "mountain"
			},
			{
				"q": 0,
				"r": -3,
				"height": 1.207689267545065,
				"terrain": "mountain"
			},
			{
				"q": 0,
				"r": -2,
				"height": 1.1630274305072663,
				"terrain": "mountain"
			},
			{
				"q": 0,
				"r": -1,
				"height": 0.6719500288477358,
				"terrain": "text3"
			},
			{
				"q": 1,
				"r": 0,
				"height": 0,
				"terrain": "text7"
			},
			{
				"q": 1,
				"r": 1,
				"height": -0.541221752513984,
				"terrain": "text7"
			},
			{
				"q": 1,
				"r": 2,
				"height": -0.7782171837008278,
				"terrain": "text4"
			},
			{
				"q": 1,
				"r": 3,
				"height": -0.7040238073547364,
				"terrain": "text1"
			},
			{
				"q": 1,
				"r": 4,
				"height": -0.5184381415952504,
				"terrain": "text5"
			},
			{
				"q": 1,
				"r": 5,
				"height": -0.48054251160272776,
				"terrain": "text6"
			},
			{
				"q": 1,
				"r": 6,
				"height": -0.6942681799081454,
				"terrain": "text4"
			},
			{
				"q": 1,
				"r": 7,
				"height": -1.0562616671222465,
				"terrain": "text5"
			},
			{
				"q": 1,
				"r": 8,
				"height": -1.2256039163664216,
				"terrain": "text2"
			},
			{
				"q": 1,
				"r": 9,
				"height": -1.1241938464388448,
				"terrain": "text3"
			},
			{
				"q": 1,
				"r": -10,
				"height": -0.6195448676191376,
				"terrain": "text7"
			},
			{
				"q": 1,
				"r": -9,
				"height": -0.8191864348263627,
				"terrain": "text3"
			},
			{
				"q": 1,
				"r": -8,
				"height": -0.6676741365306138,
				"terrain": "text3"
			},
			{
				"q": 1,
				"r": -7,
				"height": -0.16477563872371465,
				"terrain": "text3"
			},
			{
				"q": 1,
				"r": -6,
				"height": 0.42819157831870513,
				"terrain": "text4"
			},
			{
				"q": 1,
				"r": -5,
				"height": 0.8275362054356967,
				"terrain": "mountain"
			},
			{
				"q": 1,
				"r": -4,
				"height": 1.1141184354943188,
				"terrain": "mountain"
			},
			{
				"q": 1,
				"r": -3,
				"height": 1.284280489220032,
				"terrain": "mountain"
			},
			{
				"q": 1,
				"r": -2,
				"height": 1.1259541920862521,
				"terrain": "mountain"
			},
			{
				"q": 1,
				"r": -1,
				"height": 0.6237120132999526,
				"terrain": "text1"
			},
			{
				"q": 2,
				"r": 0,
				"height": 0.0020590605356470937,
				"terrain": "text3"
			},
			{
				"q": 2,
				"r": 1,
				"height": -0.3968075124342958,
				"terrain": "text4"
			},
			{
				"q": 2,
				"r": 2,
				"height": -0.6729439246745782,
				"terrain": "text7"
			},
			{
				"q": 2,
				"r": 3,
				"height": -0.7614188956073262,
				"terrain": "text5"
			},
			{
				"q": 2,
				"r": 4,
				"height": -0.6890552592486558,
				"terrain": "text5"
			},
			{
				"q": 2,
				"r": 5,
				"height": -0.5888977251022437,
				"terrain": "text1"
			},
			{
				"q": 2,
				"r": 6,
				"height": -0.6106307080489779,
				"terrain": "text2"
			},
			{
				"q": 2,
				"r": 7,
				"height": -0.7555503821579046,
				"terrain": "text4"
			},
			{
				"q": 2,
				"r": 8,
				"height": -0.8443661008729425,
				"terrain": "text3"
			},
			{
				"q": 2,
				"r": 9,
				"height": -0.819960944697264,
				"terrain": "text2"
			},
			{
				"q": 2,
				"r": -10,
				"height": -0.5315577714228477,
				"terrain": "text7"
			},
			{
				"q": 2,
				"r": -9,
				"height": -0.5574366121745622,
				"terrain": "text2"
			},
			{
				"q": 2,
				"r": -8,
				"height": -0.21123123168529034,
				"terrain": "text4"
			},
			{
				"q": 2,
				"r": -7,
				"height": 0.410678162787376,
				"terrain": "text5"
			},
			{
				"q": 2,
				"r": -6,
				"height": 0.9446137368790299,
				"terrain": "mountain"
			},
			{
				"q": 2,
				"r": -5,
				"height": 1.1167239904461068,
				"terrain": "mountain"
			},
			{
				"q": 2,
				"r": -4,
				"height": 1.1060781517159513,
				"terrain": "mountain"
			},
			{
				"q": 2,
				"r": -3,
				"height": 1.0084355212299956,
				"terrain": "mountain"
			},
			{
				"q": 2,
				"r": -2,
				"height": 0.7831065955929308,
				"terrain": "mountain"
			},
			{
				"q": 2,
				"r": -1,
				"height": 0.4251817069827678,
				"terrain": "text3"
			},
			{
				"q": 3,
				"r": 0,
				"height": 0.02990134214393575,
				"terrain": "text3"
			},
			{
				"q": 3,
				"r": 1,
				"height": -0.20346283171866753,
				"terrain": "text7"
			},
			{
				"q": 3,
				"r": 2,
				"height": -0.5177471879403035,
				"terrain": "text2"
			},
			{
				"q": 3,
				"r": 3,
				"height": -0.7498135392463884,
				"terrain": "text7"
			},
			{
				"q": 3,
				"r": 4,
				"height": -0.7472707476453868,
				"terrain": "text7"
			},
			{
				"q": 3,
				"r": 5,
				"height": -0.5187615784967882,
				"terrain": "text5"
			},
			{
				"q": 3,
				"r": 6,
				"height": -0.27457717148032185,
				"terrain": "text5"
			},
			{
				"q": 3,
				"r": 7,
				"height": -0.1759737735357281,
				"terrain": "text2"
			},
			{
				"q": 3,
				"r": 8,
				"height": -0.23759870518823129,
				"terrain": "text6"
			},
			{
				"q": 3,
				"r": 9,
				"height": -0.36987796471161716,
				"terrain": "text6"
			},
			{
				"q": 3,
				"r": -10,
				"height": -0.13432446369226259,
				"terrain": "text4"
			},
			{
				"q": 3,
				"r": -9,
				"height": -0.048753160898667436,
				"terrain": "text5"
			},
			{
				"q": 3,
				"r": -8,
				"height": 0.3743437281029712,
				"terrain": "text2"
			},
			{
				"q": 3,
				"r": -7,
				"height": 0.9449522954392734,
				"terrain": "mountain"
			},
			{
				"q": 3,
				"r": -6,
				"height": 1.2669995827551257,
				"terrain": "mountain"
			},
			{
				"q": 3,
				"r": -5,
				"height": 1.121503493823133,
				"terrain": "mountain"
			},
			{
				"q": 3,
				"r": -4,
				"height": 0.7678597462295258,
				"terrain": "mountain"
			},
			{
				"q": 3,
				"r": -3,
				"height": 0.42773518506151975,
				"terrain": "text3"
			},
			{
				"q": 3,
				"r": -2,
				"height": 0.24667371793417114,
				"terrain": "text5"
			},
			{
				"q": 3,
				"r": -1,
				"height": 0.16750689793908316,
				"terrain": "text4"
			},
			{
				"q": 4,
				"r": 0,
				"height": 0.11328694114743773,
				"terrain": "text5"
			},
			{
				"q": 4,
				"r": 1,
				"height": -0.016069738769923583,
				"terrain": "text6"
			},
			{
				"q": 4,
				"r": 2,
				"height": -0.3858456284708816,
				"terrain": "text2"
			},
			{
				"q": 4,
				"r": 3,
				"height": -0.7302738326311071,
				"terrain": "text6"
			},
			{
				"q": 4,
				"r": 4,
				"height": -0.7640473940269549,
				"terrain": "text5"
			},
			{
				"q": 4,
				"r": 5,
				"height": -0.42736528846897115,
				"terrain": "text2"
			},
			{
				"q": 4,
				"r": 6,
				"height": 0.039226125380451754,
				"terrain": "text4"
			},
			{
				"q": 4,
				"r": 7,
				"height": 0.34259160380409936,
				"terrain": "text2"
			},
			{
				"q": 4,
				"r": 8,
				"height": 0.3257269928710187,
				"terrain": "text7"
			},
			{
				"q": 4,
				"r": 9,
				"height": 0.10177372731342044,
				"terrain": "text2"
			},
			{
				"q": 4,
				"r": -10,
				"height": 0.29009439213670474,
				"terrain": "text5"
			},
			{
				"q": 4,
				"r": -9,
				"height": 0.40800052588949,
				"terrain": "text4"
			},
			{
				"q": 4,
				"r": -8,
				"height": 0.7808999506793639,
				"terrain": "mountain"
			},
			{
				"q": 4,
				"r": -7,
				"height": 1.186274869993006,
				"terrain": "mountain"
			},
			{
				"q": 4,
				"r": -6,
				"height": 1.2458752872179641,
				"terrain": "mountain"
			},
			{
				"q": 4,
				"r": -5,
				"height": 0.8403390486477127,
				"terrain": "mountain"
			},
			{
				"q": 4,
				"r": -4,
				"height": 0.2720065912801206,
				"terrain": "text6"
			},
			{
				"q": 4,
				"r": -3,
				"height": -0.15345957071064192,
				"terrain": "text3"
			},
			{
				"q": 4,
				"r": -2,
				"height": -0.19277029094224846,
				"terrain": "text2"
			},
			{
				"q": 4,
				"r": -1,
				"height": 0.010514401731437223,
				"terrain": "text4"
			},
			{
				"q": 5,
				"r": 0,
				"height": 0.25636710462650236,
				"terrain": "text3"
			},
			{
				"q": 5,
				"r": 1,
				"height": 0.14826704335281618,
				"terrain": "text5"
			},
			{
				"q": 5,
				"r": 2,
				"height": -0.30033418684808116,
				"terrain": "text2"
			},
			{
				"q": 5,
				"r": 3,
				"height": -0.7494462386423008,
				"terrain": "text7"
			},
			{
				"q": 5,
				"r": 4,
				"height": -0.8212279017402677,
				"terrain": "text1"
			},
			{
				"q": 5,
				"r": 5,
				"height": -0.4347233701785549,
				"terrain": "text6"
			},
			{
				"q": 5,
				"r": 6,
				"height": 0.14115358893045848,
				"terrain": "text6"
			},
			{
				"q": 5,
				"r": 7,
				"height": 0.5747703952761565,
				"terrain": "text2"
			},
			{
				"q": 5,
				"r": 8,
				"height": 0.6508794154573054,
				"terrain": "text2"
			},
			{
				"q": 5,
				"r": -10,
				"height": 0.4815483655873077,
				"terrain": "text1"
			},
			{
				"q": 5,
				"r": -9,
				"height": 0.5317471460872527,
				"terrain": "text7"
			},
			{
				"q": 5,
				"r": -8,
				"height": 0.7938272931583004,
				"terrain": "mountain"
			},
			{
				"q": 5,
				"r": -7,
				"height": 1.045978329491148,
				"terrain": "mountain"
			},
			{
				"q": 5,
				"r": -6,
				"height": 0.9368580213097945,
				"terrain": "mountain"
			},
			{
				"q": 5,
				"r": -5,
				"height": 0.43199620113589243,
				"terrain": "text5"
			},
			{
				"q": 5,
				"r": -4,
				"height": -0.1354198292963127,
				"terrain": "text2"
			},
			{
				"q": 5,
				"r": -3,
				"height": -0.4679920834113569,
				"terrain": "text6"
			},
			{
				"q": 5,
				"r": -2,
				"height": -0.34639330840853344,
				"terrain": "text5"
			},
			{
				"q": 5,
				"r": -1,
				"height": 0.027885412211970773,
				"terrain": "text2"
			},
			{
				"q": 6,
				"r": 0,
				"height": 0.47471579858944174,
				"terrain": "text5"
			},
			{
				"q": 6,
				"r": 1,
				"height": 0.3591149047615505,
				"terrain": "text1"
			},
			{
				"q": 6,
				"r": 2,
				"height": -0.17092853322608725,
				"terrain": "text4"
			},
			{
				"q": 6,
				"r": 3,
				"height": -0.7197608780517115,
				"terrain": "text2"
			},
			{
				"q": 6,
				"r": 4,
				"height": -0.8394204861847251,
				"terrain": "text4"
			},
			{
				"q": 6,
				"r": 5,
				"height": -0.44382602355094664,
				"terrain": "text1"
			},
			{
				"q": 6,
				"r": 6,
				"height": 0.15839247037666065,
				"terrain": "text2"
			},
			{
				"q": 6,
				"r": -10,
				"height": 0.4385353144287913,
				"terrain": "text2"
			},
			{
				"q": 6,
				"r": -9,
				"height": 0.35576705097356776,
				"terrain": "text3"
			},
			{
				"q": 6,
				"r": -8,
				"height": 0.4960996149439356,
				"terrain": "text4"
			},
			{
				"q": 6,
				"r": -7,
				"height": 0.6349857072047497,
				"terrain": "text2"
			},
			{
				"q": 6,
				"r": -6,
				"height": 0.46114502067720015,
				"terrain": "text5"
			},
			{
				"q": 6,
				"r": -5,
				"height": -0.017488606408934515,
				"terrain": "text2"
			},
			{
				"q": 6,
				"r": -4,
				"height": -0.4585395708850798,
				"terrain": "text3"
			},
			{
				"q": 6,
				"r": -3,
				"height": -0.6021543471330663,
				"terrain": "text3"
			},
			{
				"q": 6,
				"r": -2,
				"height": -0.31631787222155094,
				"terrain": "text3"
			},
			{
				"q": 6,
				"r": -1,
				"height": 0.17680588507372144,
				"terrain": "text5"
			},
			{
				"q": 7,
				"r": 0,
				"height": 0.7622167400747959,
				"terrain": "mountain"
			},
			{
				"q": 7,
				"r": 1,
				"height": 0.6200494306584168,
				"terrain": "text3"
			},
			{
				"q": 7,
				"r": 2,
				"height": 0.021865041782834813,
				"terrain": "text3"
			},
			{
				"q": 7,
				"r": 3,
				"height": -0.5967991755655976,
				"terrain": "text4"
			},
			{
				"q": 7,
				"r": 4,
				"height": -0.7608536609638118,
				"terrain": "text1"
			},
			{
				"q": 7,
				"r": -10,
				"height": 0.226405523351571,
				"terrain": "text4"
			},
			{
				"q": 7,
				"r": -9,
				"height": 0.05675992818237613,
				"terrain": "text4"
			},
			{
				"q": 7,
				"r": -8,
				"height": 0.1284867501208417,
				"terrain": "text4"
			},
			{
				"q": 7,
				"r": -7,
				"height": 0.19795947439234135,
				"terrain": "text4"
			},
			{
				"q": 7,
				"r": -6,
				"height": 0.012112622336850731,
				"terrain": "text4"
			},
			{
				"q": 7,
				"r": -5,
				"height": -0.3679710154061515,
				"terrain": "text2"
			},
			{
				"q": 7,
				"r": -4,
				"height": -0.6480400874547084,
				"terrain": "text1"
			},
			{
				"q": 7,
				"r": -3,
				"height": -0.5938086601044309,
				"terrain": "text2"
			},
			{
				"q": 7,
				"r": -2,
				"height": -0.14277300582703137,
				"terrain": "text1"
			},
			{
				"q": 7,
				"r": -1,
				"height": 0.445154866810775,
				"terrain": "text4"
			},
			{
				"q": 8,
				"r": 0,
				"height": 0.9005136392078146,
				"terrain": "mountain"
			},
			{
				"q": 8,
				"r": 1,
				"height": 0.735584807087841,
				"terrain": "text6"
			},
			{
				"q": 8,
				"r": 2,
				"height": 0.13381068763239284,
				"terrain": "text2"
			},
			{
				"q": 8,
				"r": -10,
				"height": 0.08479588147233291,
				"terrain": "text2"
			},
			{
				"q": 8,
				"r": -9,
				"height": -0.10151206958347014,
				"terrain": "text6"
			},
			{
				"q": 8,
				"r": -8,
				"height": -0.0590623476435756,
				"terrain": "text7"
			},
			{
				"q": 8,
				"r": -7,
				"height": -0.04352422813832435,
				"terrain": "text4"
			},
			{
				"q": 8,
				"r": -6,
				"height": -0.2384052321983869,
				"terrain": "text4"
			},
			{
				"q": 8,
				"r": -5,
				"height": -0.522646307051226,
				"terrain": "text3"
			},
			{
				"q": 8,
				"r": -4,
				"height": -0.6891517424003154,
				"terrain": "text3"
			},
			{
				"q": 8,
				"r": -3,
				"height": -0.5277457965303607,
				"terrain": "text5"
			},
			{
				"q": 8,
				"r": -2,
				"height": 0.011464015658770532,
				"terrain": "text5"
			},
			{
				"q": 8,
				"r": -1,
				"height": 0.6166636795665502,
				"terrain": "text2"
			},
			{
				"q": 9,
				"r": 0,
				"height": 0.7446786833515835,
				"terrain": "text4"
			},
			{
				"q": 9,
				"r": -10,
				"height": 0.136033366255144,
				"terrain": "text3"
			},
			{
				"q": 9,
				"r": -9,
				"height": -0.049113016049084746,
				"terrain": "text5"
			},
			{
				"q": 9,
				"r": -8,
				"height": -0.03851880737833374,
				"terrain": "text2"
			},
			{
				"q": 9,
				"r": -7,
				"height": -0.07689209272301345,
				"terrain": "text6"
			},
			{
				"q": 9,
				"r": -6,
				"height": -0.2898568094000943,
				"terrain": "text3"
			},
			{
				"q": 9,
				"r": -5,
				"height": -0.5186550085626647,
				"terrain": "text2"
			},
			{
				"q": 9,
				"r": -4,
				"height": -0.6392009798691035,
				"terrain": "text5"
			},
			{
				"q": 9,
				"r": -3,
				"height": -0.4788784298932368,
				"terrain": "text3"
			},
			{
				"q": 9,
				"r": -2,
				"height": 0.014250283422322887,
				"terrain": "text2"
			},
			{
				"q": 9,
				"r": -1,
				"height": 0.539835566972029,
				"terrain": "text3"
			},
			{
				"q": 10,
				"r": -10,
				"height": 0.2892851699436061,
				"terrain": "text4"
			},
			{
				"q": 10,
				"r": -9,
				"height": 0.08609178185185201,
				"terrain": "text7"
			},
			{
				"q": 10,
				"r": -8,
				"height": 0.050712727195778795,
				"terrain": "text7"
			},
			{
				"q": 10,
				"r": -7,
				"height": -0.017437431056807534,
				"terrain": "text6"
			},
			{
				"q": 10,
				"r": -6,
				"height": -0.20765113752546724,
				"terrain": "text7"
			},
			{
				"q": 10,
				"r": -5,
				"height": -0.37699793389816266,
				"terrain": "text4"
			},
			{
				"q": 10,
				"r": -4,
				"height": -0.4931117681774356,
				"terrain": "text2"
			},
			{
				"q": 10,
				"r": -3,
				"height": -0.43629079578265473,
				"terrain": "text5"
			},
			{
				"q": 10,
				"r": -2,
				"height": -0.10826568899375265,
				"terrain": "text4"
			},
			{
				"q": 11,
				"r": -10,
				"height": 0.3911939590509577,
				"terrain": "text4"
			},
			{
				"q": 11,
				"r": -9,
				"height": 0.20184191830067116,
				"terrain": "text6"
			},
			{
				"q": 11,
				"r": -8,
				"height": 0.15216299599315472,
				"terrain": "text7"
			},
			{
				"q": 11,
				"r": -7,
				"height": 0.10873381954916261,
				"terrain": "text7"
			},
			{
				"q": 11,
				"r": -6,
				"height": -0.005405917263916399,
				"terrain": "text3"
			},
			{
				"q": 11,
				"r": -5,
				"height": -0.10563460822865331,
				"terrain": "text5"
			},
			{
				"q": 11,
				"r": -4,
				"height": -0.24112339253435439,
				"terrain": "text5"
			},
			{
				"q": 12,
				"r": -10,
				"height": 0.2850474537580054,
				"terrain": "text6"
			},
			{
				"q": 12,
				"r": -9,
				"height": 0.13978438798997736,
				"terrain": "text5"
			},
			{
				"q": 12,
				"r": -8,
				"height": 0.14514241191695396,
				"terrain": "text2"
			},
			{
				"q": 12,
				"r": -7,
				"height": 0.19291654211695639,
				"terrain": "text4"
			},
			{
				"q": 12,
				"r": -6,
				"height": 0.19062420039260225,
				"terrain": "text1"
			},
			{
				"q": 13,
				"r": -10,
				"height": 0.042518513483856546,
				"terrain": "text5"
			},
			{
				"q": 13,
				"r": -9,
				"height": -0.020025456981980577,
				"terrain": "text5"
			},
			{
				"q": 13,
				"r": -8,
				"height": 0.10302743188260144,
				"terrain": "text4"
			},
			{
				"q": 14,
				"r": -10,
				"height": -0.15938931071211554,
				"terrain": "text5"
			},
			{
				"q": -5,
				"r": 0,
				"height": -0.10633476173093567,
				"terrain": "text6"
			},
			{
				"q": -5,
				"r": 1,
				"height": -0.6520323672517154,
				"terrain": "text2"
			},
			{
				"q": -5,
				"r": 2,
				"height": -1.1669177190855053,
				"terrain": "text4"
			},
			{
				"q": -5,
				"r": 3,
				"height": -1.280464073415638,
				"terrain": "text2"
			},
			{
				"q": -5,
				"r": 4,
				"height": -0.8464704271716714,
				"terrain": "text7"
			},
			{
				"q": -5,
				"r": 5,
				"height": -0.1560952027130012,
				"terrain": "text4"
			},
			{
				"q": -5,
				"r": 6,
				"height": 0.49131606395061755,
				"terrain": "text4"
			},
			{
				"q": -5,
				"r": 7,
				"height": 0.7781377701610528,
				"terrain": "mountain"
			},
			{
				"q": -5,
				"r": 8,
				"height": 0.5886753542813592,
				"terrain": "text6"
			},
			{
				"q": -5,
				"r": 9,
				"height": 0.2110881894780014,
				"terrain": "text3"
			},
			{
				"q": -5,
				"r": -10,
				"height": 0.29196805272504966,
				"terrain": "text5"
			},
			{
				"q": -5,
				"r": -9,
				"height": 0.048704615796647366,
				"terrain": "text4"
			},
			{
				"q": -5,
				"r": -8,
				"height": -0.22692534590082902,
				"terrain": "text3"
			},
			{
				"q": -5,
				"r": -7,
				"height": -0.29571517891887444,
				"terrain": "text3"
			},
			{
				"q": -5,
				"r": -6,
				"height": -0.03854608275761984,
				"terrain": "text3"
			},
			{
				"q": -5,
				"r": -5,
				"height": 0.46325171634021717,
				"terrain": "text3"
			},
			{
				"q": -5,
				"r": -4,
				"height": 0.9203429356547062,
				"terrain": "mountain"
			},
			{
				"q": -5,
				"r": -3,
				"height": 1.1500156016186616,
				"terrain": "mountain"
			},
			{
				"q": -5,
				"r": -2,
				"height": 0.9657650776961066,
				"terrain": "mountain"
			},
			{
				"q": -5,
				"r": -1,
				"height": 0.44625934210147206,
				"terrain": "text5"
			},
			{
				"q": -6,
				"r": 0,
				"height": 0.22209680820896954,
				"terrain": "text3"
			},
			{
				"q": -6,
				"r": 1,
				"height": -0.33990217313330656,
				"terrain": "text5"
			},
			{
				"q": -6,
				"r": 2,
				"height": -0.9767361807907817,
				"terrain": "text1"
			},
			{
				"q": -6,
				"r": 3,
				"height": -1.3211478126133331,
				"terrain": "text5"
			},
			{
				"q": -6,
				"r": 4,
				"height": -1.1423385791947318,
				"terrain": "text6"
			},
			{
				"q": -6,
				"r": 5,
				"height": -0.5972240289300408,
				"terrain": "text3"
			},
			{
				"q": -6,
				"r": 6,
				"height": 0.03340126719999997,
				"terrain": "text5"
			},
			{
				"q": -6,
				"r": 7,
				"height": 0.4278178672497123,
				"terrain": "text3"
			},
			{
				"q": -6,
				"r": 8,
				"height": 0.4121756864684775,
				"terrain": "text7"
			},
			{
				"q": -6,
				"r": 9,
				"height": 0.2016099532629642,
				"terrain": "text6"
			},
			{
				"q": -6,
				"r": -9,
				"height": -0.24568324448110113,
				"terrain": "text2"
			},
			{
				"q": -6,
				"r": -8,
				"height": -0.4333439903538254,
				"terrain": "text5"
			},
			{
				"q": -6,
				"r": -7,
				"height": -0.425936590889755,
				"terrain": "text6"
			},
			{
				"q": -6,
				"r": -6,
				"height": -0.11474025149666112,
				"terrain": "text5"
			},
			{
				"q": -6,
				"r": -5,
				"height": 0.41377489597893047,
				"terrain": "text2"
			},
			{
				"q": -6,
				"r": -4,
				"height": 0.892720444589276,
				"terrain": "mountain"
			},
			{
				"q": -6,
				"r": -3,
				"height": 1.1863582026405834,
				"terrain": "mountain"
			},
			{
				"q": -6,
				"r": -2,
				"height": 1.117310815525966,
				"terrain": "mountain"
			},
			{
				"q": -6,
				"r": -1,
				"height": 0.71547324848345,
				"terrain": "text4"
			},
			{
				"q": -7,
				"r": 0,
				"height": 0.5721295926623728,
				"terrain": "text6"
			},
			{
				"q": -7,
				"r": 1,
				"height": 0.13768784458538663,
				"terrain": "text4"
			},
			{
				"q": -7,
				"r": 2,
				"height": -0.49078549621263007,
				"terrain": "text5"
			},
			{
				"q": -7,
				"r": 3,
				"height": -0.9655469199381074,
				"terrain": "text3"
			},
			{
				"q": -7,
				"r": 4,
				"height": -1.0228436285799365,
				"terrain": "text4"
			},
			{
				"q": -7,
				"r": 5,
				"height": -0.7086191488777119,
				"terrain": "text4"
			},
			{
				"q": -7,
				"r": 6,
				"height": -0.2518007573550618,
				"terrain": "text7"
			},
			{
				"q": -7,
				"r": 7,
				"height": 0.06911168641073012,
				"terrain": "text1"
			},
			{
				"q": -7,
				"r": 8,
				"height": 0.0727624436448428,
				"terrain": "text5"
			},
			{
				"q": -7,
				"r": 9,
				"height": -0.06064218888954709,
				"terrain": "text1"
			},
			{
				"q": -7,
				"r": -7,
				"height": -0.5157050083273225,
				"terrain": "text3"
			},
			{
				"q": -7,
				"r": -6,
				"height": -0.2648782370377635,
				"terrain": "text4"
			},
			{
				"q": -7,
				"r": -5,
				"height": 0.21302610871262975,
				"terrain": "text2"
			},
			{
				"q": -7,
				"r": -4,
				"height": 0.6516868920630177,
				"terrain": "text4"
			},
			{
				"q": -7,
				"r": -3,
				"height": 0.9599693192574745,
				"terrain": "mountain"
			},
			{
				"q": -7,
				"r": -2,
				"height": 1.0275556108173152,
				"terrain": "mountain"
			},
			{
				"q": -7,
				"r": -1,
				"height": 0.8546448898676624,
				"terrain": "mountain"
			},
			{
				"q": -8,
				"r": 0,
				"height": 0.7778689695099656,
				"terrain": "mountain"
			},
			{
				"q": -8,
				"r": 1,
				"height": 0.5802104702816234,
				"terrain": "text4"
			},
			{
				"q": -8,
				"r": 2,
				"height": 0.07167821350528117,
				"terrain": "text2"
			},
			{
				"q": -8,
				"r": 3,
				"height": -0.45386969534708643,
				"terrain": "text6"
			},
			{
				"q": -8,
				"r": 4,
				"height": -0.6855856139527344,
				"terrain": "text5"
			},
			{
				"q": -8,
				"r": 5,
				"height": -0.594277143351623,
				"terrain": "text2"
			},
			{
				"q": -8,
				"r": 6,
				"height": -0.35882200076641935,
				"terrain": "text7"
			},
			{
				"q": -8,
				"r": 7,
				"height": -0.18844005032547062,
				"terrain": "text4"
			},
			{
				"q": -8,
				"r": 8,
				"height": -0.24502361711007473,
				"terrain": "text3"
			},
			{
				"q": -8,
				"r": 9,
				"height": -0.3622063194663374,
				"terrain": "text4"
			},
			{
				"q": -8,
				"r": -5,
				"height": 0.0005895457719461428,
				"terrain": "text2"
			},
			{
				"q": -8,
				"r": -4,
				"height": 0.3315703437644457,
				"terrain": "text2"
			},
			{
				"q": -8,
				"r": -3,
				"height": 0.5568606441236251,
				"terrain": "text4"
			},
			{
				"q": -8,
				"r": -2,
				"height": 0.6899629089653841,
				"terrain": "text6"
			},
			{
				"q": -8,
				"r": -1,
				"height": 0.7598680583233687,
				"terrain": "mountain"
			},
			{
				"q": -9,
				"r": 0,
				"height": 0.7988092176466363,
				"terrain": "mountain"
			},
			{
				"q": -9,
				"r": 1,
				"height": 0.8225317485188262,
				"terrain": "mountain"
			},
			{
				"q": -9,
				"r": 2,
				"height": 0.449212091340982,
				"terrain": "text2"
			},
			{
				"q": -9,
				"r": 3,
				"height": -0.08231141707975563,
				"terrain": "text2"
			},
			{
				"q": -9,
				"r": 4,
				"height": -0.4319675002458864,
				"terrain": "text2"
			},
			{
				"q": -9,
				"r": 5,
				"height": -0.5013222353792913,
				"terrain": "text1"
			},
			{
				"q": -9,
				"r": 6,
				"height": -0.42994835311045965,
				"terrain": "text5"
			},
			{
				"q": -9,
				"r": 7,
				"height": -0.3536320049145679,
				"terrain": "text5"
			},
			{
				"q": -9,
				"r": 8,
				"height": -0.42038562594765455,
				"terrain": "text4"
			},
			{
				"q": -9,
				"r": 9,
				"height": -0.4994349328000002,
				"terrain": "text7"
			},
			{
				"q": -9,
				"r": -3,
				"height": 0.12888723098146967,
				"terrain": "text4"
			},
			{
				"q": -9,
				"r": -2,
				"height": 0.2713841685265848,
				"terrain": "text1"
			},
			{
				"q": -9,
				"r": -1,
				"height": 0.5195298251855026,
				"terrain": "text6"
			},
			{
				"q": -10,
				"r": 0,
				"height": 0.7016868816163773,
				"terrain": "text6"
			},
			{
				"q": -10,
				"r": 1,
				"height": 0.8417160298112195,
				"terrain": "mountain"
			},
			{
				"q": -10,
				"r": 2,
				"height": 0.5450503799332697,
				"terrain": "text4"
			},
			{
				"q": -10,
				"r": 3,
				"height": 0.0259962721121543,
				"terrain": "text6"
			},
			{
				"q": -10,
				"r": 4,
				"height": -0.36348423318622103,
				"terrain": "text2"
			},
			{
				"q": -10,
				"r": 5,
				"height": -0.5059991351551627,
				"terrain": "text6"
			},
			{
				"q": -10,
				"r": 6,
				"height": -0.519772018391307,
				"terrain": "text2"
			},
			{
				"q": -10,
				"r": 7,
				"height": -0.45080729558779625,
				"terrain": "text1"
			},
			{
				"q": -10,
				"r": 8,
				"height": -0.440128989762239,
				"terrain": "text2"
			},
			{
				"q": -10,
				"r": 9,
				"height": -0.4277702099176954,
				"terrain": "text2"
			},
			{
				"q": -10,
				"r": -1,
				"height": 0.3047467201427474,
				"terrain": "text7"
			},
			{
				"q": -11,
				"r": 1,
				"height": 0.678372672592715,
				"terrain": "text5"
			},
			{
				"q": -11,
				"r": 2,
				"height": 0.39205234763377783,
				"terrain": "text6"
			},
			{
				"q": -11,
				"r": 3,
				"height": -0.11114821107150874,
				"terrain": "text2"
			},
			{
				"q": -11,
				"r": 4,
				"height": -0.482910906395219,
				"terrain": "text3"
			},
			{
				"q": -11,
				"r": 5,
				"height": -0.6039688881889704,
				"terrain": "text4"
			},
			{
				"q": -11,
				"r": 6,
				"height": -0.6216448236847897,
				"terrain": "text1"
			},
			{
				"q": -11,
				"r": 7,
				"height": -0.5182967241418849,
				"terrain": "text5"
			},
			{
				"q": -11,
				"r": 8,
				"height": -0.4069669874442856,
				"terrain": "text3"
			},
			{
				"q": -11,
				"r": 9,
				"height": -0.29114944934640674,
				"terrain": "text7"
			},
			{
				"q": -12,
				"r": 3,
				"height": -0.32047815713386474,
				"terrain": "text7"
			},
			{
				"q": -12,
				"r": 4,
				"height": -0.6659218528227917,
				"terrain": "text1"
			},
			{
				"q": -12,
				"r": 5,
				"height": -0.7405465568720486,
				"terrain": "text3"
			},
			{
				"q": -12,
				"r": 6,
				"height": -0.7548968184388833,
				"terrain": "text4"
			},
			{
				"q": -12,
				"r": 7,
				"height": -0.67301058984255,
				"terrain": "text3"
			},
			{
				"q": -12,
				"r": 8,
				"height": -0.5060340671823047,
				"terrain": "text1"
			},
			{
				"q": -12,
				"r": 9,
				"height": -0.2855728101153316,
				"terrain": "text6"
			},
			{
				"q": -13,
				"r": 5,
				"height": -0.6631281404281724,
				"terrain": "text2"
			},
			{
				"q": -13,
				"r": 6,
				"height": -0.6904780895299218,
				"terrain": "text6"
			},
			{
				"q": -13,
				"r": 7,
				"height": -0.7346582508902862,
				"terrain": "text4"
			},
			{
				"q": -13,
				"r": 8,
				"height": -0.6508970474408704,
				"terrain": "text6"
			},
			{
				"q": -13,
				"r": 9,
				"height": -0.4121132699279183,
				"terrain": "text5"
			},
			{
				"q": -14,
				"r": 7,
				"height": -0.57642649836975,
				"terrain": "text1"
			},
			{
				"q": -14,
				"r": 8,
				"height": -0.6648750994874544,
				"terrain": "text4"
			},
			{
				"q": -14,
				"r": 9,
				"height": -0.5159673701190574,
				"terrain": "text4"
			},
			{
				"q": -15,
				"r": 9,
				"height": -0.5264103497614432,
				"terrain": "text4"
			},
			{
				"q": -4,
				"r": 0,
				"height": -0.297971739329094,
				"terrain": "text3"
			},
			{
				"q": -4,
				"r": 1,
				"height": -0.7858515103944504,
				"terrain": "text3"
			},
			{
				"q": -4,
				"r": 2,
				"height": -1.1295572959316855,
				"terrain": "text1"
			},
			{
				"q": -4,
				"r": 3,
				"height": -0.9785568806877372,
				"terrain": "text2"
			},
			{
				"q": -4,
				"r": 4,
				"height": -0.33815837280609673,
				"terrain": "text1"
			},
			{
				"q": -4,
				"r": 5,
				"height": 0.36896980131737983,
				"terrain": "text5"
			},
			{
				"q": -4,
				"r": 6,
				"height": 0.8543173308997523,
				"terrain": "mountain"
			},
			{
				"q": -4,
				"r": 7,
				"height": 0.8833880723961467,
				"terrain": "mountain"
			},
			{
				"q": -4,
				"r": 8,
				"height": 0.467170884387753,
				"terrain": "text5"
			},
			{
				"q": -4,
				"r": 9,
				"height": -0.05479215589319614,
				"terrain": "text3"
			},
			{
				"q": -4,
				"r": -10,
				"height": 0.7978444141426879,
				"terrain": "mountain"
			},
			{
				"q": -4,
				"r": -9,
				"height": 0.4521101773349585,
				"terrain": "text5"
			},
			{
				"q": -4,
				"r": -8,
				"height": 0.03592024055190374,
				"terrain": "text2"
			},
			{
				"q": -4,
				"r": -7,
				"height": -0.17862928505147269,
				"terrain": "text5"
			},
			{
				"q": -4,
				"r": -6,
				"height": -0.04409503269696291,
				"terrain": "text6"
			},
			{
				"q": -4,
				"r": -5,
				"height": 0.3733914220100139,
				"terrain": "text5"
			},
			{
				"q": -4,
				"r": -4,
				"height": 0.7912941300976107,
				"terrain": "mountain"
			},
			{
				"q": -4,
				"r": -3,
				"height": 1.0004716670279743,
				"terrain": "mountain"
			},
			{
				"q": -4,
				"r": -2,
				"height": 0.7861584866378991,
				"terrain": "mountain"
			},
			{
				"q": -4,
				"r": -1,
				"height": 0.2448392928456363,
				"terrain": "text5"
			},
			{
				"q": -3,
				"r": 0,
				"height": -0.32079063370149047,
				"terrain": "text6"
			},
			{
				"q": -3,
				"r": 1,
				"height": -0.7725812306936628,
				"terrain": "text2"
			},
			{
				"q": -3,
				"r": 2,
				"height": -0.936210091967737,
				"terrain": "text2"
			},
			{
				"q": -3,
				"r": 3,
				"height": -0.5653783872,
				"terrain": "text1"
			},
			{
				"q": -3,
				"r": 4,
				"height": 0.14841309379226333,
				"terrain": "text3"
			},
			{
				"q": -3,
				"r": 5,
				"height": 0.715213279670782,
				"terrain": "text5"
			},
			{
				"q": -3,
				"r": 6,
				"height": 0.9074240222933334,
				"terrain": "mountain"
			},
			{
				"q": -3,
				"r": 7,
				"height": 0.6191558201626339,
				"terrain": "text6"
			},
			{
				"q": -3,
				"r": 8,
				"height": 0.033253950040748964,
				"terrain": "text2"
			},
			{
				"q": -3,
				"r": 9,
				"height": -0.5022312882289295,
				"terrain": "text4"
			},
			{
				"q": -3,
				"r": -10,
				"height": 1.180208994642606,
				"terrain": "mountain"
			},
			{
				"q": -3,
				"r": -9,
				"height": 0.6667968853538608,
				"terrain": "text6"
			},
			{
				"q": -3,
				"r": -8,
				"height": 0.0900158232971825,
				"terrain": "text5"
			},
			{
				"q": -3,
				"r": -7,
				"height": -0.24379300823957756,
				"terrain": "text2"
			},
			{
				"q": -3,
				"r": -6,
				"height": -0.19093707155519393,
				"terrain": "text6"
			},
			{
				"q": -3,
				"r": -5,
				"height": 0.16667582436500786,
				"terrain": "text3"
			},
			{
				"q": -3,
				"r": -4,
				"height": 0.5783576139266466,
				"terrain": "text5"
			},
			{
				"q": -3,
				"r": -3,
				"height": 0.844120331566388,
				"terrain": "mountain"
			},
			{
				"q": -3,
				"r": -2,
				"height": 0.7036522070554173,
				"terrain": "text2"
			},
			{
				"q": -3,
				"r": -1,
				"height": 0.21112105606394288,
				"terrain": "text7"
			},
			{
				"q": -2,
				"r": 0,
				"height": -0.19664802822801986,
				"terrain": "text4"
			},
			{
				"q": -2,
				"r": 1,
				"height": -0.670827853904218,
				"terrain": "text5"
			},
			{
				"q": -2,
				"r": 2,
				"height": -0.748770804526627,
				"terrain": "text6"
			},
			{
				"q": -2,
				"r": 3,
				"height": -0.3179299781178598,
				"terrain": "text7"
			},
			{
				"q": -2,
				"r": 4,
				"height": 0.30694883166879844,
				"terrain": "text5"
			},
			{
				"q": -2,
				"r": 5,
				"height": 0.6565407932982777,
				"terrain": "text2"
			},
			{
				"q": -2,
				"r": 6,
				"height": 0.5775286935387653,
				"terrain": "text1"
			},
			{
				"q": -2,
				"r": 7,
				"height": 0.07001152285900691,
				"terrain": "text6"
			},
			{
				"q": -2,
				"r": 8,
				"height": -0.5374865125824215,
				"terrain": "text3"
			},
			{
				"q": -2,
				"r": 9,
				"height": -0.9227458454571962,
				"terrain": "text7"
			},
			{
				"q": -2,
				"r": -10,
				"height": 1.0170069284197356,
				"terrain": "mountain"
			},
			{
				"q": -2,
				"r": -9,
				"height": 0.3764485393735082,
				"terrain": "text4"
			},
			{
				"q": -2,
				"r": -8,
				"height": -0.21392192666928966,
				"terrain": "text6"
			},
			{
				"q": -2,
				"r": -7,
				"height": -0.47411817899615,
				"terrain": "text7"
			},
			{
				"q": -2,
				"r": -6,
				"height": -0.3471070025809069,
				"terrain": "text3"
			},
			{
				"q": -2,
				"r": -5,
				"height": 0.031171527839424173,
				"terrain": "text6"
			},
			{
				"q": -2,
				"r": -4,
				"height": 0.47583538944267645,
				"terrain": "text6"
			},
			{
				"q": -2,
				"r": -3,
				"height": 0.8349398069221687,
				"terrain": "mountain"
			},
			{
				"q": -2,
				"r": -2,
				"height": 0.8054366194631697,
				"terrain": "mountain"
			},
			{
				"q": -2,
				"r": -1,
				"height": 0.3669630787034756,
				"terrain": "text6"
			},
			{
				"q": -1,
				"r": 0,
				"height": -0.04667636213991703,
				"terrain": "text5"
			},
			{
				"q": -1,
				"r": 1,
				"height": -0.5850858304558445,
				"terrain": "text5"
			},
			{
				"q": -1,
				"r": 2,
				"height": -0.7015588624532267,
				"terrain": "text5"
			},
			{
				"q": -1,
				"r": 3,
				"height": -0.3630536011351434,
				"terrain": "text2"
			},
			{
				"q": -1,
				"r": 4,
				"height": 0.09823004712705533,
				"terrain": "text4"
			},
			{
				"q": -1,
				"r": 5,
				"height": 0.27355921634764,
				"terrain": "text3"
			},
			{
				"q": -1,
				"r": 6,
				"height": 0.038102113733294,
				"terrain": "text5"
			},
			{
				"q": -1,
				"r": 7,
				"height": -0.5349903261798691,
				"terrain": "text6"
			},
			{
				"q": -1,
				"r": 8,
				"height": -1.0233531678161696,
				"terrain": "text4"
			},
			{
				"q": -1,
				"r": 9,
				"height": -1.1784995575109019,
				"terrain": "text5"
			},
			{
				"q": -1,
				"r": -10,
				"height": 0.36098703322964565,
				"terrain": "text1"
			},
			{
				"q": -1,
				"r": -9,
				"height": -0.24682146200303645,
				"terrain": "text6"
			},
			{
				"q": -1,
				"r": -8,
				"height": -0.6377531676282574,
				"terrain": "text5"
			},
			{
				"q": -1,
				"r": -7,
				"height": -0.6368643068664904,
				"terrain": "text6"
			},
			{
				"q": -1,
				"r": -6,
				"height": -0.3139881865341216,
				"terrain": "text7"
			},
			{
				"q": -1,
				"r": -5,
				"height": 0.12712209030933916,
				"terrain": "text7"
			},
			{
				"q": -1,
				"r": -4,
				"height": 0.5965720094003863,
				"terrain": "text6"
			},
			{
				"q": -1,
				"r": -3,
				"height": 1.0012344701971134,
				"terrain": "mountain"
			},
			{
				"q": -1,
				"r": -2,
				"height": 1.0223769430790066,
				"terrain": "mountain"
			},
			{
				"q": -1,
				"r": -1,
				"height": 0.5852142136928123,
				"terrain": "text1"
			}
		],
		"halfWidth": 10,
		"halfHeight": 10
	}
	},
  "seed_6":{
	"map_id":"seed_6",
	"data": {
		"_width": 20,
		"_height": 20,
		"data": [
			{
				"q": 0,
				"r": 0,
				"height": 0,
				"terrain": "text4"
			},
			{
				"q": 0,
				"r": 1,
				"height": 0.6719500288477367,
				"terrain": "text2"
			},
			{
				"q": 0,
				"r": 2,
				"height": 1.1651145513741863,
				"terrain": "mountain"
			},
			{
				"q": 0,
				"r": 3,
				"height": 1.2428336032058043,
				"terrain": "mountain"
			},
			{
				"q": 0,
				"r": 4,
				"height": 1.0072161683754925,
				"terrain": "mountain"
			},
			{
				"q": 0,
				"r": 5,
				"height": 0.7446059874267509,
				"terrain": "text5"
			},
			{
				"q": 0,
				"r": 6,
				"height": 0.45569493552140594,
				"terrain": "text2"
			},
			{
				"q": 0,
				"r": 7,
				"height": 0.08180039507564185,
				"terrain": "text4"
			},
			{
				"q": 0,
				"r": 8,
				"height": -0.16921068566469183,
				"terrain": "text5"
			},
			{
				"q": 0,
				"r": 9,
				"height": -0.15665818937309517,
				"terrain": "text5"
			},
			{
				"q": 0,
				"r": -10,
				"height": -0.32900025719238607,
				"terrain": "text3"
			},
			{
				"q": 0,
				"r": -9,
				"height": -0.5720810906483251,
				"terrain": "text2"
			},
			{
				"q": 0,
				"r": -8,
				"height": -0.7293933302559439,
				"terrain": "text5"
			},
			{
				"q": 0,
				"r": -7,
				"height": -0.8317322511813321,
				"terrain": "text3"
			},
			{
				"q": 0,
				"r": -6,
				"height": -0.9020256125943193,
				"terrain": "text6"
			},
			{
				"q": 0,
				"r": -5,
				"height": -0.9668124909383755,
				"terrain": "text7"
			},
			{
				"q": 0,
				"r": -4,
				"height": -1.0986949773235957,
				"terrain": "text2"
			},
			{
				"q": 0,
				"r": -3,
				"height": -1.2675947944209924,
				"terrain": "text6"
			},
			{
				"q": 0,
				"r": -2,
				"height": -1.1671412417968123,
				"terrain": "text5"
			},
			{
				"q": 0,
				"r": -1,
				"height": -0.6719500288477358,
				"terrain": "text2"
			},
			{
				"q": 1,
				"r": 0,
				"height": -0.625273666707819,
				"terrain": "text6"
			},
			{
				"q": 1,
				"r": 1,
				"height": 0.060541816788004486,
				"terrain": "text2"
			},
			{
				"q": 1,
				"r": 2,
				"height": 0.6897628544121095,
				"terrain": "text4"
			},
			{
				"q": 1,
				"r": 3,
				"height": 0.9691503705687096,
				"terrain": "mountain"
			},
			{
				"q": 1,
				"r": 4,
				"height": 0.8948093062908994,
				"terrain": "mountain"
			},
			{
				"q": 1,
				"r": 5,
				"height": 0.7034893039984242,
				"terrain": "text6"
			},
			{
				"q": 1,
				"r": 6,
				"height": 0.452662274255272,
				"terrain": "text2"
			},
			{
				"q": 1,
				"r": 7,
				"height": 0.16278368432000773,
				"terrain": "text2"
			},
			{
				"q": 1,
				"r": 8,
				"height": 0.047047570728928734,
				"terrain": "text6"
			},
			{
				"q": 1,
				"r": 9,
				"height": 0.20213689615712468,
				"terrain": "text4"
			},
			{
				"q": 1,
				"r": -10,
				"height": -0.32862291743955646,
				"terrain": "text3"
			},
			{
				"q": 1,
				"r": -9,
				"height": -0.5044471034694885,
				"terrain": "text6"
			},
			{
				"q": 1,
				"r": -8,
				"height": -0.6433000565529208,
				"terrain": "text5"
			},
			{
				"q": 1,
				"r": -7,
				"height": -0.7590876852035758,
				"terrain": "text6"
			},
			{
				"q": 1,
				"r": -6,
				"height": -0.8624670036132651,
				"terrain": "text3"
			},
			{
				"q": 1,
				"r": -5,
				"height": -0.966387756933508,
				"terrain": "text4"
			},
			{
				"q": 1,
				"r": -4,
				"height": -1.1334796940861758,
				"terrain": "text1"
			},
			{
				"q": 1,
				"r": -3,
				"height": -1.412034673047601,
				"terrain": "text2"
			},
			{
				"q": 1,
				"r": -2,
				"height": -1.5075910830217167,
				"terrain": "text7"
			},
			{
				"q": 1,
				"r": -1,
				"height": -1.2087978437557978,
				"terrain": "text3"
			},
			{
				"q": 2,
				"r": 0,
				"height": -0.9642599112993051,
				"terrain": "text2"
			},
			{
				"q": 2,
				"r": 1,
				"height": -0.31409665087754024,
				"terrain": "text3"
			},
			{
				"q": 2,
				"r": 2,
				"height": 0.45360602803265027,
				"terrain": "text1"
			},
			{
				"q": 2,
				"r": 3,
				"height": 0.9658672157675426,
				"terrain": "mountain"
			},
			{
				"q": 2,
				"r": 4,
				"height": 1.0618169802823294,
				"terrain": "mountain"
			},
			{
				"q": 2,
				"r": 5,
				"height": 0.9199520258168705,
				"terrain": "mountain"
			},
			{
				"q": 2,
				"r": 6,
				"height": 0.6653348991513497,
				"terrain": "text6"
			},
			{
				"q": 2,
				"r": 7,
				"height": 0.4062381405896886,
				"terrain": "text2"
			},
			{
				"q": 2,
				"r": 8,
				"height": 0.35968524327223916,
				"terrain": "text2"
			},
			{
				"q": 2,
				"r": 9,
				"height": 0.5677682087218576,
				"terrain": "text1"
			},
			{
				"q": 2,
				"r": -10,
				"height": -0.11047205152256462,
				"terrain": "text2"
			},
			{
				"q": 2,
				"r": -9,
				"height": -0.19023679079452832,
				"terrain": "text2"
			},
			{
				"q": 2,
				"r": -8,
				"height": -0.37758399188182284,
				"terrain": "text3"
			},
			{
				"q": 2,
				"r": -7,
				"height": -0.6147653019073533,
				"terrain": "text6"
			},
			{
				"q": 2,
				"r": -6,
				"height": -0.8040313497718594,
				"terrain": "text3"
			},
			{
				"q": 2,
				"r": -5,
				"height": -0.897430766509117,
				"terrain": "text5"
			},
			{
				"q": 2,
				"r": -4,
				"height": -1.0216898031146784,
				"terrain": "text4"
			},
			{
				"q": 2,
				"r": -3,
				"height": -1.3139778875660832,
				"terrain": "text4"
			},
			{
				"q": 2,
				"r": -2,
				"height": -1.5318774001195579,
				"terrain": "text1"
			},
			{
				"q": 2,
				"r": -1,
				"height": -1.4159315324047486,
				"terrain": "text1"
			},
			{
				"q": 3,
				"r": 0,
				"height": -0.846614147254088,
				"terrain": "text1"
			},
			{
				"q": 3,
				"r": 1,
				"height": -0.26012034213247903,
				"terrain": "text3"
			},
			{
				"q": 3,
				"r": 2,
				"height": 0.5456041535501216,
				"terrain": "text7"
			},
			{
				"q": 3,
				"r": 3,
				"height": 1.1554848768927763,
				"terrain": "mountain"
			},
			{
				"q": 3,
				"r": 4,
				"height": 1.308887385232419,
				"terrain": "mountain"
			},
			{
				"q": 3,
				"r": 5,
				"height": 1.140345388079279,
				"terrain": "mountain"
			},
			{
				"q": 3,
				"r": 6,
				"height": 0.8137206348787462,
				"terrain": "mountain"
			},
			{
				"q": 3,
				"r": 7,
				"height": 0.5074953504933677,
				"terrain": "text1"
			},
			{
				"q": 3,
				"r": 8,
				"height": 0.43962870293729794,
				"terrain": "text5"
			},
			{
				"q": 3,
				"r": 9,
				"height": 0.6044006329587888,
				"terrain": "text5"
			},
			{
				"q": 3,
				"r": -10,
				"height": 0.19602371350218106,
				"terrain": "text4"
			},
			{
				"q": 3,
				"r": -9,
				"height": 0.23772656820408677,
				"terrain": "text3"
			},
			{
				"q": 3,
				"r": -8,
				"height": -0.027131275451138692,
				"terrain": "text1"
			},
			{
				"q": 3,
				"r": -7,
				"height": -0.4475686913437999,
				"terrain": "text5"
			},
			{
				"q": 3,
				"r": -6,
				"height": -0.7565306711654087,
				"terrain": "text6"
			},
			{
				"q": 3,
				"r": -5,
				"height": -0.8126940720290508,
				"terrain": "text3"
			},
			{
				"q": 3,
				"r": -4,
				"height": -0.8187638698803844,
				"terrain": "text5"
			},
			{
				"q": 3,
				"r": -3,
				"height": -0.9931135722615199,
				"terrain": "text2"
			},
			{
				"q": 3,
				"r": -2,
				"height": -1.1952714216836804,
				"terrain": "text3"
			},
			{
				"q": 3,
				"r": -1,
				"height": -1.1753875459403216,
				"terrain": "text4"
			},
			{
				"q": 4,
				"r": 0,
				"height": -0.40682702981323593,
				"terrain": "text4"
			},
			{
				"q": 4,
				"r": 1,
				"height": 0.09759825260731514,
				"terrain": "text6"
			},
			{
				"q": 4,
				"r": 2,
				"height": 0.7863183304875233,
				"terrain": "mountain"
			},
			{
				"q": 4,
				"r": 3,
				"height": 1.2781608456206783,
				"terrain": "mountain"
			},
			{
				"q": 4,
				"r": 4,
				"height": 1.3353292623928217,
				"terrain": "mountain"
			},
			{
				"q": 4,
				"r": 5,
				"height": 1.0699684229873967,
				"terrain": "mountain"
			},
			{
				"q": 4,
				"r": 6,
				"height": 0.6330485078909703,
				"terrain": "text6"
			},
			{
				"q": 4,
				"r": 7,
				"height": 0.2438300916274691,
				"terrain": "text1"
			},
			{
				"q": 4,
				"r": 8,
				"height": 0.12417638530571161,
				"terrain": "text3"
			},
			{
				"q": 4,
				"r": 9,
				"height": 0.2376160289687353,
				"terrain": "text2"
			},
			{
				"q": 4,
				"r": -10,
				"height": 0.33059629836872534,
				"terrain": "text4"
			},
			{
				"q": 4,
				"r": -9,
				"height": 0.49958973943040264,
				"terrain": "text6"
			},
			{
				"q": 4,
				"r": -8,
				"height": 0.23871399989109576,
				"terrain": "text3"
			},
			{
				"q": 4,
				"r": -7,
				"height": -0.2612852463757119,
				"terrain": "text4"
			},
			{
				"q": 4,
				"r": -6,
				"height": -0.6507315993167304,
				"terrain": "text7"
			},
			{
				"q": 4,
				"r": -5,
				"height": -0.7056491456896012,
				"terrain": "text3"
			},
			{
				"q": 4,
				"r": -4,
				"height": -0.6101649640862172,
				"terrain": "text4"
			},
			{
				"q": 4,
				"r": -3,
				"height": -0.6257800925339728,
				"terrain": "text2"
			},
			{
				"q": 4,
				"r": -2,
				"height": -0.7142265219219108,
				"terrain": "text5"
			},
			{
				"q": 4,
				"r": -1,
				"height": -0.6787741588493899,
				"terrain": "text1"
			},
			{
				"q": 5,
				"r": 0,
				"height": 0.016390051400530764,
				"terrain": "text6"
			},
			{
				"q": 5,
				"r": 1,
				"height": 0.4374580096291156,
				"terrain": "text6"
			},
			{
				"q": 5,
				"r": 2,
				"height": 0.9259516280473254,
				"terrain": "mountain"
			},
			{
				"q": 5,
				"r": 3,
				"height": 1.174253462922947,
				"terrain": "mountain"
			},
			{
				"q": 5,
				"r": 4,
				"height": 1.0410032847430144,
				"terrain": "mountain"
			},
			{
				"q": 5,
				"r": 5,
				"height": 0.6506467289259256,
				"terrain": "text3"
			},
			{
				"q": 5,
				"r": 6,
				"height": 0.12372711774806022,
				"terrain": "text3"
			},
			{
				"q": 5,
				"r": 7,
				"height": -0.3045965878859746,
				"terrain": "text3"
			},
			{
				"q": 5,
				"r": 8,
				"height": -0.4077409342422767,
				"terrain": "text6"
			},
			{
				"q": 5,
				"r": -10,
				"height": 0.03714458099853346,
				"terrain": "text5"
			},
			{
				"q": 5,
				"r": -9,
				"height": 0.3268283984045844,
				"terrain": "text5"
			},
			{
				"q": 5,
				"r": -8,
				"height": 0.23053138357076675,
				"terrain": "text6"
			},
			{
				"q": 5,
				"r": -7,
				"height": -0.14526168910771659,
				"terrain": "text6"
			},
			{
				"q": 5,
				"r": -6,
				"height": -0.5056267009752167,
				"terrain": "text2"
			},
			{
				"q": 5,
				"r": -5,
				"height": -0.5880914038488934,
				"terrain": "text7"
			},
			{
				"q": 5,
				"r": -4,
				"height": -0.47677069951608975,
				"terrain": "text2"
			},
			{
				"q": 5,
				"r": -3,
				"height": -0.4060681321275814,
				"terrain": "text6"
			},
			{
				"q": 5,
				"r": -2,
				"height": -0.3832768413156837,
				"terrain": "text1"
			},
			{
				"q": 5,
				"r": -1,
				"height": -0.2674737104832222,
				"terrain": "text4"
			},
			{
				"q": 6,
				"r": 0,
				"height": 0.2842244379773075,
				"terrain": "text5"
			},
			{
				"q": 6,
				"r": 1,
				"height": 0.6026467296337717,
				"terrain": "text4"
			},
			{
				"q": 6,
				"r": 2,
				"height": 0.850800944587115,
				"terrain": "mountain"
			},
			{
				"q": 6,
				"r": 3,
				"height": 0.8306799271165037,
				"terrain": "mountain"
			},
			{
				"q": 6,
				"r": 4,
				"height": 0.5161048896769622,
				"terrain": "text6"
			},
			{
				"q": 6,
				"r": 5,
				"height": 0.048947743262463456,
				"terrain": "text3"
			},
			{
				"q": 6,
				"r": 6,
				"height": -0.4889526821933214,
				"terrain": "text6"
			},
			{
				"q": 6,
				"r": -10,
				"height": -0.5707940155040115,
				"terrain": "text6"
			},
			{
				"q": 6,
				"r": -9,
				"height": -0.19909674125527999,
				"terrain": "text7"
			},
			{
				"q": 6,
				"r": -8,
				"height": -0.08910230960546306,
				"terrain": "text4"
			},
			{
				"q": 6,
				"r": -7,
				"height": -0.2541401931509275,
				"terrain": "text3"
			},
			{
				"q": 6,
				"r": -6,
				"height": -0.49858964403720024,
				"terrain": "text4"
			},
			{
				"q": 6,
				"r": -5,
				"height": -0.5659866789050663,
				"terrain": "text4"
			},
			{
				"q": 6,
				"r": -4,
				"height": -0.44913525587113345,
				"terrain": "text2"
			},
			{
				"q": 6,
				"r": -3,
				"height": -0.32939280469665067,
				"terrain": "text4"
			},
			{
				"q": 6,
				"r": -2,
				"height": -0.21611755221763573,
				"terrain": "text5"
			},
			{
				"q": 6,
				"r": -1,
				"height": -0.019838002573947966,
				"terrain": "text1"
			},
			{
				"q": 7,
				"r": 0,
				"height": 0.39683728969700083,
				"terrain": "text6"
			},
			{
				"q": 7,
				"r": 1,
				"height": 0.5307021744043368,
				"terrain": "text5"
			},
			{
				"q": 7,
				"r": 2,
				"height": 0.4979067669555474,
				"terrain": "text5"
			},
			{
				"q": 7,
				"r": 3,
				"height": 0.28051710175223143,
				"terrain": "text2"
			},
			{
				"q": 7,
				"r": 4,
				"height": -0.06139879108300276,
				"terrain": "text5"
			},
			{
				"q": 7,
				"r": -10,
				"height": -1.1940307356183502,
				"terrain": "text5"
			},
			{
				"q": 7,
				"r": -9,
				"height": -0.8384899500002391,
				"terrain": "text4"
			},
			{
				"q": 7,
				"r": -8,
				"height": -0.5985329574755488,
				"terrain": "text4"
			},
			{
				"q": 7,
				"r": -7,
				"height": -0.5531101572616111,
				"terrain": "text2"
			},
			{
				"q": 7,
				"r": -6,
				"height": -0.630730251456022,
				"terrain": "text1"
			},
			{
				"q": 7,
				"r": -5,
				"height": -0.6536910036939391,
				"terrain": "text7"
			},
			{
				"q": 7,
				"r": -4,
				"height": -0.4946019921863752,
				"terrain": "text4"
			},
			{
				"q": 7,
				"r": -3,
				"height": -0.2670925666465158,
				"terrain": "text4"
			},
			{
				"q": 7,
				"r": -2,
				"height": -0.05678730552661379,
				"terrain": "text7"
			},
			{
				"q": 7,
				"r": -1,
				"height": 0.1595868076409876,
				"terrain": "text1"
			},
			{
				"q": 8,
				"r": 0,
				"height": 0.40558642228205066,
				"terrain": "text1"
			},
			{
				"q": 8,
				"r": 1,
				"height": 0.3185230843288333,
				"terrain": "text4"
			},
			{
				"q": 8,
				"r": 2,
				"height": 0.041572656419569726,
				"terrain": "text6"
			},
			{
				"q": 8,
				"r": -10,
				"height": -1.415850262429666,
				"terrain": "text6"
			},
			{
				"q": 8,
				"r": -9,
				"height": -1.1387430842549513,
				"terrain": "text5"
			},
			{
				"q": 8,
				"r": -8,
				"height": -0.9053467465864993,
				"terrain": "text4"
			},
			{
				"q": 8,
				"r": -7,
				"height": -0.7758993247875965,
				"terrain": "text2"
			},
			{
				"q": 8,
				"r": -6,
				"height": -0.7613128373580277,
				"terrain": "text5"
			},
			{
				"q": 8,
				"r": -5,
				"height": -0.7803381587481051,
				"terrain": "text7"
			},
			{
				"q": 8,
				"r": -4,
				"height": -0.5963175879751255,
				"terrain": "text4"
			},
			{
				"q": 8,
				"r": -3,
				"height": -0.2270646171078095,
				"terrain": "text3"
			},
			{
				"q": 8,
				"r": -2,
				"height": 0.09852512451120149,
				"terrain": "text5"
			},
			{
				"q": 8,
				"r": -1,
				"height": 0.2986084662224385,
				"terrain": "text6"
			},
			{
				"q": 9,
				"r": 0,
				"height": 0.306079044921583,
				"terrain": "text5"
			},
			{
				"q": 9,
				"r": -10,
				"height": -1.1192534362551438,
				"terrain": "text6"
			},
			{
				"q": 9,
				"r": -9,
				"height": -0.903545299790915,
				"terrain": "text6"
			},
			{
				"q": 9,
				"r": -8,
				"height": -0.7731925096372368,
				"terrain": "text3"
			},
			{
				"q": 9,
				"r": -7,
				"height": -0.7176138789432386,
				"terrain": "text3"
			},
			{
				"q": 9,
				"r": -6,
				"height": -0.7448424230075896,
				"terrain": "text4"
			},
			{
				"q": 9,
				"r": -5,
				"height": -0.8185143285380285,
				"terrain": "text3"
			},
			{
				"q": 9,
				"r": -4,
				"height": -0.6538987984121363,
				"terrain": "text6"
			},
			{
				"q": 9,
				"r": -3,
				"height": -0.20784566512192132,
				"terrain": "text2"
			},
			{
				"q": 9,
				"r": -2,
				"height": 0.17312756575055332,
				"terrain": "text2"
			},
			{
				"q": 9,
				"r": -1,
				"height": 0.3279298367728525,
				"terrain": "text6"
			},
			{
				"q": 10,
				"r": -10,
				"height": -0.5267489711934156,
				"terrain": "text5"
			},
			{
				"q": 10,
				"r": -9,
				"height": -0.3488206378189301,
				"terrain": "text3"
			},
			{
				"q": 10,
				"r": -8,
				"height": -0.3446669837079468,
				"terrain": "text3"
			},
			{
				"q": 10,
				"r": -7,
				"height": -0.4255301931976478,
				"terrain": "text3"
			},
			{
				"q": 10,
				"r": -6,
				"height": -0.5459064934601083,
				"terrain": "text1"
			},
			{
				"q": 10,
				"r": -5,
				"height": -0.6742367132183407,
				"terrain": "text4"
			},
			{
				"q": 10,
				"r": -4,
				"height": -0.5566640679539707,
				"terrain": "text4"
			},
			{
				"q": 10,
				"r": -3,
				"height": -0.1536058562094168,
				"terrain": "text2"
			},
			{
				"q": 10,
				"r": -2,
				"height": 0.16414964393604475,
				"terrain": "text3"
			},
			{
				"q": 11,
				"r": -10,
				"height": 0.11632820859675908,
				"terrain": "text1"
			},
			{
				"q": 11,
				"r": -9,
				"height": 0.22565786554149458,
				"terrain": "text4"
			},
			{
				"q": 11,
				"r": -8,
				"height": 0.07534840080340555,
				"terrain": "text4"
			},
			{
				"q": 11,
				"r": -7,
				"height": -0.15662078999460094,
				"terrain": "text5"
			},
			{
				"q": 11,
				"r": -6,
				"height": -0.3637025001664456,
				"terrain": "text2"
			},
			{
				"q": 11,
				"r": -5,
				"height": -0.523291884573052,
				"terrain": "text6"
			},
			{
				"q": 11,
				"r": -4,
				"height": -0.4629001698702514,
				"terrain": "text3"
			},
			{
				"q": 12,
				"r": -10,
				"height": 0.5795624670397593,
				"terrain": "text6"
			},
			{
				"q": 12,
				"r": -9,
				"height": 0.6284091291150594,
				"terrain": "text4"
			},
			{
				"q": 12,
				"r": -8,
				"height": 0.370991082215555,
				"terrain": "text1"
			},
			{
				"q": 12,
				"r": -7,
				"height": -0.004785158011629043,
				"terrain": "text6"
			},
			{
				"q": 12,
				"r": -6,
				"height": -0.318299415968046,
				"terrain": "text4"
			},
			{
				"q": 13,
				"r": -10,
				"height": 0.5925468894497954,
				"terrain": "text3"
			},
			{
				"q": 13,
				"r": -9,
				"height": 0.6313684770886336,
				"terrain": "text5"
			},
			{
				"q": 13,
				"r": -8,
				"height": 0.41794494633356616,
				"terrain": "text4"
			},
			{
				"q": 14,
				"r": -10,
				"height": 0.26716163705499263,
				"terrain": "text3"
			},
			{
				"q": -5,
				"r": 0,
				"height": 0.044712166396462846,
				"terrain": "text3"
			},
			{
				"q": -5,
				"r": 1,
				"height": 0.3140408497643595,
				"terrain": "text2"
			},
			{
				"q": -5,
				"r": 2,
				"height": 0.5747481246015057,
				"terrain": "text2"
			},
			{
				"q": -5,
				"r": 3,
				"height": 0.7009649321730143,
				"terrain": "text6"
			},
			{
				"q": -5,
				"r": 4,
				"height": 0.7694229095806466,
				"terrain": "mountain"
			},
			{
				"q": -5,
				"r": 5,
				"height": 0.8443192547587022,
				"terrain": "mountain"
			},
			{
				"q": -5,
				"r": 6,
				"height": 0.8487824296924185,
				"terrain": "mountain"
			},
			{
				"q": -5,
				"r": 7,
				"height": 0.8476010098298755,
				"terrain": "mountain"
			},
			{
				"q": -5,
				"r": 8,
				"height": 0.7833563401570612,
				"terrain": "mountain"
			},
			{
				"q": -5,
				"r": 9,
				"height": 0.5968388791790513,
				"terrain": "text6"
			},
			{
				"q": -5,
				"r": -10,
				"height": -0.1571464728003612,
				"terrain": "text1"
			},
			{
				"q": -5,
				"r": -9,
				"height": -0.33823125349533,
				"terrain": "text3"
			},
			{
				"q": -5,
				"r": -8,
				"height": -0.4792484058509644,
				"terrain": "text6"
			},
			{
				"q": -5,
				"r": -7,
				"height": -0.3887832467758664,
				"terrain": "text4"
			},
			{
				"q": -5,
				"r": -6,
				"height": -0.0025816394535864012,
				"terrain": "text1"
			},
			{
				"q": -5,
				"r": -5,
				"height": 0.5764730289056033,
				"terrain": "text3"
			},
			{
				"q": -5,
				"r": -4,
				"height": 0.9675261629249918,
				"terrain": "mountain"
			},
			{
				"q": -5,
				"r": -3,
				"height": 0.8743530402378076,
				"terrain": "mountain"
			},
			{
				"q": -5,
				"r": -2,
				"height": 0.42800121354042586,
				"terrain": "text5"
			},
			{
				"q": -5,
				"r": -1,
				"height": 0.04488978639100388,
				"terrain": "text2"
			},
			{
				"q": -6,
				"r": 0,
				"height": -0.1787014507077117,
				"terrain": "text2"
			},
			{
				"q": -6,
				"r": 1,
				"height": 0.13467326777338715,
				"terrain": "text3"
			},
			{
				"q": -6,
				"r": 2,
				"height": 0.4815159432704878,
				"terrain": "text4"
			},
			{
				"q": -6,
				"r": 3,
				"height": 0.6610636859556824,
				"terrain": "text1"
			},
			{
				"q": -6,
				"r": 4,
				"height": 0.7028017180737893,
				"terrain": "text2"
			},
			{
				"q": -6,
				"r": 5,
				"height": 0.7120736202327569,
				"terrain": "text1"
			},
			{
				"q": -6,
				"r": 6,
				"height": 0.6946642554857585,
				"terrain": "text2"
			},
			{
				"q": -6,
				"r": 7,
				"height": 0.8176000629426725,
				"terrain": "mountain"
			},
			{
				"q": -6,
				"r": 8,
				"height": 1.011640947219358,
				"terrain": "mountain"
			},
			{
				"q": -6,
				"r": 9,
				"height": 1.0864584327165814,
				"terrain": "mountain"
			},
			{
				"q": -6,
				"r": -9,
				"height": -0.6481929145280383,
				"terrain": "text4"
			},
			{
				"q": -6,
				"r": -8,
				"height": -0.8587028630948201,
				"terrain": "text7"
			},
			{
				"q": -6,
				"r": -7,
				"height": -0.861786630770095,
				"terrain": "text2"
			},
			{
				"q": -6,
				"r": -6,
				"height": -0.5270594085933225,
				"terrain": "text1"
			},
			{
				"q": -6,
				"r": -5,
				"height": 0.07482082968221582,
				"terrain": "text7"
			},
			{
				"q": -6,
				"r": -4,
				"height": 0.5533113113297213,
				"terrain": "text5"
			},
			{
				"q": -6,
				"r": -3,
				"height": 0.5719752164942751,
				"terrain": "text7"
			},
			{
				"q": -6,
				"r": -2,
				"height": 0.19960862603913515,
				"terrain": "text1"
			},
			{
				"q": -6,
				"r": -1,
				"height": -0.16881984162713104,
				"terrain": "text3"
			},
			{
				"q": -7,
				"r": 0,
				"height": -0.17272817739881594,
				"terrain": "text2"
			},
			{
				"q": -7,
				"r": 1,
				"height": 0.20065285065763017,
				"terrain": "text4"
			},
			{
				"q": -7,
				"r": 2,
				"height": 0.6118392128564476,
				"terrain": "text7"
			},
			{
				"q": -7,
				"r": 3,
				"height": 0.8106688214102326,
				"terrain": "mountain"
			},
			{
				"q": -7,
				"r": 4,
				"height": 0.7941115432437549,
				"terrain": "mountain"
			},
			{
				"q": -7,
				"r": 5,
				"height": 0.7209918542431806,
				"terrain": "text4"
			},
			{
				"q": -7,
				"r": 6,
				"height": 0.6354635065533667,
				"terrain": "text2"
			},
			{
				"q": -7,
				"r": 7,
				"height": 0.7440498890995206,
				"terrain": "text6"
			},
			{
				"q": -7,
				"r": 8,
				"height": 1.0583404388737048,
				"terrain": "mountain"
			},
			{
				"q": -7,
				"r": 9,
				"height": 1.3477462278596524,
				"terrain": "mountain"
			},
			{
				"q": -7,
				"r": -7,
				"height": -1.0983737231269532,
				"terrain": "text2"
			},
			{
				"q": -7,
				"r": -6,
				"height": -0.7804310019226874,
				"terrain": "text4"
			},
			{
				"q": -7,
				"r": -5,
				"height": -0.23421981132395364,
				"terrain": "text4"
			},
			{
				"q": -7,
				"r": -4,
				"height": 0.23115404013712715,
				"terrain": "text5"
			},
			{
				"q": -7,
				"r": -3,
				"height": 0.3036653632729496,
				"terrain": "text2"
			},
			{
				"q": -7,
				"r": -2,
				"height": 0.03671841860565349,
				"terrain": "text2"
			},
			{
				"q": -7,
				"r": -1,
				"height": -0.22596249810192892,
				"terrain": "text3"
			},
			{
				"q": -8,
				"r": 0,
				"height": -0.12316644538028765,
				"terrain": "text5"
			},
			{
				"q": -8,
				"r": 1,
				"height": 0.2938994636405464,
				"terrain": "text3"
			},
			{
				"q": -8,
				"r": 2,
				"height": 0.7819382830611237,
				"terrain": "mountain"
			},
			{
				"q": -8,
				"r": 3,
				"height": 1.0360621899855047,
				"terrain": "mountain"
			},
			{
				"q": -8,
				"r": 4,
				"height": 1.0031358609295096,
				"terrain": "mountain"
			},
			{
				"q": -8,
				"r": 5,
				"height": 0.8613193510668937,
				"terrain": "mountain"
			},
			{
				"q": -8,
				"r": 6,
				"height": 0.6596354830381592,
				"terrain": "text5"
			},
			{
				"q": -8,
				"r": 7,
				"height": 0.5917306583309586,
				"terrain": "text7"
			},
			{
				"q": -8,
				"r": 8,
				"height": 0.8269993347813063,
				"terrain": "mountain"
			},
			{
				"q": -8,
				"r": 9,
				"height": 1.2008758723801232,
				"terrain": "mountain"
			},
			{
				"q": -8,
				"r": -5,
				"height": -0.2496310761756103,
				"terrain": "text5"
			},
			{
				"q": -8,
				"r": -4,
				"height": 0.12222728162973454,
				"terrain": "text5"
			},
			{
				"q": -8,
				"r": -3,
				"height": 0.16142540075509282,
				"terrain": "text6"
			},
			{
				"q": -8,
				"r": -2,
				"height": -0.06084521368902657,
				"terrain": "text1"
			},
			{
				"q": -8,
				"r": -1,
				"height": -0.23647759443556177,
				"terrain": "text4"
			},
			{
				"q": -9,
				"r": 0,
				"height": -0.11368079637282924,
				"terrain": "text7"
			},
			{
				"q": -9,
				"r": 1,
				"height": 0.2947111277545553,
				"terrain": "text6"
			},
			{
				"q": -9,
				"r": 2,
				"height": 0.8408734946109279,
				"terrain": "mountain"
			},
			{
				"q": -9,
				"r": 3,
				"height": 1.1601752693998213,
				"terrain": "mountain"
			},
			{
				"q": -9,
				"r": 4,
				"height": 1.1376925746336146,
				"terrain": "mountain"
			},
			{
				"q": -9,
				"r": 5,
				"height": 0.9484607422247338,
				"terrain": "mountain"
			},
			{
				"q": -9,
				"r": 6,
				"height": 0.6429146565232746,
				"terrain": "text6"
			},
			{
				"q": -9,
				"r": 7,
				"height": 0.37569838666137734,
				"terrain": "text3"
			},
			{
				"q": -9,
				"r": 8,
				"height": 0.4428052652027715,
				"terrain": "text6"
			},
			{
				"q": -9,
				"r": 9,
				"height": 0.7776792515383735,
				"terrain": "mountain"
			},
			{
				"q": -9,
				"r": -3,
				"height": 0.19524304399917647,
				"terrain": "text3"
			},
			{
				"q": -9,
				"r": -2,
				"height": -0.04810622523057112,
				"terrain": "text3"
			},
			{
				"q": -9,
				"r": -1,
				"height": -0.21572660748204814,
				"terrain": "text5"
			},
			{
				"q": -10,
				"r": 0,
				"height": -0.0831358790705336,
				"terrain": "text2"
			},
			{
				"q": -10,
				"r": 1,
				"height": 0.2445353520585972,
				"terrain": "text5"
			},
			{
				"q": -10,
				"r": 2,
				"height": 0.7657316251619097,
				"terrain": "mountain"
			},
			{
				"q": -10,
				"r": 3,
				"height": 1.096738604664119,
				"terrain": "mountain"
			},
			{
				"q": -10,
				"r": 4,
				"height": 1.0792440815987314,
				"terrain": "mountain"
			},
			{
				"q": -10,
				"r": 5,
				"height": 0.8606720009282496,
				"terrain": "mountain"
			},
			{
				"q": -10,
				"r": 6,
				"height": 0.4973641953713776,
				"terrain": "text7"
			},
			{
				"q": -10,
				"r": 7,
				"height": 0.13389937761874937,
				"terrain": "text3"
			},
			{
				"q": -10,
				"r": 8,
				"height": 0.09542102220078802,
				"terrain": "text7"
			},
			{
				"q": -10,
				"r": 9,
				"height": 0.349762485596708,
				"terrain": "text2"
			},
			{
				"q": -10,
				"r": -1,
				"height": -0.12333236620559082,
				"terrain": "text7"
			},
			{
				"q": -11,
				"r": 1,
				"height": 0.22358512927936008,
				"terrain": "text3"
			},
			{
				"q": -11,
				"r": 2,
				"height": 0.6917873044292304,
				"terrain": "text2"
			},
			{
				"q": -11,
				"r": 3,
				"height": 1.0382669419096353,
				"terrain": "mountain"
			},
			{
				"q": -11,
				"r": 4,
				"height": 1.0695671702248783,
				"terrain": "mountain"
			},
			{
				"q": -11,
				"r": 5,
				"height": 0.8787746594930134,
				"terrain": "mountain"
			},
			{
				"q": -11,
				"r": 6,
				"height": 0.4985284822283399,
				"terrain": "text5"
			},
			{
				"q": -11,
				"r": 7,
				"height": 0.042348435018169095,
				"terrain": "text3"
			},
			{
				"q": -11,
				"r": 8,
				"height": -0.15409659691121336,
				"terrain": "text6"
			},
			{
				"q": -11,
				"r": 9,
				"height": -0.04179067543948123,
				"terrain": "text3"
			},
			{
				"q": -12,
				"r": 3,
				"height": 1.0232567665572585,
				"terrain": "mountain"
			},
			{
				"q": -12,
				"r": 4,
				"height": 1.194966362889292,
				"terrain": "mountain"
			},
			{
				"q": -12,
				"r": 5,
				"height": 1.1766278388001556,
				"terrain": "mountain"
			},
			{
				"q": -12,
				"r": 6,
				"height": 0.9106483757542554,
				"terrain": "mountain"
			},
			{
				"q": -12,
				"r": 7,
				"height": 0.3887175871482833,
				"terrain": "text3"
			},
			{
				"q": -12,
				"r": 8,
				"height": -0.08961399833959005,
				"terrain": "text4"
			},
			{
				"q": -12,
				"r": 9,
				"height": -0.28228115290683675,
				"terrain": "text5"
			},
			{
				"q": -13,
				"r": 5,
				"height": 1.4698005484562542,
				"terrain": "mountain"
			},
			{
				"q": -13,
				"r": 6,
				"height": 1.4479391534194153,
				"terrain": "mountain"
			},
			{
				"q": -13,
				"r": 7,
				"height": 0.9960137570633198,
				"terrain": "mountain"
			},
			{
				"q": -13,
				"r": 8,
				"height": 0.32928702900726103,
				"terrain": "text1"
			},
			{
				"q": -13,
				"r": 9,
				"height": -0.14612124621610034,
				"terrain": "text3"
			},
			{
				"q": -14,
				"r": 7,
				"height": 1.4509516521954353,
				"terrain": "mountain"
			},
			{
				"q": -14,
				"r": 8,
				"height": 0.8697359892574901,
				"terrain": "mountain"
			},
			{
				"q": -14,
				"r": 9,
				"height": 0.3460487919973135,
				"terrain": "text4"
			},
			{
				"q": -15,
				"r": 9,
				"height": 0.9109937449052421,
				"terrain": "mountain"
			},
			{
				"q": -4,
				"r": 0,
				"height": 0.442144008197309,
				"terrain": "text4"
			},
			{
				"q": -4,
				"r": 1,
				"height": 0.7251638220209632,
				"terrain": "text5"
			},
			{
				"q": -4,
				"r": 2,
				"height": 0.9113142184906717,
				"terrain": "mountain"
			},
			{
				"q": -4,
				"r": 3,
				"height": 0.9500953171566642,
				"terrain": "mountain"
			},
			{
				"q": -4,
				"r": 4,
				"height": 0.9614561529399592,
				"terrain": "mountain"
			},
			{
				"q": -4,
				"r": 5,
				"height": 1.0356944916979804,
				"terrain": "mountain"
			},
			{
				"q": -4,
				"r": 6,
				"height": 1.0402103169662997,
				"terrain": "mountain"
			},
			{
				"q": -4,
				"r": 7,
				"height": 0.880805264704406,
				"terrain": "mountain"
			},
			{
				"q": -4,
				"r": 8,
				"height": 0.5359968334810614,
				"terrain": "text4"
			},
			{
				"q": -4,
				"r": 9,
				"height": 0.11543907292752825,
				"terrain": "text6"
			},
			{
				"q": -4,
				"r": -10,
				"height": 0.059366431054284796,
				"terrain": "text3"
			},
			{
				"q": -4,
				"r": -9,
				"height": -0.061581556149444355,
				"terrain": "text5"
			},
			{
				"q": -4,
				"r": -8,
				"height": -0.1217971202470477,
				"terrain": "text6"
			},
			{
				"q": -4,
				"r": -7,
				"height": 0.03498643918056468,
				"terrain": "text1"
			},
			{
				"q": -4,
				"r": -6,
				"height": 0.4130615301965792,
				"terrain": "text1"
			},
			{
				"q": -4,
				"r": -5,
				"height": 0.8905268121224598,
				"terrain": "mountain"
			},
			{
				"q": -4,
				"r": -4,
				"height": 1.1423405114496683,
				"terrain": "mountain"
			},
			{
				"q": -4,
				"r": -3,
				"height": 0.9586761787511155,
				"terrain": "mountain"
			},
			{
				"q": -4,
				"r": -2,
				"height": 0.5560650553900172,
				"terrain": "text3"
			},
			{
				"q": -4,
				"r": -1,
				"height": 0.3164063243021313,
				"terrain": "text3"
			},
			{
				"q": -3,
				"r": 0,
				"height": 0.8543757949412372,
				"terrain": "mountain"
			},
			{
				"q": -3,
				"r": 1,
				"height": 1.2180847750003927,
				"terrain": "mountain"
			},
			{
				"q": -3,
				"r": 2,
				"height": 1.3888114495042707,
				"terrain": "mountain"
			},
			{
				"q": -3,
				"r": 3,
				"height": 1.3359529408292121,
				"terrain": "mountain"
			},
			{
				"q": -3,
				"r": 4,
				"height": 1.2128464657197862,
				"terrain": "mountain"
			},
			{
				"q": -3,
				"r": 5,
				"height": 1.180293830049714,
				"terrain": "mountain"
			},
			{
				"q": -3,
				"r": 6,
				"height": 1.0938206770592993,
				"terrain": "mountain"
			},
			{
				"q": -3,
				"r": 7,
				"height": 0.7337378413173934,
				"terrain": "text2"
			},
			{
				"q": -3,
				"r": 8,
				"height": 0.17385620449442118,
				"terrain": "text6"
			},
			{
				"q": -3,
				"r": 9,
				"height": -0.3310626090903279,
				"terrain": "text4"
			},
			{
				"q": -3,
				"r": -10,
				"height": 0.22108940435076696,
				"terrain": "text4"
			},
			{
				"q": -3,
				"r": -9,
				"height": 0.09075695653713739,
				"terrain": "text6"
			},
			{
				"q": -3,
				"r": -8,
				"height": 0.025740200578506733,
				"terrain": "text4"
			},
			{
				"q": -3,
				"r": -7,
				"height": 0.13287818368526738,
				"terrain": "text5"
			},
			{
				"q": -3,
				"r": -6,
				"height": 0.390987594620919,
				"terrain": "text2"
			},
			{
				"q": -3,
				"r": -5,
				"height": 0.6948804625043382,
				"terrain": "text5"
			},
			{
				"q": -3,
				"r": -4,
				"height": 0.7772626389085441,
				"terrain": "mountain"
			},
			{
				"q": -3,
				"r": -3,
				"height": 0.574315950812776,
				"terrain": "text3"
			},
			{
				"q": -3,
				"r": -2,
				"height": 0.39600131328505084,
				"terrain": "text2"
			},
			{
				"q": -3,
				"r": -1,
				"height": 0.4973877002545925,
				"terrain": "text5"
			},
			{
				"q": -2,
				"r": 0,
				"height": 0.9643063115779629,
				"terrain": "mountain"
			},
			{
				"q": -2,
				"r": 1,
				"height": 1.4464779627272326,
				"terrain": "mountain"
			},
			{
				"q": -2,
				"r": 2,
				"height": 1.6787533298356212,
				"terrain": "mountain"
			},
			{
				"q": -2,
				"r": 3,
				"height": 1.5839090878824986,
				"terrain": "mountain"
			},
			{
				"q": -2,
				"r": 4,
				"height": 1.3282989865447385,
				"terrain": "mountain"
			},
			{
				"q": -2,
				"r": 5,
				"height": 1.1490293575217025,
				"terrain": "mountain"
			},
			{
				"q": -2,
				"r": 6,
				"height": 0.9237057864316305,
				"terrain": "mountain"
			},
			{
				"q": -2,
				"r": 7,
				"height": 0.4310622766781109,
				"terrain": "text2"
			},
			{
				"q": -2,
				"r": 8,
				"height": -0.15304239665789487,
				"terrain": "text1"
			},
			{
				"q": -2,
				"r": 9,
				"height": -0.5451137074096883,
				"terrain": "text2"
			},
			{
				"q": -2,
				"r": -10,
				"height": 0.14869623571950374,
				"terrain": "text1"
			},
			{
				"q": -2,
				"r": -9,
				"height": -0.05183352640962552,
				"terrain": "text6"
			},
			{
				"q": -2,
				"r": -8,
				"height": -0.17225978288310267,
				"terrain": "text4"
			},
			{
				"q": -2,
				"r": -7,
				"height": -0.1687539998200608,
				"terrain": "text1"
			},
			{
				"q": -2,
				"r": -6,
				"height": -0.07210911101028257,
				"terrain": "text7"
			},
			{
				"q": -2,
				"r": -5,
				"height": 0.05104451570485152,
				"terrain": "text4"
			},
			{
				"q": -2,
				"r": -4,
				"height": 0.007083438157038616,
				"terrain": "text5"
			},
			{
				"q": -2,
				"r": -3,
				"height": -0.15252354242490604,
				"terrain": "text4"
			},
			{
				"q": -2,
				"r": -2,
				"height": -0.07191906014208739,
				"terrain": "text6"
			},
			{
				"q": -2,
				"r": -1,
				"height": 0.3836510291232027,
				"terrain": "text1"
			},
			{
				"q": -1,
				"r": 0,
				"height": 0.6252736667078188,
				"terrain": "text3"
			},
			{
				"q": -1,
				"r": 1,
				"height": 1.2224062856408655,
				"terrain": "mountain"
			},
			{
				"q": -1,
				"r": 2,
				"height": 1.5754374420043156,
				"terrain": "mountain"
			},
			{
				"q": -1,
				"r": 3,
				"height": 1.526879635452818,
				"terrain": "mountain"
			},
			{
				"q": -1,
				"r": 4,
				"height": 1.2225823513675314,
				"terrain": "mountain"
			},
			{
				"q": -1,
				"r": 5,
				"height": 0.9480023201752494,
				"terrain": "mountain"
			},
			{
				"q": -1,
				"r": 6,
				"height": 0.6431654127880181,
				"terrain": "text6"
			},
			{
				"q": -1,
				"r": 7,
				"height": 0.17034190351533657,
				"terrain": "text5"
			},
			{
				"q": -1,
				"r": 8,
				"height": -0.258309688071972,
				"terrain": "text5"
			},
			{
				"q": -1,
				"r": 9,
				"height": -0.43238916820462187,
				"terrain": "text5"
			},
			{
				"q": -1,
				"r": -10,
				"height": -0.11588276166727945,
				"terrain": "text2"
			},
			{
				"q": -1,
				"r": -9,
				"height": -0.37305478011988064,
				"terrain": "text3"
			},
			{
				"q": -1,
				"r": -8,
				"height": -0.5348364059960335,
				"terrain": "text5"
			},
			{
				"q": -1,
				"r": -7,
				"height": -0.611334050023556,
				"terrain": "text6"
			},
			{
				"q": -1,
				"r": -6,
				"height": -0.6338974582853384,
				"terrain": "text2"
			},
			{
				"q": -1,
				"r": -5,
				"height": -0.638465260708473,
				"terrain": "text4"
			},
			{
				"q": -1,
				"r": -4,
				"height": -0.7441148129673317,
				"terrain": "text4"
			},
			{
				"q": -1,
				"r": -3,
				"height": -0.8655770454930612,
				"terrain": "text1"
			},
			{
				"q": -1,
				"r": -2,
				"height": -0.6644940941573222,
				"terrain": "text5"
			},
			{
				"q": -1,
				"r": -1,
				"height": -0.06021746720884082,
				"terrain": "text2"
			}
		],
		"halfWidth": 10,
		"halfHeight": 10
	}
	},
  "seed_7":{
	"map_id":"seed_7",
	"data": {
		"_width": 20,
		"_height": 20,
		"data": [
			{
				"q": 0,
				"r": 0,
				"height": 0,
				"terrain": "text5"
			},
			{
				"q": 0,
				"r": 1,
				"height": -0.625273666707819,
				"terrain": "text2"
			},
			{
				"q": 0,
				"r": 2,
				"height": -0.9684152626755647,
				"terrain": "text4"
			},
			{
				"q": 0,
				"r": 3,
				"height": -0.9129191521439358,
				"terrain": "text5"
			},
			{
				"q": 0,
				"r": 4,
				"height": -0.664568247484886,
				"terrain": "text5"
			},
			{
				"q": 0,
				"r": 5,
				"height": -0.5538368834330867,
				"terrain": "text2"
			},
			{
				"q": 0,
				"r": 6,
				"height": -0.5865945185894419,
				"terrain": "text4"
			},
			{
				"q": 0,
				"r": 7,
				"height": -0.5943869749307631,
				"terrain": "text7"
			},
			{
				"q": 0,
				"r": 8,
				"height": -0.5889171045360647,
				"terrain": "text2"
			},
			{
				"q": 0,
				"r": 9,
				"height": -0.6475113151147336,
				"terrain": "text6"
			},
			{
				"q": 0,
				"r": -10,
				"height": 0.4775841049475315,
				"terrain": "text4"
			},
			{
				"q": 0,
				"r": -9,
				"height": 0.789704921609369,
				"terrain": "mountain"
			},
			{
				"q": 0,
				"r": -8,
				"height": 1.010297964430288,
				"terrain": "mountain"
			},
			{
				"q": 0,
				"r": -7,
				"height": 1.0435564795104113,
				"terrain": "mountain"
			},
			{
				"q": 0,
				"r": -6,
				"height": 0.9791634783473869,
				"terrain": "mountain"
			},
			{
				"q": 0,
				"r": -5,
				"height": 0.9937541076204914,
				"terrain": "mountain"
			},
			{
				"q": 0,
				"r": -4,
				"height": 1.112203823508334,
				"terrain": "mountain"
			},
			{
				"q": 0,
				"r": -3,
				"height": 1.270216291179394,
				"terrain": "mountain"
			},
			{
				"q": 0,
				"r": -2,
				"height": 1.1671552719624487,
				"terrain": "mountain"
			},
			{
				"q": 0,
				"r": -1,
				"height": 0.6719500288477358,
				"terrain": "text7"
			},
			{
				"q": 1,
				"r": 0,
				"height": 0.04667636213991771,
				"terrain": "text4"
			},
			{
				"q": 1,
				"r": 1,
				"height": -0.546521971330934,
				"terrain": "text7"
			},
			{
				"q": 1,
				"r": 2,
				"height": -0.901740696543941,
				"terrain": "text3"
			},
			{
				"q": 1,
				"r": 3,
				"height": -0.8656996102013327,
				"terrain": "text5"
			},
			{
				"q": 1,
				"r": 4,
				"height": -0.6136689819185119,
				"terrain": "text3"
			},
			{
				"q": 1,
				"r": 5,
				"height": -0.4798463151030574,
				"terrain": "text6"
			},
			{
				"q": 1,
				"r": 6,
				"height": -0.5212522870585052,
				"terrain": "text6"
			},
			{
				"q": 1,
				"r": 7,
				"height": -0.5896440020538177,
				"terrain": "text1"
			},
			{
				"q": 1,
				"r": 8,
				"height": -0.668216224760519,
				"terrain": "text1"
			},
			{
				"q": 1,
				"r": 9,
				"height": -0.8222486825202366,
				"terrain": "text7"
			},
			{
				"q": 1,
				"r": -10,
				"height": 0.3316344291403249,
				"terrain": "text6"
			},
			{
				"q": 1,
				"r": -9,
				"height": 0.6447044784241742,
				"terrain": "text6"
			},
			{
				"q": 1,
				"r": -8,
				"height": 0.8199650257686867,
				"terrain": "mountain"
			},
			{
				"q": 1,
				"r": -7,
				"height": 0.8134526766808027,
				"terrain": "mountain"
			},
			{
				"q": 1,
				"r": -6,
				"height": 0.763975198897398,
				"terrain": "mountain"
			},
			{
				"q": 1,
				"r": -5,
				"height": 0.8186938036039949,
				"terrain": "mountain"
			},
			{
				"q": 1,
				"r": -4,
				"height": 0.9416793971443986,
				"terrain": "mountain"
			},
			{
				"q": 1,
				"r": -3,
				"height": 1.1123440738205652,
				"terrain": "mountain"
			},
			{
				"q": 1,
				"r": -2,
				"height": 1.0675057507253325,
				"terrain": "mountain"
			},
			{
				"q": 1,
				"r": -1,
				"height": 0.6594653581033505,
				"terrain": "text3"
			},
			{
				"q": 2,
				"r": 0,
				"height": 0.19874431906863216,
				"terrain": "text4"
			},
			{
				"q": 2,
				"r": 1,
				"height": -0.2638521998866202,
				"terrain": "text6"
			},
			{
				"q": 2,
				"r": 2,
				"height": -0.5255237238288892,
				"terrain": "text5"
			},
			{
				"q": 2,
				"r": 3,
				"height": -0.4545335473396964,
				"terrain": "text6"
			},
			{
				"q": 2,
				"r": 4,
				"height": -0.18552594175196613,
				"terrain": "text4"
			},
			{
				"q": 2,
				"r": 5,
				"height": -0.015025644796993198,
				"terrain": "text3"
			},
			{
				"q": 2,
				"r": 6,
				"height": -0.05932138785901561,
				"terrain": "text4"
			},
			{
				"q": 2,
				"r": 7,
				"height": -0.23875009238752903,
				"terrain": "text2"
			},
			{
				"q": 2,
				"r": 8,
				"height": -0.47968719216615874,
				"terrain": "text4"
			},
			{
				"q": 2,
				"r": 9,
				"height": -0.7773373225330047,
				"terrain": "text2"
			},
			{
				"q": 2,
				"r": -10,
				"height": 0.0667872389662274,
				"terrain": "text5"
			},
			{
				"q": 2,
				"r": -9,
				"height": 0.21292953388983699,
				"terrain": "text3"
			},
			{
				"q": 2,
				"r": -8,
				"height": 0.2651455385220221,
				"terrain": "text3"
			},
			{
				"q": 2,
				"r": -7,
				"height": 0.2523350050420703,
				"terrain": "text2"
			},
			{
				"q": 2,
				"r": -6,
				"height": 0.2949413326877489,
				"terrain": "text4"
			},
			{
				"q": 2,
				"r": -5,
				"height": 0.4276136419460873,
				"terrain": "text4"
			},
			{
				"q": 2,
				"r": -4,
				"height": 0.5918403417951512,
				"terrain": "text5"
			},
			{
				"q": 2,
				"r": -3,
				"height": 0.830275568821085,
				"terrain": "mountain"
			},
			{
				"q": 2,
				"r": -2,
				"height": 0.9124367312867501,
				"terrain": "mountain"
			},
			{
				"q": 2,
				"r": -1,
				"height": 0.666955997641807,
				"terrain": "text1"
			},
			{
				"q": 3,
				"r": 0,
				"height": 0.3571942964474025,
				"terrain": "text5"
			},
			{
				"q": 3,
				"r": 1,
				"height": 0.05071971284357723,
				"terrain": "text3"
			},
			{
				"q": 3,
				"r": 2,
				"height": -0.07201492238529614,
				"terrain": "text4"
			},
			{
				"q": 3,
				"r": 3,
				"height": 0.049660984366388064,
				"terrain": "text3"
			},
			{
				"q": 3,
				"r": 4,
				"height": 0.30022883600921424,
				"terrain": "text5"
			},
			{
				"q": 3,
				"r": 5,
				"height": 0.4712311609468276,
				"terrain": "text4"
			},
			{
				"q": 3,
				"r": 6,
				"height": 0.4230105917317113,
				"terrain": "text7"
			},
			{
				"q": 3,
				"r": 7,
				"height": 0.15064025351742594,
				"terrain": "text4"
			},
			{
				"q": 3,
				"r": 8,
				"height": -0.21521614885423984,
				"terrain": "text5"
			},
			{
				"q": 3,
				"r": 9,
				"height": -0.5896267306807597,
				"terrain": "text3"
			},
			{
				"q": 3,
				"r": -10,
				"height": -0.25000622648997395,
				"terrain": "text3"
			},
			{
				"q": 3,
				"r": -9,
				"height": -0.3520104708656638,
				"terrain": "text7"
			},
			{
				"q": 3,
				"r": -8,
				"height": -0.40219222320499276,
				"terrain": "text4"
			},
			{
				"q": 3,
				"r": -7,
				"height": -0.32292350277899873,
				"terrain": "text4"
			},
			{
				"q": 3,
				"r": -6,
				"height": -0.08734916587183178,
				"terrain": "text7"
			},
			{
				"q": 3,
				"r": -5,
				"height": 0.17728366029234702,
				"terrain": "text7"
			},
			{
				"q": 3,
				"r": -4,
				"height": 0.41625912809923493,
				"terrain": "text3"
			},
			{
				"q": 3,
				"r": -3,
				"height": 0.6929374450753473,
				"terrain": "text7"
			},
			{
				"q": 3,
				"r": -2,
				"height": 0.8291868884270327,
				"terrain": "mountain"
			},
			{
				"q": 3,
				"r": -1,
				"height": 0.6878387824387969,
				"terrain": "text5"
			},
			{
				"q": 4,
				"r": 0,
				"height": 0.44242601585330615,
				"terrain": "text5"
			},
			{
				"q": 4,
				"r": 1,
				"height": 0.22712576936955856,
				"terrain": "text5"
			},
			{
				"q": 4,
				"r": 2,
				"height": 0.16446681610743002,
				"terrain": "text7"
			},
			{
				"q": 4,
				"r": 3,
				"height": 0.27563010599780674,
				"terrain": "text5"
			},
			{
				"q": 4,
				"r": 4,
				"height": 0.45170494642731684,
				"terrain": "text6"
			},
			{
				"q": 4,
				"r": 5,
				"height": 0.5623389720705019,
				"terrain": "text6"
			},
			{
				"q": 4,
				"r": 6,
				"height": 0.5073042636596222,
				"terrain": "text6"
			},
			{
				"q": 4,
				"r": 7,
				"height": 0.22644343598762126,
				"terrain": "text4"
			},
			{
				"q": 4,
				"r": 8,
				"height": -0.12536035750349156,
				"terrain": "text4"
			},
			{
				"q": 4,
				"r": 9,
				"height": -0.4464582065757924,
				"terrain": "text6"
			},
			{
				"q": 4,
				"r": -10,
				"height": -0.42890494115195815,
				"terrain": "text4"
			},
			{
				"q": 4,
				"r": -9,
				"height": -0.7190464797238825,
				"terrain": "text5"
			},
			{
				"q": 4,
				"r": -8,
				"height": -0.8123210469343317,
				"terrain": "text4"
			},
			{
				"q": 4,
				"r": -7,
				"height": -0.6092555325726641,
				"terrain": "text6"
			},
			{
				"q": 4,
				"r": -6,
				"height": -0.16787320603503914,
				"terrain": "text6"
			},
			{
				"q": 4,
				"r": -5,
				"height": 0.2486122442397338,
				"terrain": "text3"
			},
			{
				"q": 4,
				"r": -4,
				"height": 0.5658554585107827,
				"terrain": "text3"
			},
			{
				"q": 4,
				"r": -3,
				"height": 0.8084246918028593,
				"terrain": "mountain"
			},
			{
				"q": 4,
				"r": -2,
				"height": 0.8658124727036057,
				"terrain": "mountain"
			},
			{
				"q": 4,
				"r": -1,
				"height": 0.7027856766484966,
				"terrain": "text2"
			},
			{
				"q": 5,
				"r": 0,
				"height": 0.42019459193805064,
				"terrain": "text1"
			},
			{
				"q": 5,
				"r": 1,
				"height": 0.21253828990431295,
				"terrain": "text3"
			},
			{
				"q": 5,
				"r": 2,
				"height": 0.09636033482665414,
				"terrain": "text2"
			},
			{
				"q": 5,
				"r": 3,
				"height": 0.09441084369111669,
				"terrain": "text4"
			},
			{
				"q": 5,
				"r": 4,
				"height": 0.14647411281385841,
				"terrain": "text2"
			},
			{
				"q": 5,
				"r": 5,
				"height": 0.1759836741210434,
				"terrain": "text4"
			},
			{
				"q": 5,
				"r": 6,
				"height": 0.11336373548510303,
				"terrain": "text2"
			},
			{
				"q": 5,
				"r": 7,
				"height": -0.09548736334397384,
				"terrain": "text7"
			},
			{
				"q": 5,
				"r": 8,
				"height": -0.3046929190329077,
				"terrain": "text7"
			},
			{
				"q": 5,
				"r": -10,
				"height": -0.3991144774241755,
				"terrain": "text1"
			},
			{
				"q": 5,
				"r": -9,
				"height": -0.7254584310878542,
				"terrain": "text4"
			},
			{
				"q": 5,
				"r": -8,
				"height": -0.8180129509185229,
				"terrain": "text4"
			},
			{
				"q": 5,
				"r": -7,
				"height": -0.5609186118579117,
				"terrain": "text3"
			},
			{
				"q": 5,
				"r": -6,
				"height": -0.037357477108523385,
				"terrain": "text3"
			},
			{
				"q": 5,
				"r": -5,
				"height": 0.4558687212039714,
				"terrain": "text3"
			},
			{
				"q": 5,
				"r": -4,
				"height": 0.81932990066265,
				"terrain": "mountain"
			},
			{
				"q": 5,
				"r": -3,
				"height": 0.9961943436996761,
				"terrain": "mountain"
			},
			{
				"q": 5,
				"r": -2,
				"height": 0.9221277653091866,
				"terrain": "mountain"
			},
			{
				"q": 5,
				"r": -1,
				"height": 0.6713180542109553,
				"terrain": "text5"
			},
			{
				"q": 6,
				"r": 0,
				"height": 0.26667834976833815,
				"terrain": "text4"
			},
			{
				"q": 6,
				"r": 1,
				"height": 0.048449705720856454,
				"terrain": "text4"
			},
			{
				"q": 6,
				"r": 2,
				"height": -0.13687044658066166,
				"terrain": "text2"
			},
			{
				"q": 6,
				"r": 3,
				"height": -0.26058925272407923,
				"terrain": "text5"
			},
			{
				"q": 6,
				"r": 4,
				"height": -0.33585504157437096,
				"terrain": "text5"
			},
			{
				"q": 6,
				"r": 5,
				"height": -0.3942502967493885,
				"terrain": "text7"
			},
			{
				"q": 6,
				"r": 6,
				"height": -0.47511370429666067,
				"terrain": "text5"
			},
			{
				"q": 6,
				"r": -10,
				"height": -0.34113830242647636,
				"terrain": "text6"
			},
			{
				"q": 6,
				"r": -9,
				"height": -0.5706549045278276,
				"terrain": "text3"
			},
			{
				"q": 6,
				"r": -8,
				"height": -0.6069308885868646,
				"terrain": "text2"
			},
			{
				"q": 6,
				"r": -7,
				"height": -0.3229883167252069,
				"terrain": "text5"
			},
			{
				"q": 6,
				"r": -6,
				"height": 0.18900414542584226,
				"terrain": "text2"
			},
			{
				"q": 6,
				"r": -5,
				"height": 0.6499186346842796,
				"terrain": "text4"
			},
			{
				"q": 6,
				"r": -4,
				"height": 0.9849997440936848,
				"terrain": "mountain"
			},
			{
				"q": 6,
				"r": -3,
				"height": 1.0727955919630265,
				"terrain": "mountain"
			},
			{
				"q": 6,
				"r": -2,
				"height": 0.863233030914256,
				"terrain": "mountain"
			},
			{
				"q": 6,
				"r": -1,
				"height": 0.5219370554630615,
				"terrain": "text3"
			},
			{
				"q": 7,
				"r": 0,
				"height": 0.03780593189059524,
				"terrain": "text5"
			},
			{
				"q": 7,
				"r": 1,
				"height": -0.16821763156644043,
				"terrain": "text5"
			},
			{
				"q": 7,
				"r": 2,
				"height": -0.34473825469380837,
				"terrain": "text6"
			},
			{
				"q": 7,
				"r": 3,
				"height": -0.4930708876477776,
				"terrain": "text3"
			},
			{
				"q": 7,
				"r": 4,
				"height": -0.6469127231306563,
				"terrain": "text2"
			},
			{
				"q": 7,
				"r": -10,
				"height": -0.32295204036927244,
				"terrain": "text4"
			},
			{
				"q": 7,
				"r": -9,
				"height": -0.3847734543849064,
				"terrain": "text3"
			},
			{
				"q": 7,
				"r": -8,
				"height": -0.34026430594339097,
				"terrain": "text3"
			},
			{
				"q": 7,
				"r": -7,
				"height": -0.0693115529831117,
				"terrain": "text5"
			},
			{
				"q": 7,
				"r": -6,
				"height": 0.3442596498977534,
				"terrain": "text7"
			},
			{
				"q": 7,
				"r": -5,
				"height": 0.6721445854887091,
				"terrain": "text4"
			},
			{
				"q": 7,
				"r": -4,
				"height": 0.9092010279881734,
				"terrain": "mountain"
			},
			{
				"q": 7,
				"r": -3,
				"height": 0.9363464235577916,
				"terrain": "mountain"
			},
			{
				"q": 7,
				"r": -2,
				"height": 0.6699667530276103,
				"terrain": "text2"
			},
			{
				"q": 7,
				"r": -1,
				"height": 0.29068792734834414,
				"terrain": "text7"
			},
			{
				"q": 8,
				"r": 0,
				"height": -0.13795257879062084,
				"terrain": "text4"
			},
			{
				"q": 8,
				"r": 1,
				"height": -0.2839422195428979,
				"terrain": "text6"
			},
			{
				"q": 8,
				"r": 2,
				"height": -0.36004334144953154,
				"terrain": "text1"
			},
			{
				"q": 8,
				"r": -10,
				"height": -0.26076311000795904,
				"terrain": "text6"
			},
			{
				"q": 8,
				"r": -9,
				"height": -0.17350261544911533,
				"terrain": "text5"
			},
			{
				"q": 8,
				"r": -8,
				"height": -0.09263115828110835,
				"terrain": "text2"
			},
			{
				"q": 8,
				"r": -7,
				"height": 0.0854725232170529,
				"terrain": "text4"
			},
			{
				"q": 8,
				"r": -6,
				"height": 0.31818729672434715,
				"terrain": "text1"
			},
			{
				"q": 8,
				"r": -5,
				"height": 0.45238597430700755,
				"terrain": "text4"
			},
			{
				"q": 8,
				"r": -4,
				"height": 0.5673356215297345,
				"terrain": "text1"
			},
			{
				"q": 8,
				"r": -3,
				"height": 0.6067167985882487,
				"terrain": "text4"
			},
			{
				"q": 8,
				"r": -2,
				"height": 0.40698011572848536,
				"terrain": "text4"
			},
			{
				"q": 8,
				"r": -1,
				"height": 0.08060013983956149,
				"terrain": "text2"
			},
			{
				"q": 9,
				"r": 0,
				"height": -0.21993738857098918,
				"terrain": "text5"
			},
			{
				"q": 9,
				"r": -10,
				"height": -0.029651296337448396,
				"terrain": "text3"
			},
			{
				"q": 9,
				"r": -9,
				"height": 0.12819369583437187,
				"terrain": "text2"
			},
			{
				"q": 9,
				"r": -8,
				"height": 0.17624167787858736,
				"terrain": "text6"
			},
			{
				"q": 9,
				"r": -7,
				"height": 0.21408877105974217,
				"terrain": "text6"
			},
			{
				"q": 9,
				"r": -6,
				"height": 0.2483981203922661,
				"terrain": "text2"
			},
			{
				"q": 9,
				"r": -5,
				"height": 0.1923392103143163,
				"terrain": "text1"
			},
			{
				"q": 9,
				"r": -4,
				"height": 0.1887772513985542,
				"terrain": "text6"
			},
			{
				"q": 9,
				"r": -3,
				"height": 0.25731498718757256,
				"terrain": "text3"
			},
			{
				"q": 9,
				"r": -2,
				"height": 0.1617115273899825,
				"terrain": "text3"
			},
			{
				"q": 9,
				"r": -1,
				"height": -0.07172491005877862,
				"terrain": "text2"
			},
			{
				"q": 10,
				"r": -10,
				"height": 0.3739267388101407,
				"terrain": "text3"
			},
			{
				"q": 10,
				"r": -9,
				"height": 0.5326521358436214,
				"terrain": "text6"
			},
			{
				"q": 10,
				"r": -8,
				"height": 0.5094016179971964,
				"terrain": "text4"
			},
			{
				"q": 10,
				"r": -7,
				"height": 0.4263285760876266,
				"terrain": "text3"
			},
			{
				"q": 10,
				"r": -6,
				"height": 0.32043881633355875,
				"terrain": "text3"
			},
			{
				"q": 10,
				"r": -5,
				"height": 0.13424796677475448,
				"terrain": "text6"
			},
			{
				"q": 10,
				"r": -4,
				"height": 0.0399552742012132,
				"terrain": "text4"
			},
			{
				"q": 10,
				"r": -3,
				"height": 0.08714566834617893,
				"terrain": "text4"
			},
			{
				"q": 10,
				"r": -2,
				"height": 0.019026783172389095,
				"terrain": "text4"
			},
			{
				"q": 11,
				"r": -10,
				"height": 0.8235772409597117,
				"terrain": "mountain"
			},
			{
				"q": 11,
				"r": -9,
				"height": 0.9301586274588606,
				"terrain": "mountain"
			},
			{
				"q": 11,
				"r": -8,
				"height": 0.806928149942379,
				"terrain": "mountain"
			},
			{
				"q": 11,
				"r": -7,
				"height": 0.6286793800240776,
				"terrain": "text3"
			},
			{
				"q": 11,
				"r": -6,
				"height": 0.45571889563988877,
				"terrain": "text6"
			},
			{
				"q": 11,
				"r": -5,
				"height": 0.23131952047653945,
				"terrain": "text7"
			},
			{
				"q": 11,
				"r": -4,
				"height": 0.1100303754174966,
				"terrain": "text4"
			},
			{
				"q": 12,
				"r": -10,
				"height": 1.1922963600438745,
				"terrain": "mountain"
			},
			{
				"q": 12,
				"r": -9,
				"height": 1.2446613966350595,
				"terrain": "mountain"
			},
			{
				"q": 12,
				"r": -8,
				"height": 1.0410965938902876,
				"terrain": "mountain"
			},
			{
				"q": 12,
				"r": -7,
				"height": 0.7775198921557511,
				"terrain": "mountain"
			},
			{
				"q": 12,
				"r": -6,
				"height": 0.5691447763593581,
				"terrain": "text6"
			},
			{
				"q": 13,
				"r": -10,
				"height": 1.2727962363989396,
				"terrain": "mountain"
			},
			{
				"q": 13,
				"r": -9,
				"height": 1.3026587243097036,
				"terrain": "mountain"
			},
			{
				"q": 13,
				"r": -8,
				"height": 1.0949816719397034,
				"terrain": "mountain"
			},
			{
				"q": 14,
				"r": -10,
				"height": 1.0712855482473924,
				"terrain": "mountain"
			},
			{
				"q": -5,
				"r": 0,
				"height": 0.25636710462650236,
				"terrain": "text5"
			},
			{
				"q": -5,
				"r": 1,
				"height": -0.03683161428907047,
				"terrain": "text5"
			},
			{
				"q": -5,
				"r": 2,
				"height": -0.3420356853734636,
				"terrain": "text2"
			},
			{
				"q": -5,
				"r": 3,
				"height": -0.45538796241967483,
				"terrain": "text5"
			},
			{
				"q": -5,
				"r": 4,
				"height": -0.3543669743647949,
				"terrain": "text4"
			},
			{
				"q": -5,
				"r": 5,
				"height": -0.15609520271300106,
				"terrain": "text2"
			},
			{
				"q": -5,
				"r": 6,
				"height": 0.153938670352474,
				"terrain": "text3"
			},
			{
				"q": -5,
				"r": 7,
				"height": 0.49594189340718087,
				"terrain": "text6"
			},
			{
				"q": -5,
				"r": 8,
				"height": 0.5940902653306974,
				"terrain": "text3"
			},
			{
				"q": -5,
				"r": 9,
				"height": 0.3824606967103304,
				"terrain": "text3"
			},
			{
				"q": -5,
				"r": -10,
				"height": 0.5823219429222847,
				"terrain": "text3"
			},
			{
				"q": -5,
				"r": -9,
				"height": 0.9055619103507095,
				"terrain": "mountain"
			},
			{
				"q": -5,
				"r": -8,
				"height": 1.128961834474115,
				"terrain": "mountain"
			},
			{
				"q": -5,
				"r": -7,
				"height": 1.0136794622364904,
				"terrain": "mountain"
			},
			{
				"q": -5,
				"r": -6,
				"height": 0.5232317782308703,
				"terrain": "text7"
			},
			{
				"q": -5,
				"r": -5,
				"height": -0.11322131256538612,
				"terrain": "text4"
			},
			{
				"q": -5,
				"r": -4,
				"height": -0.5591165116432293,
				"terrain": "text5"
			},
			{
				"q": -5,
				"r": -3,
				"height": -0.5279190610291318,
				"terrain": "text4"
			},
			{
				"q": -5,
				"r": -2,
				"height": -0.1167627563527297,
				"terrain": "text2"
			},
			{
				"q": -5,
				"r": -1,
				"height": 0.259106655257505,
				"terrain": "text2"
			},
			{
				"q": -6,
				"r": 0,
				"height": 0.42837979858944175,
				"terrain": "text2"
			},
			{
				"q": -6,
				"r": 1,
				"height": 0.11507443822269287,
				"terrain": "text1"
			},
			{
				"q": -6,
				"r": 2,
				"height": -0.23285781130634245,
				"terrain": "text2"
			},
			{
				"q": -6,
				"r": 3,
				"height": -0.40975769367485826,
				"terrain": "text3"
			},
			{
				"q": -6,
				"r": 4,
				"height": -0.39078487919670746,
				"terrain": "text1"
			},
			{
				"q": -6,
				"r": 5,
				"height": -0.25984663533189756,
				"terrain": "text6"
			},
			{
				"q": -6,
				"r": 6,
				"height": -0.0020216780800000334,
				"terrain": "text5"
			},
			{
				"q": -6,
				"r": 7,
				"height": 0.2506074356053474,
				"terrain": "text4"
			},
			{
				"q": -6,
				"r": 8,
				"height": 0.24129458098396894,
				"terrain": "text4"
			},
			{
				"q": -6,
				"r": 9,
				"height": -0.036145420836725284,
				"terrain": "text5"
			},
			{
				"q": -6,
				"r": -9,
				"height": 0.79748523942696,
				"terrain": "mountain"
			},
			{
				"q": -6,
				"r": -8,
				"height": 1.0524033826559536,
				"terrain": "mountain"
			},
			{
				"q": -6,
				"r": -7,
				"height": 0.9937953588938664,
				"terrain": "mountain"
			},
			{
				"q": -6,
				"r": -6,
				"height": 0.5488213062166609,
				"terrain": "text2"
			},
			{
				"q": -6,
				"r": -5,
				"height": -0.0812341552381895,
				"terrain": "text4"
			},
			{
				"q": -6,
				"r": -4,
				"height": -0.5312201694927084,
				"terrain": "text4"
			},
			{
				"q": -6,
				"r": -3,
				"height": -0.48570611181171125,
				"terrain": "text7"
			},
			{
				"q": -6,
				"r": -2,
				"height": -0.03191893340518191,
				"terrain": "text4"
			},
			{
				"q": -6,
				"r": -1,
				"height": 0.39865774457652936,
				"terrain": "text7"
			},
			{
				"q": -7,
				"r": 0,
				"height": 0.5717527400747959,
				"terrain": "text7"
			},
			{
				"q": -7,
				"r": 1,
				"height": 0.22160184665857877,
				"terrain": "text2"
			},
			{
				"q": -7,
				"r": 2,
				"height": -0.14553679828761168,
				"terrain": "text6"
			},
			{
				"q": -7,
				"r": 3,
				"height": -0.3567196251654321,
				"terrain": "text1"
			},
			{
				"q": -7,
				"r": 4,
				"height": -0.42611744425753006,
				"terrain": "text1"
			},
			{
				"q": -7,
				"r": 5,
				"height": -0.42642327212383985,
				"terrain": "text7"
			},
			{
				"q": -7,
				"r": 6,
				"height": -0.32720387579069654,
				"terrain": "text1"
			},
			{
				"q": -7,
				"r": 7,
				"height": -0.2513554214292696,
				"terrain": "text2"
			},
			{
				"q": -7,
				"r": 8,
				"height": -0.3435947746623109,
				"terrain": "text6"
			},
			{
				"q": -7,
				"r": 9,
				"height": -0.5637906367802071,
				"terrain": "text3"
			},
			{
				"q": -7,
				"r": -7,
				"height": 0.9348620048960956,
				"terrain": "mountain"
			},
			{
				"q": -7,
				"r": -6,
				"height": 0.6149288985951966,
				"terrain": "text6"
			},
			{
				"q": -7,
				"r": -5,
				"height": 0.09835309580345669,
				"terrain": "text6"
			},
			{
				"q": -7,
				"r": -4,
				"height": -0.270470746238782,
				"terrain": "text5"
			},
			{
				"q": -7,
				"r": -3,
				"height": -0.19501127481256966,
				"terrain": "text3"
			},
			{
				"q": -7,
				"r": -2,
				"height": 0.2220771279588058,
				"terrain": "text4"
			},
			{
				"q": -7,
				"r": -1,
				"height": 0.5871821506050585,
				"terrain": "text3"
			},
			{
				"q": -8,
				"r": 0,
				"height": 0.6277727423961473,
				"terrain": "text1"
			},
			{
				"q": -8,
				"r": 1,
				"height": 0.26103243140751736,
				"terrain": "text2"
			},
			{
				"q": -8,
				"r": 2,
				"height": -0.0992163966541816,
				"terrain": "text3"
			},
			{
				"q": -8,
				"r": 3,
				"height": -0.33574944242336474,
				"terrain": "text4"
			},
			{
				"q": -8,
				"r": 4,
				"height": -0.48131936432322614,
				"terrain": "text1"
			},
			{
				"q": -8,
				"r": 5,
				"height": -0.599692054400961,
				"terrain": "text3"
			},
			{
				"q": -8,
				"r": 6,
				"height": -0.654292245041911,
				"terrain": "text6"
			},
			{
				"q": -8,
				"r": 7,
				"height": -0.7292031392183169,
				"terrain": "text2"
			},
			{
				"q": -8,
				"r": 8,
				"height": -0.8213882020700749,
				"terrain": "text6"
			},
			{
				"q": -8,
				"r": 9,
				"height": -0.8746414629811038,
				"terrain": "text3"
			},
			{
				"q": -8,
				"r": -5,
				"height": 0.28025520994384606,
				"terrain": "text7"
			},
			{
				"q": -8,
				"r": -4,
				"height": 0.06008759044474654,
				"terrain": "text4"
			},
			{
				"q": -8,
				"r": -3,
				"height": 0.1723171909586021,
				"terrain": "text7"
			},
			{
				"q": -8,
				"r": -2,
				"height": 0.4958962998687815,
				"terrain": "text7"
			},
			{
				"q": -8,
				"r": -1,
				"height": 0.721281717627907,
				"terrain": "text3"
			},
			{
				"q": -9,
				"r": 0,
				"height": 0.5848513151147335,
				"terrain": "text6"
			},
			{
				"q": -9,
				"r": 1,
				"height": 0.22266834784869016,
				"terrain": "text5"
			},
			{
				"q": -9,
				"r": 2,
				"height": -0.10023844666755347,
				"terrain": "text3"
			},
			{
				"q": -9,
				"r": 3,
				"height": -0.3283977787813983,
				"terrain": "text6"
			},
			{
				"q": -9,
				"r": 4,
				"height": -0.5066299245777943,
				"terrain": "text4"
			},
			{
				"q": -9,
				"r": 5,
				"height": -0.6725572601754937,
				"terrain": "text3"
			},
			{
				"q": -9,
				"r": 6,
				"height": -0.7873176890263827,
				"terrain": "text5"
			},
			{
				"q": -9,
				"r": 7,
				"height": -0.9054847064639078,
				"terrain": "text7"
			},
			{
				"q": -9,
				"r": 8,
				"height": -0.9269444331528879,
				"terrain": "text6"
			},
			{
				"q": -9,
				"r": 9,
				"height": -0.8078945347199998,
				"terrain": "text5"
			},
			{
				"q": -9,
				"r": -3,
				"height": 0.49853078668075934,
				"terrain": "text5"
			},
			{
				"q": -9,
				"r": -2,
				"height": 0.716033372642634,
				"terrain": "text5"
			},
			{
				"q": -9,
				"r": -1,
				"height": 0.7773096573804827,
				"terrain": "mountain"
			},
			{
				"q": -10,
				"r": 0,
				"height": 0.4950942124223869,
				"terrain": "text6"
			},
			{
				"q": -10,
				"r": 1,
				"height": 0.1375519688051639,
				"terrain": "text7"
			},
			{
				"q": -10,
				"r": 2,
				"height": -0.11163689758982887,
				"terrain": "text2"
			},
			{
				"q": -10,
				"r": 3,
				"height": -0.2598687796272205,
				"terrain": "text6"
			},
			{
				"q": -10,
				"r": 4,
				"height": -0.3950772548133007,
				"terrain": "text6"
			},
			{
				"q": -10,
				"r": 5,
				"height": -0.5469854774737921,
				"terrain": "text1"
			},
			{
				"q": -10,
				"r": 6,
				"height": -0.6533737030961044,
				"terrain": "text5"
			},
			{
				"q": -10,
				"r": 7,
				"height": -0.7423453807333344,
				"terrain": "text4"
			},
			{
				"q": -10,
				"r": 8,
				"height": -0.6883949064790877,
				"terrain": "text1"
			},
			{
				"q": -10,
				"r": 9,
				"height": -0.4656946666666665,
				"terrain": "text3"
			},
			{
				"q": -10,
				"r": -1,
				"height": 0.7738355785112965,
				"terrain": "mountain"
			},
			{
				"q": -11,
				"r": 1,
				"height": 0.12195130274192956,
				"terrain": "text6"
			},
			{
				"q": -11,
				"r": 2,
				"height": -0.04949895135535049,
				"terrain": "text4"
			},
			{
				"q": -11,
				"r": 3,
				"height": -0.14027975066597492,
				"terrain": "text6"
			},
			{
				"q": -11,
				"r": 4,
				"height": -0.26340312747446687,
				"terrain": "text5"
			},
			{
				"q": -11,
				"r": 5,
				"height": -0.41851336220020224,
				"terrain": "text3"
			},
			{
				"q": -11,
				"r": 6,
				"height": -0.5182018952329084,
				"terrain": "text2"
			},
			{
				"q": -11,
				"r": 7,
				"height": -0.5608700729147369,
				"terrain": "text7"
			},
			{
				"q": -11,
				"r": 8,
				"height": -0.4252048829162527,
				"terrain": "text6"
			},
			{
				"q": -11,
				"r": 9,
				"height": -0.1299719943303,
				"terrain": "text6"
			},
			{
				"q": -12,
				"r": 3,
				"height": -0.0004477662940083754,
				"terrain": "text6"
			},
			{
				"q": -12,
				"r": 4,
				"height": -0.2590311114953876,
				"terrain": "text3"
			},
			{
				"q": -12,
				"r": 5,
				"height": -0.47962517921013215,
				"terrain": "text2"
			},
			{
				"q": -12,
				"r": 6,
				"height": -0.5898105119050867,
				"terrain": "text7"
			},
			{
				"q": -12,
				"r": 7,
				"height": -0.5733312822277079,
				"terrain": "text3"
			},
			{
				"q": -12,
				"r": 8,
				"height": -0.3519576312749786,
				"terrain": "text6"
			},
			{
				"q": -12,
				"r": 9,
				"height": -0.023466679138806096,
				"terrain": "text6"
			},
			{
				"q": -13,
				"r": 5,
				"height": -0.5935905417554361,
				"terrain": "text5"
			},
			{
				"q": -13,
				"r": 6,
				"height": -0.7442438137232387,
				"terrain": "text2"
			},
			{
				"q": -13,
				"r": 7,
				"height": -0.6868612575235776,
				"terrain": "text6"
			},
			{
				"q": -13,
				"r": 8,
				"height": -0.4157051035539598,
				"terrain": "text3"
			},
			{
				"q": -13,
				"r": 9,
				"height": -0.08440288847323532,
				"terrain": "text1"
			},
			{
				"q": -14,
				"r": 7,
				"height": -0.7710445769630443,
				"terrain": "text1"
			},
			{
				"q": -14,
				"r": 8,
				"height": -0.48794806521832035,
				"terrain": "text7"
			},
			{
				"q": -14,
				"r": 9,
				"height": -0.14053779884529832,
				"terrain": "text5"
			},
			{
				"q": -15,
				"r": 9,
				"height": -0.0748464623190834,
				"terrain": "text2"
			},
			{
				"q": -4,
				"r": 0,
				"height": 0.11328694114743773,
				"terrain": "text3"
			},
			{
				"q": -4,
				"r": 1,
				"height": -0.21298100086584934,
				"terrain": "text1"
			},
			{
				"q": -4,
				"r": 2,
				"height": -0.4834260646717544,
				"terrain": "text6"
			},
			{
				"q": -4,
				"r": 3,
				"height": -0.5174276530389328,
				"terrain": "text6"
			},
			{
				"q": -4,
				"r": 4,
				"height": -0.3381583728060965,
				"terrain": "text5"
			},
			{
				"q": -4,
				"r": 5,
				"height": -0.1231336514894957,
				"terrain": "text3"
			},
			{
				"q": -4,
				"r": 6,
				"height": 0.13818657618172805,
				"terrain": "text6"
			},
			{
				"q": -4,
				"r": 7,
				"height": 0.4734486631137407,
				"terrain": "text2"
			},
			{
				"q": -4,
				"r": 8,
				"height": 0.648720309638245,
				"terrain": "text2"
			},
			{
				"q": -4,
				"r": 9,
				"height": 0.5308171262481005,
				"terrain": "text6"
			},
			{
				"q": -4,
				"r": -10,
				"height": 0.7355369875499442,
				"terrain": "text1"
			},
			{
				"q": -4,
				"r": -9,
				"height": 0.9599369980467226,
				"terrain": "mountain"
			},
			{
				"q": -4,
				"r": -8,
				"height": 1.1204188051787836,
				"terrain": "mountain"
			},
			{
				"q": -4,
				"r": -7,
				"height": 0.9902951090889134,
				"terrain": "mountain"
			},
			{
				"q": -4,
				"r": -6,
				"height": 0.5415676851387208,
				"terrain": "text5"
			},
			{
				"q": -4,
				"r": -5,
				"height": -0.005202105739502333,
				"terrain": "text5"
			},
			{
				"q": -4,
				"r": -4,
				"height": -0.3510463813520577,
				"terrain": "text3"
			},
			{
				"q": -4,
				"r": -3,
				"height": -0.28417724219621,
				"terrain": "text6"
			},
			{
				"q": -4,
				"r": -2,
				"height": 0.033120254230934065,
				"terrain": "text5"
			},
			{
				"q": -4,
				"r": -1,
				"height": 0.24260755265982123,
				"terrain": "text5"
			},
			{
				"q": -3,
				"r": 0,
				"height": 0.02990134214393575,
				"terrain": "text3"
			},
			{
				"q": -3,
				"r": 1,
				"height": -0.37582488588506335,
				"terrain": "text2"
			},
			{
				"q": -3,
				"r": 2,
				"height": -0.62138614867031,
				"terrain": "text7"
			},
			{
				"q": -3,
				"r": 3,
				"height": -0.5653783871999998,
				"terrain": "text2"
			},
			{
				"q": -3,
				"r": 4,
				"height": -0.31271613385654023,
				"terrain": "text3"
			},
			{
				"q": -3,
				"r": 5,
				"height": -0.10986283132518093,
				"terrain": "text7"
			},
			{
				"q": -3,
				"r": 6,
				"height": 0.06186067839485848,
				"terrain": "text4"
			},
			{
				"q": -3,
				"r": 7,
				"height": 0.330795633229959,
				"terrain": "text5"
			},
			{
				"q": -3,
				"r": 8,
				"height": 0.5175338507170277,
				"terrain": "text5"
			},
			{
				"q": -3,
				"r": 9,
				"height": 0.4557240332398216,
				"terrain": "text6"
			},
			{
				"q": -3,
				"r": -10,
				"height": 0.7186497927179605,
				"terrain": "text6"
			},
			{
				"q": -3,
				"r": -9,
				"height": 0.8798206434112323,
				"terrain": "mountain"
			},
			{
				"q": -3,
				"r": -8,
				"height": 1.027886445350596,
				"terrain": "mountain"
			},
			{
				"q": -3,
				"r": -7,
				"height": 0.9603600196250373,
				"terrain": "mountain"
			},
			{
				"q": -3,
				"r": -6,
				"height": 0.6413588817019062,
				"terrain": "text5"
			},
			{
				"q": -3,
				"r": -5,
				"height": 0.2753769842706555,
				"terrain": "text4"
			},
			{
				"q": -3,
				"r": -4,
				"height": 0.1270677054911713,
				"terrain": "text2"
			},
			{
				"q": -3,
				"r": -3,
				"height": 0.2698043807536119,
				"terrain": "text3"
			},
			{
				"q": -3,
				"r": -2,
				"height": 0.4336459317396965,
				"terrain": "text4"
			},
			{
				"q": -3,
				"r": -1,
				"height": 0.3627646127613318,
				"terrain": "text1"
			},
			{
				"q": -2,
				"r": 0,
				"height": 0.0020590605356470937,
				"terrain": "text2"
			},
			{
				"q": -2,
				"r": 1,
				"height": -0.5008911896166167,
				"terrain": "text3"
			},
			{
				"q": -2,
				"r": 2,
				"height": -0.7487708045266271,
				"terrain": "text6"
			},
			{
				"q": -2,
				"r": 3,
				"height": -0.6327539214152866,
				"terrain": "text7"
			},
			{
				"q": -2,
				"r": 4,
				"height": -0.33918239959113206,
				"terrain": "text3"
			},
			{
				"q": -2,
				"r": 5,
				"height": -0.16834124041376397,
				"terrain": "text3"
			},
			{
				"q": -2,
				"r": 6,
				"height": -0.08581400106567422,
				"terrain": "text7"
			},
			{
				"q": -2,
				"r": 7,
				"height": 0.07948297853398842,
				"terrain": "text6"
			},
			{
				"q": -2,
				"r": 8,
				"height": 0.20977268253704137,
				"terrain": "text5"
			},
			{
				"q": -2,
				"r": 9,
				"height": 0.1650016679113398,
				"terrain": "text2"
			},
			{
				"q": -2,
				"r": -10,
				"height": 0.6106763386912224,
				"terrain": "text2"
			},
			{
				"q": -2,
				"r": -9,
				"height": 0.7836800571194104,
				"terrain": "mountain"
			},
			{
				"q": -2,
				"r": -8,
				"height": 0.9596412044079883,
				"terrain": "mountain"
			},
			{
				"q": -2,
				"r": -7,
				"height": 0.9744157823938381,
				"terrain": "mountain"
			},
			{
				"q": -2,
				"r": -6,
				"height": 0.8025995564413884,
				"terrain": "mountain"
			},
			{
				"q": -2,
				"r": -5,
				"height": 0.6346536326429831,
				"terrain": "text3"
			},
			{
				"q": -2,
				"r": -4,
				"height": 0.6657251283025857,
				"terrain": "text5"
			},
			{
				"q": -2,
				"r": -3,
				"height": 0.8614683113777447,
				"terrain": "mountain"
			},
			{
				"q": -2,
				"r": -2,
				"height": 0.8773556796052571,
				"terrain": "mountain"
			},
			{
				"q": -2,
				"r": -1,
				"height": 0.5326293102558461,
				"terrain": "text1"
			},
			{
				"q": -1,
				"r": 0,
				"height": 0,
				"terrain": "text4"
			},
			{
				"q": -1,
				"r": 1,
				"height": -0.5850858304558452,
				"terrain": "text4"
			},
			{
				"q": -1,
				"r": 2,
				"height": -0.8714955267408286,
				"terrain": "text3"
			},
			{
				"q": -1,
				"r": 3,
				"height": -0.7598099459437433,
				"terrain": "text5"
			},
			{
				"q": -1,
				"r": 4,
				"height": -0.47464077784904146,
				"terrain": "text4"
			},
			{
				"q": -1,
				"r": 5,
				"height": -0.34170611519119165,
				"terrain": "text5"
			},
			{
				"q": -1,
				"r": 6,
				"height": -0.33256600867174657,
				"terrain": "text4"
			},
			{
				"q": -1,
				"r": 7,
				"height": -0.27574995452174633,
				"terrain": "text1"
			},
			{
				"q": -1,
				"r": 8,
				"height": -0.22347815358206416,
				"terrain": "text2"
			},
			{
				"q": -1,
				"r": 9,
				"height": -0.26957093658021314,
				"terrain": "text6"
			},
			{
				"q": -1,
				"r": -10,
				"height": 0.5274086389781014,
				"terrain": "text3"
			},
			{
				"q": -1,
				"r": -9,
				"height": 0.7659984401970361,
				"terrain": "mountain"
			},
			{
				"q": -1,
				"r": -8,
				"height": 0.9736623294057825,
				"terrain": "mountain"
			},
			{
				"q": -1,
				"r": -7,
				"height": 1.0245780806815976,
				"terrain": "mountain"
			},
			{
				"q": -1,
				"r": -6,
				"height": 0.9418688361652681,
				"terrain": "mountain"
			},
			{
				"q": -1,
				"r": -5,
				"height": 0.907850251470775,
				"terrain": "mountain"
			},
			{
				"q": -1,
				"r": -4,
				"height": 1.0265122382514016,
				"terrain": "mountain"
			},
			{
				"q": -1,
				"r": -3,
				"height": 1.217780258738193,
				"terrain": "mountain"
			},
			{
				"q": -1,
				"r": -2,
				"height": 1.1375537765607555,
				"terrain": "mountain"
			},
			{
				"q": -1,
				"r": -1,
				"height": 0.6454316809016531,
				"terrain": "text3"
			}
		],
		"halfWidth": 10,
		"halfHeight": 10
	}
	},
  "seed_8":{
	"map_id":"seed_8",
	"data": {
		"_width": 20,
		"_height": 20,
		"data": [
			{
				"q": 0,
				"r": 0,
				"height": 0,
				"terrain": "text2"
			},
			{
				"q": 0,
				"r": 1,
				"height": 0.04667636213991771,
				"terrain": "text1"
			},
			{
				"q": 0,
				"r": 2,
				"height": 0.19667122836734863,
				"terrain": "text4"
			},
			{
				"q": 0,
				"r": 3,
				"height": 0.32467145754506505,
				"terrain": "text6"
			},
			{
				"q": 0,
				"r": 4,
				"height": 0.3156302285211302,
				"terrain": "text2"
			},
			{
				"q": 0,
				"r": 5,
				"height": 0.1368858706294324,
				"terrain": "text4"
			},
			{
				"q": 0,
				"r": 6,
				"height": -0.14616731457417145,
				"terrain": "text4"
			},
			{
				"q": 0,
				"r": 7,
				"height": -0.3648430365132802,
				"terrain": "text7"
			},
			{
				"q": 0,
				"r": 8,
				"height": -0.5003492810987283,
				"terrain": "text2"
			},
			{
				"q": 0,
				"r": 9,
				"height": -0.6261323330583773,
				"terrain": "text2"
			},
			{
				"q": 0,
				"r": -10,
				"height": -0.20659266919399039,
				"terrain": "text2"
			},
			{
				"q": 0,
				"r": -9,
				"height": -0.028085464766446147,
				"terrain": "text2"
			},
			{
				"q": 0,
				"r": -8,
				"height": 0.13513216965485714,
				"terrain": "text4"
			},
			{
				"q": 0,
				"r": -7,
				"height": 0.22826993189059497,
				"terrain": "text2"
			},
			{
				"q": 0,
				"r": -6,
				"height": 0.3130143497683379,
				"terrain": "text3"
			},
			{
				"q": 0,
				"r": -5,
				"height": 0.4201945919380508,
				"terrain": "text4"
			},
			{
				"q": 0,
				"r": -4,
				"height": 0.4424260158533063,
				"terrain": "text5"
			},
			{
				"q": 0,
				"r": -3,
				"height": 0.3571942964474027,
				"terrain": "text2"
			},
			{
				"q": 0,
				"r": -2,
				"height": 0.19874431906863207,
				"terrain": "text6"
			},
			{
				"q": 0,
				"r": -1,
				"height": 0.04667636213991703,
				"terrain": "text2"
			},
			{
				"q": 1,
				"r": 0,
				"height": 0.625273666707819,
				"terrain": "text3"
			},
			{
				"q": 1,
				"r": 1,
				"height": 0.629206674871641,
				"terrain": "text3"
			},
			{
				"q": 1,
				"r": 2,
				"height": 0.6054620442624232,
				"terrain": "text5"
			},
			{
				"q": 1,
				"r": 3,
				"height": 0.47218654091711276,
				"terrain": "text6"
			},
			{
				"q": 1,
				"r": 4,
				"height": 0.21976315170607885,
				"terrain": "text2"
			},
			{
				"q": 1,
				"r": 5,
				"height": -0.0940024511599497,
				"terrain": "text2"
			},
			{
				"q": 1,
				"r": 6,
				"height": -0.4122818976218587,
				"terrain": "text5"
			},
			{
				"q": 1,
				"r": 7,
				"height": -0.5605399588386335,
				"terrain": "text2"
			},
			{
				"q": 1,
				"r": 8,
				"height": -0.5463204056892959,
				"terrain": "text1"
			},
			{
				"q": 1,
				"r": 9,
				"height": -0.5316119759854059,
				"terrain": "text4"
			},
			{
				"q": 1,
				"r": -10,
				"height": -0.3437021125036437,
				"terrain": "text3"
			},
			{
				"q": 1,
				"r": -9,
				"height": -0.06638388508758453,
				"terrain": "text5"
			},
			{
				"q": 1,
				"r": -8,
				"height": 0.20271961682237943,
				"terrain": "text4"
			},
			{
				"q": 1,
				"r": -7,
				"height": 0.3894500284982911,
				"terrain": "text3"
			},
			{
				"q": 1,
				"r": -6,
				"height": 0.5352458726350782,
				"terrain": "text7"
			},
			{
				"q": 1,
				"r": -5,
				"height": 0.6710106017138772,
				"terrain": "text1"
			},
			{
				"q": 1,
				"r": -4,
				"height": 0.7216059106514604,
				"terrain": "text7"
			},
			{
				"q": 1,
				"r": -3,
				"height": 0.7044200506613996,
				"terrain": "text5"
			},
			{
				"q": 1,
				"r": -2,
				"height": 0.6570338539042179,
				"terrain": "text6"
			},
			{
				"q": 1,
				"r": -1,
				"height": 0.6208391752592424,
				"terrain": "text6"
			},
			{
				"q": 2,
				"r": 0,
				"height": 0.9684433230068374,
				"terrain": "mountain"
			},
			{
				"q": 2,
				"r": 1,
				"height": 0.9981933031674172,
				"terrain": "mountain"
			},
			{
				"q": 2,
				"r": 2,
				"height": 0.9379293142517606,
				"terrain": "mountain"
			},
			{
				"q": 2,
				"r": 3,
				"height": 0.6903903442821685,
				"terrain": "text4"
			},
			{
				"q": 2,
				"r": 4,
				"height": 0.294891075006706,
				"terrain": "text5"
			},
			{
				"q": 2,
				"r": 5,
				"height": -0.10345447428576009,
				"terrain": "text1"
			},
			{
				"q": 2,
				"r": 6,
				"height": -0.46216163455061854,
				"terrain": "text3"
			},
			{
				"q": 2,
				"r": 7,
				"height": -0.6317375438581299,
				"terrain": "text1"
			},
			{
				"q": 2,
				"r": 8,
				"height": -0.5808081992074018,
				"terrain": "text2"
			},
			{
				"q": 2,
				"r": 9,
				"height": -0.47205896025200134,
				"terrain": "text3"
			},
			{
				"q": 2,
				"r": -10,
				"height": -0.24475443502146083,
				"terrain": "text3"
			},
			{
				"q": 2,
				"r": -9,
				"height": 0.06202074099327523,
				"terrain": "text5"
			},
			{
				"q": 2,
				"r": -8,
				"height": 0.37101307689318574,
				"terrain": "text4"
			},
			{
				"q": 2,
				"r": -7,
				"height": 0.5985004150731112,
				"terrain": "text7"
			},
			{
				"q": 2,
				"r": -6,
				"height": 0.7720301071591769,
				"terrain": "mountain"
			},
			{
				"q": 2,
				"r": -5,
				"height": 0.9188816644424124,
				"terrain": "mountain"
			},
			{
				"q": 2,
				"r": -4,
				"height": 0.9640909255613148,
				"terrain": "mountain"
			},
			{
				"q": 2,
				"r": -3,
				"height": 0.9211115769013994,
				"terrain": "mountain"
			},
			{
				"q": 2,
				"r": -2,
				"height": 0.8781009402204459,
				"terrain": "mountain"
			},
			{
				"q": 2,
				"r": -1,
				"height": 0.8986787117513462,
				"terrain": "mountain"
			},
			{
				"q": 3,
				"r": 0,
				"height": 0.9181621456607392,
				"terrain": "mountain"
			},
			{
				"q": 3,
				"r": 1,
				"height": 1.045037872531597,
				"terrain": "mountain"
			},
			{
				"q": 3,
				"r": 2,
				"height": 1.1076276001253742,
				"terrain": "mountain"
			},
			{
				"q": 3,
				"r": 3,
				"height": 0.9384271238863884,
				"terrain": "mountain"
			},
			{
				"q": 3,
				"r": 4,
				"height": 0.5382931943444246,
				"terrain": "text4"
			},
			{
				"q": 3,
				"r": 5,
				"height": 0.10118133992056368,
				"terrain": "text7"
			},
			{
				"q": 3,
				"r": 6,
				"height": -0.32208019227519336,
				"terrain": "text3"
			},
			{
				"q": 3,
				"r": 7,
				"height": -0.6007746744888496,
				"terrain": "text6"
			},
			{
				"q": 3,
				"r": 8,
				"height": -0.6101518772331433,
				"terrain": "text3"
			},
			{
				"q": 3,
				"r": 9,
				"height": -0.4472601945671536,
				"terrain": "text6"
			},
			{
				"q": 3,
				"r": -10,
				"height": -0.08111215130936389,
				"terrain": "text5"
			},
			{
				"q": 3,
				"r": -9,
				"height": 0.19857738177625744,
				"terrain": "text5"
			},
			{
				"q": 3,
				"r": -8,
				"height": 0.4844963712631457,
				"terrain": "text1"
			},
			{
				"q": 3,
				"r": -7,
				"height": 0.6877328088809875,
				"terrain": "text2"
			},
			{
				"q": 3,
				"r": -6,
				"height": 0.8393932721412346,
				"terrain": "mountain"
			},
			{
				"q": 3,
				"r": -5,
				"height": 0.9550357081481484,
				"terrain": "mountain"
			},
			{
				"q": 3,
				"r": -4,
				"height": 0.9539450495120989,
				"terrain": "mountain"
			},
			{
				"q": 3,
				"r": -3,
				"height": 0.8305806472138275,
				"terrain": "mountain"
			},
			{
				"q": 3,
				"r": -2,
				"height": 0.7373817112681484,
				"terrain": "text7"
			},
			{
				"q": 3,
				"r": -1,
				"height": 0.7796102502676538,
				"terrain": "mountain"
			},
			{
				"q": 4,
				"r": 0,
				"height": 0.6915859398543625,
				"terrain": "text2"
			},
			{
				"q": 4,
				"r": 1,
				"height": 0.9285515724207927,
				"terrain": "mountain"
			},
			{
				"q": 4,
				"r": 2,
				"height": 1.1541957894349077,
				"terrain": "mountain"
			},
			{
				"q": 4,
				"r": 3,
				"height": 1.1418207872883237,
				"terrain": "mountain"
			},
			{
				"q": 4,
				"r": 4,
				"height": 0.8185408661682667,
				"terrain": "mountain"
			},
			{
				"q": 4,
				"r": 5,
				"height": 0.35746233033648883,
				"terrain": "text5"
			},
			{
				"q": 4,
				"r": 6,
				"height": -0.15279894491951374,
				"terrain": "text6"
			},
			{
				"q": 4,
				"r": 7,
				"height": -0.5450822341339794,
				"terrain": "text3"
			},
			{
				"q": 4,
				"r": 8,
				"height": -0.6140752850925616,
				"terrain": "text6"
			},
			{
				"q": 4,
				"r": 9,
				"height": -0.4004822457084041,
				"terrain": "text4"
			},
			{
				"q": 4,
				"r": -10,
				"height": 0.017848298233196946,
				"terrain": "text5"
			},
			{
				"q": 4,
				"r": -9,
				"height": 0.24081875968545524,
				"terrain": "text5"
			},
			{
				"q": 4,
				"r": -8,
				"height": 0.4414783835171791,
				"terrain": "text4"
			},
			{
				"q": 4,
				"r": -7,
				"height": 0.5541415366264612,
				"terrain": "text4"
			},
			{
				"q": 4,
				"r": -6,
				"height": 0.6180368083858432,
				"terrain": "text4"
			},
			{
				"q": 4,
				"r": -5,
				"height": 0.6690142281989534,
				"terrain": "text6"
			},
			{
				"q": 4,
				"r": -4,
				"height": 0.6320072400367589,
				"terrain": "text3"
			},
			{
				"q": 4,
				"r": -3,
				"height": 0.4864823817665843,
				"terrain": "text3"
			},
			{
				"q": 4,
				"r": -2,
				"height": 0.40286249242662575,
				"terrain": "text6"
			},
			{
				"q": 4,
				"r": -1,
				"height": 0.4858483284093624,
				"terrain": "text4"
			},
			{
				"q": 5,
				"r": 0,
				"height": 0.6077201167973185,
				"terrain": "text2"
			},
			{
				"q": 5,
				"r": 1,
				"height": 0.908489847731661,
				"terrain": "mountain"
			},
			{
				"q": 5,
				"r": 2,
				"height": 1.2080957734064968,
				"terrain": "mountain"
			},
			{
				"q": 5,
				"r": 3,
				"height": 1.2639936949076864,
				"terrain": "mountain"
			},
			{
				"q": 5,
				"r": 4,
				"height": 0.9814131947837128,
				"terrain": "mountain"
			},
			{
				"q": 5,
				"r": 5,
				"height": 0.49178006250187956,
				"terrain": "text2"
			},
			{
				"q": 5,
				"r": 6,
				"height": -0.08730512802510873,
				"terrain": "text4"
			},
			{
				"q": 5,
				"r": 7,
				"height": -0.5179511269217518,
				"terrain": "text1"
			},
			{
				"q": 5,
				"r": 8,
				"height": -0.5729249374563842,
				"terrain": "text5"
			},
			{
				"q": 5,
				"r": -10,
				"height": 0.14414209906449998,
				"terrain": "text5"
			},
			{
				"q": 5,
				"r": -9,
				"height": 0.3179455173678694,
				"terrain": "text5"
			},
			{
				"q": 5,
				"r": -8,
				"height": 0.3788185675867498,
				"terrain": "text4"
			},
			{
				"q": 5,
				"r": -7,
				"height": 0.3015691796900877,
				"terrain": "text1"
			},
			{
				"q": 5,
				"r": -6,
				"height": 0.19796491139917693,
				"terrain": "text4"
			},
			{
				"q": 5,
				"r": -5,
				"height": 0.1799677227810802,
				"terrain": "text7"
			},
			{
				"q": 5,
				"r": -4,
				"height": 0.1715093232063202,
				"terrain": "text1"
			},
			{
				"q": 5,
				"r": -3,
				"height": 0.13018167917695478,
				"terrain": "text5"
			},
			{
				"q": 5,
				"r": -2,
				"height": 0.17090598656251593,
				"terrain": "text3"
			},
			{
				"q": 5,
				"r": -1,
				"height": 0.342134018501174,
				"terrain": "text5"
			},
			{
				"q": 6,
				"r": 0,
				"height": 0.6481982500955774,
				"terrain": "text7"
			},
			{
				"q": 6,
				"r": 1,
				"height": 0.9566680596539208,
				"terrain": "mountain"
			},
			{
				"q": 6,
				"r": 2,
				"height": 1.2364602950056718,
				"terrain": "mountain"
			},
			{
				"q": 6,
				"r": 3,
				"height": 1.2689344541939398,
				"terrain": "mountain"
			},
			{
				"q": 6,
				"r": 4,
				"height": 0.9788315870998668,
				"terrain": "mountain"
			},
			{
				"q": 6,
				"r": 5,
				"height": 0.488754319847243,
				"terrain": "text7"
			},
			{
				"q": 6,
				"r": 6,
				"height": -0.08200108733666064,
				"terrain": "text6"
			},
			{
				"q": 6,
				"r": -10,
				"height": 0.4020669248607926,
				"terrain": "text4"
			},
			{
				"q": 6,
				"r": -9,
				"height": 0.5717421892797618,
				"terrain": "text7"
			},
			{
				"q": 6,
				"r": -8,
				"height": 0.5031199143084772,
				"terrain": "text7"
			},
			{
				"q": 6,
				"r": -7,
				"height": 0.19717979372082278,
				"terrain": "text7"
			},
			{
				"q": 6,
				"r": -6,
				"height": -0.1364787594113583,
				"terrain": "text6"
			},
			{
				"q": 6,
				"r": -5,
				"height": -0.2598572037448557,
				"terrain": "text6"
			},
			{
				"q": 6,
				"r": -4,
				"height": -0.21274237036510232,
				"terrain": "text5"
			},
			{
				"q": 6,
				"r": -3,
				"height": -0.1091087905520986,
				"terrain": "text2"
			},
			{
				"q": 6,
				"r": -2,
				"height": 0.07320625343736639,
				"terrain": "text3"
			},
			{
				"q": 6,
				"r": -1,
				"height": 0.3384639810046214,
				"terrain": "text5"
			},
			{
				"q": 7,
				"r": 0,
				"height": 0.637107431588922,
				"terrain": "text2"
			},
			{
				"q": 7,
				"r": 1,
				"height": 0.8635951642171468,
				"terrain": "mountain"
			},
			{
				"q": 7,
				"r": 2,
				"height": 1.0230332965304423,
				"terrain": "mountain"
			},
			{
				"q": 7,
				"r": 3,
				"height": 0.990822818676978,
				"terrain": "mountain"
			},
			{
				"q": 7,
				"r": 4,
				"height": 0.7357659872737653,
				"terrain": "text2"
			},
			{
				"q": 7,
				"r": -10,
				"height": 0.7803531618559625,
				"terrain": "mountain"
			},
			{
				"q": 7,
				"r": -9,
				"height": 0.9829218422307816,
				"terrain": "mountain"
			},
			{
				"q": 7,
				"r": -8,
				"height": 0.8718407382552619,
				"terrain": "mountain"
			},
			{
				"q": 7,
				"r": -7,
				"height": 0.43455460973381643,
				"terrain": "text1"
			},
			{
				"q": 7,
				"r": -6,
				"height": -0.08749149934452713,
				"terrain": "text3"
			},
			{
				"q": 7,
				"r": -5,
				"height": -0.3664771414276279,
				"terrain": "text6"
			},
			{
				"q": 7,
				"r": -4,
				"height": -0.34559176676546055,
				"terrain": "text6"
			},
			{
				"q": 7,
				"r": -3,
				"height": -0.19090288446156378,
				"terrain": "text1"
			},
			{
				"q": 7,
				"r": -2,
				"height": 0.043326466589848234,
				"terrain": "text2"
			},
			{
				"q": 7,
				"r": -1,
				"height": 0.3421141209664402,
				"terrain": "text3"
			},
			{
				"q": 8,
				"r": 0,
				"height": 0.6037683148742767,
				"terrain": "text2"
			},
			{
				"q": 8,
				"r": 1,
				"height": 0.6908544887632672,
				"terrain": "text6"
			},
			{
				"q": 8,
				"r": 2,
				"height": 0.6785531880104811,
				"terrain": "text2"
			},
			{
				"q": 8,
				"r": -10,
				"height": 1.0189440373010648,
				"terrain": "mountain"
			},
			{
				"q": 8,
				"r": -9,
				"height": 1.2797987441972019,
				"terrain": "mountain"
			},
			{
				"q": 8,
				"r": -8,
				"height": 1.234180868552542,
				"terrain": "mountain"
			},
			{
				"q": 8,
				"r": -7,
				"height": 0.8183231781165106,
				"terrain": "mountain"
			},
			{
				"q": 8,
				"r": -6,
				"height": 0.22663847466139936,
				"terrain": "text6"
			},
			{
				"q": 8,
				"r": -5,
				"height": -0.19095274123507577,
				"terrain": "text7"
			},
			{
				"q": 8,
				"r": -4,
				"height": -0.2688629132358438,
				"terrain": "text2"
			},
			{
				"q": 8,
				"r": -3,
				"height": -0.1392976749461632,
				"terrain": "text2"
			},
			{
				"q": 8,
				"r": -2,
				"height": 0.09126393886098144,
				"terrain": "text7"
			},
			{
				"q": 8,
				"r": -1,
				"height": 0.3729267032844791,
				"terrain": "text3"
			},
			{
				"q": 9,
				"r": 0,
				"height": 0.6167251579428288,
				"terrain": "text7"
			},
			{
				"q": 9,
				"r": -10,
				"height": 0.8649223580658435,
				"terrain": "mountain"
			},
			{
				"q": 9,
				"r": -9,
				"height": 1.1954433560434568,
				"terrain": "mountain"
			},
			{
				"q": 9,
				"r": -8,
				"height": 1.2772457415680658,
				"terrain": "mountain"
			},
			{
				"q": 9,
				"r": -7,
				"height": 0.9939547819088064,
				"terrain": "mountain"
			},
			{
				"q": 9,
				"r": -6,
				"height": 0.45867901200612166,
				"terrain": "text2"
			},
			{
				"q": 9,
				"r": -5,
				"height": -0.008837288052091524,
				"terrain": "text2"
			},
			{
				"q": 9,
				"r": -4,
				"height": -0.16250952603539448,
				"terrain": "text4"
			},
			{
				"q": 9,
				"r": -3,
				"height": -0.04543677881008279,
				"terrain": "text5"
			},
			{
				"q": 9,
				"r": -2,
				"height": 0.19884440315499777,
				"terrain": "text7"
			},
			{
				"q": 9,
				"r": -1,
				"height": 0.465241620018284,
				"terrain": "text2"
			},
			{
				"q": 10,
				"r": -10,
				"height": 0.322105370116344,
				"terrain": "text3"
			},
			{
				"q": 10,
				"r": -9,
				"height": 0.7082382593004114,
				"terrain": "text7"
			},
			{
				"q": 10,
				"r": -8,
				"height": 0.9096077894291557,
				"terrain": "mountain"
			},
			{
				"q": 10,
				"r": -7,
				"height": 0.7900133129897684,
				"terrain": "mountain"
			},
			{
				"q": 10,
				"r": -6,
				"height": 0.39047432598983,
				"terrain": "text6"
			},
			{
				"q": 10,
				"r": -5,
				"height": -0.022396926420043317,
				"terrain": "text3"
			},
			{
				"q": 10,
				"r": -4,
				"height": -0.17442382079722246,
				"terrain": "text6"
			},
			{
				"q": 10,
				"r": -3,
				"height": -0.021025284786492737,
				"terrain": "text3"
			},
			{
				"q": 10,
				"r": -2,
				"height": 0.2779176762888274,
				"terrain": "text3"
			},
			{
				"q": 11,
				"r": -10,
				"height": -0.2722370871213743,
				"terrain": "text1"
			},
			{
				"q": 11,
				"r": -9,
				"height": 0.12177225247924628,
				"terrain": "text6"
			},
			{
				"q": 11,
				"r": -8,
				"height": 0.37957484129631114,
				"terrain": "text4"
			},
			{
				"q": 11,
				"r": -7,
				"height": 0.36414261203252574,
				"terrain": "text4"
			},
			{
				"q": 11,
				"r": -6,
				"height": 0.0922413193483479,
				"terrain": "text6"
			},
			{
				"q": 11,
				"r": -5,
				"height": -0.21985867763823536,
				"terrain": "text5"
			},
			{
				"q": 11,
				"r": -4,
				"height": -0.314559965109241,
				"terrain": "text4"
			},
			{
				"q": 12,
				"r": -10,
				"height": -0.5820934328952132,
				"terrain": "text3"
			},
			{
				"q": 12,
				"r": -9,
				"height": -0.22801514491224223,
				"terrain": "text6"
			},
			{
				"q": 12,
				"r": -8,
				"height": -0.0254835110471599,
				"terrain": "text1"
			},
			{
				"q": 12,
				"r": -7,
				"height": -0.06973517086954428,
				"terrain": "text3"
			},
			{
				"q": 12,
				"r": -6,
				"height": -0.27726115290573505,
				"terrain": "text6"
			},
			{
				"q": 13,
				"r": -10,
				"height": -0.4109007543205149,
				"terrain": "text4"
			},
			{
				"q": 13,
				"r": -9,
				"height": -0.1746150948448968,
				"terrain": "text6"
			},
			{
				"q": 13,
				"r": -8,
				"height": -0.11887628439806902,
				"terrain": "text4"
			},
			{
				"q": 14,
				"r": -10,
				"height": 0.08952071486944632,
				"terrain": "text3"
			},
			{
				"q": -5,
				"r": 0,
				"height": -0.9704219831547565,
				"terrain": "text5"
			},
			{
				"q": -5,
				"r": 1,
				"height": -0.8178952331312477,
				"terrain": "text3"
			},
			{
				"q": -5,
				"r": 2,
				"height": -0.4197281056134004,
				"terrain": "text2"
			},
			{
				"q": -5,
				"r": 3,
				"height": -0.0718478977858335,
				"terrain": "text4"
			},
			{
				"q": -5,
				"r": 4,
				"height": 0.15907441922145313,
				"terrain": "text1"
			},
			{
				"q": -5,
				"r": 5,
				"height": 0.35741034224536594,
				"terrain": "text4"
			},
			{
				"q": -5,
				"r": 6,
				"height": 0.4862359376759577,
				"terrain": "text5"
			},
			{
				"q": -5,
				"r": 7,
				"height": 0.6226217325083292,
				"terrain": "text4"
			},
			{
				"q": -5,
				"r": 8,
				"height": 0.7165559173160311,
				"terrain": "text2"
			},
			{
				"q": -5,
				"r": 9,
				"height": 0.6079274120950007,
				"terrain": "text6"
			},
			{
				"q": -5,
				"r": -10,
				"height": 0.06329163714335112,
				"terrain": "text5"
			},
			{
				"q": -5,
				"r": -9,
				"height": -0.27344437356738627,
				"terrain": "text6"
			},
			{
				"q": -5,
				"r": -8,
				"height": -0.5845691182299422,
				"terrain": "text6"
			},
			{
				"q": -5,
				"r": -7,
				"height": -0.6492251574023437,
				"terrain": "text4"
			},
			{
				"q": -5,
				"r": -6,
				"height": -0.37577931732552106,
				"terrain": "text5"
			},
			{
				"q": -5,
				"r": -5,
				"height": 0.14745532795938107,
				"terrain": "text4"
			},
			{
				"q": -5,
				"r": -4,
				"height": 0.5332603966995605,
				"terrain": "text7"
			},
			{
				"q": -5,
				"r": -3,
				"height": 0.43017810765780246,
				"terrain": "text1"
			},
			{
				"q": -5,
				"r": -2,
				"height": -0.12032267694847504,
				"terrain": "text1"
			},
			{
				"q": -5,
				"r": -1,
				"height": -0.7206239978790067,
				"terrain": "text5"
			},
			{
				"q": -6,
				"r": 0,
				"height": -0.8544812404760496,
				"terrain": "text3"
			},
			{
				"q": -6,
				"r": 1,
				"height": -0.6811638184610325,
				"terrain": "text4"
			},
			{
				"q": -6,
				"r": 2,
				"height": -0.3436442298297585,
				"terrain": "text2"
			},
			{
				"q": -6,
				"r": 3,
				"height": -0.15064726202555173,
				"terrain": "text6"
			},
			{
				"q": -6,
				"r": 4,
				"height": -0.10181968712917305,
				"terrain": "text6"
			},
			{
				"q": -6,
				"r": 5,
				"height": -0.026263321866008243,
				"terrain": "text2"
			},
			{
				"q": -6,
				"r": 6,
				"height": 0.0942468152171167,
				"terrain": "text6"
			},
			{
				"q": -6,
				"r": 7,
				"height": 0.4303079996923022,
				"terrain": "text1"
			},
			{
				"q": -6,
				"r": 8,
				"height": 0.8412968169754075,
				"terrain": "mountain"
			},
			{
				"q": -6,
				"r": 9,
				"height": 0.9869456842567479,
				"terrain": "mountain"
			},
			{
				"q": -6,
				"r": -9,
				"height": -0.4961972004314713,
				"terrain": "text5"
			},
			{
				"q": -6,
				"r": -8,
				"height": -0.7339008233671735,
				"terrain": "text7"
			},
			{
				"q": -6,
				"r": -7,
				"height": -0.7524469716425792,
				"terrain": "text6"
			},
			{
				"q": -6,
				"r": -6,
				"height": -0.4559713759766612,
				"terrain": "text2"
			},
			{
				"q": -6,
				"r": -5,
				"height": 0.0686723774604121,
				"terrain": "text2"
			},
			{
				"q": -6,
				"r": -4,
				"height": 0.46096549016302346,
				"terrain": "text3"
			},
			{
				"q": -6,
				"r": -3,
				"height": 0.3986628445783553,
				"terrain": "text7"
			},
			{
				"q": -6,
				"r": -2,
				"height": -0.08827305476917413,
				"terrain": "text2"
			},
			{
				"q": -6,
				"r": -1,
				"height": -0.6335994254964659,
				"terrain": "text4"
			},
			{
				"q": -7,
				"r": 0,
				"height": -0.6367305790013453,
				"terrain": "text1"
			},
			{
				"q": -7,
				"r": 1,
				"height": -0.3878871837177814,
				"terrain": "text2"
			},
			{
				"q": -7,
				"r": 2,
				"height": -0.10776541890974523,
				"terrain": "text6"
			},
			{
				"q": -7,
				"r": 3,
				"height": -0.05088970717972621,
				"terrain": "text2"
			},
			{
				"q": -7,
				"r": 4,
				"height": -0.1621816941100876,
				"terrain": "text1"
			},
			{
				"q": -7,
				"r": 5,
				"height": -0.19754154481997027,
				"terrain": "text3"
			},
			{
				"q": -7,
				"r": 6,
				"height": -0.07819282150852647,
				"terrain": "text5"
			},
			{
				"q": -7,
				"r": 7,
				"height": 0.4109433187213949,
				"terrain": "text6"
			},
			{
				"q": -7,
				"r": 8,
				"height": 1.0373941011766867,
				"terrain": "mountain"
			},
			{
				"q": -7,
				"r": 9,
				"height": 1.3321450822122447,
				"terrain": "mountain"
			},
			{
				"q": -7,
				"r": -7,
				"height": -0.8501407620330156,
				"terrain": "text4"
			},
			{
				"q": -7,
				"r": -6,
				"height": -0.5630612931567452,
				"terrain": "text6"
			},
			{
				"q": -7,
				"r": -5,
				"height": -0.15959527791442157,
				"terrain": "text4"
			},
			{
				"q": -7,
				"r": -4,
				"height": 0.11603702747177286,
				"terrain": "text2"
			},
			{
				"q": -7,
				"r": -3,
				"height": 0.0671092146326761,
				"terrain": "text7"
			},
			{
				"q": -7,
				"r": -2,
				"height": -0.24669445262353248,
				"terrain": "text4"
			},
			{
				"q": -7,
				"r": -1,
				"height": -0.5650427289606568,
				"terrain": "text5"
			},
			{
				"q": -8,
				"r": 0,
				"height": -0.453894442503313,
				"terrain": "text6"
			},
			{
				"q": -8,
				"r": 1,
				"height": -0.10128097583021795,
				"terrain": "text3"
			},
			{
				"q": -8,
				"r": 2,
				"height": 0.19150469334861553,
				"terrain": "text2"
			},
			{
				"q": -8,
				"r": 3,
				"height": 0.21988392676647428,
				"terrain": "text1"
			},
			{
				"q": -8,
				"r": 4,
				"height": 0.07389944340870114,
				"terrain": "text4"
			},
			{
				"q": -8,
				"r": 5,
				"height": 0.014068564779742776,
				"terrain": "text6"
			},
			{
				"q": -8,
				"r": 6,
				"height": 0.1251249234542911,
				"terrain": "text5"
			},
			{
				"q": -8,
				"r": 7,
				"height": 0.5994539775584138,
				"terrain": "text4"
			},
			{
				"q": -8,
				"r": 8,
				"height": 1.1718510553372705,
				"terrain": "mountain"
			},
			{
				"q": -8,
				"r": 9,
				"height": 1.3846307728255551,
				"terrain": "mountain"
			},
			{
				"q": -8,
				"r": -5,
				"height": -0.3844850303347379,
				"terrain": "text1"
			},
			{
				"q": -8,
				"r": -4,
				"height": -0.3279738708976594,
				"terrain": "text3"
			},
			{
				"q": -8,
				"r": -3,
				"height": -0.43151449179528467,
				"terrain": "text7"
			},
			{
				"q": -8,
				"r": -2,
				"height": -0.5655510270343929,
				"terrain": "text5"
			},
			{
				"q": -8,
				"r": -1,
				"height": -0.5914644394775068,
				"terrain": "text4"
			},
			{
				"q": -9,
				"r": 0,
				"height": -0.427919963369533,
				"terrain": "text6"
			},
			{
				"q": -9,
				"r": 1,
				"height": 0.03824651636251564,
				"terrain": "text5"
			},
			{
				"q": -9,
				"r": 2,
				"height": 0.41512296735394894,
				"terrain": "text5"
			},
			{
				"q": -9,
				"r": 3,
				"height": 0.527067179841987,
				"terrain": "text3"
			},
			{
				"q": -9,
				"r": 4,
				"height": 0.42720378629221006,
				"terrain": "text2"
			},
			{
				"q": -9,
				"r": 5,
				"height": 0.3690900005686558,
				"terrain": "text5"
			},
			{
				"q": -9,
				"r": 6,
				"height": 0.4460357978604045,
				"terrain": "text6"
			},
			{
				"q": -9,
				"r": 7,
				"height": 0.766044278143188,
				"terrain": "mountain"
			},
			{
				"q": -9,
				"r": 8,
				"height": 1.0796087944663109,
				"terrain": "mountain"
			},
			{
				"q": -9,
				"r": 9,
				"height": 1.0454653775749165,
				"terrain": "mountain"
			},
			{
				"q": -9,
				"r": -3,
				"height": -0.9527109736213797,
				"terrain": "text6"
			},
			{
				"q": -9,
				"r": -2,
				"height": -1.0082210483722294,
				"terrain": "text2"
			},
			{
				"q": -9,
				"r": -1,
				"height": -0.7924680816070856,
				"terrain": "text2"
			},
			{
				"q": -10,
				"r": 0,
				"height": -0.5518760288251042,
				"terrain": "text4"
			},
			{
				"q": -10,
				"r": 1,
				"height": 0.033896661372588344,
				"terrain": "text4"
			},
			{
				"q": -10,
				"r": 2,
				"height": 0.4938823763110802,
				"terrain": "text3"
			},
			{
				"q": -10,
				"r": 3,
				"height": 0.6814034375535911,
				"terrain": "text4"
			},
			{
				"q": -10,
				"r": 4,
				"height": 0.6175190929798022,
				"terrain": "text6"
			},
			{
				"q": -10,
				"r": 5,
				"height": 0.5262381350423347,
				"terrain": "text4"
			},
			{
				"q": -10,
				"r": 6,
				"height": 0.5274763178475862,
				"terrain": "text6"
			},
			{
				"q": -10,
				"r": 7,
				"height": 0.6733550236251866,
				"terrain": "text5"
			},
			{
				"q": -10,
				"r": 8,
				"height": 0.7412609601672241,
				"terrain": "text4"
			},
			{
				"q": -10,
				"r": 9,
				"height": 0.4870486296707818,
				"terrain": "text4"
			},
			{
				"q": -10,
				"r": -1,
				"height": -1.093757953837172,
				"terrain": "text2"
			},
			{
				"q": -11,
				"r": 1,
				"height": -0.24221531352064948,
				"terrain": "text4"
			},
			{
				"q": -11,
				"r": 2,
				"height": 0.30494068696734555,
				"terrain": "text2"
			},
			{
				"q": -11,
				"r": 3,
				"height": 0.6029335830987881,
				"terrain": "text4"
			},
			{
				"q": -11,
				"r": 4,
				"height": 0.6466831341731436,
				"terrain": "text2"
			},
			{
				"q": -11,
				"r": 5,
				"height": 0.5813335158557571,
				"terrain": "text5"
			},
			{
				"q": -11,
				"r": 6,
				"height": 0.5286906918843166,
				"terrain": "text5"
			},
			{
				"q": -11,
				"r": 7,
				"height": 0.4867384417769664,
				"terrain": "text6"
			},
			{
				"q": -11,
				"r": 8,
				"height": 0.2930369094765841,
				"terrain": "text1"
			},
			{
				"q": -11,
				"r": 9,
				"height": -0.14404295053676555,
				"terrain": "text3"
			},
			{
				"q": -12,
				"r": 3,
				"height": 0.23192227809558658,
				"terrain": "text6"
			},
			{
				"q": -12,
				"r": 4,
				"height": 0.5254937811486317,
				"terrain": "text5"
			},
			{
				"q": -12,
				"r": 5,
				"height": 0.6342458764595393,
				"terrain": "text3"
			},
			{
				"q": -12,
				"r": 6,
				"height": 0.6293899224034178,
				"terrain": "text5"
			},
			{
				"q": -12,
				"r": 7,
				"height": 0.4270927596600782,
				"terrain": "text3"
			},
			{
				"q": -12,
				"r": 8,
				"height": -0.05635579865695625,
				"terrain": "text1"
			},
			{
				"q": -12,
				"r": 9,
				"height": -0.6664857973208249,
				"terrain": "text3"
			},
			{
				"q": -13,
				"r": 5,
				"height": 0.6244729479114082,
				"terrain": "text2"
			},
			{
				"q": -13,
				"r": 6,
				"height": 0.7653717173954304,
				"terrain": "mountain"
			},
			{
				"q": -13,
				"r": 7,
				"height": 0.5342249726917664,
				"terrain": "text3"
			},
			{
				"q": -13,
				"r": 8,
				"height": -0.07656347197566277,
				"terrain": "text3"
			},
			{
				"q": -13,
				"r": 9,
				"height": -0.7579055788920284,
				"terrain": "text2"
			},
			{
				"q": -14,
				"r": 7,
				"height": 0.695013782276189,
				"terrain": "text5"
			},
			{
				"q": -14,
				"r": 8,
				"height": 0.16418193799559655,
				"terrain": "text3"
			},
			{
				"q": -14,
				"r": 9,
				"height": -0.47896749554599427,
				"terrain": "text2"
			},
			{
				"q": -15,
				"r": 9,
				"height": -0.160153484988924,
				"terrain": "text4"
			},
			{
				"q": -4,
				"r": 0,
				"height": -1.1028446203308944,
				"terrain": "text6"
			},
			{
				"q": -4,
				"r": 1,
				"height": -0.9110762134017858,
				"terrain": "text7"
			},
			{
				"q": -4,
				"r": 2,
				"height": -0.4116579448896255,
				"terrain": "text6"
			},
			{
				"q": -4,
				"r": 3,
				"height": 0.13214357620226075,
				"terrain": "text4"
			},
			{
				"q": -4,
				"r": 4,
				"height": 0.5422469643039831,
				"terrain": "text1"
			},
			{
				"q": -4,
				"r": 5,
				"height": 0.7983955391018314,
				"terrain": "mountain"
			},
			{
				"q": -4,
				"r": 6,
				"height": 0.8808209582436657,
				"terrain": "mountain"
			},
			{
				"q": -4,
				"r": 7,
				"height": 0.811418327235642,
				"terrain": "mountain"
			},
			{
				"q": -4,
				"r": 8,
				"height": 0.5932525512816078,
				"terrain": "text5"
			},
			{
				"q": -4,
				"r": 9,
				"height": 0.23795811873301292,
				"terrain": "text4"
			},
			{
				"q": -4,
				"r": -10,
				"height": 0.2628280988965447,
				"terrain": "text2"
			},
			{
				"q": -4,
				"r": -9,
				"height": -0.06638635496286464,
				"terrain": "text3"
			},
			{
				"q": -4,
				"r": -8,
				"height": -0.4022908085559994,
				"terrain": "text5"
			},
			{
				"q": -4,
				"r": -7,
				"height": -0.5163032361102973,
				"terrain": "text6"
			},
			{
				"q": -4,
				"r": -6,
				"height": -0.3134374286058118,
				"terrain": "text2"
			},
			{
				"q": -4,
				"r": -5,
				"height": 0.1304115207293184,
				"terrain": "text3"
			},
			{
				"q": -4,
				"r": -4,
				"height": 0.424458210356661,
				"terrain": "text4"
			},
			{
				"q": -4,
				"r": -3,
				"height": 0.2223136468688649,
				"terrain": "text3"
			},
			{
				"q": -4,
				"r": -2,
				"height": -0.35913895956243436,
				"terrain": "text2"
			},
			{
				"q": -4,
				"r": -1,
				"height": -0.9175548008710925,
				"terrain": "text2"
			},
			{
				"q": -3,
				"r": 0,
				"height": -1.2688541215061653,
				"terrain": "text1"
			},
			{
				"q": -3,
				"r": 1,
				"height": -1.039541818972282,
				"terrain": "text2"
			},
			{
				"q": -3,
				"r": 2,
				"height": -0.4304733332170463,
				"terrain": "text4"
			},
			{
				"q": -3,
				"r": 3,
				"height": 0.3067215576153849,
				"terrain": "text5"
			},
			{
				"q": -3,
				"r": 4,
				"height": 0.8606145468819263,
				"terrain": "mountain"
			},
			{
				"q": -3,
				"r": 5,
				"height": 1.1051408539180267,
				"terrain": "mountain"
			},
			{
				"q": -3,
				"r": 6,
				"height": 1.0744709714513982,
				"terrain": "mountain"
			},
			{
				"q": -3,
				"r": 7,
				"height": 0.8099250772943484,
				"terrain": "mountain"
			},
			{
				"q": -3,
				"r": 8,
				"height": 0.37118949563548187,
				"terrain": "text1"
			},
			{
				"q": -3,
				"r": 9,
				"height": -0.1279404621920831,
				"terrain": "text6"
			},
			{
				"q": -3,
				"r": -10,
				"height": 0.3650718889077118,
				"terrain": "text3"
			},
			{
				"q": -3,
				"r": -9,
				"height": 0.10661513637812295,
				"terrain": "text4"
			},
			{
				"q": -3,
				"r": -8,
				"height": -0.19240338215771202,
				"terrain": "text3"
			},
			{
				"q": -3,
				"r": -7,
				"height": -0.3355423229163755,
				"terrain": "text3"
			},
			{
				"q": -3,
				"r": -6,
				"height": -0.22629291224407966,
				"terrain": "text2"
			},
			{
				"q": -3,
				"r": -5,
				"height": 0.08698028813556109,
				"terrain": "text7"
			},
			{
				"q": -3,
				"r": -4,
				"height": 0.2522605944600289,
				"terrain": "text6"
			},
			{
				"q": -3,
				"r": -3,
				"height": -0.044645807953611706,
				"terrain": "text2"
			},
			{
				"q": -3,
				"r": -2,
				"height": -0.6510236902496532,
				"terrain": "text4"
			},
			{
				"q": -3,
				"r": -1,
				"height": -1.1555221489089862,
				"terrain": "text2"
			},
			{
				"q": -2,
				"r": 0,
				"height": -1.1671504117705047,
				"terrain": "text3"
			},
			{
				"q": -2,
				"r": 1,
				"height": -0.9656295202218097,
				"terrain": "text4"
			},
			{
				"q": -2,
				"r": 2,
				"height": -0.39455137650860705,
				"terrain": "text3"
			},
			{
				"q": -2,
				"r": 3,
				"height": 0.3199895386910585,
				"terrain": "text3"
			},
			{
				"q": -2,
				"r": 4,
				"height": 0.8357788499276457,
				"terrain": "mountain"
			},
			{
				"q": -2,
				"r": 5,
				"height": 0.9861226392394282,
				"terrain": "mountain"
			},
			{
				"q": -2,
				"r": 6,
				"height": 0.8447775868359101,
				"terrain": "mountain"
			},
			{
				"q": -2,
				"r": 7,
				"height": 0.5006618630581066,
				"terrain": "text3"
			},
			{
				"q": -2,
				"r": 8,
				"height": 0.038623272582783155,
				"terrain": "text3"
			},
			{
				"q": -2,
				"r": 9,
				"height": -0.42699093895118795,
				"terrain": "text2"
			},
			{
				"q": -2,
				"r": -10,
				"height": 0.2914019508108927,
				"terrain": "text4"
			},
			{
				"q": -2,
				"r": -9,
				"height": 0.16293228557615463,
				"terrain": "text7"
			},
			{
				"q": -2,
				"r": -8,
				"height": -0.017892986366849696,
				"terrain": "text3"
			},
			{
				"q": -2,
				"r": -7,
				"height": -0.13032195358283832,
				"terrain": "text6"
			},
			{
				"q": -2,
				"r": -6,
				"height": -0.08810425118049725,
				"terrain": "text2"
			},
			{
				"q": -2,
				"r": -5,
				"height": 0.09395267339292981,
				"terrain": "text5"
			},
			{
				"q": -2,
				"r": -4,
				"height": 0.15098684555685965,
				"terrain": "text4"
			},
			{
				"q": -2,
				"r": -3,
				"height": -0.13495070990529584,
				"terrain": "text3"
			},
			{
				"q": -2,
				"r": -2,
				"height": -0.6580164186174807,
				"terrain": "text5"
			},
			{
				"q": -2,
				"r": -1,
				"height": -1.084089470213037,
				"terrain": "text2"
			},
			{
				"q": -1,
				"r": 0,
				"height": -0.6719500288477358,
				"terrain": "text2"
			},
			{
				"q": -1,
				"r": 1,
				"height": -0.5551850457246205,
				"terrain": "text7"
			},
			{
				"q": -1,
				"r": 2,
				"height": -0.1842292535525639,
				"terrain": "text2"
			},
			{
				"q": -1,
				"r": 3,
				"height": 0.2664376463828593,
				"terrain": "text3"
			},
			{
				"q": -1,
				"r": 4,
				"height": 0.5490129786859992,
				"terrain": "text5"
			},
			{
				"q": -1,
				"r": 5,
				"height": 0.5415107998897942,
				"terrain": "text2"
			},
			{
				"q": -1,
				"r": 6,
				"height": 0.31704717976232655,
				"terrain": "text2"
			},
			{
				"q": -1,
				"r": 7,
				"height": 0.017715263677878415,
				"terrain": "text1"
			},
			{
				"q": -1,
				"r": 8,
				"height": -0.2953786804108921,
				"terrain": "text4"
			},
			{
				"q": -1,
				"r": 9,
				"height": -0.5918516058868692,
				"terrain": "text2"
			},
			{
				"q": -1,
				"r": -10,
				"height": 0.06155894226992447,
				"terrain": "text3"
			},
			{
				"q": -1,
				"r": -9,
				"height": 0.09437944972979181,
				"terrain": "text1"
			},
			{
				"q": -1,
				"r": -8,
				"height": 0.0887085973522157,
				"terrain": "text3"
			},
			{
				"q": -1,
				"r": -7,
				"height": 0.06703739904305643,
				"terrain": "text2"
			},
			{
				"q": -1,
				"r": -6,
				"height": 0.10269433095608317,
				"terrain": "text4"
			},
			{
				"q": -1,
				"r": -5,
				"height": 0.21221000851936206,
				"terrain": "text6"
			},
			{
				"q": -1,
				"r": -4,
				"height": 0.22410816644129045,
				"terrain": "text6"
			},
			{
				"q": -1,
				"r": -3,
				"height": 0.035673364363578174,
				"terrain": "text3"
			},
			{
				"q": -1,
				"r": -2,
				"height": -0.2958187518648832,
				"terrain": "text2"
			},
			{
				"q": -1,
				"r": -1,
				"height": -0.5905144325097623,
				"terrain": "text1"
			}
		],
		"halfWidth": 10,
		"halfHeight": 10
	}
	},
  "seed_9":{
	"map_id": "seed_9",
	"data": {
		"_width": 20,
		"_height": 20,
		"data": [
			{
				"q": 0,
				"r": 0,
				"height": 0,
				"terrain": "text6"
			},
			{
				"q": 0,
				"r": 1,
				"height": -0.5785973045679013,
				"terrain": "text6"
			},
			{
				"q": 0,
				"r": 2,
				"height": -0.7676302230186698,
				"terrain": "text6"
			},
			{
				"q": 0,
				"r": 3,
				"height": -0.5283421677229436,
				"terrain": "text6"
			},
			{
				"q": 0,
				"r": 4,
				"height": -0.11715457649873896,
				"terrain": "text6"
			},
			{
				"q": 0,
				"r": 5,
				"height": 0.11550582869870449,
				"terrain": "text4"
			},
			{
				"q": 0,
				"r": 6,
				"height": 0.11088037400487757,
				"terrain": "text5"
			},
			{
				"q": 0,
				"r": 7,
				"height": 0.02424704139460196,
				"terrain": "text4"
			},
			{
				"q": 0,
				"r": 8,
				"height": -0.09328753634074931,
				"terrain": "text3"
			},
			{
				"q": 0,
				"r": 9,
				"height": -0.291045745094173,
				"terrain": "text6"
			},
			{
				"q": 0,
				"r": -10,
				"height": -0.36402047214209676,
				"terrain": "text6"
			},
			{
				"q": 0,
				"r": -9,
				"height": -0.5351568636673325,
				"terrain": "text4"
			},
			{
				"q": 0,
				"r": -8,
				"height": -0.5435894299986206,
				"terrain": "text3"
			},
			{
				"q": 0,
				"r": -7,
				"height": -0.35903135780640566,
				"terrain": "text4"
			},
			{
				"q": 0,
				"r": -6,
				"height": -0.017546088208969635,
				"terrain": "text1"
			},
			{
				"q": 0,
				"r": -5,
				"height": 0.4038045405375199,
				"terrain": "text4"
			},
			{
				"q": 0,
				"r": -4,
				"height": 0.8492530456665424,
				"terrain": "mountain"
			},
			{
				"q": 0,
				"r": -3,
				"height": 1.2038084437014902,
				"terrain": "mountain"
			},
			{
				"q": 0,
				"r": -2,
				"height": 1.1630042303679375,
				"terrain": "mountain"
			},
			{
				"q": 0,
				"r": -1,
				"height": 0.6719500288477358,
				"terrain": "text6"
			},
			{
				"q": 1,
				"r": 0,
				"height": 0.04667636213991771,
				"terrain": "text5"
			},
			{
				"q": 1,
				"r": 1,
				"height": -0.4972292913351555,
				"terrain": "text4"
			},
			{
				"q": 1,
				"r": 2,
				"height": -0.7019650137316902,
				"terrain": "text5"
			},
			{
				"q": 1,
				"r": 3,
				"height": -0.5552834258282717,
				"terrain": "text1"
			},
			{
				"q": 1,
				"r": 4,
				"height": -0.25211045508110375,
				"terrain": "text3"
			},
			{
				"q": 1,
				"r": 5,
				"height": -0.06289047748760923,
				"terrain": "text6"
			},
			{
				"q": 1,
				"r": 6,
				"height": -0.03809495198666485,
				"terrain": "text6"
			},
			{
				"q": 1,
				"r": 7,
				"height": -0.08277898084578805,
				"terrain": "text7"
			},
			{
				"q": 1,
				"r": 8,
				"height": -0.1797984108288318,
				"terrain": "text1"
			},
			{
				"q": 1,
				"r": 9,
				"height": -0.3455699354505246,
				"terrain": "text2"
			},
			{
				"q": 1,
				"r": -10,
				"height": -0.25833782821921336,
				"terrain": "text5"
			},
			{
				"q": 1,
				"r": -9,
				"height": -0.2703710223218123,
				"terrain": "text7"
			},
			{
				"q": 1,
				"r": -8,
				"height": -0.14324521886029123,
				"terrain": "text6"
			},
			{
				"q": 1,
				"r": -7,
				"height": 0.1251290159319573,
				"terrain": "text6"
			},
			{
				"q": 1,
				"r": -6,
				"height": 0.4775054280696027,
				"terrain": "text5"
			},
			{
				"q": 1,
				"r": -5,
				"height": 0.8278606868036129,
				"terrain": "mountain"
			},
			{
				"q": 1,
				"r": -4,
				"height": 1.1417031616348792,
				"terrain": "mountain"
			},
			{
				"q": 1,
				"r": -3,
				"height": 1.3420314869931393,
				"terrain": "mountain"
			},
			{
				"q": 1,
				"r": -2,
				"height": 1.1958431712296804,
				"terrain": "mountain"
			},
			{
				"q": 1,
				"r": -1,
				"height": 0.6839983409123959,
				"terrain": "text5"
			},
			{
				"q": 2,
				"r": 0,
				"height": 0.19872111892930347,
				"terrain": "text5"
			},
			{
				"q": 2,
				"r": 1,
				"height": -0.258744356756075,
				"terrain": "text4"
			},
			{
				"q": 2,
				"r": 2,
				"height": -0.540451229885987,
				"terrain": "text3"
			},
			{
				"q": 2,
				"r": 3,
				"height": -0.570221314594791,
				"terrain": "text3"
			},
			{
				"q": 2,
				"r": 4,
				"height": -0.40209232125991295,
				"terrain": "text3"
			},
			{
				"q": 2,
				"r": 5,
				"height": -0.20353376360249015,
				"terrain": "text4"
			},
			{
				"q": 2,
				"r": 6,
				"height": -0.06688234592395934,
				"terrain": "text1"
			},
			{
				"q": 2,
				"r": 7,
				"height": -0.014692296361292073,
				"terrain": "text3"
			},
			{
				"q": 2,
				"r": 8,
				"height": -0.10952925315566389,
				"terrain": "text6"
			},
			{
				"q": 2,
				"r": 9,
				"height": -0.29759861081948424,
				"terrain": "text2"
			},
			{
				"q": 2,
				"r": -10,
				"height": 0.01948120817646326,
				"terrain": "text5"
			},
			{
				"q": 2,
				"r": -9,
				"height": 0.1791645915258493,
				"terrain": "text5"
			},
			{
				"q": 2,
				"r": -8,
				"height": 0.4035466458383231,
				"terrain": "text5"
			},
			{
				"q": 2,
				"r": -7,
				"height": 0.6648084321668319,
				"terrain": "text4"
			},
			{
				"q": 2,
				"r": -6,
				"height": 0.9207676577853976,
				"terrain": "mountain"
			},
			{
				"q": 2,
				"r": -5,
				"height": 1.1212052081606603,
				"terrain": "mountain"
			},
			{
				"q": 2,
				"r": -4,
				"height": 1.2648283685204869,
				"terrain": "mountain"
			},
			{
				"q": 2,
				"r": -3,
				"height": 1.3267837584461788,
				"terrain": "mountain"
			},
			{
				"q": 2,
				"r": -2,
				"height": 1.145721022132981,
				"terrain": "mountain"
			},
			{
				"q": 2,
				"r": -1,
				"height": 0.709661791774717,
				"terrain": "text6"
			},
			{
				"q": 3,
				"r": 0,
				"height": 0.3533134726038278,
				"terrain": "text3"
			},
			{
				"q": 3,
				"r": 1,
				"height": -0.047334326057479295,
				"terrain": "text2"
			},
			{
				"q": 3,
				"r": 2,
				"height": -0.4495188385228823,
				"terrain": "text3"
			},
			{
				"q": 3,
				"r": 3,
				"height": -0.6555067469263884,
				"terrain": "text3"
			},
			{
				"q": 3,
				"r": 4,
				"height": -0.5732142358767787,
				"terrain": "text2"
			},
			{
				"q": 3,
				"r": 5,
				"height": -0.29795037036409516,
				"terrain": "text4"
			},
			{
				"q": 3,
				"r": 6,
				"height": 0.02697675191079235,
				"terrain": "text5"
			},
			{
				"q": 3,
				"r": 7,
				"height": 0.26000436204897903,
				"terrain": "text4"
			},
			{
				"q": 3,
				"r": 8,
				"height": 0.22242640616932607,
				"terrain": "text4"
			},
			{
				"q": 3,
				"r": 9,
				"height": 0.020183223555078594,
				"terrain": "text1"
			},
			{
				"q": 3,
				"r": -10,
				"height": 0.26962540793116396,
				"terrain": "text6"
			},
			{
				"q": 3,
				"r": -9,
				"height": 0.5744438571392327,
				"terrain": "text6"
			},
			{
				"q": 3,
				"r": -8,
				"height": 0.8440226148822305,
				"terrain": "mountain"
			},
			{
				"q": 3,
				"r": -7,
				"height": 1.0236461442839089,
				"terrain": "mountain"
			},
			{
				"q": 3,
				"r": -6,
				"height": 1.1285131883159496,
				"terrain": "mountain"
			},
			{
				"q": 3,
				"r": -5,
				"height": 1.1852742421772955,
				"terrain": "mountain"
			},
			{
				"q": 3,
				"r": -4,
				"height": 1.2042872470537596,
				"terrain": "mountain"
			},
			{
				"q": 3,
				"r": -3,
				"height": 1.192194974530732,
				"terrain": "mountain"
			},
			{
				"q": 3,
				"r": -2,
				"height": 1.0429073357903542,
				"terrain": "mountain"
			},
			{
				"q": 3,
				"r": -1,
				"height": 0.725789475887993,
				"terrain": "text6"
			},
			{
				"q": 4,
				"r": 0,
				"height": 0.42476752666126966,
				"terrain": "text3"
			},
			{
				"q": 4,
				"r": 1,
				"height": 0.02450599659677846,
				"terrain": "text7"
			},
			{
				"q": 4,
				"r": 2,
				"height": -0.48571557809858623,
				"terrain": "text6"
			},
			{
				"q": 4,
				"r": 3,
				"height": -0.8030456437215883,
				"terrain": "text6"
			},
			{
				"q": 4,
				"r": 4,
				"height": -0.7368006579562991,
				"terrain": "text2"
			},
			{
				"q": 4,
				"r": 5,
				"height": -0.36326848382628124,
				"terrain": "text7"
			},
			{
				"q": 4,
				"r": 6,
				"height": 0.15175107341102656,
				"terrain": "text5"
			},
			{
				"q": 4,
				"r": 7,
				"height": 0.5923105912697659,
				"terrain": "text5"
			},
			{
				"q": 4,
				"r": 8,
				"height": 0.6747351377877643,
				"terrain": "text4"
			},
			{
				"q": 4,
				"r": 9,
				"height": 0.5030998374642542,
				"terrain": "text6"
			},
			{
				"q": 4,
				"r": -10,
				"height": 0.4347482027758258,
				"terrain": "text1"
			},
			{
				"q": 4,
				"r": -9,
				"height": 0.8011888540819972,
				"terrain": "mountain"
			},
			{
				"q": 4,
				"r": -8,
				"height": 1.0408824636391543,
				"terrain": "mountain"
			},
			{
				"q": 4,
				"r": -7,
				"height": 1.102323822761788,
				"terrain": "mountain"
			},
			{
				"q": 4,
				"r": -6,
				"height": 1.0907174575794905,
				"terrain": "mountain"
			},
			{
				"q": 4,
				"r": -5,
				"height": 1.096573302359221,
				"terrain": "mountain"
			},
			{
				"q": 4,
				"r": -4,
				"height": 1.0906148768156723,
				"terrain": "mountain"
			},
			{
				"q": 4,
				"r": -3,
				"height": 1.0710859447170489,
				"terrain": "mountain"
			},
			{
				"q": 4,
				"r": -2,
				"height": 0.9608825966726475,
				"terrain": "mountain"
			},
			{
				"q": 4,
				"r": -1,
				"height": 0.719163706902519,
				"terrain": "text2"
			},
			{
				"q": 5,
				"r": 0,
				"height": 0.3896434830395538,
				"terrain": "text2"
			},
			{
				"q": 5,
				"r": 1,
				"height": -0.028279026601402697,
				"terrain": "text4"
			},
			{
				"q": 5,
				"r": 2,
				"height": -0.5779934547626288,
				"terrain": "text2"
			},
			{
				"q": 5,
				"r": 3,
				"height": -0.9217738379304129,
				"terrain": "text3"
			},
			{
				"q": 5,
				"r": 4,
				"height": -0.8401835389274762,
				"terrain": "text7"
			},
			{
				"q": 5,
				"r": 5,
				"height": -0.4061950240168925,
				"terrain": "text4"
			},
			{
				"q": 5,
				"r": 6,
				"height": 0.21797770415679596,
				"terrain": "text3"
			},
			{
				"q": 5,
				"r": 7,
				"height": 0.7987267732449818,
				"terrain": "mountain"
			},
			{
				"q": 5,
				"r": 8,
				"height": 0.9882210064282008,
				"terrain": "mountain"
			},
			{
				"q": 5,
				"r": -10,
				"height": 0.558359985347717,
				"terrain": "text6"
			},
			{
				"q": 5,
				"r": -9,
				"height": 0.9042152335188143,
				"terrain": "mountain"
			},
			{
				"q": 5,
				"r": -8,
				"height": 1.0555166296779142,
				"terrain": "mountain"
			},
			{
				"q": 5,
				"r": -7,
				"height": 1.002137794146687,
				"terrain": "mountain"
			},
			{
				"q": 5,
				"r": -6,
				"height": 0.9301600550995422,
				"terrain": "mountain"
			},
			{
				"q": 5,
				"r": -5,
				"height": 0.9672745798848401,
				"terrain": "mountain"
			},
			{
				"q": 5,
				"r": -4,
				"height": 1.0271884826573334,
				"terrain": "mountain"
			},
			{
				"q": 5,
				"r": -3,
				"height": 1.039646244202065,
				"terrain": "mountain"
			},
			{
				"q": 5,
				"r": -2,
				"height": 0.924044236874988,
				"terrain": "mountain"
			},
			{
				"q": 5,
				"r": -1,
				"height": 0.6713604399887678,
				"terrain": "text7"
			},
			{
				"q": 6,
				"r": 0,
				"height": 0.28342085613354007,
				"terrain": "text4"
			},
			{
				"q": 6,
				"r": 1,
				"height": -0.09440231747719628,
				"terrain": "text5"
			},
			{
				"q": 6,
				"r": 2,
				"height": -0.6090876734411119,
				"terrain": "text3"
			},
			{
				"q": 6,
				"r": 3,
				"height": -0.944477920209469,
				"terrain": "text5"
			},
			{
				"q": 6,
				"r": 4,
				"height": -0.8736369303272603,
				"terrain": "text6"
			},
			{
				"q": 6,
				"r": 5,
				"height": -0.448093760176461,
				"terrain": "text2"
			},
			{
				"q": 6,
				"r": 6,
				"height": 0.1802185798166607,
				"terrain": "text3"
			},
			{
				"q": 6,
				"r": -10,
				"height": 0.6210893231713359,
				"terrain": "text6"
			},
			{
				"q": 6,
				"r": -9,
				"height": 0.9297513748892525,
				"terrain": "mountain"
			},
			{
				"q": 6,
				"r": -8,
				"height": 0.9936478078254515,
				"terrain": "mountain"
			},
			{
				"q": 6,
				"r": -7,
				"height": 0.8470562009237976,
				"terrain": "mountain"
			},
			{
				"q": 6,
				"r": -6,
				"height": 0.7262233920029584,
				"terrain": "text7"
			},
			{
				"q": 6,
				"r": -5,
				"height": 0.79547520186641,
				"terrain": "mountain"
			},
			{
				"q": 6,
				"r": -4,
				"height": 0.9399985841585858,
				"terrain": "mountain"
			},
			{
				"q": 6,
				"r": -3,
				"height": 0.9800893852010915,
				"terrain": "mountain"
			},
			{
				"q": 6,
				"r": -2,
				"height": 0.8192629490489314,
				"terrain": "mountain"
			},
			{
				"q": 6,
				"r": -1,
				"height": 0.5355573377617779,
				"terrain": "text6"
			},
			{
				"q": 7,
				"r": 0,
				"height": 0.21144737574150263,
				"terrain": "text6"
			},
			{
				"q": 7,
				"r": 1,
				"height": -0.004150134040700484,
				"terrain": "text6"
			},
			{
				"q": 7,
				"r": 2,
				"height": -0.38829375204212835,
				"terrain": "text1"
			},
			{
				"q": 7,
				"r": 3,
				"height": -0.7345859457684872,
				"terrain": "text2"
			},
			{
				"q": 7,
				"r": 4,
				"height": -0.803104863950746,
				"terrain": "text2"
			},
			{
				"q": 7,
				"r": -10,
				"height": 0.7121169953187783,
				"terrain": "text6"
			},
			{
				"q": 7,
				"r": -9,
				"height": 0.9870093300983639,
				"terrain": "mountain"
			},
			{
				"q": 7,
				"r": -8,
				"height": 0.9943350442709961,
				"terrain": "mountain"
			},
			{
				"q": 7,
				"r": -7,
				"height": 0.7999775852578606,
				"terrain": "mountain"
			},
			{
				"q": 7,
				"r": -6,
				"height": 0.6432551827159811,
				"terrain": "text6"
			},
			{
				"q": 7,
				"r": -5,
				"height": 0.6893032981646957,
				"terrain": "text3"
			},
			{
				"q": 7,
				"r": -4,
				"height": 0.8326987100086758,
				"terrain": "mountain"
			},
			{
				"q": 7,
				"r": -3,
				"height": 0.8237679549940325,
				"terrain": "mountain"
			},
			{
				"q": 7,
				"r": -2,
				"height": 0.6017422537632298,
				"terrain": "text5"
			},
			{
				"q": 7,
				"r": -1,
				"height": 0.34587213343616763,
				"terrain": "text3"
			},
			{
				"q": 8,
				"r": 0,
				"height": 0.13023188116433143,
				"terrain": "text3"
			},
			{
				"q": 8,
				"r": 1,
				"height": 0.1619881648239868,
				"terrain": "text3"
			},
			{
				"q": 8,
				"r": 2,
				"height": -0.004044703669913621,
				"terrain": "text3"
			},
			{
				"q": 8,
				"r": -10,
				"height": 0.7676901015066058,
				"terrain": "mountain"
			},
			{
				"q": 8,
				"r": -9,
				"height": 1.0343927518056726,
				"terrain": "mountain"
			},
			{
				"q": 8,
				"r": -8,
				"height": 1.0287855972507742,
				"terrain": "mountain"
			},
			{
				"q": 8,
				"r": -7,
				"height": 0.8272038289530077,
				"terrain": "mountain"
			},
			{
				"q": 8,
				"r": -6,
				"height": 0.6344306835604949,
				"terrain": "text6"
			},
			{
				"q": 8,
				"r": -5,
				"height": 0.5839617867310001,
				"terrain": "text6"
			},
			{
				"q": 8,
				"r": -4,
				"height": 0.6097898875271243,
				"terrain": "text4"
			},
			{
				"q": 8,
				"r": -3,
				"height": 0.4945054475166438,
				"terrain": "text4"
			},
			{
				"q": 8,
				"r": -2,
				"height": 0.24832432609407595,
				"terrain": "text2"
			},
			{
				"q": 8,
				"r": -1,
				"height": 0.0855783830074685,
				"terrain": "text6"
			},
			{
				"q": 9,
				"r": 0,
				"height": -0.04780682872694117,
				"terrain": "text6"
			},
			{
				"q": 9,
				"r": -10,
				"height": 0.691649366255144,
				"terrain": "text3"
			},
			{
				"q": 9,
				"r": -9,
				"height": 0.9853546452492884,
				"terrain": "mountain"
			},
			{
				"q": 9,
				"r": -8,
				"height": 1.000980095880768,
				"terrain": "mountain"
			},
			{
				"q": 9,
				"r": -7,
				"height": 0.8050318275271308,
				"terrain": "mountain"
			},
			{
				"q": 9,
				"r": -6,
				"height": 0.560892915550365,
				"terrain": "text4"
			},
			{
				"q": 9,
				"r": -5,
				"height": 0.3795749132363795,
				"terrain": "text3"
			},
			{
				"q": 9,
				"r": -4,
				"height": 0.26021729848443675,
				"terrain": "text6"
			},
			{
				"q": 9,
				"r": -3,
				"height": 0.060545051186518484,
				"terrain": "text4"
			},
			{
				"q": 9,
				"r": -2,
				"height": -0.17735391469594358,
				"terrain": "text5"
			},
			{
				"q": 9,
				"r": -1,
				"height": -0.24138719879340592,
				"terrain": "text5"
			},
			{
				"q": 10,
				"r": -10,
				"height": 0.5138444342833917,
				"terrain": "text4"
			},
			{
				"q": 10,
				"r": -9,
				"height": 0.8297881358436213,
				"terrain": "mountain"
			},
			{
				"q": 10,
				"r": -8,
				"height": 0.8636670695323208,
				"terrain": "mountain"
			},
			{
				"q": 10,
				"r": -7,
				"height": 0.6747113857538714,
				"terrain": "text2"
			},
			{
				"q": 10,
				"r": -6,
				"height": 0.4105977098370333,
				"terrain": "text6"
			},
			{
				"q": 10,
				"r": -5,
				"height": 0.1776331504644379,
				"terrain": "text2"
			},
			{
				"q": 10,
				"r": -4,
				"height": -0.006687580829755457,
				"terrain": "text3"
			},
			{
				"q": 10,
				"r": -3,
				"height": -0.25764009229810114,
				"terrain": "text3"
			},
			{
				"q": 10,
				"r": -2,
				"height": -0.5118919844297989,
				"terrain": "text5"
			},
			{
				"q": 11,
				"r": -10,
				"height": 0.2873722863384644,
				"terrain": "text2"
			},
			{
				"q": 11,
				"r": -9,
				"height": 0.5918300920085595,
				"terrain": "text5"
			},
			{
				"q": 11,
				"r": -8,
				"height": 0.6439824686839987,
				"terrain": "text2"
			},
			{
				"q": 11,
				"r": -7,
				"height": 0.5072023475584091,
				"terrain": "text5"
			},
			{
				"q": 11,
				"r": -6,
				"height": 0.31685294855947405,
				"terrain": "text3"
			},
			{
				"q": 11,
				"r": -5,
				"height": 0.1581131990681768,
				"terrain": "text4"
			},
			{
				"q": 11,
				"r": -4,
				"height": 0.015171738634429444,
				"terrain": "text6"
			},
			{
				"q": 12,
				"r": -10,
				"height": 0.07183310799934106,
				"terrain": "text1"
			},
			{
				"q": 12,
				"r": -9,
				"height": 0.36559852822515926,
				"terrain": "text1"
			},
			{
				"q": 12,
				"r": -8,
				"height": 0.49946662483226323,
				"terrain": "text1"
			},
			{
				"q": 12,
				"r": -7,
				"height": 0.47181176582386863,
				"terrain": "text1"
			},
			{
				"q": 12,
				"r": -6,
				"height": 0.3872148940314858,
				"terrain": "text4"
			},
			{
				"q": 13,
				"r": -10,
				"height": 0.1722868413551446,
				"terrain": "text5"
			},
			{
				"q": 13,
				"r": -9,
				"height": 0.3908147450228523,
				"terrain": "text4"
			},
			{
				"q": 13,
				"r": -8,
				"height": 0.5581729991603527,
				"terrain": "text2"
			},
			{
				"q": 14,
				"r": -10,
				"height": 0.6434229491767329,
				"terrain": "text5"
			},
			{
				"q": -5,
				"r": 0,
				"height": 0.2796992290922374,
				"terrain": "text3"
			},
			{
				"q": -5,
				"r": 1,
				"height": -0.0828434353216834,
				"terrain": "text1"
			},
			{
				"q": -5,
				"r": 2,
				"height": -0.5301026500411522,
				"terrain": "text7"
			},
			{
				"q": -5,
				"r": 3,
				"height": -0.7086197483127572,
				"terrain": "text1"
			},
			{
				"q": -5,
				"r": 4,
				"height": -0.4955667746796728,
				"terrain": "text4"
			},
			{
				"q": -5,
				"r": 5,
				"height": -0.13432236892242036,
				"terrain": "text4"
			},
			{
				"q": -5,
				"r": 6,
				"height": 0.1803097057201647,
				"terrain": "text5"
			},
			{
				"q": -5,
				"r": 7,
				"height": 0.22155857711121277,
				"terrain": "text4"
			},
			{
				"q": -5,
				"r": 8,
				"height": -0.08443966055631795,
				"terrain": "text6"
			},
			{
				"q": -5,
				"r": 9,
				"height": -0.45093298911792506,
				"terrain": "text3"
			},
			{
				"q": -5,
				"r": -10,
				"height": 0.6808586598861224,
				"terrain": "text3"
			},
			{
				"q": -5,
				"r": -9,
				"height": 0.5539691296227598,
				"terrain": "text5"
			},
			{
				"q": -5,
				"r": -8,
				"height": 0.38599520892774064,
				"terrain": "text5"
			},
			{
				"q": -5,
				"r": -7,
				"height": 0.16631057687849599,
				"terrain": "text5"
			},
			{
				"q": -5,
				"r": -6,
				"height": -0.05274115112296335,
				"terrain": "text3"
			},
			{
				"q": -5,
				"r": -5,
				"height": -0.12463265103005111,
				"terrain": "text2"
			},
			{
				"q": -5,
				"r": -4,
				"height": -0.05638769281648451,
				"terrain": "text3"
			},
			{
				"q": -5,
				"r": -3,
				"height": 0.16607738892401724,
				"terrain": "text5"
			},
			{
				"q": -5,
				"r": -2,
				"height": 0.3938707192828444,
				"terrain": "text3"
			},
			{
				"q": -5,
				"r": -1,
				"height": 0.44583482674796887,
				"terrain": "text4"
			},
			{
				"q": -6,
				"r": 0,
				"height": 0.5067260364607792,
				"terrain": "text6"
			},
			{
				"q": -6,
				"r": 1,
				"height": 0.13190181642037532,
				"terrain": "text5"
			},
			{
				"q": -6,
				"r": 2,
				"height": -0.3730733455275721,
				"terrain": "text2"
			},
			{
				"q": -6,
				"r": 3,
				"height": -0.6714081584720987,
				"terrain": "text4"
			},
			{
				"q": -6,
				"r": 4,
				"height": -0.6036977879651024,
				"terrain": "text1"
			},
			{
				"q": -6,
				"r": 5,
				"height": -0.323848409423868,
				"terrain": "text2"
			},
			{
				"q": -6,
				"r": 6,
				"height": -0.04073776997135792,
				"terrain": "text6"
			},
			{
				"q": -6,
				"r": 7,
				"height": -0.048934944335472935,
				"terrain": "text3"
			},
			{
				"q": -6,
				"r": 8,
				"height": -0.40894148428905375,
				"terrain": "text2"
			},
			{
				"q": -6,
				"r": 9,
				"height": -0.7874411009108416,
				"terrain": "text6"
			},
			{
				"q": -6,
				"r": -9,
				"height": 0.6174738369610315,
				"terrain": "text6"
			},
			{
				"q": -6,
				"r": -8,
				"height": 0.654042506476501,
				"terrain": "text5"
			},
			{
				"q": -6,
				"r": -7,
				"height": 0.6238931894501761,
				"terrain": "text6"
			},
			{
				"q": -6,
				"r": -6,
				"height": 0.5243114156566611,
				"terrain": "text7"
			},
			{
				"q": -6,
				"r": -5,
				"height": 0.4627421650621462,
				"terrain": "text1"
			},
			{
				"q": -6,
				"r": -4,
				"height": 0.45299147206352075,
				"terrain": "text4"
			},
			{
				"q": -6,
				"r": -3,
				"height": 0.54332395750855,
				"terrain": "text1"
			},
			{
				"q": -6,
				"r": -2,
				"height": 0.6579486690301599,
				"terrain": "text5"
			},
			{
				"q": -6,
				"r": -1,
				"height": 0.6654390459975958,
				"terrain": "text5"
			},
			{
				"q": -7,
				"r": 0,
				"height": 0.7881146405838622,
				"terrain": "mountain"
			},
			{
				"q": -7,
				"r": 1,
				"height": 0.4635205435554721,
				"terrain": "text1"
			},
			{
				"q": -7,
				"r": 2,
				"height": -0.09162775814457683,
				"terrain": "text4"
			},
			{
				"q": -7,
				"r": 3,
				"height": -0.5738204158525104,
				"terrain": "text6"
			},
			{
				"q": -7,
				"r": 4,
				"height": -0.7451381501264442,
				"terrain": "text2"
			},
			{
				"q": -7,
				"r": 5,
				"height": -0.6369517440065029,
				"terrain": "text4"
			},
			{
				"q": -7,
				"r": 6,
				"height": -0.47405701244082266,
				"terrain": "text3"
			},
			{
				"q": -7,
				"r": 7,
				"height": -0.5031361748744151,
				"terrain": "text5"
			},
			{
				"q": -7,
				"r": 8,
				"height": -0.7900346429980593,
				"terrain": "text4"
			},
			{
				"q": -7,
				"r": 9,
				"height": -1.0752204068977778,
				"terrain": "text1"
			},
			{
				"q": -7,
				"r": -7,
				"height": 0.8356582623012413,
				"terrain": "mountain"
			},
			{
				"q": -7,
				"r": -6,
				"height": 0.9017248907957595,
				"terrain": "mountain"
			},
			{
				"q": -7,
				"r": -5,
				"height": 0.902712743545234,
				"terrain": "mountain"
			},
			{
				"q": -7,
				"r": -4,
				"height": 0.8571243667106083,
				"terrain": "mountain"
			},
			{
				"q": -7,
				"r": -3,
				"height": 0.846191502005421,
				"terrain": "mountain"
			},
			{
				"q": -7,
				"r": -2,
				"height": 0.876274677674368,
				"terrain": "mountain"
			},
			{
				"q": -7,
				"r": -1,
				"height": 0.8814581380968567,
				"terrain": "mountain"
			},
			{
				"q": -8,
				"r": 0,
				"height": 0.9112634416945495,
				"terrain": "mountain"
			},
			{
				"q": -8,
				"r": 1,
				"height": 0.7134787339726792,
				"terrain": "text5"
			},
			{
				"q": -8,
				"r": 2,
				"height": 0.1839781808405174,
				"terrain": "text2"
			},
			{
				"q": -8,
				"r": 3,
				"height": -0.4446319828388381,
				"terrain": "text2"
			},
			{
				"q": -8,
				"r": 4,
				"height": -0.8439832283230323,
				"terrain": "text3"
			},
			{
				"q": -8,
				"r": 5,
				"height": -0.9272349693781438,
				"terrain": "text2"
			},
			{
				"q": -8,
				"r": 6,
				"height": -0.8962973738561315,
				"terrain": "text4"
			},
			{
				"q": -8,
				"r": 7,
				"height": -0.8827778338568105,
				"terrain": "text7"
			},
			{
				"q": -8,
				"r": 8,
				"height": -0.9813584688230697,
				"terrain": "text6"
			},
			{
				"q": -8,
				"r": 9,
				"height": -1.0844567036612345,
				"terrain": "text1"
			},
			{
				"q": -8,
				"r": -5,
				"height": 0.967417753592136,
				"terrain": "mountain"
			},
			{
				"q": -8,
				"r": -4,
				"height": 0.9347886016534557,
				"terrain": "mountain"
			},
			{
				"q": -8,
				"r": -3,
				"height": 0.8599572312941743,
				"terrain": "mountain"
			},
			{
				"q": -8,
				"r": -2,
				"height": 0.8357753226204739,
				"terrain": "mountain"
			},
			{
				"q": -8,
				"r": -1,
				"height": 0.8799637898430024,
				"terrain": "mountain"
			},
			{
				"q": -9,
				"r": 0,
				"height": 0.7707966273338731,
				"terrain": "mountain"
			},
			{
				"q": -9,
				"r": 1,
				"height": 0.6980690750434226,
				"terrain": "text6"
			},
			{
				"q": -9,
				"r": 2,
				"height": 0.29352346539433954,
				"terrain": "text4"
			},
			{
				"q": -9,
				"r": 3,
				"height": -0.30829537546349817,
				"terrain": "text3"
			},
			{
				"q": -9,
				"r": 4,
				"height": -0.7798084910578797,
				"terrain": "text4"
			},
			{
				"q": -9,
				"r": 5,
				"height": -0.9659859868180063,
				"terrain": "text4"
			},
			{
				"q": -9,
				"r": 6,
				"height": -1.0098442593506975,
				"terrain": "text6"
			},
			{
				"q": -9,
				"r": 7,
				"height": -0.9425179171397532,
				"terrain": "text3"
			},
			{
				"q": -9,
				"r": 8,
				"height": -0.8737964813303705,
				"terrain": "text7"
			},
			{
				"q": -9,
				"r": 9,
				"height": -0.8076444573965431,
				"terrain": "text6"
			},
			{
				"q": -9,
				"r": -3,
				"height": 0.6379334525891932,
				"terrain": "text6"
			},
			{
				"q": -9,
				"r": -2,
				"height": 0.587553081587105,
				"terrain": "text5"
			},
			{
				"q": -9,
				"r": -1,
				"height": 0.6540906009136073,
				"terrain": "text2"
			},
			{
				"q": -10,
				"r": 0,
				"height": 0.4950942124223869,
				"terrain": "text4"
			},
			{
				"q": -10,
				"r": 1,
				"height": 0.47151577840598574,
				"terrain": "text2"
			},
			{
				"q": -10,
				"r": 2,
				"height": 0.24648958449927008,
				"terrain": "text5"
			},
			{
				"q": -10,
				"r": 3,
				"height": -0.13746464903260058,
				"terrain": "text3"
			},
			{
				"q": -10,
				"r": 4,
				"height": -0.4739685499893499,
				"terrain": "text7"
			},
			{
				"q": -10,
				"r": 5,
				"height": -0.6417291417783118,
				"terrain": "text2"
			},
			{
				"q": -10,
				"r": 6,
				"height": -0.7130199801148764,
				"terrain": "text5"
			},
			{
				"q": -10,
				"r": 7,
				"height": -0.6609242487666351,
				"terrain": "text5"
			},
			{
				"q": -10,
				"r": 8,
				"height": -0.5589346047865311,
				"terrain": "text1"
			},
			{
				"q": -10,
				"r": 9,
				"height": -0.4227751811111109,
				"terrain": "text6"
			},
			{
				"q": -10,
				"r": -1,
				"height": 0.39479435244289807,
				"terrain": "text4"
			},
			{
				"q": -11,
				"r": 1,
				"height": 0.17658542625526868,
				"terrain": "text6"
			},
			{
				"q": -11,
				"r": 2,
				"height": 0.13073251366094688,
				"terrain": "text5"
			},
			{
				"q": -11,
				"r": 3,
				"height": 0.0510089425530406,
				"terrain": "text7"
			},
			{
				"q": -11,
				"r": 4,
				"height": -0.0423766456790185,
				"terrain": "text1"
			},
			{
				"q": -11,
				"r": 5,
				"height": -0.11971216979306876,
				"terrain": "text6"
			},
			{
				"q": -11,
				"r": 6,
				"height": -0.20072125505611624,
				"terrain": "text2"
			},
			{
				"q": -11,
				"r": 7,
				"height": -0.21491231446810055,
				"terrain": "text4"
			},
			{
				"q": -11,
				"r": 8,
				"height": -0.16413316256314722,
				"terrain": "text4"
			},
			{
				"q": -11,
				"r": 9,
				"height": -0.026763146023842888,
				"terrain": "text5"
			},
			{
				"q": -12,
				"r": 3,
				"height": 0.05883933187611072,
				"terrain": "text3"
			},
			{
				"q": -12,
				"r": 4,
				"height": 0.24011548283687617,
				"terrain": "text7"
			},
			{
				"q": -12,
				"r": 5,
				"height": 0.2957689813960397,
				"terrain": "text2"
			},
			{
				"q": -12,
				"r": 6,
				"height": 0.23917142324112295,
				"terrain": "text2"
			},
			{
				"q": -12,
				"r": 7,
				"height": 0.19228603654911117,
				"terrain": "text2"
			},
			{
				"q": -12,
				"r": 8,
				"height": 0.18781442271720036,
				"terrain": "text5"
			},
			{
				"q": -12,
				"r": 9,
				"height": 0.25631763611917513,
				"terrain": "text1"
			},
			{
				"q": -13,
				"r": 5,
				"height": 0.486961809157582,
				"terrain": "text4"
			},
			{
				"q": -13,
				"r": 6,
				"height": 0.49898142050167915,
				"terrain": "text2"
			},
			{
				"q": -13,
				"r": 7,
				"height": 0.4764228724344314,
				"terrain": "text3"
			},
			{
				"q": -13,
				"r": 8,
				"height": 0.4219198643988742,
				"terrain": "text4"
			},
			{
				"q": -13,
				"r": 9,
				"height": 0.3361799053245971,
				"terrain": "text7"
			},
			{
				"q": -14,
				"r": 7,
				"height": 0.6428664105393846,
				"terrain": "text4"
			},
			{
				"q": -14,
				"r": 8,
				"height": 0.5008307350293502,
				"terrain": "text4"
			},
			{
				"q": -14,
				"r": 9,
				"height": 0.19836780916840968,
				"terrain": "text7"
			},
			{
				"q": -15,
				"r": 9,
				"height": -0.02689892498892399,
				"terrain": "text4"
			},
			{
				"q": -4,
				"r": 0,
				"height": 0.12264614432487754,
				"terrain": "text5"
			},
			{
				"q": -4,
				"r": 1,
				"height": -0.2563516672090809,
				"terrain": "text3"
			},
			{
				"q": -4,
				"r": 2,
				"height": -0.6590815811395253,
				"terrain": "text3"
			},
			{
				"q": -4,
				"r": 3,
				"height": -0.7297676741843622,
				"terrain": "text1"
			},
			{
				"q": -4,
				"r": 4,
				"height": -0.3999554243806247,
				"terrain": "text4"
			},
			{
				"q": -4,
				"r": 5,
				"height": 0.0019381303129603067,
				"terrain": "text6"
			},
			{
				"q": -4,
				"r": 6,
				"height": 0.2653660474258433,
				"terrain": "text2"
			},
			{
				"q": -4,
				"r": 7,
				"height": 0.31196412862547773,
				"terrain": "text1"
			},
			{
				"q": -4,
				"r": 8,
				"height": 0.09194141818999108,
				"terrain": "text1"
			},
			{
				"q": -4,
				"r": 9,
				"height": -0.22106315741772428,
				"terrain": "text6"
			},
			{
				"q": -4,
				"r": -10,
				"height": 0.6871853811081999,
				"terrain": "text2"
			},
			{
				"q": -4,
				"r": -9,
				"height": 0.4343782756609793,
				"terrain": "text7"
			},
			{
				"q": -4,
				"r": -8,
				"height": 0.09049549006423013,
				"terrain": "text5"
			},
			{
				"q": -4,
				"r": -7,
				"height": -0.27767353589353977,
				"terrain": "text5"
			},
			{
				"q": -4,
				"r": -6,
				"height": -0.5634934464078767,
				"terrain": "text2"
			},
			{
				"q": -4,
				"r": -5,
				"height": -0.6163551897475782,
				"terrain": "text3"
			},
			{
				"q": -4,
				"r": -4,
				"height": -0.4433765672199518,
				"terrain": "text6"
			},
			{
				"q": -4,
				"r": -3,
				"height": -0.05640490694629742,
				"terrain": "text3"
			},
			{
				"q": -4,
				"r": -2,
				"height": 0.28105048332741334,
				"terrain": "text4"
			},
			{
				"q": -4,
				"r": -1,
				"height": 0.34035791058981973,
				"terrain": "text1"
			},
			{
				"q": -3,
				"r": 0,
				"height": 0.031263511817164406,
				"terrain": "text4"
			},
			{
				"q": -3,
				"r": 1,
				"height": -0.40347085786995884,
				"terrain": "text3"
			},
			{
				"q": -3,
				"r": 2,
				"height": -0.7334721781030453,
				"terrain": "text1"
			},
			{
				"q": -3,
				"r": 3,
				"height": -0.6730185425461724,
				"terrain": "text4"
			},
			{
				"q": -3,
				"r": 4,
				"height": -0.2623050064388476,
				"terrain": "text4"
			},
			{
				"q": -3,
				"r": 5,
				"height": 0.11623428065843638,
				"terrain": "text2"
			},
			{
				"q": -3,
				"r": 6,
				"height": 0.2793032047012347,
				"terrain": "text7"
			},
			{
				"q": -3,
				"r": 7,
				"height": 0.31389660101004113,
				"terrain": "text4"
			},
			{
				"q": -3,
				"r": 8,
				"height": 0.19217984769047086,
				"terrain": "text4"
			},
			{
				"q": -3,
				"r": 9,
				"height": -0.05534190811400441,
				"terrain": "text4"
			},
			{
				"q": -3,
				"r": -10,
				"height": 0.4867688400328261,
				"terrain": "text5"
			},
			{
				"q": -3,
				"r": -9,
				"height": 0.13559717089711162,
				"terrain": "text6"
			},
			{
				"q": -3,
				"r": -8,
				"height": -0.3001610066391665,
				"terrain": "text5"
			},
			{
				"q": -3,
				"r": -7,
				"height": -0.6853330926004066,
				"terrain": "text1"
			},
			{
				"q": -3,
				"r": -6,
				"height": -0.9047517294405834,
				"terrain": "text5"
			},
			{
				"q": -3,
				"r": -5,
				"height": -0.850884886063106,
				"terrain": "text3"
			},
			{
				"q": -3,
				"r": -4,
				"height": -0.5330646376501964,
				"terrain": "text1"
			},
			{
				"q": -3,
				"r": -3,
				"height": 0.008100819793611908,
				"terrain": "text4"
			},
			{
				"q": -3,
				"r": -2,
				"height": 0.3989765867877879,
				"terrain": "text5"
			},
			{
				"q": -3,
				"r": -1,
				"height": 0.3767766240305396,
				"terrain": "text4"
			},
			{
				"q": -2,
				"r": 0,
				"height": 0.0020639207275912758,
				"terrain": "text5"
			},
			{
				"q": -2,
				"r": 1,
				"height": -0.4994503685790053,
				"terrain": "text6"
			},
			{
				"q": -2,
				"r": 2,
				"height": -0.7403758060045971,
				"terrain": "text7"
			},
			{
				"q": -2,
				"r": 3,
				"height": -0.549742312469794,
				"terrain": "text7"
			},
			{
				"q": -2,
				"r": 4,
				"height": -0.09785314800483666,
				"terrain": "text6"
			},
			{
				"q": -2,
				"r": 5,
				"height": 0.21787302783874415,
				"terrain": "text5"
			},
			{
				"q": -2,
				"r": 6,
				"height": 0.27720520771423884,
				"terrain": "text5"
			},
			{
				"q": -2,
				"r": 7,
				"height": 0.2640008668186868,
				"terrain": "text2"
			},
			{
				"q": -2,
				"r": 8,
				"height": 0.1776855345527218,
				"terrain": "text5"
			},
			{
				"q": -2,
				"r": 9,
				"height": -0.04069987164738359,
				"terrain": "text6"
			},
			{
				"q": -2,
				"r": -10,
				"height": 0.13230962345796976,
				"terrain": "text5"
			},
			{
				"q": -2,
				"r": -9,
				"height": -0.2488963180596656,
				"terrain": "text5"
			},
			{
				"q": -2,
				"r": -8,
				"height": -0.6323387544848296,
				"terrain": "text1"
			},
			{
				"q": -2,
				"r": -7,
				"height": -0.8648943427088476,
				"terrain": "text7"
			},
			{
				"q": -2,
				"r": -6,
				"height": -0.8794051361870359,
				"terrain": "text2"
			},
			{
				"q": -2,
				"r": -5,
				"height": -0.6436122012915952,
				"terrain": "text3"
			},
			{
				"q": -2,
				"r": -4,
				"height": -0.1894056611277069,
				"terrain": "text7"
			},
			{
				"q": -2,
				"r": -3,
				"height": 0.3967098312645825,
				"terrain": "text4"
			},
			{
				"q": -2,
				"r": -2,
				"height": 0.7036625472068869,
				"terrain": "text6"
			},
			{
				"q": -2,
				"r": -1,
				"height": 0.5066161829746272,
				"terrain": "text1"
			},
			{
				"q": -1,
				"r": 0,
				"height": 0,
				"terrain": "text4"
			},
			{
				"q": -1,
				"r": 1,
				"height": -0.5547002875746259,
				"terrain": "text3"
			},
			{
				"q": -1,
				"r": 2,
				"height": -0.7410952264261339,
				"terrain": "text3"
			},
			{
				"q": -1,
				"r": 3,
				"height": -0.47866105747621385,
				"terrain": "text3"
			},
			{
				"q": -1,
				"r": 4,
				"height": -0.02059376951948809,
				"terrain": "text4"
			},
			{
				"q": -1,
				"r": 5,
				"height": 0.24609772646720604,
				"terrain": "text4"
			},
			{
				"q": -1,
				"r": 6,
				"height": 0.24419728885987296,
				"terrain": "text4"
			},
			{
				"q": -1,
				"r": 7,
				"height": 0.16304967671600767,
				"terrain": "text2"
			},
			{
				"q": -1,
				"r": 8,
				"height": 0.04466429775057984,
				"terrain": "text3"
			},
			{
				"q": -1,
				"r": 9,
				"height": -0.17946612092410463,
				"terrain": "text5"
			},
			{
				"q": -1,
				"r": -10,
				"height": -0.20384464669526547,
				"terrain": "text2"
			},
			{
				"q": -1,
				"r": -9,
				"height": -0.5140721559420829,
				"terrain": "text1"
			},
			{
				"q": -1,
				"r": -8,
				"height": -0.7191921088093266,
				"terrain": "text6"
			},
			{
				"q": -1,
				"r": -7,
				"height": -0.715792165913631,
				"terrain": "text6"
			},
			{
				"q": -1,
				"r": -6,
				"height": -0.5005587696531624,
				"terrain": "text4"
			},
			{
				"q": -1,
				"r": -5,
				"height": -0.11375182643516141,
				"terrain": "text7"
			},
			{
				"q": -1,
				"r": -4,
				"height": 0.3912224111202584,
				"terrain": "text5"
			},
			{
				"q": -1,
				"r": -3,
				"height": 0.8921138479360564,
				"terrain": "mountain"
			},
			{
				"q": -1,
				"r": -2,
				"height": 1.0116478256593264,
				"terrain": "mountain"
			},
			{
				"q": -1,
				"r": -1,
				"height": 0.623582106475527,
				"terrain": "text5"
			}
		],
		"halfWidth": 10,
		"halfHeight": 10
	}
	},
  "seed_10":{
	"map_id": "seed_10",
	"data": {
		"_width": 20,
		"_height": 20,
		"data": [
			{
				"q": 0,
				"r": 0,
				"height": 0,
				"terrain": "text1"
			},
			{
				"q": 0,
				"r": 1,
				"height": 0.6719500288477367,
				"terrain": "text5"
			},
			{
				"q": 0,
				"r": 2,
				"height": 1.1671595817441967,
				"terrain": "mountain"
			},
			{
				"q": 0,
				"r": 3,
				"height": 1.2701134485913386,
				"terrain": "mountain"
			},
			{
				"q": 0,
				"r": 4,
				"height": 1.1069942633381922,
				"terrain": "mountain"
			},
			{
				"q": 0,
				"r": 5,
				"height": 0.9740314753711373,
				"terrain": "mountain"
			},
			{
				"q": 0,
				"r": 6,
				"height": 0.9459448683577801,
				"terrain": "mountain"
			},
			{
				"q": 0,
				"r": 7,
				"height": 1.0131209068213582,
				"terrain": "mountain"
			},
			{
				"q": 0,
				"r": 8,
				"height": 0.9964463193687786,
				"terrain": "mountain"
			},
			{
				"q": 0,
				"r": 9,
				"height": 0.7472286630174443,
				"terrain": "text3"
			},
			{
				"q": 0,
				"r": -10,
				"height": 0.09180203135242809,
				"terrain": "text5"
			},
			{
				"q": 0,
				"r": -9,
				"height": -0.0038612525153320365,
				"terrain": "text6"
			},
			{
				"q": 0,
				"r": -8,
				"height": -0.10939004466271349,
				"terrain": "text4"
			},
			{
				"q": 0,
				"r": -7,
				"height": -0.2813397394356155,
				"terrain": "text6"
			},
			{
				"q": 0,
				"r": -6,
				"height": -0.5044476797579451,
				"terrain": "text7"
			},
			{
				"q": 0,
				"r": -5,
				"height": -0.7373870029939891,
				"terrain": "text6"
			},
			{
				"q": 0,
				"r": -4,
				"height": -0.9989168823608962,
				"terrain": "text7"
			},
			{
				"q": 0,
				"r": -3,
				"height": -1.2403149490354584,
				"terrain": "text4"
			},
			{
				"q": 0,
				"r": -2,
				"height": -1.1650962114268015,
				"terrain": "text6"
			},
			{
				"q": 0,
				"r": -1,
				"height": -0.6719500288477358,
				"terrain": "text2"
			},
			{
				"q": 1,
				"r": 0,
				"height": 0.04667636213991771,
				"terrain": "text1"
			},
			{
				"q": 1,
				"r": 1,
				"height": 0.6703868518524128,
				"terrain": "text6"
			},
			{
				"q": 1,
				"r": 2,
				"height": 1.150703051408694,
				"terrain": "mountain"
			},
			{
				"q": 1,
				"r": 3,
				"height": 1.21855915888491,
				"terrain": "mountain"
			},
			{
				"q": 1,
				"r": 4,
				"height": 0.9734387773521339,
				"terrain": "mountain"
			},
			{
				"q": 1,
				"r": 5,
				"height": 0.7484043734908332,
				"terrain": "text4"
			},
			{
				"q": 1,
				"r": 6,
				"height": 0.680303482615411,
				"terrain": "text4"
			},
			{
				"q": 1,
				"r": 7,
				"height": 0.7598633766688252,
				"terrain": "mountain"
			},
			{
				"q": 1,
				"r": 8,
				"height": 0.817321895801572,
				"terrain": "mountain"
			},
			{
				"q": 1,
				"r": 9,
				"height": 0.6334535061516269,
				"terrain": "text2"
			},
			{
				"q": 1,
				"r": -10,
				"height": -0.008774628267407159,
				"terrain": "text4"
			},
			{
				"q": 1,
				"r": -9,
				"height": -0.09228966625172141,
				"terrain": "text5"
			},
			{
				"q": 1,
				"r": -8,
				"height": -0.2226365177316148,
				"terrain": "text5"
			},
			{
				"q": 1,
				"r": -7,
				"height": -0.4152901608595152,
				"terrain": "text4"
			},
			{
				"q": 1,
				"r": -6,
				"height": -0.6393492439086148,
				"terrain": "text3"
			},
			{
				"q": 1,
				"r": -5,
				"height": -0.8458224868327597,
				"terrain": "text3"
			},
			{
				"q": 1,
				"r": -4,
				"height": -1.0329183757609852,
				"terrain": "text5"
			},
			{
				"q": 1,
				"r": -3,
				"height": -1.1702005323885278,
				"terrain": "text5"
			},
			{
				"q": 1,
				"r": -2,
				"height": -1.0371531355548107,
				"terrain": "text3"
			},
			{
				"q": 1,
				"r": -1,
				"height": -0.5687934876096877,
				"terrain": "text2"
			},
			{
				"q": 2,
				"r": 0,
				"height": 0.19666691858560056,
				"terrain": "text2"
			},
			{
				"q": 2,
				"r": 1,
				"height": 0.6245719522705615,
				"terrain": "text7"
			},
			{
				"q": 2,
				"r": 2,
				"height": 0.9532886255179147,
				"terrain": "mountain"
			},
			{
				"q": 2,
				"r": 3,
				"height": 0.9233607003144003,
				"terrain": "mountain"
			},
			{
				"q": 2,
				"r": 4,
				"height": 0.5713769839470777,
				"terrain": "text2"
			},
			{
				"q": 2,
				"r": 5,
				"height": 0.20755707819703556,
				"terrain": "text2"
			},
			{
				"q": 2,
				"r": 6,
				"height": 0.0029647079627984074,
				"terrain": "text6"
			},
			{
				"q": 2,
				"r": 7,
				"height": -0.022624381354256984,
				"terrain": "text4"
			},
			{
				"q": 2,
				"r": 8,
				"height": 0.0670000188511728,
				"terrain": "text4"
			},
			{
				"q": 2,
				"r": 9,
				"height": 0.04991273141611696,
				"terrain": "text2"
			},
			{
				"q": 2,
				"r": -10,
				"height": -0.033947118484284944,
				"terrain": "text6"
			},
			{
				"q": 2,
				"r": -9,
				"height": -0.10161035637961274,
				"terrain": "text1"
			},
			{
				"q": 2,
				"r": -8,
				"height": -0.30031561386326555,
				"terrain": "text2"
			},
			{
				"q": 2,
				"r": -7,
				"height": -0.5660713917029342,
				"terrain": "text6"
			},
			{
				"q": 2,
				"r": -6,
				"height": -0.7812868976059082,
				"terrain": "text5"
			},
			{
				"q": 2,
				"r": -5,
				"height": -0.8618001896910675,
				"terrain": "text5"
			},
			{
				"q": 2,
				"r": -4,
				"height": -0.8378921046642507,
				"terrain": "text6"
			},
			{
				"q": 2,
				"r": -3,
				"height": -0.7437396659568358,
				"terrain": "text3"
			},
			{
				"q": 2,
				"r": -2,
				"height": -0.5414273062246695,
				"terrain": "text4"
			},
			{
				"q": 2,
				"r": -1,
				"height": -0.21109842752464503,
				"terrain": "text5"
			},
			{
				"q": 3,
				"r": 0,
				"height": 0.3247743001331207,
				"terrain": "text6"
			},
			{
				"q": 3,
				"r": 1,
				"height": 0.47936717101039594,
				"terrain": "text2"
			},
			{
				"q": 3,
				"r": 2,
				"height": 0.6329174113455125,
				"terrain": "text2"
			},
			{
				"q": 3,
				"r": 3,
				"height": 0.5675707641600002,
				"terrain": "text6"
			},
			{
				"q": 3,
				"r": 4,
				"height": 0.21244208642414783,
				"terrain": "text6"
			},
			{
				"q": 3,
				"r": 5,
				"height": -0.2525716461445997,
				"terrain": "text5"
			},
			{
				"q": 3,
				"r": 6,
				"height": -0.6410149470957904,
				"terrain": "text6"
			},
			{
				"q": 3,
				"r": 7,
				"height": -0.8522677309985016,
				"terrain": "text2"
			},
			{
				"q": 3,
				"r": 8,
				"height": -0.7750821155432681,
				"terrain": "text3"
			},
			{
				"q": 3,
				"r": 9,
				"height": -0.5802942497112556,
				"terrain": "text4"
			},
			{
				"q": 3,
				"r": -10,
				"height": 0.016885932764932332,
				"terrain": "text5"
			},
			{
				"q": 3,
				"r": -9,
				"height": -0.007485323507572972,
				"terrain": "text4"
			},
			{
				"q": 3,
				"r": -8,
				"height": -0.2779708387660262,
				"terrain": "text2"
			},
			{
				"q": 3,
				"r": -7,
				"height": -0.639290021128958,
				"terrain": "text5"
			},
			{
				"q": 3,
				"r": -6,
				"height": -0.8366521709594427,
				"terrain": "text2"
			},
			{
				"q": 3,
				"r": -5,
				"height": -0.7124919109505301,
				"terrain": "text3"
			},
			{
				"q": 3,
				"r": -4,
				"height": -0.3905497275061124,
				"terrain": "text2"
			},
			{
				"q": 3,
				"r": -3,
				"height": -0.03611781095230768,
				"terrain": "text6"
			},
			{
				"q": 3,
				"r": -2,
				"height": 0.16978464329384196,
				"terrain": "text3"
			},
			{
				"q": 3,
				"r": -1,
				"height": 0.23955416833381682,
				"terrain": "text6"
			},
			{
				"q": 4,
				"r": 0,
				"height": 0.3208397886912717,
				"terrain": "text6"
			},
			{
				"q": 4,
				"r": 1,
				"height": 0.2734121674471897,
				"terrain": "text6"
			},
			{
				"q": 4,
				"r": 2,
				"height": 0.3860818477346202,
				"terrain": "text6"
			},
			{
				"q": 4,
				"r": 3,
				"height": 0.43416483277210627,
				"terrain": "text3"
			},
			{
				"q": 4,
				"r": 4,
				"height": 0.21482888554481316,
				"terrain": "text5"
			},
			{
				"q": 4,
				"r": 5,
				"height": -0.2557729400553022,
				"terrain": "text2"
			},
			{
				"q": 4,
				"r": 6,
				"height": -0.7923471064231289,
				"terrain": "text6"
			},
			{
				"q": 4,
				"r": 7,
				"height": -1.1807548249703976,
				"terrain": "text6"
			},
			{
				"q": 4,
				"r": 8,
				"height": -1.1524285287496423,
				"terrain": "text2"
			},
			{
				"q": 4,
				"r": 9,
				"height": -0.8124320978167162,
				"terrain": "text5"
			},
			{
				"q": 4,
				"r": -10,
				"height": 0.03941949660405025,
				"terrain": "text2"
			},
			{
				"q": 4,
				"r": -9,
				"height": 0.08292250173724786,
				"terrain": "text7"
			},
			{
				"q": 4,
				"r": -8,
				"height": -0.2010656567036398,
				"terrain": "text3"
			},
			{
				"q": 4,
				"r": -7,
				"height": -0.5907957080292227,
				"terrain": "text4"
			},
			{
				"q": 4,
				"r": -6,
				"height": -0.6987853598773435,
				"terrain": "text6"
			},
			{
				"q": 4,
				"r": -5,
				"height": -0.3594096615326456,
				"terrain": "text3"
			},
			{
				"q": 4,
				"r": -4,
				"height": 0.1909557754502407,
				"terrain": "text7"
			},
			{
				"q": 4,
				"r": -3,
				"height": 0.6649100301282063,
				"terrain": "text5"
			},
			{
				"q": 4,
				"r": -2,
				"height": 0.7583161297034502,
				"terrain": "mountain"
			},
			{
				"q": 4,
				"r": -1,
				"height": 0.5353644382711348,
				"terrain": "text7"
			},
			{
				"q": 5,
				"r": 0,
				"height": 0.1566085028787865,
				"terrain": "text3"
			},
			{
				"q": 5,
				"r": 1,
				"height": 0.0659867891123258,
				"terrain": "text3"
			},
			{
				"q": 5,
				"r": 2,
				"height": 0.32759752394416336,
				"terrain": "text3"
			},
			{
				"q": 5,
				"r": 3,
				"height": 0.6412390238337612,
				"terrain": "text7"
			},
			{
				"q": 5,
				"r": 4,
				"height": 0.633980428788853,
				"terrain": "text5"
			},
			{
				"q": 5,
				"r": 5,
				"height": 0.21210205189757655,
				"terrain": "text6"
			},
			{
				"q": 5,
				"r": 6,
				"height": -0.3931156618641211,
				"terrain": "text5"
			},
			{
				"q": 5,
				"r": 7,
				"height": -0.8975661017945525,
				"terrain": "text4"
			},
			{
				"q": 5,
				"r": 8,
				"height": -0.9546561742005563,
				"terrain": "text3"
			},
			{
				"q": 5,
				"r": -10,
				"height": -0.0715937648619362,
				"terrain": "text5"
			},
			{
				"q": 5,
				"r": -9,
				"height": 0.05890255635234998,
				"terrain": "text5"
			},
			{
				"q": 5,
				"r": -8,
				"height": -0.13946072739954066,
				"terrain": "text4"
			},
			{
				"q": 5,
				"r": -7,
				"height": -0.4204291165363889,
				"terrain": "text6"
			},
			{
				"q": 5,
				"r": -6,
				"height": -0.3730188473321814,
				"terrain": "text6"
			},
			{
				"q": 5,
				"r": -5,
				"height": 0.10118249133555696,
				"terrain": "text3"
			},
			{
				"q": 5,
				"r": -4,
				"height": 0.6941820637829945,
				"terrain": "text5"
			},
			{
				"q": 5,
				"r": -3,
				"height": 1.0832883090166268,
				"terrain": "mountain"
			},
			{
				"q": 5,
				"r": -2,
				"height": 0.9851248490186878,
				"terrain": "mountain"
			},
			{
				"q": 5,
				"r": -1,
				"height": 0.5415000384995067,
				"terrain": "text5"
			},
			{
				"q": 6,
				"r": 0,
				"height": -0.11294870458456424,
				"terrain": "text4"
			},
			{
				"q": 6,
				"r": 1,
				"height": -0.15002999918442933,
				"terrain": "text2"
			},
			{
				"q": 6,
				"r": 2,
				"height": 0.30550111139628433,
				"terrain": "text6"
			},
			{
				"q": 6,
				"r": 3,
				"height": 0.8877338976425037,
				"terrain": "mountain"
			},
			{
				"q": 6,
				"r": 4,
				"height": 1.0988061781491674,
				"terrain": "mountain"
			},
			{
				"q": 6,
				"r": 5,
				"height": 0.7787251433456028,
				"terrain": "mountain"
			},
			{
				"q": 6,
				"r": 6,
				"height": 0.1993290547200001,
				"terrain": "text6"
			},
			{
				"q": 6,
				"r": -10,
				"height": -0.1509815099961101,
				"terrain": "text2"
			},
			{
				"q": 6,
				"r": -9,
				"height": 0.07901767064773357,
				"terrain": "text4"
			},
			{
				"q": 6,
				"r": -8,
				"height": 0.014378409910849432,
				"terrain": "text2"
			},
			{
				"q": 6,
				"r": -7,
				"height": -0.11547360050093018,
				"terrain": "text6"
			},
			{
				"q": 6,
				"r": -6,
				"height": 0.04021984536855816,
				"terrain": "text5"
			},
			{
				"q": 6,
				"r": -5,
				"height": 0.5290927930972376,
				"terrain": "text3"
			},
			{
				"q": 6,
				"r": -4,
				"height": 1.02302509273961,
				"terrain": "mountain"
			},
			{
				"q": 6,
				"r": -3,
				"height": 1.2128782444323656,
				"terrain": "mountain"
			},
			{
				"q": 6,
				"r": -2,
				"height": 0.914992175699436,
				"terrain": "mountain"
			},
			{
				"q": 6,
				"r": -1,
				"height": 0.33069994065067804,
				"terrain": "text3"
			},
			{
				"q": 7,
				"r": 0,
				"height": -0.3344074638242269,
				"terrain": "text4"
			},
			{
				"q": 7,
				"r": 1,
				"height": -0.2870240029506144,
				"terrain": "text6"
			},
			{
				"q": 7,
				"r": 2,
				"height": 0.21346680624048203,
				"terrain": "text4"
			},
			{
				"q": 7,
				"r": 3,
				"height": 0.848641520109457,
				"terrain": "mountain"
			},
			{
				"q": 7,
				"r": 4,
				"height": 1.1835946668472723,
				"terrain": "mountain"
			},
			{
				"q": 7,
				"r": -10,
				"height": -0.05908047233159339,
				"terrain": "text1"
			},
			{
				"q": 7,
				"r": -9,
				"height": 0.2502715874126637,
				"terrain": "text2"
			},
			{
				"q": 7,
				"r": -8,
				"height": 0.3251528664106433,
				"terrain": "text4"
			},
			{
				"q": 7,
				"r": -7,
				"height": 0.3248349724834856,
				"terrain": "text7"
			},
			{
				"q": 7,
				"r": -6,
				"height": 0.489422405795616,
				"terrain": "text6"
			},
			{
				"q": 7,
				"r": -5,
				"height": 0.8377251329533467,
				"terrain": "mountain"
			},
			{
				"q": 7,
				"r": -4,
				"height": 1.1179041477687026,
				"terrain": "mountain"
			},
			{
				"q": 7,
				"r": -3,
				"height": 1.080547218506269,
				"terrain": "mountain"
			},
			{
				"q": 7,
				"r": -2,
				"height": 0.6470437217507041,
				"terrain": "text2"
			},
			{
				"q": 7,
				"r": -1,
				"height": 0.048169489593719084,
				"terrain": "text4"
			},
			{
				"q": 8,
				"r": 0,
				"height": -0.4870638424138844,
				"terrain": "text1"
			},
			{
				"q": 8,
				"r": 1,
				"height": -0.3721733961321484,
				"terrain": "text6"
			},
			{
				"q": 8,
				"r": 2,
				"height": 0.013195778935468305,
				"terrain": "text4"
			},
			{
				"q": 8,
				"r": -10,
				"height": 0.04070668046950063,
				"terrain": "text4"
			},
			{
				"q": 8,
				"r": -9,
				"height": 0.4068605534433609,
				"terrain": "text7"
			},
			{
				"q": 8,
				"r": -8,
				"height": 0.5914461599424634,
				"terrain": "text4"
			},
			{
				"q": 8,
				"r": -7,
				"height": 0.6630013189829397,
				"terrain": "text3"
			},
			{
				"q": 8,
				"r": -6,
				"height": 0.7498230456248229,
				"terrain": "text1"
			},
			{
				"q": 8,
				"r": -5,
				"height": 0.8673122934486978,
				"terrain": "mountain"
			},
			{
				"q": 8,
				"r": -4,
				"height": 0.8936730442674075,
				"terrain": "mountain"
			},
			{
				"q": 8,
				"r": -3,
				"height": 0.6847783736470044,
				"terrain": "text7"
			},
			{
				"q": 8,
				"r": -2,
				"height": 0.22822194636205656,
				"terrain": "text7"
			},
			{
				"q": 8,
				"r": -1,
				"height": -0.2528338229475866,
				"terrain": "text3"
			},
			{
				"q": 9,
				"r": 0,
				"height": -0.6408333379927529,
				"terrain": "text5"
			},
			{
				"q": 9,
				"r": -10,
				"height": 0.006858930041152289,
				"terrain": "text3"
			},
			{
				"q": 9,
				"r": -9,
				"height": 0.41766742582745814,
				"terrain": "text1"
			},
			{
				"q": 9,
				"r": -8,
				"height": 0.6627492205577983,
				"terrain": "text1"
			},
			{
				"q": 9,
				"r": -7,
				"height": 0.738313486565217,
				"terrain": "text2"
			},
			{
				"q": 9,
				"r": -6,
				"height": 0.710641593776748,
				"terrain": "text4"
			},
			{
				"q": 9,
				"r": -5,
				"height": 0.6180756106135189,
				"terrain": "text2"
			},
			{
				"q": 9,
				"r": -4,
				"height": 0.4500957869256053,
				"terrain": "text2"
			},
			{
				"q": 9,
				"r": -3,
				"height": 0.15777070196791673,
				"terrain": "text2"
			},
			{
				"q": 9,
				"r": -2,
				"height": -0.23382655177489176,
				"terrain": "text3"
			},
			{
				"q": 9,
				"r": -1,
				"height": -0.5462498219637182,
				"terrain": "text2"
			},
			{
				"q": 10,
				"r": -10,
				"height": -0.1234567901234567,
				"terrain": "text2"
			},
			{
				"q": 10,
				"r": -9,
				"height": 0.30871124695473234,
				"terrain": "text6"
			},
			{
				"q": 10,
				"r": -8,
				"height": 0.5656934492624377,
				"terrain": "text2"
			},
			{
				"q": 10,
				"r": -7,
				"height": 0.6042699417145594,
				"terrain": "text2"
			},
			{
				"q": 10,
				"r": -6,
				"height": 0.48969335531996916,
				"terrain": "text4"
			},
			{
				"q": 10,
				"r": -5,
				"height": 0.2918720953974587,
				"terrain": "text2"
			},
			{
				"q": 10,
				"r": -4,
				"height": 0.04940785210679853,
				"terrain": "text1"
			},
			{
				"q": 10,
				"r": -3,
				"height": -0.24615123036635392,
				"terrain": "text1"
			},
			{
				"q": 10,
				"r": -2,
				"height": -0.5624087365634112,
				"terrain": "text7"
			},
			{
				"q": 11,
				"r": -10,
				"height": -0.29613534847330214,
				"terrain": "text7"
			},
			{
				"q": 11,
				"r": -9,
				"height": 0.09879876516552644,
				"terrain": "text7"
			},
			{
				"q": 11,
				"r": -8,
				"height": 0.3291949911058109,
				"terrain": "text1"
			},
			{
				"q": 11,
				"r": -7,
				"height": 0.3626049499130242,
				"terrain": "text2"
			},
			{
				"q": 11,
				"r": -6,
				"height": 0.26451405830464597,
				"terrain": "text3"
			},
			{
				"q": 11,
				"r": -5,
				"height": 0.1015210024897375,
				"terrain": "text3"
			},
			{
				"q": 11,
				"r": -4,
				"height": -0.09431552940853108,
				"terrain": "text7"
			},
			{
				"q": 12,
				"r": -10,
				"height": -0.4544639113840426,
				"terrain": "text3"
			},
			{
				"q": 12,
				"r": -9,
				"height": -0.1571975787160344,
				"terrain": "text2"
			},
			{
				"q": 12,
				"r": -8,
				"height": 0.017476323757612836,
				"terrain": "text6"
			},
			{
				"q": 12,
				"r": -7,
				"height": 0.07961862945009544,
				"terrain": "text7"
			},
			{
				"q": 12,
				"r": -6,
				"height": 0.09446998065657297,
				"terrain": "text3"
			},
			{
				"q": 13,
				"r": -10,
				"height": -0.3180951716214893,
				"terrain": "text6"
			},
			{
				"q": 13,
				"r": -9,
				"height": -0.1744969154461348,
				"terrain": "text6"
			},
			{
				"q": 13,
				"r": -8,
				"height": -0.10074990624860139,
				"terrain": "text4"
			},
			{
				"q": 14,
				"r": -10,
				"height": 0.13678203881728507,
				"terrain": "text6"
			},
			{
				"q": -5,
				"r": 0,
				"height": 0.43991722418740486,
				"terrain": "text3"
			},
			{
				"q": -5,
				"r": 1,
				"height": 0.6713743075033891,
				"terrain": "text1"
			},
			{
				"q": -5,
				"r": 2,
				"height": 0.9221277653091867,
				"terrain": "mountain"
			},
			{
				"q": -5,
				"r": 3,
				"height": 0.9961943436996762,
				"terrain": "mountain"
			},
			{
				"q": -5,
				"r": 4,
				"height": 0.81932990066265,
				"terrain": "mountain"
			},
			{
				"q": -5,
				"r": 5,
				"height": 0.4558687212039715,
				"terrain": "text3"
			},
			{
				"q": -5,
				"r": 6,
				"height": -0.037357477108523274,
				"terrain": "text2"
			},
			{
				"q": -5,
				"r": 7,
				"height": -0.5609186118579117,
				"terrain": "text4"
			},
			{
				"q": -5,
				"r": 8,
				"height": -0.8180129509185228,
				"terrain": "text4"
			},
			{
				"q": -5,
				"r": 9,
				"height": -0.7254667563716077,
				"terrain": "text2"
			},
			{
				"q": -5,
				"r": -10,
				"height": -0.33731294799026745,
				"terrain": "text3"
			},
			{
				"q": -5,
				"r": -9,
				"height": -0.6728354742600986,
				"terrain": "text4"
			},
			{
				"q": -5,
				"r": -8,
				"height": -0.9962732745961159,
				"terrain": "text6"
			},
			{
				"q": -5,
				"r": -7,
				"height": -1.0621569520912093,
				"terrain": "text2"
			},
			{
				"q": -5,
				"r": -6,
				"height": -0.7559062626871667,
				"terrain": "text3"
			},
			{
				"q": -5,
				"r": -5,
				"height": -0.1550453595742518,
				"terrain": "text1"
			},
			{
				"q": -5,
				"r": -4,
				"height": 0.3939559871134003,
				"terrain": "text6"
			},
			{
				"q": -5,
				"r": -3,
				"height": 0.6209834452997874,
				"terrain": "text4"
			},
			{
				"q": -5,
				"r": -2,
				"height": 0.5230269497308653,
				"terrain": "text4"
			},
			{
				"q": -5,
				"r": -1,
				"height": 0.37192756764547075,
				"terrain": "text7"
			},
			{
				"q": -6,
				"r": 0,
				"height": 0.2535609597579453,
				"terrain": "text6"
			},
			{
				"q": -6,
				"r": 1,
				"height": 0.48110719864079615,
				"terrain": "text7"
			},
			{
				"q": -6,
				"r": 2,
				"height": 0.846314830594256,
				"terrain": "mountain"
			},
			{
				"q": -6,
				"r": 3,
				"height": 1.0897137922830265,
				"terrain": "mountain"
			},
			{
				"q": -6,
				"r": 4,
				"height": 1.0259681818536845,
				"terrain": "mountain"
			},
			{
				"q": -6,
				"r": 5,
				"height": 0.6962546346842793,
				"terrain": "text2"
			},
			{
				"q": -6,
				"r": 6,
				"height": 0.22174330958584204,
				"terrain": "text6"
			},
			{
				"q": -6,
				"r": 7,
				"height": -0.35484921656520707,
				"terrain": "text2"
			},
			{
				"q": -6,
				"r": 8,
				"height": -0.7366407637868646,
				"terrain": "text1"
			},
			{
				"q": -6,
				"r": 9,
				"height": -0.7782133447372241,
				"terrain": "text4"
			},
			{
				"q": -6,
				"r": -9,
				"height": -0.6586087592850871,
				"terrain": "text2"
			},
			{
				"q": -6,
				"r": -8,
				"height": -0.7507245294169707,
				"terrain": "text7"
			},
			{
				"q": -6,
				"r": -7,
				"height": -0.5975120802253518,
				"terrain": "text5"
			},
			{
				"q": -6,
				"r": -6,
				"height": -0.15013134336000006,
				"terrain": "text4"
			},
			{
				"q": -6,
				"r": -5,
				"height": 0.46907353840733135,
				"terrain": "text4"
			},
			{
				"q": -6,
				"r": -4,
				"height": 0.9289608570294539,
				"terrain": "mountain"
			},
			{
				"q": -6,
				"r": -3,
				"height": 0.9532403098336174,
				"terrain": "mountain"
			},
			{
				"q": -6,
				"r": -2,
				"height": 0.6096746708322494,
				"terrain": "text5"
			},
			{
				"q": -6,
				"r": -1,
				"height": 0.26915821070972645,
				"terrain": "text3"
			},
			{
				"q": -7,
				"r": 0,
				"height": -0.12222249542035142,
				"terrain": "text4"
			},
			{
				"q": -7,
				"r": 1,
				"height": 0.12231749502729046,
				"terrain": "text1"
			},
			{
				"q": -7,
				"r": 2,
				"height": 0.6004245373476104,
				"terrain": "text1"
			},
			{
				"q": -7,
				"r": 3,
				"height": 1.0058886392377915,
				"terrain": "mountain"
			},
			{
				"q": -7,
				"r": 4,
				"height": 1.0776016782281734,
				"terrain": "mountain"
			},
			{
				"q": -7,
				"r": 5,
				"height": 0.862608585488709,
				"terrain": "mountain"
			},
			{
				"q": -7,
				"r": 6,
				"height": 0.5115556498977533,
				"terrain": "text5"
			},
			{
				"q": -7,
				"r": 7,
				"height": -0.02597718370311186,
				"terrain": "text5"
			},
			{
				"q": -7,
				"r": 8,
				"height": -0.5094930445033912,
				"terrain": "text2"
			},
			{
				"q": -7,
				"r": 9,
				"height": -0.7505737795049063,
				"terrain": "text3"
			},
			{
				"q": -7,
				"r": -7,
				"height": -0.2757674692579585,
				"terrain": "text2"
			},
			{
				"q": -7,
				"r": -6,
				"height": 0.3086350875839641,
				"terrain": "text5"
			},
			{
				"q": -7,
				"r": -5,
				"height": 0.9003582924382356,
				"terrain": "mountain"
			},
			{
				"q": -7,
				"r": -4,
				"height": 1.2242754432267413,
				"terrain": "mountain"
			},
			{
				"q": -7,
				"r": -3,
				"height": 1.0139820967060773,
				"terrain": "mountain"
			},
			{
				"q": -7,
				"r": -2,
				"height": 0.42696654761389885,
				"terrain": "text1"
			},
			{
				"q": -7,
				"r": -1,
				"height": -0.06364898364654767,
				"terrain": "text5"
			},
			{
				"q": -8,
				"r": 0,
				"height": -0.3975192142888715,
				"terrain": "text6"
			},
			{
				"q": -8,
				"r": 1,
				"height": -0.16079676000043824,
				"terrain": "text5"
			},
			{
				"q": -8,
				"r": 2,
				"height": 0.3072935928484854,
				"terrain": "text7"
			},
			{
				"q": -8,
				"r": 3,
				"height": 0.7064033214682485,
				"terrain": "text5"
			},
			{
				"q": -8,
				"r": 4,
				"height": 0.8087325213697344,
				"terrain": "mountain"
			},
			{
				"q": -8,
				"r": 5,
				"height": 0.7254099743070075,
				"terrain": "text5"
			},
			{
				"q": -8,
				"r": 6,
				"height": 0.5801796218443471,
				"terrain": "text3"
			},
			{
				"q": -8,
				"r": 7,
				"height": 0.25470126177705293,
				"terrain": "text6"
			},
			{
				"q": -8,
				"r": 8,
				"height": -0.13596552756110852,
				"terrain": "text4"
			},
			{
				"q": -8,
				"r": 9,
				"height": -0.4657266154491152,
				"terrain": "text7"
			},
			{
				"q": -8,
				"r": -5,
				"height": 0.922938870990673,
				"terrain": "mountain"
			},
			{
				"q": -8,
				"r": -4,
				"height": 1.1280620124700924,
				"terrain": "mountain"
			},
			{
				"q": -8,
				"r": -3,
				"height": 0.8038049866200695,
				"terrain": "mountain"
			},
			{
				"q": -8,
				"r": -2,
				"height": 0.15169451101357312,
				"terrain": "text3"
			},
			{
				"q": -8,
				"r": -1,
				"height": -0.3461460841189674,
				"terrain": "text6"
			},
			{
				"q": -9,
				"r": 0,
				"height": -0.407042115721518,
				"terrain": "text2"
			},
			{
				"q": -9,
				"r": 1,
				"height": -0.23831480061877786,
				"terrain": "text3"
			},
			{
				"q": -9,
				"r": 2,
				"height": 0.09291707746998315,
				"terrain": "text5"
			},
			{
				"q": -9,
				"r": 3,
				"height": 0.32608725304915,
				"terrain": "text5"
			},
			{
				"q": -9,
				"r": 4,
				"height": 0.35523724799820744,
				"terrain": "text6"
			},
			{
				"q": -9,
				"r": 5,
				"height": 0.38068230645437684,
				"terrain": "text1"
			},
			{
				"q": -9,
				"r": 6,
				"height": 0.4559560213753743,
				"terrain": "text2"
			},
			{
				"q": -9,
				"r": 7,
				"height": 0.4476066462597422,
				"terrain": "text6"
			},
			{
				"q": -9,
				"r": 8,
				"height": 0.3330305777185874,
				"terrain": "text3"
			},
			{
				"q": -9,
				"r": 9,
				"height": 0.09545453167437196,
				"terrain": "text2"
			},
			{
				"q": -9,
				"r": -3,
				"height": 0.5169185168943252,
				"terrain": "text2"
			},
			{
				"q": -9,
				"r": -2,
				"height": 0.015540521844990177,
				"terrain": "text5"
			},
			{
				"q": -9,
				"r": -1,
				"height": -0.3629307230113753,
				"terrain": "text5"
			},
			{
				"q": -10,
				"r": 0,
				"height": -0.20659266919399039,
				"terrain": "text6"
			},
			{
				"q": -10,
				"r": 1,
				"height": -0.15326422550580152,
				"terrain": "text6"
			},
			{
				"q": -10,
				"r": 2,
				"height": 0.011429252186377747,
				"terrain": "text3"
			},
			{
				"q": -10,
				"r": 3,
				"height": 0.06578544001709938,
				"terrain": "text3"
			},
			{
				"q": -10,
				"r": 4,
				"height": 0.009153408448145217,
				"terrain": "text5"
			},
			{
				"q": -10,
				"r": 5,
				"height": 0.10730635009263848,
				"terrain": "text7"
			},
			{
				"q": -10,
				"r": 6,
				"height": 0.35326597014882055,
				"terrain": "text2"
			},
			{
				"q": -10,
				"r": 7,
				"height": 0.6141710793292248,
				"terrain": "text5"
			},
			{
				"q": -10,
				"r": 8,
				"height": 0.7824115878315602,
				"terrain": "mountain"
			},
			{
				"q": -10,
				"r": 9,
				"height": 0.7210681358436213,
				"terrain": "text5"
			},
			{
				"q": -10,
				"r": -1,
				"height": -0.12657583975233372,
				"terrain": "text7"
			},
			{
				"q": -11,
				"r": 1,
				"height": 0.07816703839444508,
				"terrain": "text3"
			},
			{
				"q": -11,
				"r": 2,
				"height": 0.0050563924531320525,
				"terrain": "text2"
			},
			{
				"q": -11,
				"r": 3,
				"height": -0.1327171339620075,
				"terrain": "text4"
			},
			{
				"q": -11,
				"r": 4,
				"height": -0.2656419711007878,
				"terrain": "text6"
			},
			{
				"q": -11,
				"r": 5,
				"height": -0.12477018381723726,
				"terrain": "text4"
			},
			{
				"q": -11,
				"r": 6,
				"height": 0.23442614417499197,
				"terrain": "text1"
			},
			{
				"q": -11,
				"r": 7,
				"height": 0.681968820118863,
				"terrain": "text2"
			},
			{
				"q": -11,
				"r": 8,
				"height": 1.0664602276954467,
				"terrain": "mountain"
			},
			{
				"q": -11,
				"r": 9,
				"height": 1.1812731498218938,
				"terrain": "mountain"
			},
			{
				"q": -12,
				"r": 3,
				"height": -0.465365351517286,
				"terrain": "text6"
			},
			{
				"q": -12,
				"r": 4,
				"height": -0.5402521013201959,
				"terrain": "text2"
			},
			{
				"q": -12,
				"r": 5,
				"height": -0.3001973325643783,
				"terrain": "text4"
			},
			{
				"q": -12,
				"r": 6,
				"height": 0.14332028851018921,
				"terrain": "text7"
			},
			{
				"q": -12,
				"r": 7,
				"height": 0.6358414849773977,
				"terrain": "text2"
			},
			{
				"q": -12,
				"r": 8,
				"height": 1.0447193933537453,
				"terrain": "mountain"
			},
			{
				"q": -12,
				"r": 9,
				"height": 1.2183420759628176,
				"terrain": "mountain"
			},
			{
				"q": -13,
				"r": 5,
				"height": -0.27983044240327326,
				"terrain": "text1"
			},
			{
				"q": -13,
				"r": 6,
				"height": 0.2143996941024669,
				"terrain": "text5"
			},
			{
				"q": -13,
				"r": 7,
				"height": 0.6061349737257451,
				"terrain": "text2"
			},
			{
				"q": -13,
				"r": 8,
				"height": 0.8340823927671345,
				"terrain": "mountain"
			},
			{
				"q": -13,
				"r": 9,
				"height": 0.9478143927392095,
				"terrain": "mountain"
			},
			{
				"q": -14,
				"r": 7,
				"height": 0.7014883637971486,
				"terrain": "text6"
			},
			{
				"q": -14,
				"r": 8,
				"height": 0.7221805538187358,
				"terrain": "text6"
			},
			{
				"q": -14,
				"r": 9,
				"height": 0.7799463953732443,
				"terrain": "mountain"
			},
			{
				"q": -15,
				"r": 9,
				"height": 0.9441451755511696,
				"terrain": "mountain"
			},
			{
				"q": -4,
				"r": 0,
				"height": 0.4476355760234479,
				"terrain": "text2"
			},
			{
				"q": -4,
				"r": 1,
				"height": 0.7027858802065964,
				"terrain": "text4"
			},
			{
				"q": -4,
				"r": 2,
				"height": 0.865812472703606,
				"terrain": "mountain"
			},
			{
				"q": -4,
				"r": 3,
				"height": 0.8084246918028593,
				"terrain": "mountain"
			},
			{
				"q": -4,
				"r": 4,
				"height": 0.5658554585107827,
				"terrain": "text6"
			},
			{
				"q": -4,
				"r": 5,
				"height": 0.24861224423973383,
				"terrain": "text2"
			},
			{
				"q": -4,
				"r": 6,
				"height": -0.15964393243503897,
				"terrain": "text6"
			},
			{
				"q": -4,
				"r": 7,
				"height": -0.5641536573726638,
				"terrain": "text3"
			},
			{
				"q": -4,
				"r": 8,
				"height": -0.7153429221343313,
				"terrain": "text3"
			},
			{
				"q": -4,
				"r": 9,
				"height": -0.585191409835189,
				"terrain": "text5"
			},
			{
				"q": -4,
				"r": -10,
				"height": -0.1787877572168976,
				"terrain": "text3"
			},
			{
				"q": -4,
				"r": -9,
				"height": -0.586321996539434,
				"terrain": "text2"
			},
			{
				"q": -4,
				"r": -8,
				"height": -1.064786121184449,
				"terrain": "text5"
			},
			{
				"q": -4,
				"r": -7,
				"height": -1.3240847042566437,
				"terrain": "text5"
			},
			{
				"q": -4,
				"r": -6,
				"height": -1.1850717568194127,
				"terrain": "text4"
			},
			{
				"q": -4,
				"r": -5,
				"height": -0.6818811409359882,
				"terrain": "text7"
			},
			{
				"q": -4,
				"r": -4,
				"height": -0.16033541340350133,
				"terrain": "text7"
			},
			{
				"q": -4,
				"r": -3,
				"height": 0.1575092232073815,
				"terrain": "text3"
			},
			{
				"q": -4,
				"r": -2,
				"height": 0.24375630409857058,
				"terrain": "text2"
			},
			{
				"q": -4,
				"r": -1,
				"height": 0.2774694047614796,
				"terrain": "text7"
			},
			{
				"q": -3,
				"r": 0,
				"height": 0.3572971390354583,
				"terrain": "text2"
			},
			{
				"q": -3,
				"r": 1,
				"height": 0.6878387824387976,
				"terrain": "text2"
			},
			{
				"q": -3,
				"r": 2,
				"height": 0.8291868884270329,
				"terrain": "mountain"
			},
			{
				"q": -3,
				"r": 3,
				"height": 0.692937445075347,
				"terrain": "text4"
			},
			{
				"q": -3,
				"r": 4,
				"height": 0.41625912809923477,
				"terrain": "text2"
			},
			{
				"q": -3,
				"r": 5,
				"height": 0.17728366029234688,
				"terrain": "text2"
			},
			{
				"q": -3,
				"r": 6,
				"height": -0.08256729067183155,
				"terrain": "text1"
			},
			{
				"q": -3,
				"r": 7,
				"height": -0.2967156563789987,
				"terrain": "text3"
			},
			{
				"q": -3,
				"r": 8,
				"height": -0.34584006960499253,
				"terrain": "text6"
			},
			{
				"q": -3,
				"r": 9,
				"height": -0.27422832913540274,
				"terrain": "text2"
			},
			{
				"q": -3,
				"r": -10,
				"height": 0.08061676826014913,
				"terrain": "text4"
			},
			{
				"q": -3,
				"r": -9,
				"height": -0.2988879687718917,
				"terrain": "text7"
			},
			{
				"q": -3,
				"r": -8,
				"height": -0.7952496861697576,
				"terrain": "text2"
			},
			{
				"q": -3,
				"r": -7,
				"height": -1.159214471584984,
				"terrain": "text2"
			},
			{
				"q": -3,
				"r": -6,
				"height": -1.2011070479936174,
				"terrain": "text3"
			},
			{
				"q": -3,
				"r": -5,
				"height": -0.9126836052997871,
				"terrain": "text6"
			},
			{
				"q": -3,
				"r": -4,
				"height": -0.6015467410473812,
				"terrain": "text4"
			},
			{
				"q": -3,
				"r": -3,
				"height": -0.37895717951999985,
				"terrain": "text5"
			},
			{
				"q": -3,
				"r": -2,
				"height": -0.19463337084195184,
				"terrain": "text2"
			},
			{
				"q": -3,
				"r": -1,
				"height": 0.03887422933686137,
				"terrain": "text5"
			},
			{
				"q": -2,
				"r": 0,
				"height": 0.198740009286884,
				"terrain": "text3"
			},
			{
				"q": -2,
				"r": 1,
				"height": 0.6669559976418078,
				"terrain": "text5"
			},
			{
				"q": -2,
				"r": 2,
				"height": 0.9124367312867504,
				"terrain": "mountain"
			},
			{
				"q": -2,
				"r": 3,
				"height": 0.8302755688210847,
				"terrain": "mountain"
			},
			{
				"q": -2,
				"r": 4,
				"height": 0.591840341795151,
				"terrain": "text4"
			},
			{
				"q": -2,
				"r": 5,
				"height": 0.4276136419460873,
				"terrain": "text7"
			},
			{
				"q": -2,
				"r": 6,
				"height": 0.29015945748774974,
				"terrain": "text2"
			},
			{
				"q": -2,
				"r": 7,
				"height": 0.22612715864207067,
				"terrain": "text6"
			},
			{
				"q": -2,
				"r": 8,
				"height": 0.2087933849220222,
				"terrain": "text4"
			},
			{
				"q": -2,
				"r": 9,
				"height": 0.1351514090898363,
				"terrain": "text5"
			},
			{
				"q": -2,
				"r": -10,
				"height": 0.2505960276757078,
				"terrain": "text6"
			},
			{
				"q": -2,
				"r": -9,
				"height": -0.02312769214714111,
				"terrain": "text3"
			},
			{
				"q": -2,
				"r": -8,
				"height": -0.38591536875825716,
				"terrain": "text2"
			},
			{
				"q": -2,
				"r": -7,
				"height": -0.7092575753573268,
				"terrain": "text3"
			},
			{
				"q": -2,
				"r": -6,
				"height": -0.8717106210913439,
				"terrain": "text5"
			},
			{
				"q": -2,
				"r": -5,
				"height": -0.842772164701652,
				"terrain": "text1"
			},
			{
				"q": -2,
				"r": -4,
				"height": -0.8270291590581922,
				"terrain": "text4"
			},
			{
				"q": -2,
				"r": -3,
				"height": -0.8427928799580482,
				"terrain": "text6"
			},
			{
				"q": -2,
				"r": -2,
				"height": -0.6883032359407326,
				"terrain": "text3"
			},
			{
				"q": -2,
				"r": -1,
				"height": -0.2928384352847833,
				"terrain": "text4"
			},
			{
				"q": -1,
				"r": 0,
				"height": 0.04667636213991703,
				"terrain": "text5"
			},
			{
				"q": -1,
				"r": 1,
				"height": 0.6594653581033505,
				"terrain": "text3"
			},
			{
				"q": -1,
				"r": 2,
				"height": 1.0675057507253316,
				"terrain": "mountain"
			},
			{
				"q": -1,
				"r": 3,
				"height": 1.112344073820565,
				"terrain": "mountain"
			},
			{
				"q": -1,
				"r": 4,
				"height": 0.9416791935862993,
				"terrain": "mountain"
			},
			{
				"q": -1,
				"r": 5,
				"height": 0.8186375503115614,
				"terrain": "mountain"
			},
			{
				"q": -1,
				"r": 6,
				"height": 0.7556073443596643,
				"terrain": "mountain"
			},
			{
				"q": -1,
				"r": 7,
				"height": 0.7683205835618572,
				"terrain": "mountain"
			},
			{
				"q": -1,
				"r": 8,
				"height": 0.7229869009686871,
				"terrain": "text4"
			},
			{
				"q": -1,
				"r": 9,
				"height": 0.5090368970025154,
				"terrain": "text1"
			},
			{
				"q": -1,
				"r": -10,
				"height": 0.21953798275154512,
				"terrain": "text7"
			},
			{
				"q": -1,
				"r": -9,
				"height": 0.06472730322094078,
				"terrain": "text4"
			},
			{
				"q": -1,
				"r": -8,
				"height": -0.11879525973786115,
				"terrain": "text6"
			},
			{
				"q": -1,
				"r": -7,
				"height": -0.3334972963569804,
				"terrain": "text3"
			},
			{
				"q": -1,
				"r": -6,
				"height": -0.5411790261352408,
				"terrain": "text7"
			},
			{
				"q": -1,
				"r": -5,
				"height": -0.7041068019268302,
				"terrain": "text5"
			},
			{
				"q": -1,
				"r": -4,
				"height": -0.9105135057991056,
				"terrain": "text7"
			},
			{
				"q": -1,
				"r": -3,
				"height": -1.1270627848568613,
				"terrain": "text6"
			},
			{
				"q": -1,
				"r": -2,
				"height": -1.0538059170997558,
				"terrain": "text1"
			},
			{
				"q": -1,
				"r": -1,
				"height": -0.5824019294947559,
				"terrain": "text6"
			}
		],
		"halfWidth": 10,
		"halfHeight": 10
	}
	}
}
